/**
 * AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
 * This file is generated by scripts/generate-html-cache.js
 * To regenerate, run: npm run generate-templates
 */

  /* eslint-disable */

/**
 * Template cache for all HTML templates in the application.
 * This is automatically generated at build time.
 */
const TEMPLATES = {
  '404.html': `<!DOCTYPE html>
<html lang="en">
    <head>
        <meta charset="utf-8">
        <title>Page Not Found :(</title>
        <style>
            ::-moz-selection {
                background: #b3d4fc;
                text-shadow: none;
            }

            ::selection {
                background: #b3d4fc;
                text-shadow: none;
            }

            html {
                padding: 30px 10px;
                font-size: 20px;
                line-height: 1.4;
                color: #737373;
                background: #f0f0f0;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
            }

            html,
            input {
                font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
            }

            body {
                max-width: 500px;
                _width: 500px;
                padding: 30px 20px 50px;
                border: 1px solid #b3b3b3;
                border-radius: 4px;
                margin: 0 auto;
                box-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;
                background: #fcfcfc;
            }

            h1 {
                margin: 0 10px;
                font-size: 50px;
                text-align: center;
            }

            h1 span {
                color: #bbb;
            }

            h3 {
                margin: 1.5em 0 0.5em;
            }

            p {
                margin: 1em 0;
            }

            ul {
                padding: 0 0 0 40px;
                margin: 1em 0;
            }

            .container {
                max-width: 380px;
                _width: 380px;
                margin: 0 auto;
            }

            /* google search */

            #goog-fixurl ul {
                list-style: none;
                padding: 0;
                margin: 0;
            }

            #goog-fixurl form {
                margin: 0;
            }

            #goog-wm-qt,
            #goog-wm-sb {
                border: 1px solid #bbb;
                font-size: 16px;
                line-height: normal;
                vertical-align: top;
                color: #444;
                border-radius: 2px;
            }

            #goog-wm-qt {
                width: 220px;
                height: 20px;
                padding: 5px;
                margin: 5px 10px 0 0;
                box-shadow: inset 0 1px 1px #ccc;
            }

            #goog-wm-sb {
                display: inline-block;
                height: 32px;
                padding: 0 10px;
                margin: 5px 0 0;
                white-space: nowrap;
                cursor: pointer;
                background-color: #f5f5f5;
                background-image: -webkit-linear-gradient(rgba(255,255,255,0), #f1f1f1);
                background-image: -moz-linear-gradient(rgba(255,255,255,0), #f1f1f1);
                background-image: -ms-linear-gradient(rgba(255,255,255,0), #f1f1f1);
                background-image: -o-linear-gradient(rgba(255,255,255,0), #f1f1f1);
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                *overflow: visible;
                *display: inline;
                *zoom: 1;
            }

            #goog-wm-sb:hover,
            #goog-wm-sb:focus {
                border-color: #aaa;
                box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
                background-color: #f8f8f8;
            }

            #goog-wm-qt:hover,
            #goog-wm-qt:focus {
                border-color: #105cb6;
                outline: 0;
                color: #222;
            }

            input::-moz-focus-inner {
                padding: 0;
                border: 0;
            }
        </style>
    </head>
    <body>
        <div class="container">
            <h1>Not found <span>:(</span></h1>
            <p>Sorry, but the page you were trying to view does not exist.</p>
            <p>It looks like this was the result of either:</p>
            <ul>
                <li>a mistyped address</li>
                <li>an out-of-date link</li>
            </ul>
            <script>
                var GOOG_FIXURL_LANG = (navigator.language || '').slice(0,2),GOOG_FIXURL_SITE = location.host;
            </script>
            <script src="//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js"></script>
        </div>
    </body>
</html>
`,
  'ang2/app/ai-form-filler/ai-form-filler.component.html': `@if ($has_permission()) {
  <div>
    <h2 i18n>AI Form Assistant</h2>
  </div>
  <div>
    <div role="status">
    @if ($recognitionState().alertMessage) {
      <div>
        <p>{{ $recognitionState().alertMessage }}</p>
      </div>
    }
    </div>
    @if ($recognitionState().state !== 'unavailable') {
      <ul class="list-inline list-unstyled">
        <li>@if ($recognitionState().buttonLabel) {
          <button class="btn btn-primary" [disabled]="$isButtonDisabled()" type="button" id="main-btn" (click)="handleMainBtnClick()">{{ $recognitionState().buttonLabel }}</button>
        }</li>
        <li>@if ($recognitionState().state === 'listening') {
          <button class="btn btn-primary btn-outline" type="button" id="discard-btn" (click)="handleDiscardBtnClick()" i18n>Discard</button>
        }</li>
      </ul>
    }
    @if ($bannerVisible()) {
      <div class="fixed inset-x-0 top-0 w-screen bg-info-200 text-info-800 z-50 px-2 py-2 flex gap-2 justify-center items-center">
        <p>{{ $recognitionState().alertMessage }}</p>
        @if ($recognitionState().state === 'listening') {
          <p i18n>Audio recording will stop in <strong>{{ $recordingTimeLeft() | date:'mm:ss' }}</strong></p>
          <button class="btn btn-info" type="button" id="extend-btn" (click)="handleContinueBtnClick()" i18n>Extend</button>
        }
        @if ($recognitionState().state === 'stopped') {
          <ul class="list-inline list-unstyled">
            <li><button class="btn btn-info" type="button" id="continue-btn" (click)="handleContinueBtnClick()" i18n>Continue Recording</button></li>
            <li><button class="btn btn-primary" type="button" id="apply-btn" (click)="handleApplyBtnClick()" i18n>Apply</button></li>
            <li><button class="btn btn-warning" type="button" id="discard-btn" (click)="handleDiscardBtnClick()" i18n>Discard</button></li>
          </ul>
        }
      </div>
    }
  </div>
}
`,
  'ang2/app/app.component.html': `<router-outlet></router-outlet>
`,
  'ang2/app/main.component.html': `<!-- Session problems (expired session, masquerade changed in another tab) are
     surfaced outside the bootstrap gate so they remain visible at all times. -->
<risr-session-banner></risr-session-banner>

@if (bootstraped()) {
    <!-- Skip navigation to main content -->
    <button type="button" class="btn kz-skip-navigation" (click)="skipToContent()" i18n>Skip to content</button>
    <main-template-directive>
        <router-outlet></router-outlet>
    </main-template-directive>

    <!-- Global AI assistant (gated by the "ai-assistant" feature flag — which
         superadmins bypass — and the user's aiassistant.use permission;
         renders only when a risrai backend URL is configured) -->
    @if (showAiAssistant()) {
        <risr-ai-assistant-host [context]="aiContext()"></risr-ai-assistant-host>
    }
}
`,
  'ang2/app/shared/forms/password-strength.component.html': `<div class="password-strength">
  <span i18n>Password strength: {{ strength }}</span>
  <div class="strength-meter">
    <div
      class="strength-bar"
      [ngClass]="{
        weak: strengthLevel === 'weak',
        moderate: strengthLevel === 'moderate',
        strong: strengthLevel === 'strong'
      }"
    ></div>
  </div>
  <ul class="password-requirements">
    <li [ngClass]="{ valid: criteria.hasMinLength }" i18n>At least 12 characters</li>
    <li [ngClass]="{ valid: criteria.hasLowercase }" i18n>At least one lowercase letter</li>
    <li [ngClass]="{ valid: criteria.hasUppercase }" i18n>At least one uppercase letter</li>
    <li [ngClass]="{ valid: criteria.hasNumber }" i18n>At least one number</li>
    <li [ngClass]="{ valid: criteria.hasSpecialChar }" i18n>At least one special character</li>
  </ul>
</div>
`,
  'ang2/app/system/account/credential/dialogs/create-local-credential-dialog.component.html': `<h2 mat-dialog-title i18n>Register Local Credential</h2>
<form [formGroup]="localForm">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label i18n>Username</mat-label>
      <input matInput formControlName="username" required>
      @if (localForm.get('username')?.hasError('required')) {
        <mat-error i18n>Username is required</mat-error>
      }
    </mat-form-field>

    <!-- Show passwordOptions only if isForRemoteUser is true -->
    @if (isForRemoteUser) {
      <mat-form-field appearance="outline" class="w-full">
        <mat-label i18n>Password Options</mat-label>
        <mat-select formControlName="passwordOptions">
          <mat-option value="customPassword" i18n>Set a password on behalf of the user</mat-option>
          <mat-option value="letTheUserChooseOne" i18n>Send an email and let the user set a password</mat-option>
        </mat-select>
      </mat-form-field>
    }

    <!-- Show password field based on the conditions defined in updatePasswordFieldVisibility() -->
    @if (!isForRemoteUser || localForm.get('passwordOptions')?.value === 'customPassword') {
      <div>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label i18n>Password</mat-label>
          <input matInput type="password" autocomplete="new-password" formControlName="password" required>
          @if (localForm.get('password')?.hasError('required')) {
            <mat-error i18n>
              Password is required
            </mat-error>
          }
        </mat-form-field>
        <p>
          <app-password-strength [control]="localForm.get('password')"></app-password-strength>
        </p>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label i18n>Re-type Password</mat-label>
          <input matInput type="password" formControlName="passwordConfirmation" required autocomplete="new-password" passwordrules="required: upper; required: lower; required: digit; required: [-().&@?'#,/&quot;+]" />
          @if (localForm.get('passwordConfirmation')?.hasError('required')) {
            <mat-error i18n>
              Re-type Password is required
            </mat-error>
          }
        </mat-form-field>
        @if (localForm.hasError('mismatch')) {
          <div i18n>
            Passwords do not match.
          </div>
        }
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" i18n>Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="localForm.invalid" (click)="onSubmit()" i18n>Submit</button>
  </mat-dialog-actions>
</form>
`,
  'ang2/app/system/account/credential/dialogs/create-proxy-credential-dialog.component.html': `<h2 mat-dialog-title i18n>Register SSO Credential</h2>
<form [formGroup]="proxyForm">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label i18n>Username</mat-label>
      <input matInput formControlName="username" required>
      @if (proxyForm['username']?.hasError('required')) {
        <mat-error i18n>Username is required</mat-error>
      }
    </mat-form-field>

    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()" i18n>Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="proxyForm.invalid" (click)="onSubmit()" i18n>Submit</button>
    </mat-dialog-actions>
  </mat-dialog-content>
</form>
`,
  'ang2/app/system/account/credential/dialogs/update-credential-password-dialog.component.html': `<h2 mat-dialog-title i18n>Change Password</h2>
<form [formGroup]="changePasswordForm">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label i18n>New Password</mat-label>
      <input matInput type="password" formControlName="newPassword" required autocomplete="new-password" passwordrules="required: upper; required: lower; required: digit; required: [-().&@?'#,/&quot;+]" />
      @if (changePasswordForm.get('newPassword')?.hasError('required')) {
        <mat-error i18n>
          Password is required
        </mat-error>
      }
    </mat-form-field>
    <p>
      <app-password-strength
      [control]="changePasswordForm.get('newPassword')!"></app-password-strength>
    </p>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label i18n>Re-type New Password</mat-label>
      <input matInput type="password" formControlName="passwordConfirmation" required autocomplete="new-password" />
      @if (changePasswordForm.get('passwordConfirmation')?.hasError('required')) {
        <mat-error i18n>
          Re-type New Password is required
        </mat-error>
      }
    </mat-form-field>
    @if (changePasswordForm.hasError('mismatch')) {
      <mat-error i18n>
        Passwords do not match.
      </mat-error>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <ul class="list-inline list-unstyled">
      <li>
        <button class="btn btn-primary" type="submit" [disabled]="changePasswordForm.invalid"
          (click)="onSubmit()" i18n>Change
        </button>
      </li>
      <li>
        <button class="btn btn-warning btn-outline" (click)="onCancel()" i18n>Cancel</button>
      </li>
    </ul>
  </mat-dialog-actions>
</form>
`,
  'ang2/app/system/account/credential/dialogs/update-credential-username-dialog.component.html': `<h2 mat-dialog-title>{{dialogTitle}}</h2>
<form [formGroup]="editUsernameForm">
  <mat-dialog-content>
    @if (orgHasintegration) {
      <mat-form-field appearance="outline" class="w-full">
        <mat-label i18n>Would you like to also edit this account in your CRM?</mat-label>
        <input type="checkbox" matInput formControlName="useIntegration" required>
      </mat-form-field>
    }
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ label }}</mat-label>
      <input matInput formControlName="newUsername" required autocomplete="username" />
      @if (editUsernameForm.get('newUsername')?.hasError('required')) {
        <mat-error i18n>Username is required</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <ul class="list-inline list-unstyled">
      <li>
        <button class="btn btn-primary" type="submit" [disabled]="editUsernameForm.invalid" (click)="onSubmit()" i18n>Change</button>
      </li>
      <li>
        <button class="btn btn-warning btn-outline" (click)="onCancel()" i18n>Cancel</button>
      </li>
    </ul>
  </mat-dialog-actions>
</form>
`,
  'ang2/app/system/account/credential/list-credentials.component.html': `<section class="wrapper">
  <header class="row">
    <h1 i18n>Account security</h1>
  </header>

  <div class="row">
    <div class="col-xs-12">
      <mat-tab-group>
        <mat-tab label="Login credentials" i18n-label>
          <p i18n>This is how you currently login to risr/advance. Make sure you can always access your
          account by keeping this information up to date.</p>

          @for (loginCredential of loginCredentials(); track loginCredential) {
            <div class="row row-bordered">
              <div class="col-xs-4">
                <div class="label label-info">{{ readableName[loginCredential.type] }}</div>
                <div><strong>{{ loginCredential.username }}</strong></div>
                @if (loginCredential.passwordNotSet) {
                  <div class="label label-warning" i18n>
                    A welcome email will be sent to guide the user through the setup process
                  </div>
                }
              </div>
              <div class="col-xs-8 text-right">
                <ul class="list-inline list-unstyled">
                  @if (canAccessTwoFactorAuth(loginCredential.type)) {
                    <li>
                      @if (isForRemoteUser()) {
                        <a class="btn btn-sm btn-success" [routerLink]="['./', loginCredential.username, 'mfas']"
                          [attr.aria-label]="twoFactorAuthLabel(loginCredential.username)" i18n>Two
                        factor authentication</a>
                      } @else {
                        <a class="btn btn-sm btn-success" [routerLink]="['./', loginCredential.username, 'mfas']"
                          [attr.aria-label]="twoFactorAuthLabel(loginCredential.username)" i18n>Two factor
                        authentication</a>
                      }
                    </li>
                  }
                  @if (canUpdateUsername(loginCredential.type)) {
                    <li>
                      <button class="btn btn-sm btn-success" (click)="updateUsername(loginCredential)" [attr.aria-label]="editUsernameLabel(loginCredential.username)" i18n>
                        Edit username
                      </button>
                    </li>
                  }
                  @if (canUpdateSSOID(loginCredential.type)) {
                    <li>
                      <button class="btn btn-sm btn-success" (click)="updateUsername(loginCredential)" [attr.aria-label]="editSSOIDLabel(loginCredential.username)" i18n>
                        Edit SSO ID
                      </button>
                    </li>
                  }
                  @if (canSendPasswordEmail(loginCredential.type)) {
                    <li>
                      <button class="btn btn-sm btn-success"
                        (click)="sendPasswordEmail(loginCredential)" [attr.aria-label]="sendPasswordEmailLabel(loginCredential.username)" i18n>Send password reset email
                      </button>
                    </li>
                  }
                  @if (canUpdatePassword(loginCredential.type)) {
                    <li>
                      <button class="btn btn-sm btn-success" (click)="updatePassword(loginCredential)" [attr.aria-label]="changePasswordLabel(loginCredential.username)" i18n>
                        Change password
                      </button>
                    </li>
                  }
                  @if (canDelete()) {
                    <li>
                      <button class="btn btn-sm btn-danger" (click)="deleteCredential(loginCredential)" [attr.aria-label]="removeLabel(loginCredential.username)" i18n>
                        Remove
                      </button>
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
          <ul class="mt-4 list-inline list-unstyled">
            @for (type of allowedAccountTypes; track type) {
              <li>
                @if (canCreateCredential(type)) {
                  <button class="btn btn-primary" (click)="addLoginCredential(type)"
                    >Add {{ readableName[type] }} Credential
                  </button>
                }
              </li>
            }
          </ul>
        </mat-tab>

        @if (canAccessAPIKeys()) {
          <mat-tab label="API keys" i18n-label>
            @if (newlyCreatedAPICredential()) {
              <div class="box box-warning">
                <p i18n>
                  <i class="icon-warning"></i><strong>Warning!</strong> Make sure you copy the API
                  credentials below. You won't be able to see them again!
                </p>
              </div>
            }
            @if (newlyCreatedAPICredential()) {
              <div class="box box-info row">
                <div class="col-xs-8">
                  <ul>
                    <li>public_key: {{ newlyCreatedAPICredential()?.public_key }}</li>
                    <li>secret_key: {{ newlyCreatedAPICredential()?.secret_key }}</li>
                  </ul>
                </div>
                <div class="col-xs-4 text-right">
                  <button class="btn btn-info copy-btn" (click)="copyToClipboard()" aria-label="Copy keys" i18n>Copy</button>
                </div>
              </div>
            }
            @for (apiCredential of apiCredentials(); track apiCredential) {
              <div class="row row-bordered">
                <div class="col-xs-8">
                  <div class="label label-info">{{ readableName[apiCredential.type] }}</div>
                  <div><strong>{{ apiCredential.public_key }}</strong></div>
                </div>
                <div class="col-xs-4 text-right">
                  <button class="btn btn-sm btn-danger" (click)="deleteCredential(apiCredential)" [attr.aria-label]="removeLabel(apiCredential.public_key)" i18n>
                    Remove
                  </button>
                </div>
              </div>
            }
            <div class="add-credential">
              <p>
                @if (canCreateCredential(CredentialTypes.API)) {
                  <button class="btn btn-primary" (click)="createApiCredential()" i18n
                    >Add API credential
                  </button>
                }
              </p>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
</section>
`,
  'ang2/app/system/account/credential/pre-register-api-credential.component.html': `<section class="wrapper">
  <header class="row">
    <h1 i18n>Register new REST API client</h1>
  </header>

  <div class="row">
    <div class="col-xs-12">
      <span i18n>Here we will register a new REST API client.</span>

      <form (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="accountSearch" i18n>User associated with the API requests:</label>
          <mat-form-field>
            <input
              matInput
              [formControl]="userSearchControl"
              [matAutocomplete]="auto"
              placeholder="Search for user profiles"
              i18n-placeholder>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUser" (optionSelected)="onUserSelected($event.option.value)">
              @for (userProfile of filteredUsers$ | async; track userProfile) {
                <mat-option [value]="userProfile">
                  {{ userProfile.firstName }} {{ userProfile.lastName }} ({{ userProfile.email }})
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <button type="submit" class="btn btn-primary" i18n>Proceed</button>
      </form>
    </div>
  </div>
</section>
`,
  'ang2/app/system/account/mfa/create-mfa-dialog.component.html': `<h2 mat-dialog-title i18n>Setup new two-factor authentication method</h2>
<mat-dialog-content>
  @switch (currentStep) {
    <!-- Step 1: Method Selection -->
    @case ('selectMethod') {
      <div>
        <p class="" i18n>Choose an authentication method:</p>
        <ul class="list-unstyled">
          @for (method of availableMethods; track method) {
            <li>
              <button class="btn btn-outline btn-lg btn-block" [class]="{'btn-primary': method.secure, 'btn-warning': !method.secure}" (click)="selectMethod(method.id)">
                {{ method.name }}
                @if (method.secure) { <span class="text-sm" i18n>(Recommended)</span> }
              </button>
            </li>
          }
        </ul>
      </div>
    }
    <!-- Step 2: Verification -->
    @case ('completeRegistration') {
      <div>
        @switch (selectedMethod) {
          <!-- Email OTP -->
          @case (MFAMethodsEnum.EMAIL_OTP) {
            <div>
              <p class="text-lg"><strong i18n>Configure email as your two-factor authentication method</strong></p>
              <form [formGroup]="otpForm">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label i18n>Enter code from your email</mat-label>
                  <input matInput formControlName="code" required />
                </mat-form-field>
              </form>
              <p>{{ errorMessage }}</p>
            </div>
          }
          <!-- TOTP -->
          @case (MFAMethodsEnum.TOTP) {
            <div>
              <p class="text-lg"><strong i18n>Configure your Authenticator App</strong></p>
              @if (qrCodeDataUrl) {
                <div>
                  <p i18n>Scan the QR code with your authenticator app:</p>
                  <img [src]="qrCodeDataUrl" alt="TOTP QR Code" i18n-alt />
                </div>
              }
              @if (secretKey) {
                <p class="box box-info flex justify-between items-center">
                  <span>{{ secretKey }}</span>
                  <button class="btn btn-sm btn-info" type="button" (click)="copyToClipboard()" i18n>Copy</button>
                </p>
              }
              <form [formGroup]="totpForm">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label i18n>Enter code from authenticator app</mat-label>
                  <input matInput formControlName="code" required />
                </mat-form-field>
              </form>
              @if (errorMessage.length > 0) {
                <p role="status" class="box box-danger">{{ errorMessage }}</p>
              }
            </div>
          }
        }
      </div>
    }
  }
</mat-dialog-content>

<!-- Footer Actions -->
<mat-dialog-actions align="end">
  <ul class="list-inline list-unstyled">
    <li>@if (currentStep === 'completeRegistration' && !isPreselectedMethod) {
      <button class="btn btn-info btn-outline" (click)="goBack()" i18n>Back</button>
    }</li>
    <li><button class="btn btn-warning btn-outline" mat-dialog-close (click)="closeDialog()" i18n>Cancel</button></li>
    <li>@if (currentStep === 'completeRegistration') {
      <button
        class="btn btn-primary"
        [disabled]="isCompleteRegistrationDisabled()"
        (click)="completeRegistration()"
        i18n>
        Verify and complete registration
      </button>
    }</li>
  </ul>
</mat-dialog-actions>
`,
  'ang2/app/system/account/mfa/list-mfas.component.html': `<section class="wrapper">
  <header class="row">
    <div class="col-xs-9">
      <h1 i18n>Two Factor Authentications</h1>
      <p class="text-gray"><span i18n>Username:</span> <span class="text-success">{{credentialUsername()}}</span></p>
    </div>
    <div class="col-xs-3 text-right">
      <button class="btn border border-primary text-primary" (click)="goBack()">
        <i class="icon-left-open-big"></i>
        <span i18n>Back</span>
      </button>
    </div>
  </header>

  <div class="row">
    <div class="col-xs-12">
      <p class="box box-warning" i18n>
        Your organisation has enforced two factor authentication on your account. You cannot turn it off, but you can add or change your second steps.
      </p>

      @for (mfa of mfas(); track mfa) {
        <div class="row row-bordered">
          <div class="col-xs-8">
            <p>{{ readableName[mfa.type] }}</p>
            <div class="text-gray" i18n>Registered on {{ mfa.createdAt | date:'medium' }}</div>
          </div>
          <div class="col-xs-4 text-right">
            <ul class="list-inline list-unstyled">
              <li>@if (canReplaceMFA(mfa)) {
                <button class="btn btn-sm btn-primary" (click)="createMFA(mfa.type)" [attr.aria-label]="replaceLabel(mfa.type)" i18n>Replace</button>
              }</li>
              <li>@if (canDelete()) {
                <button class="btn btn-sm btn-danger" (click)="deleteMFA(mfa.id)" [attr.aria-label]="removeLabel(mfa.type)" i18n>Remove</button>
              }</li>
            </ul>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      @if (canAdd()) {
        <button class="btn btn-primary add-credential" (click)="createMFA()">
          <i class="icon-plus"></i>
          <span i18n>Setup two factor authentication</span>
        </button>
      }
    </div>
  </div>

</section>
`,
  'ang2/app/upgrade-required.component.html': `<div class="row" style="margin-top: 50px" data-ng-show="ctrl.show">
    <div class="col-xs-12 col-sm-6 col-sm-offset-3">
      <div class="wrapper">
        <div class="row">
          <h3 i18n>Upgrade required</h3>
        </div>

        <div class="row">
          <p i18n>
            risr/advance has been updated and needs to be reloaded. This will happen automatically within 15 seconds.
          </p>
          <p i18n>Alternatively you can reload manually by clicking the button below.</p>

        </div>
        <div class="row">
          <div class="col-sm-6">
            <p><button type="button" class="btn btn-info" (click)="reload()" i18n>Reload</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
`,
  'ang2/index.html': `<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <title>risr/advance</title>
  <base href="/">
  <meta name="viewport" content="width=device-width, initial-scale=1">

  <link rel="icon" href="/assets/images/favicon.ico" sizes="any">
  <link rel="icon" href="/assets/images/icon.svg" type="image/svg+xml">
  <link rel="apple-touch-icon" href="/assets/images/apple-touch-icon.png">
  <link rel="manifest" href="/manifest.webmanifest">
  <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">

  <!--
    Critical, inline boot styles. These intentionally duplicate a small subset of
    the bundled stylesheet (src/assets/styles/modules/animation.css) so the loading
    indicator is painted instantly, before the large styles.css bundle downloads.
    Inline <style> is CSP-compliant (the policy only restricts scripts).
  -->
  <style>
    #app-loader {
      position: fixed;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      z-index: 2147483646;
      opacity: 1;
      transition: opacity 0.35s ease;
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
      color: #1f2937;
    }
    #app-loader.app-loader--hide {
      opacity: 0;
      pointer-events: none;
    }
    #app-loader .app-loader__inner {
      width: 100%;
      max-width: 760px;
      padding: 24px;
      text-align: center;
    }
    #app-loader h1 {
      font-size: 1.25rem;
      font-weight: 500;
      margin: 1.5rem 0 0.5rem;
    }
    #app-loader #msg-for-impatient {
      color: #6b7280;
      font-size: 0.95rem;
    }
    #app-loader #unregister-btn {
      background: none;
      border: none;
      color: #318fb5;
      text-decoration: underline;
      cursor: pointer;
      font: inherit;
      padding: 0;
    }
    .pinwheel-loading__container {
      --pw-size: 3.125rem;
      --pw-color: #1f5b73;
      --pw-line-weight: 4px;
      --pw-speed: 1s;
      align-items: center;
      display: flex;
      height: var(--pw-size);
      justify-content: center;
      margin: 0 auto;
      position: relative;
      width: var(--pw-size);
    }
    .pinwheel-loading__line {
      animation: rotate var(--pw-speed) ease-in-out infinite;
      background-color: var(--pw-color);
      border-radius: calc(var(--pw-line-weight) / 2);
      height: var(--pw-line-weight);
      left: 0;
      position: absolute;
      top: calc(50% - var(--pw-line-weight) / 2);
      width: 100%;
    }
    .pinwheel-loading__line:nth-child(2) { animation-delay: calc(var(--pw-speed) * 0.075); opacity: 0.8; }
    .pinwheel-loading__line:nth-child(3) { animation-delay: calc(var(--pw-speed) * 0.15); opacity: 0.6; }
    .pinwheel-loading__line:nth-child(4) { animation-delay: calc(var(--pw-speed) * 0.225); opacity: 0.4; }
    .pinwheel-loading__line:nth-child(5) { animation-delay: calc(var(--pw-speed) * 0.3); opacity: 0.2; }
    .pinwheel-loading__line:nth-child(6) { animation-delay: calc(var(--pw-speed) * 0.375); opacity: 0.1; }
    @keyframes rotate {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(180deg); }
    }
    @media screen and (prefers-reduced-motion: reduce) {
      .pinwheel-loading__line { animation: none; }
      #app-loader { transition: none; }
    }
  </style>
</head>
<body>
  <app-root></app-root>

  <!--
    Boot overlay. Kept as a SIBLING of <app-root> (not a child) so Angular's
    bootstrap does not wipe it. It stays on screen continuously from first paint
    until the application shell (#header-menu) or routed content renders, then
    the injected, content-hashed app-init bundle fades it out. On a fatal boot
    error it shows the error panel.
  -->
  <div id="app-loader">
    <main class="app-loader__inner">
      <div class="row">
        <div class="col-xs-12 text-center">
          <span aria-hidden="true" class="pinwheel-loading__container">
            <span class="pinwheel-loading__line"></span>
            <span class="pinwheel-loading__line"></span>
            <span class="pinwheel-loading__line"></span>
            <span class="pinwheel-loading__line"></span>
            <span class="pinwheel-loading__line"></span>
            <span class="pinwheel-loading__line"></span>
          </span>
          <div id="inner-content">
            <h1 class="text-xl font-medium">risr/advance is loading ...</h1>
            <p id="msg-for-impatient" style="visibility: hidden">
              This looks like something may have gone wrong, click to <button type="button" id="unregister-btn">Reload the application</button>
            </p>
          </div>
          <!-- Error Display Container (hidden by default) -->
          <div id="error-container" style="display: none; max-width: 700px; margin: 0 auto; text-align: center;">
            <!-- Error icon and main message -->
            <div style="margin-bottom: 30px;">
              <h2 style="color: #dc2626; font-size: 24px; font-weight: 600; margin: 0 0 10px 0;">Something went wrong</h2>
              <p style="color: #6b7280; font-size: 16px; margin: 0;">The application encountered an unexpected error and could not continue.</p>
            </div>

            <!-- Action buttons -->
            <div style="margin-bottom: 30px;">
              <button id="reload-btn" style="background-color: #3b82f6; color: white; border: none; padding: 12px 24px; font-size: 16px; font-weight: 500; border-radius: 8px; cursor: pointer; margin: 0 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">🔄 Refresh Page</button>
              <button id="copy-btn" style="background-color: #3b82f6; color: white; border: none; padding: 12px 24px; font-size: 16px; font-weight: 500; border-radius: 8px; cursor: pointer; margin: 0 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">📋 Copy Error Details</button>
            </div>

            <!-- Error details box (collapsible) -->
            <details style="text-align: left; background: #fef2f2; border: 2px solid #fecaca; border-radius: 8px; padding: 20px; margin-top: 20px;">
              <summary style="cursor: pointer; font-weight: 600; color: #991b1b; margin-bottom: 15px; user-select: none;">Technical Details (click to expand)</summary>
              <div style="background: white; border-radius: 6px; padding: 15px; margin-top: 10px;">
                <div style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #e5e7eb;">
                  <p style="margin: 5px 0; color: #374151;"><strong>Error Message:</strong></p>
                  <p id="error-message" style="margin: 5px 0; color: #dc2626; font-family: monospace; font-size: 14px; word-break: break-word;"></p>
                </div>

                <div id="error-location" style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #e5e7eb; display: none;">
                  <p style="margin: 5px 0; color: #374151;"><strong>Location:</strong></p>
                  <p id="error-source" style="margin: 5px 0; color: #6b7280; font-size: 13px; font-family: monospace; word-break: break-all;"></p>
                  <p id="error-linecol" style="margin: 5px 0; color: #6b7280; font-size: 13px;"></p>
                </div>

                <div style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #e5e7eb;">
                  <p style="margin: 5px 0; color: #374151;"><strong>Timestamp:</strong></p>
                  <p id="error-timestamp" style="margin: 5px 0; color: #6b7280; font-size: 13px; font-family: monospace;"></p>
                </div>

                <div id="error-stack-container" style="margin-bottom: 15px; display: none;">
                  <p style="margin: 5px 0 10px 0; color: #374151;"><strong>Stack Trace:</strong></p>
                  <pre id="error-stack" style="background: #f9fafb; padding: 12px; border-radius: 4px; overflow-x: auto; font-size: 12px; line-height: 1.5; color: #1f2937; margin: 0; white-space: pre-wrap; word-wrap: break-word;"></pre>
                </div>

                <div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #e5e7eb;">
                  <p style="margin: 5px 0; color: #6b7280; font-size: 12px;"><strong>Browser:</strong> <span id="error-useragent"></span></p>
                  <p style="margin: 5px 0; color: #6b7280; font-size: 12px;"><strong>URL:</strong> <span id="error-url"></span></p>
                </div>
              </div>
            </details>

            <!-- Help text -->
            <div style="margin-top: 30px; padding: 20px; background: #f3f4f6; border-radius: 8px; text-align: left;">
              <p style="margin: 0 0 10px 0; color: #374151; font-weight: 600;">💡 What can you do?</p>
              <ul style="margin: 0; padding-left: 20px; color: #6b7280; line-height: 1.8;">
                <li>Try refreshing the page using the button above</li>
                <li>If the problem persists, copy the error details and report it to support</li>
                <li>Clear your browser cache and try again</li>
                <li>Try accessing the application in a different browser</li>
              </ul>
            </div>

            <!-- Hidden element for copying -->
            <pre id="error-full-details" style="display: none;"></pre>
          </div>
        </div>
      </div>
    </main>
  </div>
  <!-- The app-init bundle is injected here automatically by the Angular build
       (configured in angular.json "scripts"). It is content-hashed so a new
       deploy is never served from a stale browser/CDN cache. -->
</body>
</html>
`,
  'app/blocks/auth/logo.html': `<p class="navbar-logo">
  <span class="sr-only">My risr/advance</span>
  <img data-ng-src="{{imgSrc}}" alt="{{imgAlt}}" />
  <img src="assets/images/main-logo-append.png" alt="risr/advance" class="hidden-xs" />
</p>
`,
  'app/blocks/image/image.html': `<img ng-src="{{imageCtrl.image.src}}" class="kz-image" data-image-layout="{{ imageCtrl.image.layout }}" alt="{{ imageCtrl.image.alt }}" decoding="async" />
`,
  'app/blocks/image/picture.html': `<picture>
  <source
    ng-repeat="format in imageCtrl.formats"
    type="image/{{format}}"
    sizes="100vw"
    ng-srcset="{{imageCtrl.image.sources[format]}}"
  />
  <img
    alt="{{imageCtrl.image.alt}}"
    ng-src="{{imageCtrl.image.src}}"
    sizes="100vw"
    class="kz-image"
    data-image-layout="{{imageCtrl.image.layout}}"
    decoding="async"
  />
</picture>
`,
  'app/blocks/list/dotbuttons.html': `<div class="dotbuttons">
  <div data-ng-if="shouldShowButtons">
    <span class="featured-icons">
      <span class="dropdown-item" data-ng-repeat="action in featuredActionButtons track by $index" kz-single-button action="action" klass="action-button">
      </span>
    </span>

    <a href="" data-target="#" ng-if="actionButtons.length" class="dropdown-toggle" data-toggle="dropdown" aria-label="{{ 'Show more actions' | translate }}">
      <i class="icon-menu-dots"></i>
    </a>

    <ul class="dropdown-menu">
      <li class="dropdown-item" data-ng-repeat="action in actionButtons track by $index" kz-single-button action="action" klass="action-button">
      </li>
      <li class="dropdown-item" data-ng-repeat="action in secondaryActionButtons track by $index" kz-single-button action="action" klass="action-button">
      </li>
    </ul>
  </div>
  <div data-ng-if="!shouldShowButtons" class="row dotbuttons">
    <span class="featured-icons">
      <span class="dropdown-item" data-ng-repeat="action in featuredActionButtons track by $index" kz-single-button action="action" klass="action-button">
      </span>
    </span>

    <a href="" aria-label="Show more actions" ng-if="actionButtons.length && useContextualMenu" class="hidden-md hidden-lg text-info" kz-contextual-menu toggle="{{'#' + containerId}}">
      <i class="icon-menu-dots"></i>
    </a>

    <div ng-attr-id="{{containerId}}" class="col-xs-12" ng-class="{'contextual-action-buttons': useContextualMenu}">
      <div class="row">
        <div class="{{ 'col-xs-12 col-sm-' + leftSize }}" kz-loading loaded="loaded">
          <ul class="list-inline list-unstyled">
            <li data-ng-repeat="action in actionButtons track by $index" kz-single-button action="action" klass="action-button">
            </li>
          </ul>
        </div>
        <div class="{{ 'col-xs-12 col-sm-' + (12 - leftSize) }}" data-ng-if="secondaryActionButtons">
          <ul class="list-inline list-unstyled">
            <li data-ng-repeat="action in secondaryActionButtons track by $index" kz-single-button action="action" klass="action-button">
            </li>
          </ul>
        </div>
        <div class="{{ 'col-xs-12 col-sm-' + (12 - leftSize) }}" data-ng-if="version">
            <version-actions version="version" post-action="options.loadList()"></version-actions>
        </div>
      </div>
    </div>
  </div>
</div>
`,
  'app/blocks/list/list.pagination.html': `<div class="kz-pagination row">

  <div class="col-xs-4 text-left">
    <ul>
      <li ng-if="currentPage > 2">
        <a href="" ng-click="goToPage(0)" aria-label="Go to the first page"><i class="icon-arrow-double-left"></i></a>
      </li>
      <li ng-if="currentPage > 1">
        <a href="" ng-click="goToPage(currentPage - 2)" aria-label="Go to the previous page"><i class="icon-arrow-left"></i></a>
      </li>
    </ul>
  </div>

  <div class="col-xs-4 text-center">
    <ul>
      <li class="text-sm" ng-if="startAt !== endAt">
        <strong>{{ startAt }}</strong> - <strong>{{ endAt }}</strong> of <strong>{{ totalItems }}</strong>
      </li>
      <li class="text-sm" ng-if="startAt === endAt">
        <strong>{{ startAt }}</strong> of <strong>{{ totalItems }}</strong>
      </li>
    </ul>
  </div>

  <div class="col-xs-4 text-right">
    <ul>
      <li ng-if="currentPage < totalPages">
        <a href="" ng-click="goToPage(currentPage)" aria-label="Go to the next page"><i class="icon-arrow-right"></i></a>
      </li>
      <li ng-if="totalPages > 3 && currentPage < totalPages - 1">
        <a href="" ng-click="goToPage(totalPages - 1)" aria-label="Go to the last page"><i class="icon-arrow-double-right"></i></a>
      </li>
    </ul>
  </div>

</div>
`,
  'app/blocks/list/list.slot.html': `  <div class="col-xs-12" >
    <div class="row event-inner" kz-reload obj="item">
      <div class="col-sm-7">
        <h2>{{ ::item.doc.name || item.doc.title}}</h2>
        <div class="text-gray">{{ ::item.doc.description }}</div>
      </div>

      <div class="col-sm-5 col-right" style="padding: 15px;">
        <kz-state map="options.stateMapping" state="item | kzGetDotted: options.stateField"></kz-state>
      </div>
    </div>

    <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons"></kz-list-buttons>
  </div>
`,
  'app/blocks/list/listbuttons.html': `<div class="row buttons">
  <a href="" aria-label="Show more actions" ng-if="(actionButtons.length || secondaryActionButtons.length) && useContextualMenu" class="hidden-md hidden-lg text-info" kz-contextual-menu toggle="{{'#' + containerId}}">
    <i class="icon-menu-dots"></i> {{ 'Actions' | translate }}
  </a>

  <div ng-attr-id="{{containerId}}" class="col-xs-12" ng-class="{'contextual-action-buttons': useContextualMenu}">
    <div class="row">
      <div class="{{ 'col-xs-12 col-sm-' + leftSize }}" kz-loading loaded="loaded">
        <ul class="list-inline list-unstyled">
          <li data-ng-repeat="action in actionButtons track by $index" kz-single-button action="action" klass="action-button">
          </li>
        </ul>
      </div>
      <div class="{{ 'col-xs-12 col-sm-' + (12 - leftSize) }}" data-ng-if="secondaryActionButtons">
        <ul class="list-inline list-unstyled text-right-sm">
          <li data-ng-repeat="action in secondaryActionButtons track by $index" kz-single-button action="action" klass="action-button">
          </li>
        </ul>
      </div>
      <div class="{{ 'col-xs-12 col-sm-' + (12 - leftSize) }}" data-ng-if="version">
          <version-actions version="version" post-action="options.loadList()"></version-actions>
      </div>
    </div>
  </div>
</div>
`,
  'app/blocks/list/listview.html': `<div>
  <div ng-if="!list.hideList">
    <div data-ng-if="list.items.length || list.showFilters" data-infinite-scroll="list.doPaginate()"
    infinite-scroll-disabled='list.isLoading || list.finished || list.options.pagination === "links"'
    infinite-scroll-use-document-bottom="false">
      <div class="event-group" data-ng-repeat="item in list.items track by item | kzGetDotted:options.trackBy">
        <div
          data-ng-if="list.search.orderGroups[list.orderedBy()].groupBy.getter && !options.hideHeaderGroup"
          data-kz-group-title
          data-group-item="item"
          data-group-by="list.search.orderGroups[list.orderedBy()].groupBy"
          data-prev-item="list.items[$index - 1]"
          data-next-item="list.items[$index + 1]"
          data-template-url="{{ list.search.orderGroups[list.orderedBy()].groupBy.templateUrl }}"></div>

        <div class="wrapper">
          <div class="row event progress-border" kz-reload obj="item" data-ng-class="getBorderClass(item)">
            <div kz-inject></div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!--the content placeholders-->
  <div data-ng-show="list.isLoading || !list.ready" data-ng-include="'app/layout/placeholders/list.html'"></div>
  <!--end placeholders-->

  <div class="row" data-ng-if="list.ready && list.finished && list.items.length > 0 && !options.hideEndOfListText">
    <div>
      <p class="text-gray-700 text-center">{{ 'You have reached the end of the list.' | translate }}</p>
    </div>
  </div>

  <div role="status">
    <div kz-loading loaded="list.ready" class="row">
      <div data-ng-if="!list.isLoading && !list.items.length">
        <p class="text-warning text-center"><i class="icon-warning">
          </i>
          <span data-ng-if="list.searchModel.filteredBy | kzIsEmpty:'deep'">
            {{ options.noItemsText ? (options.noItemsText) : ('There are no items available' | translate) }}
          </span>
          <span data-ng-if="!(list.searchModel.filteredBy | kzIsEmpty:'deep')">
            {{ options.noItemsFound ? (options.noItemsFound) : ('There are no items available' | translate) }}
            {{ 'for' | translate }} <span kz-search-applied></span>
          </span>
        </p>
      </div>
    </div>
  </div>

    <div class="col-sm-12" data-ng-if="list.options.pagination === 'links'">
      <kz-pagination
        ng-if="list.ready && !list.isLoading && list.items.length"
        total="list.found_count"
        startkey="list.startkey"
        per-page="list.findOptions.limit"
        to="goToPage(page)">
      </kz-pagination>
    </div>
</div>
`,
  'app/blocks/network/login.popup.html': `<div class="modal-header">
  <button type="button" class="close" data-ng-click="ctrl.dismiss()" aria-label="Close"><i class="icon-cancel"></i></button>
  <div class="modal-title">
    <h3>
      Authenticate
    </h3>
  </div>
</div>

<div class="modal-body event-modal-body">
  <kz-login-form organisation="ctrl.organisation"
    options="{ compact: true, newTab: true, force: true, forceCurrentUser: true }"
    success="ctrl.success()"></kz-login-form>
</div>
`,
  'app/blocks/network/network.link.html': `<div>
  <div uib-dropdown auto-close="outsideClick">
    <!-- FIXME: a11y -->
    <a href="" uib-dropdown-toggle>
      <i class="icon-bell icon-md"></i>
      <span class="caret"></span>
    </a>
    <ul uib-dropdown-menu class="dropdown-menu">
      <li><kz-net-status></kz-net-status></li>
    </ul>
  </div>
</div>
`,
  'app/blocks/network/network.status.html': `<ul class="list-unstyled">
  <li data-ng-if="ctrl.info.mode">
    <p class="col-xs-8 text-gray">
      <span
        class="label-color-dot label-color-dot-sm"
        ng-class="{'label-success-dot': ctrl.info.mode.status === 'online', 'label-warning-dot': ctrl.info.mode.status === 'offline'}">
      </span>
      <span data-ng-if="ctrl.info.mode.status === ctrl.info.network.status">
        {{ 'You are currently' | translate }} <span class="{{ ctrl.info.mode.class }}">{{ ctrl.info.mode.translatedStatus }}</span>
      </span>
      <span data-ng-if="ctrl.info.mode.status !== ctrl.info.network.status">
        {{ 'You are working in' | translate }} <span class="{{ ctrl.info.mode.class }}">{{ ctrl.info.mode.translatedStatus }}</span> {{ 'mode but appear to have a network connection' | translate }}
      </span>
      <br />
      <a data-ng-if="ctrl.info.mode && ctrl.info.mode.status === 'online' && ctrl.info.storageMode !== 'none'"
        href="" style="padding-left: 2em" data-ng-click="ctrl.setModeOffline();$event.stopPropagation();">{{ 'Work in offline mode' | translate }}</a>
      <a data-ng-if="ctrl.info.mode && ctrl.info.mode.status === 'offline' && ctrl.info.network.status === 'online' && ctrl.info.authError.status !== 401"
        href="" style="padding-left: 2em" data-ng-click="ctrl.setModeOnline();$event.stopPropagation();">{{ 'Try to connect' | translate }}</a>
    </p>
    <p class="col-xs-4 text-right">
      <a href="" class="btn btn-xs border border-primary text-primary" router-link="['/settings/offline']">Settings</a>
    </p>
  </li>

  <li data-ng-if="ctrl.info.offlineCapability.state && ctrl.info.offlineCapability.state !== 'success'">
    <p class="col-xs-8">
      <span class="{{ ctrl.info.offlineCapability.state | kzStateClass }}">
        <i class="icon-warning {{ ctrl.info.offlineCapability.state | kzStateClass }}"></i>
        {{ ctrl.info.offlineCapability.message }}
      </span>
    </p>
    <p class="col-xs-4 text-right">
      <a class="btn btn-xs border border-primary text-primary" router-link="['/settings/test']">{{ 'Diagnose' | translate }}</a>
    </p>
  </li>
  <li data-ng-if="ctrl.info.toSync > 0">
    <p class="col-xs-8 text-gray">
      <span data-ng-if="ctrl.info.toSync === 0"><i class="icon-ok text-success"></i>{{ 'Up to date' | translate }}</span>
      <span data-ng-if="ctrl.info.toSync > 0 && !ctrl.info.error.warn">
        <i class="icon-reload text-warning"></i>
        <ng-pluralize
          count="ctrl.info.toSync"
          when="{'0': 'no items',
                 '1': '1 item',
                 'other': '{} items'}"></ng-pluralize> {{ 'waiting to sync' | translate }}
      </span>
      <span data-ng-if="ctrl.info.toSync > 0 && ctrl.info.error.warn">
        <i class="icon-reload text-danger"></i>
        <ng-pluralize
          count="ctrl.info.toSync"
          when="{'0': 'no items',
                 '1': '1 item',
                 'other': '{} items'}"></ng-pluralize> {{ 'failed to sync' | translate }}
      </span>
    </p>
    <p class="col-xs-4 text-right">
      <a data-ng-if="!ctrl.info.error" href="" class="btn btn-xs border border-primary" router-link="['/settings/review']">{{ 'View' | translate }}</a>
      <a data-ng-if="ctrl.info.error" href="" class="btn btn-xs border border-danger" router-link="['/settings/review']">{{ 'Review' | translate }}</a>
    </p>
  </li>
  <li data-ng-if="ctrl.info.toSyncOthers > 0">
    <p class="col-xs-8 text-gray">
      <span data-ng-if="ctrl.info.toSyncOthers > 0">
        <i class="icon-reload text-warning"></i>
        <ng-pluralize
          count="ctrl.info.toSyncOthers"
          when="{'0': 'no items',
                 '1': '1 item',
                 'other': '{} items'}"></ng-pluralize>
        to sync in other organisations</span>
    </p>
    <p class="col-xs-4 text-right">
      <a class="btn btn-xs border border-primary" router-link="['/org-chooser']">{{ 'Change' | translate }}</a>
    </p>
  </li>
  <li data-ng-if="ctrl.info.error && ctrl.info.error.status === 401">
    <div class="col-xs-8 text-gray">
      <div class="box box-danger">{{ ctrl.info.error.message }}</div>
    </div>
    <p class="col-xs-4 text-right">
      <a href="" class="btn btn-xs border border-primary" data-ng-if="ctrl.info.error.status === 401" data-ng-click="ctrl.relogin()">{{ 'Login' | translate }}</a>
      <a href="" class="btn btn-xs border border-primary" data-ng-if="ctrl.info.error.status !== 401" router-link="['/settings/review']">View</a>
    </p>
  </li>
  <li data-ng-if="ctrl.info.authError && ctrl.info.authError.status === 401">
    <div class="col-xs-8 text-gray">
      <div class="box box-danger">{{ ctrl.info.authError.message }}</div>
    </div>
    <p class="col-xs-4 text-right">
      <a href="" class="btn btn-xs border border-primary" data-ng-if="ctrl.info.authError.status === 401" data-ng-click="ctrl.relogin()">{{ 'Login' | translate }}</a>
    </p>
  </li>

  <!--
  <li>{{ offlineState }}</li>
  <li class="{{ networkClass }}">Current connectivity: {{ networkStatus }}</li>
  <li>Local storage mode: {{ mode }}</li>
  <li>
    <span data-ng-if="all_count > 0">({{ toSync }} / {{ all_count }} to sync
    <a data-ng-if="networkStatus === 'online' && toSync > 0" href="" data-ng-click="ctrl.pushAll()">push</a>
    )</span>
    <div data-ng-if="error">
      <p>
        <span class="box box-danger">{{ error.message }}
          <a href="" data-ng-if="error.status === 401" data-ng-click="relogin()">Click here to re-authenticate</a>
        </span>
      </p>
    </div>
  </li>
  !-->
</ul>
`,
  'app/blocks/pdf/print-pdf.html': `<button type="button" ng-click="pdfPrintCtrl.pdf()" ng-disabled="pdfPrintCtrl.loading">
  {{ pdfPrintCtrl.loading ? 'Loading...' : pdfPrintCtrl.buttonTitle }}
</button>
`,
  'app/blocks/queue/queue.process.box.html': `<div>
  <div data-ng-if="ctrl.queue.state && ctrl.queue.state !== 'success'">
    <div class="box box-info">
      <span class="" data-ng-if="ctrl.queue.state !== 'success'">
        {{ scheduleMapping[ctrl.queue.action] || ctrl.queue.action }}
        {{ mapping[ctrl.queue.state] }}
        <span class="text-danger" data-ng-if="ctrl.queue.reason">
          - {{ ctrl.queue.reason }}
        </span>
      </span>
    </div>
  </div>
</div>
`,
  'app/blocks/queue/queue.process.html': `<span class="text-gray">
  <span class="text-warning" data-ng-if="ctrl.queue.state !== 'success'">
    {{ scheduleMapping[ctrl.queue.action] || ctrl.queue.action }}
    {{ mapping[ctrl.queue.state] }}
    <span class="text-danger" data-ng-if="ctrl.queue.reason">
      - {{ ctrl.queue.reason }}
    </span>
  </span>
</span>
`,
  'app/blocks/types/type.preview.html': `<div class="modal-header event-modal-header">

  <header class="row">
    <div class="col-sm-10">
      <h3>
        <span kz-title doc="ctrl.item"></span>
      </h3>
    </div>

    <div class="col-sm-2 text-right">
      <p class="button-list">
        <button type="button" class="close" data-ng-click="ctrl.close()"><i class="icon-cancel"></i></button>
      </p>
    </div>
  </header>
</div>

<div class="modal-body event-modal-body">
  <div class="wrapper">
    <div class="row"  ng-if="ctrl.item.dates">
      <div class="col-xs-4 col-sm-3 text-right">
        <p>
          <a href="" ng-click="ctrl.auditLogShown = !ctrl.auditLogShown">
            <i class="icon-history"></i> {{ctrl.auditLogShown ? 'Hide' : 'Show'}} audit log
          </a>
        </p>
      </div>
    </div>
    <kz-audit-log dates="ctrl.item.dates" ng-show="ctrl.auditLogShown" doc="ctrl.item" data-ng-if="ctrl.item.dates"></kz-audit-log>

    <div class="row">
      <kz-readonly-form fields="ctrl.form.fields" model="ctrl.item"></kz-readonly-form>
    </div>
  </div>

</div>
`,
  'app/blocks/utils/datepicker.html': `<div class="row">
  <div class="col-sm-12">
    <input id="{{ labeledBy  }}" placeholder="{{ format }}" autocomplete="off"  class="form-control date-picker" data-ng-model="innerModel" ng-disabled="disabled" />
    <button ng-if="false" class="btn" ng-click="openCalendar()"><i class="icon-calendar"></i></button>
  </div>
</div>`,
  'app/blocks/utils/datetimepicker.html': `<div class="row">
  <div class="col-sm-12">
    <formly-form class="inline" model="dt" fields="timeForm.fields" form="form" aria-label="Date time fields"></formly-form>
    <button class="btn btn-sm btn-danger" href="" ng-click="reset()"><i class="icon-trash"></i> Clear</button>
  </div>
</div>
`,
  'app/blocks/utils/feature.html': `<span>
    <span ng-if="showFeature">
        <ng-transclude></ng-transclude>
    </span>
</span>`,
  'app/blocks/utils/offline.limit.html': `<div>
    <p data-ng-if="offline" class="box box-warning">
        It looks as though you are working offline. We may not be able to show you everything at this time.
    </p>
</div`,
  'app/blocks/utils/title.html': `<span>
  <span data-ng-if="type === 'simple' || type === 'both'">{{ title }}</span>
  <span data-ng-if="type === 'event' || type === 'both'" kz-event-title event="event"></span>
  <span data-ng-if="related"> of <span kz-event-title event-id="{{ related }}"></span></span>
</span>
`,
  'app/blocks/utils/turnitin.component.html': `<div class="row" ng-if="!$ctrl.readOnly">
  <div class="col-sm-8">
    <p>
      <span data-ng-if="$ctrl.showSubmit()">
        <button type="button" class="btn btn-sm btn-info" ng-click="$ctrl.submit()" ng-if="$ctrl.maxAttempts === 0 || $ctrl.maxAttempts - $ctrl.usedAttempts > 0">
          {{$ctrl.plagiarismTitle || "Check for plagiarism"}}
        </button>
        <span class="text-danger" ng-if="$ctrl.maxAttempts !== 0 && $ctrl.maxAttempts - $ctrl.usedAttempts <= 0">
            <b>You have used all your immediate attempts</b>
<!--          <span ng-if="$ctrl.nextAllowedSubmission && $ctrl.nextAllowedSubmission.isAfter()">-->
<!--            You have used all your immediate attempts. The next submission will be allowed {{ $ctrl.nextAllowedSubmission.fromNow() }}-->
<!--          </span>-->
<!--          <span ng-if="$ctrl.nextAllowedSubmission && $ctrl.nextAllowedSubmission.isBefore()">-->
<!--            You have used all your attempts however you are still allowed one extra attempt a day.-->
<!--          </span>-->
        </span>
      </span>

      <span ng-if="$ctrl.maxAttempts !== 0 && $ctrl.maxAttempts - $ctrl.usedAttempts > 0" class="text-info">
        You have used <strong>{{ $ctrl.usedAttempts }}</strong> attempts. You have
        <strong>{{ $ctrl.maxAttempts - $ctrl.usedAttempts }}</strong> attempts left.
      </span>
    </p>
  </div>
  <div class="col-sm-4 text-right-sm">
    <p ng-if="$ctrl.showResult()">
      <span class="label" ng-class="{'label-success': $ctrl.submission.score < 40, 'label-warning': $ctrl.submission.score > 40 && $ctrl.submission.score < 80, 'label-danger': $ctrl.submission.score > 80}">
        Similarity Score: <strong>{{ $ctrl.submission.score }}%</strong>
      </span>
      <button type="button" class="ml-4 btn btn-sm btn-info" ng-click="$ctrl.openViewer()">View analysis details</button>
    </p>
    <p ng-if="$ctrl.showState()">
      <span ng-if="$ctrl.submission.state.state" class="label label-info">
        Similarity Score: <strong>{{ $ctrl.states[$ctrl.submission.state.state || 'undefined'] }}</strong>
      </span>
    </p>
    <p class="text-danger" data-ng-if="['file_error', 'report_error'].indexOf($ctrl.submission.state.state) !== -1">{{ $ctrl.submission.error_message  || 'Submission failed, please try again later'}}</p>
  </div>
</div>

<span ng-if="$ctrl.readOnly && $ctrl.showResult()">
  <span class="label" ng-class="{'label-success': $ctrl.submission.score <= 40, 'label-warning': $ctrl.submission.score > 40 && $ctrl.submission.score <= 80, 'label-danger': $ctrl.submission.score > 80}">
    Similarity Score: <strong>{{ $ctrl.submission.score }}%</strong>
  </span>
  <button type="button" class="ml-4 btn btn-sm btn-info" ng-click="$ctrl.openViewer()">View analysis details</button>
</span>

<span ng-if="$ctrl.readOnly && $ctrl.showState()">
  <span ng-if="$ctrl.submission.state.state" class="label label-info">
    Similarity Score: <strong>{{ $ctrl.states[$ctrl.submission.state.state || 'undefined'] }}</strong>
  </span>
</span>
`,
  'app/blocks/utils/turnitin.eula.html': `<div class="modal-header">
    <button type="button" class="close" data-ng-click="$ctrl.close()" aria-label="Close"><i class="icon-cancel"></i></button>
    <div class="modal-title">
      <h3>
        Accept EULA
      </h3>
    </div>
  </div>

  <div class="modal-body">
      <iframe style="width: 100%; height: 100%"></iframe>
  </div>

  <div class="modal-footer">
      <button class="btn btn-primary" data-ng-click="$ctrl.acceptEula()">Accept EULA</button>
  </div>
</div>`,
  'app/blocks/utils/turnitin.field.component.html': `<turnitin
    title="$ctrl.title"
    data="$ctrl.getDataModel()"
    result="$ctrl.getResultModel()"
    metadata="{ key: $ctrl.key }"
    read-only="$ctrl.readOnly"
    max-attempts="$ctrl.maxAttempts"
    origin-id="$ctrl.originId"
    field-id="$ctrl.fieldId"
    plagiarism-title="$ctrl.enableAntiPlagiarismTitle"
    on-update="$ctrl.onUpdate(result)"></turnitin>
`,
  'app/blocks/versions/actions.html': `<span>
  <ul class="list-inline list-unstyled" >
    <li data-ng-repeat="actionLink in ctrl.actionLinks" data-ng-if="!ctrl.loading">
      <a href=""
         class="text-{{ ::actionLink.style }}"
         unsaved-warning-clear
         data-ng-if="!(actionLink.disabled && actionLink.disabled())"
         data-ng-click="ctrl.doAction(actionLink.action)"
      >
        <i class="icon-{{ ::actionLink.icon }}"></i> {{ ::actionLink.title }}

       </a>
      <a
         class="disabled"
         title="{{ 'This link is disabled' | translate }}"
         data-ng-if="(actionLink.disabled && actionLink.disabled())"
         >
        <i class="icon-{{ ::actionLink.icon }}"></i> {{ ::actionLink.title }}
      </a>
    </li>
    <li data-ng-if="ctrl.loading"><p class="text-center"><i class="icon-spin animate-spin"></i></p></li>
  </ul>

</span>
`,
  'app/blocks/versions/last-change.html': `<div>
  <div class="text-gray" data-ng-repeat="date in versionlastChangeCtrl.dates">
    {{::date.action | capitalize}} on
    <span class="label label-info">{{::date.date}}</span>
     by
    <span class="label label-info" epf-fullname user="::date.actor"></span>
  <div>
</div>
`,
  'app/blocks/versions/list.html': `<div>
<div class="row" data-ng-if="list.isLoading && list.items.length">
  <p class="text-warning"><i class="icon-warning"></i> There are no items available.</p>
</div>

<div class="col-xs-12">
  <div class="row" data-ng-if="list.items.length || list.showFilters"
       data-infinite-scroll="list.doPaginate()"
       infinite-scroll-disabled='list.isLoading || list.finished'>
    <div class="event-group" data-ng-repeat="version in list.items track by version.doc._id" >
      <div class="wrapper">
        <div
          class="row event progress-border"
          data-ng-class="{'progress-border-complete': version.hasState(listCtrl.versionStates.published), 'progress-border-pending': version.hasState(listCtrl.versionStates.draft), 'progress-border-danger': version.hasState(listCtrl.versionStates.archived)}">
          <div class="col-xs-12">
            <div class="row event-inner">
              <div class="col-sm-7">
                <h2>
                  <span data-ng-bind="::version.doc.name || version.doc.title"></span>
                </h2>
                <p class="text-gray">{{::version.doc[bodyItems.subHeader]}}</p>

                <p class="text-gray">
                  <span data-ng-if="version.linkedVersions.length">CURRENT VERSION: {{::version.linkedVersions.length}} </span>
                  <version-state version="version.headVersion" data-ng-if="version.headVersion"></version-state>
                  <version-state version="version" data-ng-if="!version.headVersion"></version-state>
                </p>
              </div>
          </div>
          <div class="row buttons">
            <div class="col-xs-12 col-sm-4">
              <ul class="list-inline list-unstyled">
                <li data-ng-repeat="actionButton in actionButtons" data-ng-if="!actionButton.hideIf(version.headVersion.doc || version.doc)">
                  <a class="text-{{actionButton.style}}" href="" data-ng-click="listCtrl.goTo(actionButton.sref, version.headVersion.doc || version.doc)" title="{{actionButton.title}}">
                    <i class="icon-{{actionButton.icon}}"></i> {{actionButton.title}}
                  </a>
                </li>
              </ul>
            </div>

            <div class="col-xs-12 col-sm-8">
              <version-actions version="version" post-action="listCtrl.loadList()"></version-actions>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div data-ng-if="list.isLoading">
      <p class="text-center"><i class="icon-spin animate-spin"></i></p>
    </div>
  </div>
</div>
</div>
`,
  'app/blocks/versions/versions-list.html': `<div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
        <h4 id="myModalLabel">{{ 'Showing All versions of' | translate }} {{::version.doc.name || version.doc.title}}</h4>
        <div class="text-gray">{{ 'Click on a version name to view the form' | translate }}</div>
    </div>
</div>
<div class="modal-body">
    <div class="event-group" data-ng-repeat="linkedVersion in versions track by linkedVersion.id">
    <div class="wrapper">
        <div
        class="row event progress-border"
        data-ng-class="{'progress-border-complete': linkedVersion.state === 'published', 'progress-border-pending': linkedVersion.state === 'draft', 'progress-border-danger': linkedVersion.state === 'archived'}">
        <div class="col-xs-12">

            <div class="row event-inner">
            <div class="col-sm-7 text-left">
                <a href="" data-ng-click="goTo('edit', linkedVersion.id)" title="{{ 'View event type details' | translate }}">
                <h2>
                    <span data-ng-bind="::linkedVersion.name || linkedVersion.title"></span>
                </h2>
                </a>
                <div class="text-gray">
                    {{ 'Version' | translate }} <span data-ng-bind="::linkedVersion.version"></span>
                    <div ng-repeat="log in linkedVersion.filteredLog">
                        <audit-log-entry log="log"></audit-log-entry>
                    </div>
                </div>
            </div>

            <div class="col-sm-5 col-right" style="padding: 15px;">
                <span class="label label-success" data-ng-if="linkedVersion.id === version.doc._id">{{ 'CURRENTLY VIEWING' | translate }} </span>
                <version-state version="linkedVersion"></version-state>
            </div>
            </div>
        </div>
        </div>
    </div>
    </div>
</div>
`,
  'app/blocks/versions/widget.html': `<div class="row">
  <div class="col-xs-6">
    <div>THIS VERSION IS <version-state version="version.doc"></version-state></div>
    <div class="text-gray">
      Version {{ version.doc.version}}
    </div>
  </div>
  <div class="col-xs-6 text-right">
    <version-actions version="version" form="form"></version-actions>
  </div>
</div>
`,
  'app/blocks/widgets/auditlog/audit-log-entry.component.html': `<span>
    {{::$ctrl.actionMapping[$ctrl.log.action] | capitalize}}
    on {{::$ctrl.log.date | kzDateFormat:'datetime'}}
    by <span class="label label-info" epf-fullname user="::$ctrl.log.actor"></span>
</span>`,
  'app/blocks/widgets/auditlog/audit-log.component.html': `<div class="row" ng-if="$ctrl.conf.showHeader">
    <div class="col-xs-12 text-right">
        <a href="" ng-click="$ctrl.toggleExpand()" class="text-info">
            <i class="icon-history "></i>  {{ $ctrl.conf.shown ? 'Hide' : 'Show' }} audit log
        </a>
    </div>
</div>

<div class="row" data-ng-if="$ctrl.conf.shown || $ctrl.expanded">
    <div class="col-xs-12">
        <kz-audit-log data-ng-if="$ctrl.entries !== undefined" show-header="false" per-page="3" show-details="false" per-page="perPage" dates="$ctrl.entries"></kz-audit-log>
    </div>
</div>
`,
  'app/blocks/widgets/auditlog/audit-log.html': `<div class="row audit-log">
  <div class="col-xs-12">
    <p class="font-bold text-info" ng-if="showHeader">Audit log</p>

    <ul class="list-unstyled">
      <li class="audit-log-entry" ng-repeat="date in dates.slice().reverse() | limitTo: perPage">
        <p class="audit-log-date">{{::date.date | date: dateFormat}}</p>
        <p>
          <span data-ng-if="date.masquerade">
            <span class="meta-author" event-filled-by user="date.masquerade" event="doc"></span>
            as
          </span>

          <span class="meta-author" event-filled-by user="date.actor" event="doc"></span>
          <strong data-ng-bind="::actionMapping[date.action] || date.action"></strong>
          <ul class="list-unstyled" data-ng-if="showDetails">
            <li ng-repeat="(key, value) in date" ng-if="::(['_id', 'user', 'action', 'date', 'actor', 'changes', 'changed', 'patch', 'masquerade'].indexOf(key) === -1)">
              <span ng-if="key !== 'email_logs'"><strong>{{::key | capitalize}}</strong>: {{::value}}</span>
              <span ng-if="key === 'email_logs' && showEmailPreview">
                <strong>Sent emails:</strong>
                <span ng-repeat="val in value track by $index">
                  <button
                    email-log-preview-link
                    eid="val"
                    class="btn-link"
                    aria-label="Preview email{{value.length > 1 ? $index + 1 : ''}} in modal window">
                      Preview <span ng-if="value.length > 1">({{$index + 1}})</span>
                  </button>
                  <span ng-if="!$last"> | </span>
                </span>
              </span>
            </li>
          </ul>
        </p>

        <ul class="list-unstyled audit-log-changes" ng-if="date.changes && date.changes.length">
          <li ng-repeat="log in date.changes">{{ ::log }}</li>
        </ul>
      </li>
    </ul>

    <p ng-if="dates.length > perPage">
      <a href="" ng-click="showOlderEntries(dates)" title="Show older entries">Show older entries</a>
    </p>
  </div>
</div>
`,
  'app/blocks/widgets/auditlog/audit-log.preview.html': `<div class="modal-header event-modal-header">

  <header class="row">
    <div class="col-sm-10">
      <h3>
        Audit log
      </h3>
    </div>

    <div class="col-sm-2 text-right">
      <p class="button-list">
        <button type="button" class="close" data-ng-click="ctrl.close()" aria-label="Close"><i class="icon-cancel"></i></button>
      </p>
    </div>
  </header>
</div>

<div class="modal-body event-modal-body">
  <kz-audit-log show-header="false" show-details="ctrl.showDetails" dates="::ctrl.dates"></kz-audit-log>
</div>
`,
  'app/blocks/widgets/buttons/pagebuttons.html': `<div class="button-list text-right no-print">

  <a href="" aria-label="Show actions" ng-if="actionButtons.length && useContextualMenu" class="hidden-md hidden-lg btn btn-primary btn-icon-circle" kz-contextual-menu toggle="#page-action-buttons">
    <i class="icon-plus"></i>
  </a>

  <div id="page-action-buttons" ng-class="{'contextual-action-buttons': useContextualMenu}">
    <div class="page-action-buttons-row" ng-repeat="buttonGroup in actionButtons">
      <ul class="list-inline list-unstyled">
        <li class="action-button" ng-repeat="actionButton in buttonGroup">
          <span kz-single-button data-ng-if="!actionButton.buttons" action="actionButton"></span>
          <div class="btn-group" data-ng-if="actionButton.buttons.length > 0">
            <a href="" data-target="#" class="btn {{actionButton.klass}} dropdown-toggle" data-toggle="dropdown">{{ actionButton.label }} <span class="caret"></span></a>
            <ul class="dropdown-menu">
              <li data-ng-repeat="action in actionButton.buttons track by $index" kz-single-button action="action" klass="">
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
`,
  'app/blocks/widgets/buttons/singlebutton.html': `<span>
<a data-ng-if="action.onClick"
   class="{{ className }}"
   href="javascript:void(0)"
   kz-button-loading
   indicator="loading"
   data-ng-click="doAction()"
   ng-mouseup="mouseUp()"
   ng-keydown="keydown($event)"
   role="button"
   tabindex="0"
   title="{{action.label}}"
   aria-label="{{ action.ariaLabel ? action.ariaLabel : action.label }}"
   kz-attrs="action.attrs"
  >
  <i class="{{action.icon}}"></i>
  {{action.label}}
</a>
<a data-ng-if="action.href && !action.route"
   class="{{ className }}"
   href=""
   ng-mouseup="mouseUp()"
   data-ng-href="{{action.href}}"
   title="{{action.label}}"
   aria-label="{{ action.ariaLabel ? action.ariaLabel : action.label }}">
  <i class="{{action.icon}}"></i>
  {{action.label}}
</a>
<a data-ng-if="action.route"
   class="{{ className }}"
   href=""
   ng-mouseup="mouseUp()"
   router-link="action.route"
   title="{{action.label}}"
   aria-label="{{ action.ariaLabel ? action.ariaLabel : action.label }}">
  <i class="{{action.icon}}"></i>
  {{action.label}}
</a>
<a data-ng-if="action.back"
  class="{{ className }}"
  ng-mouseup="mouseUp()"
  href="javascript:void(0)"
  aria-label="{{ action.ariaLabel ? action.ariaLabel : action.label }}"
  epf-back>
  <i class="{{action.icon}}"></i>
  {{action.label}}
</a>
<span data-ng-if="action.labelOnly"
   class="{{ className }}"
   title="{{action.label}}">
  <i class="{{action.icon}}"></i>
  {{action.label}}
</span>
</span>
`,
  'app/blocks/widgets/deletable-items/deletable-items.html': `<div class="row">
  <div class="col-lg-12">
    <h6 ng-repeat="item in model track by item">
      {{ item }} <button type="button" class="btn btn-xs btn-danger" ng-if="!readOnly" data-ng-click="removeItem(item)"><i class="icon-trash"></i> Remove</button>
    </h6>
    <div ng-if="model.length === 0 || !model">There are no items</div>
  </div>
</div>
`,
  'app/blocks/widgets/files/files-table.html': `<div class="table-scrollable">
  <table ng-if="$ctrl.files && $ctrl.files.length > 0" class="table table-striped files-table">
    <thead>
      <tr>
          <th scope="col">Name</th>
          <th scope="col" class="col-icon-actions">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="file in $ctrl.files">
          <td>
            {{file.filename}}
            <br />
            <ul class="list-inline list-unstyled">
              <li><span class="label label-default">{{file.type | uppercase}}</span></li>
              <li ng-if="file.plagiarism" ng-class="{'text-success': file.plagiarism.score < 40, 'text-warning': file.plagiarism.score > 40 && file.plagiarism.score < 80, 'text-danger': file.plagiarism.score > 80}">
                <span ng-class="{'text-danger': file.plagiarism.status === 'error'}">{{file.plagiarism.details}}</span>
                <span class="label" ng-if="file.plagiarism.status !== 'error'" ng-class="{'label-success': file.plagiarism.score < 40, 'label-warning': file.plagiarism.score > 40 && file.plagiarism.score < 80, 'label-danger': file.plagiarism.score > 80}">
                  <strong>{{ file.plagiarism.score }}%</strong>
                </span>
              </li>
            </ul>
          </td>
          <td>
            <ul class="list-unstyled list-inline files-table__actions">
              <li ng-repeat="btn in file.buttons">
                <button type="button" class="btn btn-sm px-0 {{ btn.klass }}" ng-click="btn.action(file)" aria-label="{{ btn.label }} {{ file.filename }}">
                  <i class="icon-{{ btn.icon }}"></i>
                  <span class="button--text">{{ btn.label }}</span>
                </button>
              </li>
            </ul>
          </td>
      </tr>
    </tbody>
  </table>
</div>
`,
  'app/blocks/widgets/filters/kz-field.html': `<formly-form model="searchModel.filteredBy" fields="ctrl.form.fields" form="kzSearchForm" aria-label="Filed"></formly-form>
`,
  'app/blocks/widgets/filters/kz-linked-fields.html': `<formly-form model="ctrl.formData" fields="ctrl.form.fields" form="kzSearchForm" aria-label="Linked fields">
  <button type="submit" data-ng-click="ctrl.addPair()">Add pair</button>
</formly-form>
`,
  'app/blocks/widgets/forms/file-preview.html': `<div class="modal-header event-modal-header">
  <header class="row">
    <div class="col-sm-10">
        <h3>{{ ctrl.file.filename }}</h3>
    </div>

    <div class="col-sm-2 text-right">
        <div class="">
          <button type="button" class="close" data-ng-click="ctrl.dismiss()"><i class="icon-cancel"></i></button>
        </div>
      </div>
  </header>
</div>

<div class="preview-body">
    <div class="wrapper">
        <div class="row">
            <div class="col-md-12">
                <a href="{{ctrl.url}}" target="_blank">Open on another tab</a>
                <object ng-if="!ctrl.isImage" ng-attr-data="{{ctrl.url}}" style="width:100%; height:80vh;"></object>
                <img ng-src="{{ctrl.url}}" ng-if="ctrl.isImage" class="img-responsive" alt="{{ctrl.file.filename}} preview" width="100%" />
            </div>
        </div>
    </div>
</div>
`,
  'app/blocks/widgets/forms/file-widget.html': `<div class="table-scrollable mb-4" ng-if="!$ctrl.readOnly">
    <table data-ng-if="!$ctrl.hideList && $ctrl.files && $ctrl.files.length" class="table table-striped files-table">
      <thead>
        <tr>
            <th scope="col" class="col-filename">Name</th>
            <th scope="col">File size</th>
            <th scope="col">File type</th>
            <th scope="col" ng-if="!$ctrl.readOnly">Status</th>
            <th scope="col" class="col-btn-actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr data-ng-repeat="file in $ctrl.files" ng-class="{'bg-danger-100': file.status === 'failed'}">
            <td>{{file.filename}}</td>
            <td><span ng-if="file.readableSize">{{file.readableSize}}</span></td>
            <td>{{file.type | uppercase}}</td>
            <td ng-if="!$ctrl.readOnly">
                <span data-ng-switch on="file.status">
                    <span data-ng-switch-when="uploading">
                        <kz-progress-bar rate="file.progress" inline="true"><span>{{ file.progress }}%</span></kz-progress-bar>
                    </span>
                    <span role="status" aria-live="polite" ng-class="{'text-danger-600': file.status === 'failed' || file.currentSubmission.error_message, 'text-success-600': file.status === 'uploaded' && (!file.currentSubmission || !file.currentSubmission.error_message)}" data-ng-switch-default>{{ file | fileStatus}}</span>
                </span>
            </td>
            <td>
              <ul class="item-list list-inline">
                <li ng-repeat="butt in file.buttons">
                  <button type="button" class="btn btn-sm {{ butt.klass }}" aria-label="{{butt.label}} {{file.filename}}" data-ng-click="butt.action(file)">{{ butt.label }}</button>
                </li>
              </ul>
            </td>
        </tr>
      </tbody>
    </table>

    <div class="file-input__upload" ng-if="!$ctrl.readOnly">
        <input type="hidden" ng-model="$ctrl.model"/>
        <span ng-if="$ctrl.hideList">
            <span ng-if="$ctrl.files && $ctrl.files.length">
                <button ng-repeat="butt in $ctrl.files[0].buttons" type="button" class="btn btn-sm {{ butt.klass }}" data-ng-click="butt.action($ctrl.files[0])">{{ butt.label }}</button>
            </span>
            <span ng-if="!$ctrl.files || $ctrl.files.length === 0 && $ctrl.allowEdit">
                <button aria-label="{{label || 'Upload'}} files for {{$ctrl.label}}" type="button" class="btn btn-sm btn-info" data-ng-click="$ctrl.select()">{{label || 'Upload'}}</button>
            </span>
        </span>
        <p>
          <span ng-if="!$ctrl.hideList && $ctrl.allowEdit">
            <button aria-label="{{label || 'Upload'}} files for {{$ctrl.label}}" ng-if="!$ctrl.fullFileOptions.fileLimit || ($ctrl.uploadedCount || 0) < $ctrl.fullFileOptions.fileLimit" type="button" class="btn btn-sm btn-info" data-ng-click="$ctrl.select()">{{label || 'Upload'}}</button>
          </span>
          <span class="text-info" ng-if="!$ctrl.readOnly && $ctrl.turnitInOptions.enabled && $ctrl.turnitInOptions.attempts > 0 && $ctrl.turnitInOptions.attempts - $ctrl.usedAttempts > 0">
           You have used <strong>{{ $ctrl.usedAttempts }}</strong> attempts. You have
            <strong>{{ $ctrl.turnitInOptions.attempts - $ctrl.usedAttempts }}</strong> attempts left.
            <strong></span>
          <span class="text-danger" ng-if="!$ctrl.readOnly && $ctrl.turnitInOptions.enabled && $ctrl.turnitInOptions.attempts !== 0 && $ctrl.turnitInOptions.attempts - $ctrl.usedAttempts <= 0">
            You have used all your immediate attempts
<!--            <span ng-if="$ctrl.nextAllowedSubmission && $ctrl.nextAllowedSubmission.isAfter()">-->
<!--              You have used all your immediate attempts. The next submission will be allowed {{ $ctrl.nextAllowedSubmission.fromNow() }}-->
<!--            </span>-->
<!--            <span ng-if="$ctrl.nextAllowedSubmission && $ctrl.nextAllowedSubmission.isBefore()">-->
<!--              You have used all your attempts however you are still allowed one extra attempt a day.-->
<!--            </span>-->
          </span>
        </p>

        <p class="hint-text">
          <span ng-if="$ctrl.fullFileOptions.multiple && $ctrl.fullFileOptions.fileLimit">
            You can upload a maximum of {{ $ctrl.fullFileOptions.fileLimit }} files.
            {{ $ctrl.uploadedCount }} uploaded so far.
          </span>
          <span ng-if="!$ctrl.fullFileOptions.accept.includes('all')">Only <span ng-repeat="type in $ctrl.fullFileOptions.accept">{{$ctrl.getTypeName(type)}}<span ng-if="!$last && $index !== $ctrl.fullFileOptions.accept.length - 2">, </span><span ng-if="$index === $ctrl.fullFileOptions.accept.length - 2"> and </span></span> are allowed, with a maximum file size of {{ $ctrl.fullFileOptions.sizeLimit }}MB.</span>
          <span class="text-warning" ng-if="$ctrl.fullFileOptions.multiple && $ctrl.fullFileOptions.fileLimit && $ctrl.uploadedCount >= $ctrl.fullFileOptions.fileLimit">
            You have reached the maximum number of files allowed.
          </span>
        </p>
    </div>
</div>

<kz-files-table ng-if="$ctrl.readOnly" doc-id="$ctrl.docId" model="$ctrl.model"></kz-files-table>
`,
  'app/blocks/widgets/forms/form-title.html': `<span ng-if="showType === 'file'">
  <file-widget
  doc-id="parent || eventId"
  model="value"
  ng-model="value"
  multiple="templateOptions.multiple"
  file-options="templateOptions.fileOptions"
  read-only="true"
  turnit-in-options="templateOptions.turnitInOptions"
></file-widget>
</span>
<span ng-if="showType !== 'file'" data-ng-repeat="itm in value track by $index">
  <span data-ng-switch on="showType">
    <span data-ng-switch-when="title" klass="{{klass}}">{{ itm }}</span>
    <span data-ng-switch-when="categoryTitle" kz-category-title category="itm" klass="{{klass}}" kz-type="{{kzType}}" field-id="{{ fieldId }}" event-type-id="{{ eventTypeId }}" watch="{{watch}}" show-href="showHref"></span>
    <span data-ng-switch-when="blueprint" kz-blueprint-category-title category="itm" klass="{{klass}}" kz-type="{{kzType}}" field-id="{{ fieldId }}" event-type-id="{{ eventTypeId }}" watch="{{watch}}"></span>
    <span data-ng-switch-when="role" epf-role-title user-role="{{ itm }}"></span>
    <span data-ng-switch-when="text" style="white-space: pre-line" data-ng-bind-html="itm | kzHighlight: highlight">{{ itm | kzHighlight: highlight }}</span>
    <span data-ng-switch-when="date">{{ itm | date : dateFormat }}</span>
    <span data-ng-switch-when="datetime">{{ itm | date : datetimeFormat }}</span>
    <span data-ng-switch-when="bool">{{ itm | smartboolean:'yesno' }}</span>
    <span data-ng-switch-when="eventType" kz-event-type-title event-type="itm"></span>
    <span data-ng-switch-when="eventType_versionGroupId" kz-event-type-group-title event-type-group="itm" show-href="showHref"></span>
    <span data-ng-switch-when="user" epf-fullname user="itm"></span>
    <event-define-filters data-ng-switch-when="filters" model="itm" readonly="true"></event-define-filters>
    <span data-ng-switch-when="signature" style="display: block; text-align: center;">
      <img ng-src="{{itm}}" ng-if="itm.indexOf('data:image/png') > -1" class="img-signature" alt="signature" />
      <span ng-if="itm.indexOf('data:image/png') === -1">Signature filled in on a old browser: {{itm}}</span>
    </span>
    <span data-ng-switch-when="file">

    </span>
    <span data-ng-switch-when="goal">
      <span ng-if="!options.featuredFieldView">
        <kz-list-view template="app/components/goals/listview-no-featured.html" list="list" options="options" ng-if="list">
          <goal-slot goal="item"></goal-slot>
        </kz-list-view>
        <kz-pagination
          ng-if="list.ready && !list.isLoading && list.items.length"
          total="list.found_count"
          startkey="list.startkey"
          per-page="list.findOptions.limit"
          to="goToPage(page)">
        </kz-pagination>
      </span>

      <span ng-if="options.featuredFieldView">
        <div>Due date: {{item.dueDate | date : dateFormat}}</div>
        <kz-list-view list="list" options="itm.options" ng-if="list">
          <goal-slot goal="item"></goal-slot>
        </kz-list-view>
      </span>

      <div class="row" data-ng-if="loading">
        <p class="text-center"><i class="icon-spin animate-spin"></i></p>
      </div>

      <span data-ng-if="!list && !loading">
        <div>No goals are within this goal set</div>
        <kz-list-buttons actions="goalActions" data-ng-if="!options.featuredFieldView"></kz-list-buttons>
      </span>
    </span>
    <kz-report-view data-ng-switch-when="report"
                    report-id="{{itm.report}}"
                    model="itm.reportData"
                    field="itm"
                    size="500"
                    stored-result="itm.reportResult"
                    extra="{ user: user }"
                    items-to-display="field.templateOptions"></kz-report-view>

    <sql-report-field-wrapper
      data-ng-switch-when="sqlreport"
      model="itm"
      extra="{ user: user }"
      report="options.templateOptions.report"
      report-id="options.templateOptions.reportId"
      read-only="true"></sql-report-field-wrapper>
  </span>

  <b ng-if="!$last" ng-class="{'text-info': separator}"><span ng-if="separator">{{separator}}</span> <span ng-if="!separator">, </span></b>
</span>
`,
  'app/blocks/widgets/forms/readonly-form.html': `<div ng-if="show">
  <div class="formly-field formly-field--readonly" ng-repeat="field in fields">
    <div data-ng-switch on="field.type" ng-show="getShowValue(field)">
      <h4 data-ng-switch-when="text_heading" class="form-text form-text__heading">{{ field.templateOptions.label }}</h4>
      <div data-ng-switch-when="text_text" class="form-text form-text__description" style="white-space:pre-line"
        data-ng-bind-html="field.templateOptions.label"></div>
      <div data-ng-switch-when="file" class="form-text form-text__form-group">
        <div class="row">
          <div class="col-xs-12">
            <label for="{{::field.id}}" class="form-text form-text__control-label" ng-if="field.templateOptions.label">
              {{ ::field.templateOptions.label }}
            </label>
            <kz-files-table model="model[field.key]"
                            doc-id="field.templateOptions.docId"
                            field-id="field.templateOptions.fieldId"
                            turnitin-enabled="field.templateOptions.turnitInOptions.enabled"
            >
            </kz-files-table>
          </div>
        </div>
      </div>
      <div data-ng-switch-default class="form-text form-text__form-group"
        ng-if="!(model[field.key] | kzIsEmpty) || field.type === 'boolean'">
        <div class="row">
          <div class="col-xs-12">
            <label for="{{::field.id}}" class="form-text form-text__control-label" ng-if="field.templateOptions.label">
              {{ ::field.templateOptions.label }}
            </label>
            <div class="form-text form-text__field-value" data-ng-if="!options.passTemplateOptions" kz-form-title
              field="field" item="model[field.key]"
              type="{{ field.type === 'multi' ? field.templateOptions.originalType : field.type }}"
              kz-type="{{ field.templateOptions.kzType }}" field-id="{{ field.id }}" event-type-id="{{ eventTypeId }}"
              event-id="{{eventId}}" section-id="{{field.templateOptions.sectionId || sectionId}}" user="{{user}}"
              highlight="highlight" options="options" parent="parent"></div>
            <div data-ng-if="options.passTemplateOptions" kz-form-title field="field" item="model[field.key]"
              type="{{ field.type === 'multi' ? field.templateOptions.originalType : field.type }}"
              kz-type="{{ field.templateOptions.kzType }}" field-id="{{ field.id }}" event-type-id="{{ eventTypeId }}"
              event-id="{{eventId}}" section-id="{{field.templateOptions.sectionId || sectionId}}" user="{{user}}"
              highlight="highlight" options="options" template-options="field.templateOptions" parent="parent"></div>
          </div>
        </div>
      </div>
    </div>
    <div kz-feature-enabled feature="turnitin" data-ng-if="field.templateOptions.turnitInOptions.enabled && field.type !== 'file'">
      <turnitin-field
        model="model"
        key="field.key"
        read-only="true"
        max-attempts="field.templateOptions.turnitInOptions.attempts"
        origin-id="field.templateOptions.originId"
        field-id="field.templateOptions.fieldId"
        enable-anti-plagiarism-title="field.templateOptions.turnitInOptions.buttonLabel"
        title="field.templateOptions.label"
      ></turnitin-field>
    </div>
  </div>
</div>
`,
  'app/blocks/widgets/forms/types/boolean.html': `<input data-ng-if="!formState.readOnly && model[options.key].length" data-ng-model="model[options.key]" type="checkbox" data-ng-true-value="'Yes'" data-ng-false-value="'No'">
<input data-ng-if="!formState.readOnly && !model[options.key].length" data-ng-model="model[options.key]" type="checkbox">

<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key]" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/checkboxes_grid.html': `<div data-ng-if="!(formState.readOnly || options.templateOptions.readOnly)">
  <div class="row">
    <div class="col-md-4" ng-repeat="option in options.templateOptions.options">
      <input type="checkbox" checklist-model="model[options.key]" checklist-value="option.id" > {{option.name}}
    </div>
  </div>
</div>

<div data-ng-if="formState.readOnly || options.templateOptions.readOnly">
</div>

`,
  'app/blocks/widgets/forms/types/date.html': `<span labeled-by="{{options.id}}" data-kz-date-picker data-ng-if="!formState.readOnly" data-model="model" data-start-field="{{to.startField || options.key}}" data-end-field="{{to.endField}}" data-options="templateOptions.options" data-ng-model="model[to.startField || options.key]" data-disabled="options.templateOptions.disabled" id="{{ options.id + '_kz_date_picker' }}">
</span>

<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[to.startField || options.key]" type="{{ options.type }}"></span>

  <span data-ng-if="model[to.endField] && model[to.startField || options.key] !== model[to.endField]"> -
    <span kz-form-title item="model[to.endField]" type="{{ options.type }}"></span>
  </span>
</div>
`,
  'app/blocks/widgets/forms/types/datetime.html': `<span data-ng-if="!formState.readOnly"
  data-kz-date-time-picker
  data-model="model[options.key]"
  data-disabled="options.templateOptions.disabled"
  data-required="options.templateOptions.required"
>
</span>

<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[to.startField || options.key]" type="{{ options.type }}"></span>

  <span data-ng-if="model[to.endField] && model[to.startField || options.key] !== model[to.endField]"> -
    <span kz-form-title item="model[to.endField]" type="{{ options.type }}"></span>
  </span>
</div>
`,
  'app/blocks/widgets/forms/types/deletableItems.html': `<kz-deletable-items model="model[options.key]" read-only="options.templateOptions.readOnly  || options.templateOptions.disabled"></kz-deletable-items>
`,
  'app/blocks/widgets/forms/types/discrete_multiple.html': `<div>

  <ui-select data-ng-if="!formState.readOnly" data-ng-model="model[options.key]" multiple="true" title="{{model[options.key]}}" ng-required="required">

    <ui-select-match placeholder="{{options.templateOptions.placeholder}}">
      {{$item[options.templateOptions.itemLabel]}}
    </ui-select-match>

    <ui-select-choices repeat="choice[options.templateOptions.itemValue] as choice in options.templateOptions.options | choicePreserveFilter:(reload ? '' : $select.search):$select.selected:to.itemValue track by choice[options.templateOptions.itemValue]" refresh="reload($select.search)">
      <div ng-bind-html="choice[options.templateOptions.itemLabel] | highlight: $select.search"></div>
    </ui-select-choices>

  </ui-select>
</div>

<div data-ng-if="formState.readOnly || options.templateOptions.readOnly">
    <span kz-form-title item="model[options.key]" type="{{ options.type }}" options="formState"></span>
</div>
`,
  'app/blocks/widgets/forms/types/discrete.html': `<div>
<select ng-if="!(formState.readOnly || options.templateOptions.readOnly) && !options.templateOptions.loading" class="form-control" data-ng-model="model[options.key]" data-ng-options="option[to.itemValue || '_id'] as option[to.itemLabel || 'name'] group by option.group for option in options.templateOptions.options"></select>
<span data-ng-if="options.templateOptions.loading">
  <i class="icon-spin animate-spin"></i> Loading
</span>
</div>
<div data-ng-if="formState.readOnly || options.templateOptions.readOnly">
  <span kz-form-title item="model[options.key]" type="{{ options.type }}"></span>
</div>

`,
  'app/blocks/widgets/forms/types/email_list.html': `<input data-ng-if="!formState.readOnly" data-ng-model="model[options.key]" type="text" class="form-control" ng-model-options="{ updateOn: 'default blur', debounce: { default: 1000, blur: 0 } }" data-record-id="model._id" kz-list="\s*[;|,]\s*">
<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key] | nl2br" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/email_multiple.html': `<div>

  <ui-select tagging="taggingFunc" tagging-label="(new)" tagging-tokens=",|/" data-ng-if="!formState.readOnly" data-ng-model="model[options.key]" multiple="true" title="{{model[options.key]}}" ng-required="required">

    <ui-select-match placeholder="{{options.templateOptions.placeholder}}">
      <span data-ng-if="$item.isTag">{{$item.email}}</span>
      <span data-ng-if="!$item.isTag">{{$item.fullname}} &lt;{{$item.email}}&gt;</span>
    </ui-select-match>

    <ui-select-choices repeat="choice.email as choice in options.templateOptions.options | filter:(reload ? '' : $select.search)" refresh="reload($select.search)">
      <div ng-if="choice.isTag">
        <span ng-bind-html="(choice.fullname  | highlight: $select.search)"></span>
        &lt;{{choice.email }}&gt; {{ $select.taggingLabel }}
      </div>
      <div ng-if="!choice.isTag">
        <span ng-bind-html="(choice.fullname  | highlight: $select.search)"></span>
        &lt;{{choice.email }}&gt;
      </div>
    </ui-select-choices>

  </ui-select>
</div>

<div data-ng-if="formState.readOnly || options.templateOptions.readOnly">
    <span kz-form-title item="model[options.key]" type="{{ options.type }}" options="formState"></span>
</div>
`,
  'app/blocks/widgets/forms/types/email_select.html': `<div>

  <ui-select tagging="taggingFunc" tagging-label="false" tagging-tokens="TAB|ENTER"
    data-ng-if="!formState.readOnly" data-ng-model="model[options.key]"
    title="{{model[options.key]}}" close-on-select="true" ng-required="required">

    <ui-select-match placeholder="{{options.templateOptions.placeholder}}">
      <span data-ng-if="!$select.selected.fullname">{{$select.selected.email}}</span>
      <span data-ng-if="$select.selected.fullname">{{$select.selected.fullname}} &lt;{{$select.selected.email}}&gt;</span>
    </ui-select-match>

    <ui-select-choices repeat="choice.email as choice in options.templateOptions.options | filter:(reload ? '' : $select.search)" refresh="reload($select.search)">
      <div ng-if="choice.isTag">
        <span ng-bind-html="(choice.fullname  | highlight: $select.search)"></span>
        &lt;{{choice.email }}&gt; {{ $select.taggingLabel }}
      </div>
      <div ng-if="!choice.isTag">
        <span ng-bind-html="(choice.fullname  | highlight: $select.search)"></span>
        &lt;{{choice.email }}&gt;
      </div>
    </ui-select-choices>

  </ui-select>
</div>

<div data-ng-if="formState.readOnly || options.templateOptions.readOnly">
    <span kz-form-title item="model[options.key]" type="{{ options.type }}" options="formState"></span>
</div>
`,
  'app/blocks/widgets/forms/types/email.html': `<input data-ng-if="!formState.readOnly" data-ng-model="model[options.key]" type="email" class="form-control" ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }" data-record-id="model._id">

<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key]" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/file.html': `<file-widget
  ng-if="!formState.readOnly"
  doc-id="to.docId"
  model="model[options.key]"
  ng-model="model[options.key]"
  file-fields="model"
  field-key="options.key"
  multiple="to.multiple"
  origin-id="to.originId"
  field-id="to.fieldId"
  required="{{to.required}}"
  file-options="to.fileOptions"
  turnit-in-options="to.turnitInOptions"
  hide-list="to.hideList"
  label="to.label"
  on-model-updated="to.onModelUpdated(files)"
></file-widget>
<div ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key]" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/filters.html': `<event-define-filters model="model[options.key]" readonly="formState.readOnly"></event-define-filters>
`,
  'app/blocks/widgets/forms/types/goal.html': `<goals-field def="to" model="model[options.key]" end-date="formState.endDate" read-only="formState.readOnly" form="form" ng-model="model[options.key]"></goals-field>
`,
  'app/blocks/widgets/forms/types/hidden.html': `<input ng-model="model[options.key]" type="hidden" class="form-control" record-id="model._id">
`,
  'app/blocks/widgets/forms/types/json.html': `<textarea msd-elastic ng-if="!formState.readOnly" class="form-control" ng-model="model[options.key]" rows="model[options.templateOptions.rows]" cols="model[options.templateOptions.cols]" ng-model-options="{ updateOn: 'blur', debounce: { default: 500, blur: 0 } }"></textarea>
<div data-ng-if="formState.readOnly" data-ng-bind-html="model[options.key] | json"></div>
`,
  'app/blocks/widgets/forms/types/likert.html': `<select ng-if="!(formState.readOnly || options.templateOptions.readOnly)" class="form-control" data-ng-model="model[options.key]" data-ng-options="option._id as option.name for option in options.templateOptions.options"></select>
<div data-ng-if="formState.readOnly || options.templateOptions.readOnly">
    <span kz-form-title item="model[options.key]" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/link.html': `<a href="" data-ng-click="to.onClick()">{{ to.label }}</a>
`,
  'app/blocks/widgets/forms/types/multi.html': `<div data-ng-if="formState.readOnly">
  <div data-ng-repeat="item in model[options.key] track by $index">
    <span kz-form-title item="item" type="{{ options.templateOptions.originalType }}"></span>
  </div>
</div>
`,
  'app/blocks/widgets/forms/types/numeric.html': `<input data-ng-if="!formState.readOnly" data-ng-model="model[options.key]" type="number" step=".001" class="form-control" ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }"  data-record-id="model._id">

<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key]" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/password.html': `<input data-ng-if="!formState.readOnly" data-ng-model="model[options.key]" type="password" class="form-control" ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }" data-record-id="model._id">
<p data-ng-if="formState.readOnly"></p>
`,
  'app/blocks/widgets/forms/types/report.html': `<input type="hidden" data-ng-model="model[options.key].reportResult">
<div data-ng-if="!formState.readOnly && !options.templateOptions.readOnly">
  <kz-report-field report-doc="to.report" default-model="to.reportData" extra="to.extra" model="model[options.key]" options="{  variable: to.variable,  size: to.size, display: to.display, charts: to.charts, chartsColumns: to.chartsColumns, tableColumns: to.tableColumns }"></kz-report-field>
</div>
<div data-ng-if="formState.readOnly || options.templateOptions.readOnly">
    <span kz-form-title item="model[options.key]" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/search.html': `<input placeholder="{{ to.placeholder }}" data-ng-if="!formState.readOnly" data-ng-model="model[options.key]" type="search" class="form-control" ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }" data-record-id="model._id">
<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key] | nl2br" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/select.html': `<ui-select data-ng-if="!formState.readOnly" ng-model="model[options.key]" close-on-select="true" title="{{model[options.name]}}" ng-required="required">

  <ui-select-match placeholder="{{options.templateOptions.placeholder}}" allow-clear="true">
    {{$select.selected.name}}
  </ui-select-match>

  <ui-select-choices repeat="choice[options.templateOptions.itemValue] as choice in options.templateOptions.options | filter:(reload ? '' : $select.search)" refresh="reload($select.search)">
    <div ng-bind-html="choice[options.templateOptions.itemLabel]| highlight: $select.search"></div>
  </ui-select-choices>

</ui-select>

<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key]" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/signature.html': `<div class="form-signature" data-ng-if="!formState.readOnly" style="max-width: 700px">
  <signature-pad
    dataurl="model[options.key]"
    clear="clear"
    width="700"
    height="250"
    disabled="showInputBox">
  </signature-pad>

  <input ng-model="model[options.key]" type="hidden" />
  <input class="form-control my-4" ng-if="showInputBox" ng-model="typedSignature.value" type="text" ng-change="typedSignature.toCanvas()" aria-label="{{options.templateOptions.label}}" />

  <button type="button" class="btn btn-warning btn-xs" ng-click="clearSignature(clear)">Clear signature</button>
  <button type="button" class="btn btn-xs border border-info text-info" ng-click="toggleInputBox(clear)">{{ showInputBox ? 'Sign your name instead' : 'Type your name instead' }}</button>
</div>

<div data-ng-if="formState.readOnly" class="text-center">
  <img ng-src="{{itm}}" ng-if="itm.indexOf('data:image/png') > -1" class="img-signature" />
</div>
`,
  'app/blocks/widgets/forms/types/sqlreport.html': `<input type="hidden" data-ng-model="model[options.key].reportResult">
<sql-report-field-wrapper
    model="model[options.key]"
    extra="options.templateOptions.extra"
    report="options.templateOptions.report"
    report-id="options.templateOptions.reportId"
    read-only="options.templateOptions.readOnly || formState.readOnly"
></sql-report-field-wrapper>
`,
  'app/blocks/widgets/forms/types/string_list.html': `<input data-ng-if="!formState.readOnly" data-ng-model="model[options.key]" type="text" class="form-control" ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }" data-record-id="model._id" data-ng-list>
<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key] | nl2br" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/string.html': `<input placeholder="{{ to.placeholder }}" data-ng-if="!formState.readOnly" data-ng-model="model[options.key]" type="text" class="form-control" ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }" data-record-id="model._id">
<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key] | nl2br" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/text_heading.html': `<h4>{{ options.templateOptions.label}}</h4>
`,
  'app/blocks/widgets/forms/types/text_text.html': `<div data-ng-bind-html="options.templateOptions.label | nl2br | a2nt | videoUrlToIframe" class="readonly"></div>`,
  'app/blocks/widgets/forms/types/text.html': `<div data-ng-if="!formState.readOnly">
    <textarea msd-elastic  data-ng-model="model[options.key]" class="form-control" rows="model[options.templateOptions.rows]" cols="model[options.templateOptions.cols]" ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }"></textarea>
</div>
<div data-ng-if="formState.readOnly" data-ng-bind-html="model[options.key] | nl2br"></div>
<div kz-feature-enabled feature="turnitin" data-ng-if="to.turnitInOptions.enabled">
    <turnitin-field
        model="model"
        key="options.key"
        read-only="formState.readOnly"
        max-attempts="to.turnitInOptions.attempts"
        origin-id="to.originId"
        field-id="to.fieldId"
        enable-anti-plagiarism-title="to.turnitInOptions.buttonLabel"
        title="to.label"
    ></turnitin-field>
</div>
`,
  'app/blocks/widgets/forms/types/tree.html': `<div class="form-wrap" data-ng-if="!formState.readOnly" ng-model="model[options.key]"></div>

<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key]" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/typeahead.html': `<input class="form-control" type="{{ to.inputType }}" sf-typeahead
  options="to.tpOptions" datasets="datasets" autocomplete="off"
  data-ng-model="innerModel" invite-validator invite-domain-validator allow-custom="to.allowCustom">
`,
  'app/blocks/widgets/forms/types/username.html': `<input placeholder="{{ to.placeholder }}" data-ng-if="!formState.readOnly" data-ng-model="model[options.key]" type="text" class="form-control" ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }" data-record-id="model._id">
<div data-ng-if="formState.readOnly">
  <span kz-form-title item="model[options.key] | nl2br" type="{{ options.type }}"></span>
</div>
`,
  'app/blocks/widgets/forms/types/wysiwyg.html': `<ng-quill-editor ng-if="!formState.readOnly"
    ng-model="model[options.key]"
    toolbar="true"
    link-tooltip="true"
    image-tooltip="true"
    class="form-control wysiwyg-editor"
    editor-required="true"
    required="required"
    error-class="input-error"
></ng-quill-editor>
<div ng-if="formState.readOnly" data-ng-bind-html="model[options.key] | nl2br | a2nt | videoUrlToIframe" class="readonly"></div>`,
  'app/blocks/widgets/forms/wrappers/file.html': `<div class="form-group">
  <div class="row">
    <div class="col-xs-12">
      <label for="{{::id}}" class="control-label" ng-if="to.label">
        {{to.label}}
        <i ng-show="to.required && !to.disabled && !formState.readOnly" class="icon-star required"></i>
        <i ng-if="to.disabled && !formState.readOnly" class="icon-lock disabled"></i>
      </label>

      <formly-transclude></formly-transclude>
    </div>
    <div class="col-xs-12" ng-if="!formState.readOnly && (to.helpText || to.helpTextHtml)">
      <p ng-if="to.helpText" class="text-gray">{{to.helpText}}</p>
      <p ng-if="to.helpTextHtml" class="text-gray" ng-bind-html="to.helpTextHtml"></p>
    </div>
  </div>
</div>
`,
  'app/blocks/widgets/forms/wrappers/hasError.html': `<div class="form-group {{  (form.$submitted || options.formControl.$touched) && fc.$invalid ? 'has-error' : '' }}">
  <div data-ng-class="{'form-group': true, 'has-error': (form.$submitted || options.formControl.$touched) && fc.$invalid }">
    <formly-transclude></formly-transclude>
    <div class="hint" ng-messages="fc.$error" ng-if="(form.$submitted || options.formControl.$touched)" class="error-messages">
      <p ng-show="options.formControl.$error[name] === true" class="text-danger" ng-message="{{ name }}" ng-repeat="(name, message) in options.validation.messages" class="message"><i class="icon-warning"></i>{{ message(fc.$viewValue, fc.$modelValue, this)}}</p>
    </div>
  </div>
</div>
`,
  'app/blocks/widgets/forms/wrappers/label.html': `<div class="row">
  <div class="col-xs-12">
    <label for="{{::id}}" class="control-label" ng-if="to.label">
      {{to.label}}
      <i ng-show="to.required && !to.disabled && !formState.readOnly" class="icon-star required"></i>
      <i ng-if="to.disabled && !formState.readOnly" class="icon-lock disabled"></i>
    </label>
    <span data-ng-if="options.templateOptions.loading">
      <i class="icon-spin animate-spin"></i>
    </span>
    <formly-transclude></formly-transclude>
    <p ng-if="to.helpText && !formState.readOnly" class="text-gray">{{to.helpText}}</p>
    <p ng-if="to.helpTextHtml && !formState.readOnly" class="text-gray" ng-bind-html="to.helpTextHtml"></p>
  </div>
</div>
`,
  'app/blocks/widgets/forms/wrappers/messages.html': `<div>
  <formly-transclude></formly-transclude>

</div>
`,
  'app/blocks/widgets/forms/wrappers/toggleButton.html': `<div class="form-group">
  <div class="row">
    <div class="col-xs-12">
      <div ng-switch on="formState.readOnly">
        <div ng-switch-when="true">
          <label class="control-label">{{to.label}}</label>
        </div>
        <div ng-switch-default class="togglebutton">
          <label for="{{::id}}" class="control-label">
            {{to.label}}
            <i ng-show="to.required && !to.disabled" class="icon-star required"></i>
            <i ng-if="to.disabled" class="icon-lock disabled"></i>
            <br /><br />
            <span aria-hidden="true">{{ 'No' | translate }}&nbsp;&nbsp;</span>
            <formly-transclude></formly-transclude>
            <span aria-hidden="true">{{ 'Yes' | translate }}</span>
          </label>
        </div>
        <p ng-if="to.helpText" class="text-gray">{{to.helpText}}</p>
      </div>
    </div>
  </div>
</div>
`,
  'app/blocks/widgets/header/header.html': `<div class="row">
  <div ng-class="{'col-xs-12 col-sm-12': !actions || actions.length === 0,
                  'col-xs-9 col-sm-5': actions && actions.length > 2,
                  'col-xs-9 col-sm-7': actions && actions.length <= 2
                  }">
    <ng-transclude></ng-transclude>
  </div>
  <div ng-if="actions" ng-class="{
                  'col-xs-3 col-sm-7': actions && actions.length > 2,
                  'col-xs-3 col-sm-5': actions && actions.length <= 2
                  }">
    <kz-page-buttons class="page-actions" actions="actions" use-contextual-menu="true"></kz-page-buttons>
  </div>
</div>
`,
  'app/blocks/widgets/progress/progress-inline.html': `<span class="inline-progress">
    <span class="progress">
        <span class="progress-bar progress-bar-{{ labelStyle }}" aria-label="{{description}}" role="progressbar" ng-attr-aria-valuenow="{{ completionRate }}" aria-valuemin="0" aria-valuemax="100" ng-style="{ width: completionRate + '%'}"></span>
    </span>
    <span class="text-gray">
        <span class="text-{{ labelStyle }}"><ng-transclude></ng-transclude><span data-ng-if="!useTransclude">{{ numerator }} / {{ denominator }} {{::objName}} ({{ completionRate }} %)</span></span>
    </span>
</span>
`,
  'app/blocks/widgets/progress/progress.html': `<div>
  <p class="text-gray">
    <span class="text-{{ labelStyle }}"><ng-transclude></ng-transclude><span data-ng-if="!useTransclude">{{ numerator }} / {{ denominator }} {{::objName}} ({{ completionRate }} %)</span></span>
  </p>
  <div class="progress">
    <div class="progress-bar progress-bar-{{ labelStyle }}" aria-label="{{description}}" role="progressbar" ng-attr-aria-valuenow="{{ completionRate }}" aria-valuemin="0" aria-valuemax="100" ng-style="{ width: completionRate + '%'}"></div>
  </div>
</div>
`,
  'app/blocks/widgets/progress/progress.new.html': `<div class="kz-progress" ng-class="{'kz-progress--inline': inline}">
  <div class="kz-progress__progress-bar" ng-if="showBar">
    <div class="progress">
      <div aria-label="{{objName}}" class="progress-bar progress-bar-{{ labelStyle }}" role="progressbar" ng-attr-aria-valuenow="{{ completionRate }}" aria-valuemin="0" aria-valuemax="100" ng-style="{ width: completionRate + '%'}"></div>
    </div>
  </div>
  <div class="kz-progress__progress-stats">
    <p class="text-gray"><span class="text-{{ labelStyle }}">{{ statsCount }}</span></p>
  </div>
</div>
`,
  'app/blocks/widgets/search/kz-advanced-search.html': `<div>
  <formly-form model="model.filteredBy" fields="fields" form="form" aria-label="Filtered by"></formly-form>
  <formly-form model="model" ng-if="orderFields" fields="orderFields" form="form" aria-label="Other fields"></formly-form>
</div>
`,
  'app/blocks/widgets/search/kz-refine-filter.html': `<div class="refine-filters">
  <div class="row" ng-if="list">
    <div class="col-sm-8">
      <ul class="list-unstyled list-inline" ng-if="false && refineBy && facet.options.length">
        <li>
          Refine by {{ facet.label.toLowerCase() }}:</li>
        <li ng-repeat="option in facet.options track by $index">
          <a href="" ng-click="selectOption(option.id)">{{ option.title }}</a>
        </li>
        <li>
          <a href="" ng-click="clearAll()">{{ clearRefineTitle || ('All' | translate) }}</a>
        </li>
      </ul>
    </div>
    <div class="col-sm-4 text-right pull-right">
      {{ orderByTitle || ('Ordered by' | translate) }}
      <button
        type="button"
        ng-if="orderGroupsCount > 1"
        data-target="#"
        class="dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="listbox"
        aria-expanded="false">
        {{ list.search.orderGroups[list.searchModel.orderBy || list.search.defaultOrder].title }}
        <span class="caret"></span>
      </button>
      <ul role="listbox" ng-if="orderGroupsCount > 1" class="dropdown-menu">
        <li
          role="option"
          aria-selected="{{list.search.orderGroups[list.searchModel.orderBy || list.search.defaultOrder].title === order.title}}"
          ng-repeat="(key, order) in orderGroups">
            <a href="" ng-click="selectOrder(key)">{{order.title | separateByUppercase | lowercase}}</a>
        </li>
      </ul>
      <ul role="listbox" ng-if="orderGroupsCount === 1" class="list-inline list-unstyled">
        <li role="option" ng-repeat="(key, order) in orderGroups">
          {{order.title | separateByUppercase | lowercase}}
        </li>
      </ul>
    </div>
  </div>
</div>
`,
  'app/blocks/widgets/search/kz-search-applied.html': `<span data-ng-repeat="item in filters track by $index">
    <span class="text-info">{{ item.label }}</span> matching
    <span data-ng-if="item.value.push" data-ng-repeat="itm in item.value track by $index">
      <span class="text-success" data-ng-if="item.titled">{{ itm }}</span>
      <span class="text-success" data-ng-if="!item.titled" kz-category-title category="itm"></span>
      <span data-ng-if="!$last">, </span>
    </span>
    <span class="text-success" data-ng-if="!item.value.push && item.titled">{{ item.value }}</span>
    <span class="text-success" data-ng-if="!item.value.push && !item.titled" kz-category-title category="item.value"></span>
    <span data-ng-if="!$last">and</span>
</span>
`,
  'app/blocks/widgets/search/kz-search-string.html': `<span class="text-gray" data-ng-show="list.found_count">{{ 'Found' | translate }}
  <span class="text-success">{{ list.found_count }}</span> {{ 'items' | translate }}
  <span data-ng-if="!(list.searchModel.filteredBy | kzIsEmpty:'deep')">
    {{ 'for' | translate }} <span kz-search-applied></span>
  </span>
</span>
`,
  'app/blocks/widgets/search/kz-search.html': `<div class="row search-bar">
  <div class="search-filters col-xs-12">
    <!--<p class="lead">Search options</p>-->
    <form ng-submit="applyFilters()">
      <div class="forms">
      <!-- do not put anything here. Contents is emptied in kz-search.directive.js -->
      </div>
      <div data-ng-if="!_.isEmpty(search.filteredBy) && !search.options.noButtons">
        <button type="submit" class="btn btn-xs btn-primary" data-ng-click="applyFilters()">Apply filters</button>
        <button type="button" class="btn btn-xs btn-danger btn-bordered" data-ng-click="removeAllFilters()">Remove all</button>
      </div>
    </form>
  </div>
</div>
`,
  'app/blocks/widgets/search/kz-simplesearch.html': `<div data-ng-if="list.search">
    <facetly data-ng-if="useFacetly" facets="facets"

      options="list.search.facetly.options" ng-model="list.searchModel.filteredBy"
      applied-filters="list.appliedFilters" do-search="search()" do-remove-all="removeAll()">
    </facetly>
    <div data-ng-if="!useFacetly" class="row">
        <div class="col-sm-8">
            <kz-advanced-search model="list.searchModel" search="list.search" facets="facets"></kz-advanced-search>
        </div>
        <div class="col-sm-4">
            <div class="">
                <a href="" class="facetly-button facetly-button-success" ng-click="search()">{{ 'Search' | translate }}</a>
                <a data-ng-if="!(list.searchModel.filteredBy | kzIsEmpty:'deep')" class="facetly-button facetly-button-danger" href="" ng-click="removeAll()">Clear</a>
            </div>
        </div>
    </div>
</div>`,
  'app/blocks/widgets/search/kz.filters-banner.html': `<div class="wrapper">
  <div class="row" data-ng-if="show">
    <div class="col-sm-9">
      <ul class="list-inline list-unstyled">
        <li>Showing search results for: </li>
        <li data-ng-repeat="(key,value) in appliedFilters" data-ng-if="value.length > 0">
          <span class="label-filter">
            <span class="text-gray text-uppercase">{{key | separateByUppercase }}: </span>
            <span data-ng-switch="key">
              <span data-ng-switch-when="blueprint" kz-form-title item="value" type="tree" kzType="tree" watch="true"></span>
              <span data-ng-switch-when="eventType_versionGroupId" version-title version-group-ids="value"></span>
              <span data-ng-switch-when="eventType" version-title version-group-ids="value"></span>
              <!--<span data-ng-switch-when="eventType" kz-form-title item="value" type="tree" kzType="tree" watch="true"></span>-->
              <span data-ng-switch-when="relation" kz-form-title item="value" type="tree" kzType="tree" watch="true"></span>
              <span data-ng-switch-when="userfield" kz-form-title item="value" type="tree" kzType="tree" watch="true"></span>
              <span data-ng-switch-when="state">
                <span data-ng-repeat="val in value track by $index">{{ val | eventState }}</span>
              </span>
              <span data-ng-switch-when="roles" kz-form-title item="value" type="role" kzType="role" watch="true"></span>
              <span data-ng-switch-default data-ng-bind="value"></span>
            </span>
          </span>
          <span class="text-gray label-connect" data-ng-if="!$last">AND</span>
        </li>
      </ul>
    </div>
    <div class="col-sm-3 text-right">
      <ul class="list-inline list-unstyled">
        <li><a href="" data-ng-click="removeAllAppliedFilters()" class="btn btn-xs btn-danger">Remove all filters</a></li>
      </ul>
    </div>
  </div>
</div>
`,
  'app/components/accounts/org-chooser.html': `<div class="row">
  <div class="col-xs-12 col-sm-6 col-sm-offset-3">
    <form>

      <div class="wrapper">

        <div class="row">
          <div class="col-xs-12">
            <h1>risr/advance</h1>
          </div>
        </div>

        <div kz-loading loaded="orgChooserCtrl.loaded" class="row" data-ng-if="!orgChooserCtrl.loaded">
        </div>

        <div class="row" data-ng-if="orgChooserCtrl.error">
          <div class="col-xs-12">
            <span class="text-danger">{{ orgChooserCtrl.error }}</span>
          </div>
        </div>

        <div class="row" data-ng-if="orgChooserCtrl.offline">
          <div class="col-xs-12">
            <p class="box box-warning">
              Listed below are all your organisations in which you have enabled offline
              access. If you believe anything is missing please try again when you
              have a network connection.
            </p>
          </div>
        </div>

        <div class="row" data-ng-repeat="organisation in orgChooserCtrl.organisations">
            <div class="col-xs-8">
              <p>
                <span data-ng-bind="::organisation.name"></span>
                <span data-ng-if="organisation.count > 0" class="text-right badge badge-danger">
                  Unsynced data: {{ organisation.count }} items
                </span>
              </p>
            </div>

            <div class="col-xs-4">
              <div class="button-list">
                <ul class="list-unstyled list-inline">
                  <li><a href="" data-ng-click="orgChooserCtrl.chooseOrg(organisation.id)" class="btn btn-sm btn-border btn-primary">Choose</a></li>
                </ul>
              </div>
            </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <p class="text-gray">
              <a href="" data-ng-click="orgChooserCtrl.logout()" title="Log out">Log in as a different user</a>
            </p>
          </div>
        </div>

      </div>
    </form>
  </div>
</div>
`,
  'app/components/accounts/partials/organisation-select.html': `<form>
  <div class="form-group">
    <ui-select
      ng-model="loginCtrl.organisationId"
      on-select="loginCtrl.selectOrganisation(loginCtrl.organisationId)"
      title="Select your organisation..."
      close-on-select="true">
      <ui-select-match placeholder="Select your organisation...">
        {{$select.selected.name}}
      </ui-select-match>
      <ui-select-choices repeat="organisation.id as organisation in loginCtrl.organisations | filter:$select.search">
        <div ng-bind-html="organisation.name | highlight: $select.search"></div>
      </ui-select-choices>
    </ui-select>

  </div>
  <p class="help-block text-left">After making your selection, you will be prompted to continue to the organisation’s login.</p>
</form>
`,
  'app/components/admin/eventType.wrapper.html': `<div>
  <p class="details">{{title}} <span kz-event-type-title event-type="value"></span></p>
</div>
`,
  'app/components/admin/pending-section.preview.html': `<div class="modal-header">
    <button type="button" class="close" data-ng-click="sectionCtrl.close()" aria-label="Close"><i class="icon-cancel"></i></button>
    <div class="modal-title">
      <h3>
        {{ sectionCtrl.eventType.name }} for <span epf-fullname user="sectionCtrl.resolvedDoc.doc.eventOwner"></span>
      </h3>
      <a target="_blank" href="" router-link="['/users/edit', sectionCtrl.resolvedDoc.doc.eventOwner, 'events',sectionCtrl.resolvedDoc.doc.event]">Click here to view the original event in a new window</a>
      <div data-ng-repeat="message in sectionCtrl.messages || [] track by $index">
        <p class="box box-{{message.type}}"><span class="text-gray">
          {{ message.message }}</span>
        </p>
      </div>
    </div>
</div>
<div class="modal-body event-modal-body" style="height: 100%; max-height: 300px">
  <div kz-loading loaded="sectionCtrl.loaded">
    <p class="box box-info" data-ng-if="sectionCtrl.userInfo.userState === 'waiting_for_approval' && sectionCtrl.invitableRoles">
      By approving this response this user will have an account created
      for them with the following role(s) assigned:
      <span data-ng-repeat="role in sectionCtrl.invitableRoles track by $index">
        {{ role.doc.title }}<span data-ng-if="!$last">, </span>
      </span>
    </p>

    <p class="box box-warning" data-ng-if="sectionCtrl.userInfo.userState === 'active' && !sectionCtrl.userInfo.userHasRoles">
      This user does not have the required role(s):
      <span data-ng-repeat="role in sectionCtrl.allRoles track by $index">
        {{ role.doc.title }}<span data-ng-if="!$last">, </span></span>. Please assign this manually from their
       <a target="_blank" router-link="['/users/view', sectionCtrl.resolvedDoc.doc.user]">profile</a> or simply approve the response by clicking below.
         </p>

    <p class="box box-info" data-ng-if="sectionCtrl.resolvedDoc.doc.section_type === 'not_registered'">
      This response has been submitted by a user who has chosen not to register.
      No user account will be created.
    </p>

    <div data-ng-if="!sectionCtrl.error">
      <event-section-view event-section="sectionCtrl.resolvedDoc"></event-section-view>
    </div>
  </div>
</div>
<div class="modal-footer" kz-loading loaded="sectionCtrl.loaded">
  <kz-page-buttons class="page-actions" use-contextual-menu="false" actions="sectionCtrl.actions"></kz-page-buttons>
</div>
`,
  'app/components/admin/pending-section.slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-sm-7">
      <h2 class="entry-title">
        <span data-ng-if="item">Section of </span>
        <span kz-event-title event="item" event-id="{{item.doc._id}}"></span>
        by <event-filled-by class="meta-author" user="item.getFilledBy()" event="item.doc" email="item.doc.email"/>
        <span kz-event-icons event="item"></span>
      </h2>
    </div>
    <div class="col-sm-5 col-right">
      <ul class="list-inline list-unstyled">
        <li>
            <kz-event-progress states="ctrl.sectionStates"></kz-event-progress>
        </li>
        <li>
          <span class="label label-default">Submitted on:</span> {{ submitted | date: dateFormat }}
        </li>
      </ul>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12" data-ng-if="ctrl.shownDescription && item.doc.dates">
      <div class="row audit-log">
        <div class="col-xs-12">
          <kz-audit-log id="{{ctrl.auditLogId}}" dates="::item.doc.dates"></kz-audit-log>
        </div>
      </div>
    </div>
  </div>
  <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons" left-slot-size="8"></kz-list-buttons>
</div>
`,
  'app/components/admin/pending-sections.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="pendingCtrl.actions"><h1>{{ 'Pending sections' | translate }}</h1></kz-header>

      <kz-simple-search list="pendingCtrl.list"></kz-simple-search>
      <kz-search-string list="pendingCtrl.list"></kz-search-string>

  </header>
  <kz-refine-filter list="pendingCtrl.list"
    refine-by="state"
    clear-refine-title="Default"
    ></kz-refine-filter>
</section>


<kz-list-view list="pendingCtrl.list" options="pendingCtrl.options">
<section-slot item="item" options="options"></section-slot>
</kz-list-view>
`,
  'app/components/announcements/directives/announcement-condensed.slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-sm-7">
      <h2>{{ ::item.title }}</h2>
      <ul class="list-inline list-unstyled">
        <li ng-if="item.visibleForRoles.length || item.visibleForRelations.length">
          <span class="label label-default">{{ 'Visible for' | translate }}: </span>
        </li>
        <li ng-if="item.visibleForRoles.length">
          <span class="text-info" ng-repeat="role in ::item.visibleForRoles | limitTo: ctrl.showLimit">
            <epf-role-title user-role="{{ ::role }}"></epf-role-title><span ng-if="!$last">, </span>
          </span>
          <span ng-if="item.visibleForRoles.length > ctrl.showLimit">
            <span class="text-info"> and {{ item.visibleForRoles.length - ctrl.showLimit }} more</span>
          </span>
        </li>
        <li ng-if="item.visibleForRelations.length">
          <span ng-repeat="relation in ::item.visibleForRelations | limitTo: ctrl.showLimit">
              <span class="text-info"><epf-relation-title relation="{{ ::relation }}"></epf-relation-title><span ng-if="!$last">, </span></span>
            </span>
            <span ng-if="item.visibleForRelations.length > ctrl.showLimit">
              <span class="text-info"> and {{ item.visibleForRelations.length - ctrl.showLimit }} more</span>
            </span>
          </span>
        </li>
      </ul>
    </div>

    <div class="col-sm-5 col-right">
      <ul class="list-inline list-unstyled">
        <li>
          <a href="" ng-click="ctrl.showPreview()" class="text-info" aria-label="{{ 'Show preview' | translate }}"><i class="icon-view"></i></a>
        </li>
        <li>
          <button type="button" class="btn-link text-success drag-handle" aria-label="Move {{::item.title}}" aria-describedby="announcements-move-instructions"><i class="icon-move"></i></button>
        </li>
      </ul>
    </div>
  </div>
</div>
`,
  'app/components/announcements/directives/announcement.slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-sm-7">
      <h2>
        <span ng-if="!ctrl.canEditAnnouncement">{{ ::item.title }}</span>
        <a ng-if="ctrl.canEditAnnouncement" router-link="['/announcements/edit', item._id]" title="{{ 'Edit announcement' | translate }}">{{ ::item.title }}</a>
      </h2>
      <ul class="list-inline list-unstyled">
        <li ng-if="item.visibleForRoles.length || item.visibleForRelations.length">
          <span class="label label-default">{{ 'Visible for' | translate }}: </span>
        </li>
        <li ng-if="item.visibleForRoles.length">
          <span class="text-info" ng-repeat="role in ::item.visibleForRoles | limitTo: ctrl.showLimit">
            <epf-role-title user-role="{{ ::role }}"></epf-role-title><span ng-if="!$last">, </span>
          </span>
          <span ng-if="item.visibleForRoles.length > ctrl.showLimit">
            <span class="text-info"> and {{ item.visibleForRoles.length - ctrl.showLimit }} more</span>
          </span>
        </li>
        <li ng-if="item.visibleForRelations.length">
          <span ng-repeat="relation in ::item.visibleForRelations | limitTo: ctrl.showLimit">
              <span class="text-info"><epf-relation-title relation="{{ ::relation }}"></epf-relation-title><span ng-if="!$last">, </span></span>
            </span>
            <span ng-if="item.visibleForRelations.length > ctrl.showLimit">
              <span class="text-info"> and {{ item.visibleForRelations.length - ctrl.showLimit }} more</span>
            </span>
          </span>
        </li>
        <li ng-if="item.visibleForUsers.length">
          <span class="text-info" ng-repeat="user in ::item.visibleForUsers | limitTo: ctrl.showLimit">
            <span epf-fullname user="user"></span><span ng-if="!$last">, </span>
          </span>
          <span ng-if="item.visibleForUsers.length > ctrl.showLimit">
            <span class="text-info"> and {{ item.visibleForUsers.length - ctrl.showLimit }} more</span>
          </span>
        </li>
      </ul>
    </div>

    <div class="col-sm-5 col-right">
      <ul class="list-inline list-unstyled">
        <li ng-if="item.status !== 'unpublish'">
          <span ng-if="item.publishDate <= ctrl.today" class="label label-default">{{ 'Published on' | translate }}: </span>
          <span ng-if="item.publishDate > ctrl.today" class="label label-default">{{ 'Scheduled for' | translate }}: </span>
          <span class="text-info">{{ ::item.publishDate | date: ctrl.dateFormat }}</span>
        </li>
        <li ng-if="item.expireDate && item.status !== 'unpublish'">
          <span class="label label-default">{{item.expireDate < ctrl.today ? ('Expired' | translate) : ('Expires' | translate)}} {{ 'on' | translate }}: </span>
          <span class="text-info">{{ ::item.expireDate | date: ctrl.dateFormat }}</span>
        </li>
        <li ng-if="item.status === 'unpublish'">
          <span class="label label-warning">{{ 'Unpublished' | translate }}</span>
        </li>
      </ul>
    </div>
  </div>

  <kz-audit-log id="{{ctrl.auditLogId}}" dates="::item.dates" ng-if="ctrl.shownDescription"></kz-audit-log>

  <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons"></kz-list-buttons>
</div>
`,
  'app/components/announcements/directives/basic-form.html': `<formly-form
  class="announcement-basic-form"
  model="announcement"
  fields="ctrl.form.fields"
  aria-label="Announcement fields">
</formly-form>
`,
  'app/components/announcements/directives/kz-inbox-notifications.html': `<div class="row box" ng-class="{'box-warning': ctrl.unread.length > 0, 'box-info': ctrl.alwaysShow}" ng-if="ctrl.alwaysShow || ctrl.unread.length > 0">
  <div class="col-sm-8">
    <p class="text-warning" ng-if="ctrl.unread.length > 0">
      <i class="icon-mail"></i> {{ 'You have' | translate }} <strong>{{ ctrl.unread.length }} {{ 'unread' | translate }}</strong> <ng-pluralize count="{{ ctrl.unread.length }}" when="{'1': 'announcement', 'other': 'announcements'}"></ng-pluralize> {{ 'in your Inbox.' | translate }}
    </p>
    <p class="text-info" ng-if="ctrl.unread.length === 0 && ctrl.alwaysShow">
      <i class="icon-mail"></i> {{ 'You have no unread announcements in your Inbox.' | translate }}
    </p>
  </div>
  <div class="col-sm-4 text-right-sm">
    <a href="" class="btn btn-xs border" ng-class="{'border-warning text-warning': ctrl.unread.length > 0, 'border-info text-info': ctrl.alwaysShow}" router-link="['/inbox']">{{ 'Go to my inbox' | translate }}</a>
  </div>
</div>
`,
  'app/components/announcements/directives/visibility-form.html': `<div class="row">
  <div class="col-xs-12">
    <p class="box box-info">
      <i class="icon-info"></i>
      <span class="text-gray">{{ 'Here you can select the roles and relations the user must have in order to be able to see this message. If you select both, then the user must have at least one of the roles selected AND one of the relations selected in order to be able to view it.' | translate }}</span>
    </p>

    <formly-form
      model="announcement"
      fields="ctrl.rolesRelationsForm.fields"
      aria-label="Roles and relation">
    </formly-form>

    <p class="box box-info">
      <i class="icon-info"></i>
      <span class="text-gray">{{ 'Any individual users who you specify below will be able to view this message, regardless of any roles or relations selected above.' | translate }}</span>
    </p>

    <formly-form
      model="announcement"
      fields="ctrl.usersListForm.fields"
      aria-label="Users list">
    </formly-form>
  </div>
</div>
`,
  'app/components/announcements/form.html': `<form novalidate unsaved-warning-form name="announcementCtrl.form" aria-label="announcementCtrl.form">

  <div kz-loading loaded="announcementCtrl.loaded">
    <div class="wrapper">
      <header class="row">
        <div class="col-sm-5">
          <h1>{{ announcementCtrl.isNew ? ('New' | translate) : ('Edit' | translate) }} {{ 'announcement' | translate }}</h1>
        </div>
        <div class="col-sm-7 button-list">

          <button type="button" class="btn btn-success btn-raised" unsaved-warning-clear ng-disabled="announcementCtrl.shouldNotSubmit" ng-click="announcementCtrl.save(announcementCtrl.form)">{{ 'Save' | translate }}</button>

          <p>
            <ul class="list-inline list-unstyled">
              <li ng-if="!announcementCtrl.isNew">
                <a href="" ng-click="announcementCtrl.remove()" class="text-danger" data-ng-disabled="announcementCtrl.submitted" unsaved-warning-clear>{{ 'Delete' | translate }}</a>
              </li>
              <li ng-if="announcementCtrl.canUnpublish">
                <a href="" ng-click="announcementCtrl.unpublish()" class="text-danger" data-ng-disabled="announcementCtrl.submitted" unsaved-warning-clear>{{ 'Unpublish' | translate }}</a>
              </li>
              <li ng-if="announcementCtrl.announcement.status && announcementCtrl.announcement.status === 'unpublish'">
                <a href="" ng-click="announcementCtrl.publish()" class="text-success" data-ng-disabled="announcementCtrl.submitted" unsaved-warning-clear>{{ 'Publish' | translate }}</a>
              </li>
              <li>
                <a router-link="['/announcements']" class="text-warning" data-ng-disabled="announcementCtrl.submitted">{{ 'Cancel' | translate }}</a>
              </li>
            </ul>
          </p>
        </div>
      </header>

      <div class="row">
        <div class="col-xs-12">
          <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <announcement-basic-form
            announcement="announcementCtrl.announcement">
          </announcement-basic-form>
        </div>
      </div>

    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-xs-12">
          <div class="row">
            <div class="col-xs-12">
              <p class="text-info"><strong>{{ 'Announcement visibility' | translate }}</strong></p>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <announcement-visibility-form
            announcement="announcementCtrl.announcement">
          </announcement-visibility-form>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-sm-6">
          <button ng-if="announcementCtrl.announcement.title" type="button" class="btn btn-info btn-border" ng-click="announcementCtrl.preview()">{{ 'Preview' | translate }}</button>
        </div>
        <div class="col-sm-6 button-list">
          <button type="button" class="btn btn-success btn-raised" unsaved-warning-clear ng-disabled="announcementCtrl.shouldNotSubmit" ng-click="announcementCtrl.save(announcementCtrl.form)">{{ 'Save' | translate }}</button>
        </div>
      </div>
    </div>
  </div>

</form>
`,
  'app/components/announcements/inbox/inbox-message-details.card.html': `<div class="row row-bordered" ng-if="loaded">
  <div class="col-xs-12">
    <p ng-if="message.readDate">{{ 'Message read on' | translate }} {{ message.readDate | date: dateFormat }}</p>
    <p ng-if="!message.readDate">{{ 'Message not yet read' | translate }}</p>
  </div>
</div>
`,
  'app/components/announcements/inbox/list.html': `<section class="wrapper">
  <header class="row">
    <kz-header actions="inboxCtrl.actions"><h1>{{ 'Inbox' | translate }}</h1></kz-header>
  </header>
</section>

<kz-list-view list="inboxCtrl.list" options="inboxCtrl.options">
  <div class="col-xs-12" >
    <div class="row event-inner">
      <div class="col-sm-7">
        <h2>
          <span ng-if="!item.isRead" class="label-color-dot label-warning-dot"></span>
          <a router-link="['/inbox', item._id]">{{ ::item.title }}</a>
        </h2>
      </div>

      <div class="col-sm-5 col-right">
        <ul class="list-inline list-unstyled">
          <li ng-if="!item.isRead">
            <span class="badge badge-warning font-bold">{{ 'New' | translate }}</span>
          </li>
          <li><span class="label label-default">{{ 'Published on' | translate }}:</span> <span class="text-info">{{ item.publishDate | date: inboxCtrl.dateFormat }}</span></li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div ng-bind-html="item.content | truncate:40" class="col-xs-12 readonly"></div>
    </div>
  </div>
</kz-list-view>
`,
  'app/components/announcements/inbox/view.html': `<section class="wrapper">
  <header class="row">
    <div class="col-xs-12">
      <h1>{{ inboxMessageCtrl.message.title }}</h1>
      <p>
        <span class="label label-default">{{ 'Published on:' | translate }}</span> <span class="text-info">{{ inboxMessageCtrl.message.publishDate | date: inboxMessageCtrl.dateFormat }}</span>
      </p>
    </div>
  </header>

  <div class="row">
    <div ng-bind-html="inboxMessageCtrl.message.content" class="col-xs-12"></div>
  </div>
</section>
`,
  'app/components/announcements/list-reorder.html': `<section class="wrapper">
  <header class="row">
    <kz-header actions="announcementsReorderCtrl.actions"><h1>{{ 'Announcements' | translate }}</h1></kz-header>
    <p>{{announcementsReorderCtrl.announcements.length}} announcements.</p>
  </header>
</section>

<p class="box box-info" ng-bind-html="announcementsReorderCtrl.reorderInfo"></p>

<div kz-loading loaded="announcementsReorderCtrl.loaded">
  <div hidden id="announcements-move-instructions">{{ 'Use the arrow up and down keys to move this announcement' | translate }}</div>
  <div ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost', onUpdate: announcementsReorderCtrl.reorder }">

    <div class="wrapper" ng-repeat="item in announcementsReorderCtrl.announcements track by item._id">
      <div class="row event progress-border" ng-class="announcementsReorderCtrl.getBorderClass(item)">
        <announcement-condensed-slot item="item"></announcement-condensed-slot>
      </div>
    </div>

  </div>
</div>
`,
  'app/components/announcements/list.html': `<section class="wrapper">
  <header class="row">
    <kz-header actions="announcementsCtrl.actions"><h1>{{ 'Announcements' | translate }}</h1></kz-header>
    <kz-simple-search list="announcementsCtrl.list"></kz-simple-search>
    <kz-search-string list="announcementsCtrl.list"></kz-search-string>
  </header>

  <kz-refine-filter
    list="announcementsCtrl.list"
    refine-by="status">
  </kz-refine-filter>
</section>

<kz-list-view list="announcementsCtrl.list" options="announcementsCtrl.options">
  <announcement-slot item="item"></announcement-slot>
</kz-list-view>
`,
  'app/components/announcements/preview.html': `<div class="modal-header">
  <button type="button" class="close" data-ng-click="announcementPreviewCtrl.close()" aria-label="{{ 'Close' | translate }}"><i class="icon-cancel"></i></button>
  <div class="modal-title">
    <h3>{{ ::announcementPreviewCtrl.announcement.title }}</h3>
    <span ng-if="announcementPreviewCtrl.announcement.publishDate" class="label label-default">{{ 'Published on:' | translate }} </span>
    <span ng-if="announcementPreviewCtrl.announcement.publishDate" class="text-info">{{ ::announcementPreviewCtrl.announcement.publishDate | date: announcementPreviewCtrl.dateFormat }}</span>
  </div>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-xs-12">
      <div ng-if="announcementPreviewCtrl.announcement.content.length" data-ng-bind-html="announcementPreviewCtrl.announcement.content | nl2br | a2nt | videoUrlToIframe" class="readonly"></div>
      <p class="text-gray" ng-if="!announcementPreviewCtrl.announcement.content.length"><em>{{ 'This announcement contains no further content.' | translate }}</em></p>
    </div>
  </div>
</div>
<div ng-if="announcementPreviewCtrl.announcement.isDismissable" class="modal-footer">
  <a href="" class="btn btn-sm btn-info" ng-click="announcementPreviewCtrl.dimiss()">{{ 'Dismiss' | translate }}</a>
</div>
`,
  'app/components/announcements/widgets/inbox/view.html': `<ul class="item-list item-list-bordered">
  <li class="item row" ng-class="{'item-new': !announcement.isRead}" ng-repeat="announcement in inboxCtrl.announcements | filter: inboxCtrl.shouldShow track by announcement._id">
    <div class="col-xs-12">

      <h3 class="text-lg">
        <span ng-if="!announcement.isRead" class="label-color-dot label-warning-dot"></span>
        <a href="" ng-class="{'text-warning': !announcement.isRead}" ng-click="inboxCtrl.openPreview(announcement)" ng-class="{'font-bold': !announcement.isRead}">
          {{ announcement.title }}
        </a>
      </h3>

      <ul class="list-inline list-unstyled">
        <li ng-if="!announcement.isRead">
          <span class="badge badge-warning font-bold">{{ 'New' | translate }}</span>
        </li>
        <li>
          <span class="label label-default" ng-class="{'font-bold': !announcement.isRead}">
            {{ 'Published on' | translate }}: {{ announcement.publishDate | date: inboxCtrl.dateFormat }}
          </span>
        </li>
      </ul>

      <div ng-bind-html="announcement.content | truncate:30" class="readonly"></div>

    </div>
  </li>

  <li class="item row" ng-show="!inboxCtrl.archiveIsVisible && !inboxCtrl.hasCurrentAnnouncements">
    <div class="col-xs-12">
      <p class="text-gray">{{ 'There are no published announcements for you at the moment.' | translate }}</p>
    </div>
  </li>

  <li class="item row">
    <div class="col-sm-6" ng-show="inboxCtrl.hasArchive">
      <a href="" ng-click="inboxCtrl.toggleArchiveView()"><i class="icon-archive"></i> {{ inboxCtrl.archiveIsVisible ? ('Hide' | translate) : ('Show' | translate) }} {{ 'archive' | translate }}</a>
    </div>
    <div class="col-sm-6" ng-if="inboxCtrl.hasCurrentAnnouncements">
      <a href="" class="btn btn-xs btn-info" router-link="['/inbox']">{{ 'Go to my inbox' | translate }}</a>
    </div>
  </li>
</ul>
`,
  'app/components/blueprints/blueprint.slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-sm-7">
      <h2>
        <a router-link="['/blueprints/edit', item.doc._id]" title="{{ 'Edit announcement' | translate }}">{{ ::item.doc.name }}</a>
      </h2>
      <div class="text-gray">{{ item.doc.description }}</div>
    </div>

    <div class="col-sm-5 col-right">
      <kz-state map="ctrl.BLUEPRINT_TYPES" state="item.doc.blueprintType"></kz-state>
    </div>
  </div>

  <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons"></kz-list-buttons>
</div>
`,
  'app/components/blueprints/blueprintMap.edit.html': `<form novalidate unsaved-warning-form name="form" ng-submit="$ctrl.save(form)" aria-label="{{ 'Edit blueprint details' | translate }}">
<div class="wrapper">
    <header class="row">
        <div class="col-sm-6">
            <h1>{{ 'New blueprint map' | translate }}</h1>
        </div>
        <div class="col-sm-6">
            <p class="button-list">
                <button type="submit" unsaved-warning-clear class="btn btn-success btn-raised" data-ng-disabled="form.$invalid || $ctrl.showMappedToForm || $ctrl.showMappedForm">{{ 'Save' | translate }}</button>
                <button type="button" class="btn btn-info btn-raised" router-link="['/blueprint-maps']">{{ 'Cancel' | translate }}</button>
            </p>
        </div>
      <audit-log-component ng-if="$ctrl.blueprintMap._rev" entries="$ctrl.auditlog" on-expand="$ctrl.loadAuditlog()"></audit-log-component>
    </header>

    <div class="row" kz-loading loaded="$ctrl.loaded">
        <div class="col-sm-12">
            <formly-form model="$ctrl.model" fields="$ctrl.mapForm.fields" aria-label="{{ 'Blueprint map form' | translate }}"></formly-form>

            <div class="box box-info">
              <p class="text-info-700 font-semibold">{{ 'Instructions' | translate }}</p>
              <ol>
                <li class="text-info-700">{{ 'Click "Add blueprint" to select your source(s). You can add multiple blueprints to group them together.' | translate }}</li>
	              <li class="text-info-700">{{ 'Click "Add map to" to define their destination.' | translate }}</li>
	              <li class="text-info-700">{{ 'Link them to either another blueprint or a numeric value.' | translate }}</li>
              </ol>
            </div>

        </div>

        <div class="col-sm-6">
            <div class="my-4">
                <p class="font-semibold mb-4">{{ 'Map these blueprints:' | translate }}</p>
                <ul class="list-unstyled flex flex-column gap-4">
                    <li class="flex items-center gap-4" ng-repeat="blp in $ctrl.mappedBlueprints track by blp.id">
                      <span class="font-semibold text-info">{{ blp.name }}</span>
                      <button ng-if="$ctrl.hasEditPermission" type="button" ng-click="$ctrl.removeBlueprint(blp)" class="btn btn-link text-danger">
                        <span class="sr-only">{{ 'Remove' | translate }} {{ blp.name }}</span>
                        <i aria-hidden="true" class="glyphicon glyphicon-remove"></i>
                      </button>
                    </li>
                </ul>
            </div>
            <button ng-if="$ctrl.hasEditPermission" type="button" ng-if="!$ctrl.showMappedForm" class="btn btn-info btn-outline" ng-click="$ctrl.showMappedBlueprint()">{{ 'Add blueprint' | translate }}</button>

            <div ng-if="$ctrl.showMappedForm">
                <formly-form model="$ctrl.mappedModel" fields="$ctrl.blueprintForm.fields" aria-label="{{ 'Blueprint map form' | translate }}"></formly-form>
                <button ng-if="$ctrl.hasEditPermission" type="button" class="btn btn-info btn-raised" ng-click="$ctrl.addMappedBlueprint()">{{ 'Add' | translate }}</button>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="my-4">
                <p class="font-semibold mb-4">{{ 'to:' | translate }}</p>
                <ul class="list-unstyled flex flex-column gap-4">
                    <li class="flex items-center gap-4" ng-repeat="blp in $ctrl.mappedTos track by $index">
                      <span class="font-semibold text-info">{{ blp.name }} ({{ blp.type }})</span>
                        <button ng-if="$ctrl.hasEditPermission" type="button" ng-click="$ctrl.removeMapTo(blp)" class="btn btn-link text-danger">
                          <span class="sr-only">{{ 'Remove' | translate }} {{ blp.name }} {{ blp.type }}</span>
                          <i aria-hidden="true" class="glyphicon glyphicon-remove"></i>
                        </button>
                    </li>
                </ul>
            </div>
            <button ng-if="$ctrl.hasEditPermission" type="button" ng-if="!$ctrl.showMappedToForm" class="btn btn-info btn-outline" ng-click="$ctrl.showMappedTo()">{{ 'Add map to' | translate }}</button>

            <div ng-if="$ctrl.showMappedToForm">
                <formly-form model="$ctrl.mappedToModel" fields="$ctrl.mappedTo.fields" aria-label="{{ 'Blueprint map to form' | translate }}"></formly-form>
                <button ng-if="$ctrl.hasEditPermission" type="button" class="btn btn-info btn-outline" ng-click="$ctrl.addMappedTo()">{{ 'Add' | translate }}</button>
            </div>
        </div>
    </div>
</div>
</form>
`,
  'app/components/blueprints/blueprintMap.mapping.html': `<div class="wrapper">
    <header class="row">
      <div class="col-sm-6">
        <h1>{{ $ctrl.blueprintMap.name }}</h1>
      </div>
      <div class="col-sm-6">
        <p class="button-list">
          <button type="button" unsaved-warning-clear class="btn btn-success btn-raised" data-ng-click="$ctrl.save()">{{ 'Save' | translate }}</button>
        </p>
      </div>
      <audit-log-component ng-if="$ctrl.blueprintMap._rev" entries="$ctrl.auditlog" on-expand="$ctrl.loadAuditlog()"></audit-log-component>
    </header>

    <div class="row" kz-loading loaded="$ctrl.loaded">
        <div class="col-sm-12 alert alert-danger" ng-if="$ctrl.error">
            {{ $ctrl.error }}
        </div>
        <div class="col-sm-12" ng-if="!$ctrl.error">
            <div>{{ 'Maps' | translate }}
                <ul>
                    <li ng-repeat="blp in $ctrl.blueprintMap.blueprints track by $index">
                        {{ $ctrl.blueprints[blp].blueprint.name }}
                    </li>
                </ul>
                {{ 'to' | translate }}
                <ul>
                    <li ng-repeat="coord in $ctrl.blueprintMap.coordinate_values track by $index">
                        <span ng-if="coord.type == 'blueprint'">
                            {{ $ctrl.blueprints[coord.id].blueprint.name }}
                        </span>
                        <span ng-if="coord.type != 'blueprint'">
                            {{ coord.id }}
                        </span>
                    </li>
                </ul>

                <form name="mappingForm" ng-if="false">
                    <formly-form model="$ctrl.model" fields="$ctrl.mappingForm.fields" form="mappingForm" aria-label="{{ 'Date time fields' | translate }}"></formly-form>
                </form>

                <table class="table table-bordered table-hover" data-ng-if="!($ctrl.blueprintMap.blueprints | kzIsEmpty)">
                    <tr>
                        <th ng-repeat="blp in $ctrl.blueprintMap.blueprints track by $index">
                            {{ $ctrl.blueprints[blp].blueprint.name }}
                        </th>
                        <th ng-repeat="coord in $ctrl.blueprintMap.coordinate_values track by $index">
                            <span ng-if="coord.type == 'blueprint'">
                                {{ $ctrl.blueprints[coord.id].blueprint.name }}
                            </span>
                            <span ng-if="coord.type != 'blueprint'">
                                {{ coord.id }}
                            </span>
                        </th>
                        <th>&nbsp</th>
                    </tr>
                    <tr ng-repeat="row in $ctrl.keyData track by $index">
                        <th ng-repeat="blp in row.blueprints track by $index">
                            {{ blp.value }}
                        </th>
                        <td ng-repeat="coord in $ctrl.blueprintMap.coordinate_values track by $index">
                            <span ng-if="coord.type == 'blueprint'">
                                {{ $ctrl.blueprints[coord.id].categories[$ctrl.model[row.id][coord.id]].value }}
                            </span>
                            <span ng-if="coord.type != 'blueprint'">
                                {{ $ctrl.model[row.id][coord.id] }}
                            </span>
                        </td>
                        <td>
                            <a ng-click="$ctrl.edit(row)"><i class="icon-edit"></i></a>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>`,
  'app/components/blueprints/blueprintMap.view.html': `<div class="wrapper">
    <header class="row">
        <div class="col-sm-6">
            <h1>{{ $ctrl.blueprintMap.name }}</h1>
        </div>
    </header>

    <div class="row" kz-loading loaded="$ctrl.loaded">
        <div class="col-sm-12">
            <div>{{ 'Maps' | translate }}
                <ul>
                    <li ng-repeat="blp in $ctrl.blueprintMap.blueprints">
                        {{ $ctrl.blueprints[blp].blueprint.name }}
                    </li>
                </ul>
                {{ 'to' | translate }}
                <ul>
                    <li ng-repeat="coord in $ctrl.blueprintMap.coordinate_values">
                        <span ng-if="coord.type == 'blueprint'">
                            {{ $ctrl.blueprints[coord.id].blueprint.name }}
                        </span>
                        <span ng-if="coord.type != 'blueprint'">
                            {{ coord.id }}
                        </span>
                    </li>
                </ul>

                <table class="table">
                    <tr ng-repeat="row in $ctrl.blueprintMap.data">
                        <th ng-repeat="blp in $ctrl.blueprintMap.blueprints">
                            {{ $ctrl.blueprints[blp].categories[row.id[$index]].value }}
                        </th>
                        <td ng-repeat="coord in $ctrl.blueprintMap.coordinate_values">
                            <span ng-if="coord.type == 'blueprint'">
                                {{ $ctrl.blueprints[coord.id].categories[row.value[$index]].value }}
                            </span>
                            <span ng-if="coord.type != 'blueprint'">
                                {{ row.value[$index] }}
                            </span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>`,
  'app/components/blueprints/blueprintMapItem.edit.html': `<form novalidate name="itemForm" ng-submit="$ctrl.submit()">
<div class="modal-header event-modal-header">

    <header class="row">
      <div class="col-sm-10">
        {{ 'Enter mapping for' | translate }}
        <h3>
            {{ $ctrl.itemName }}
        </h3>
      </div>

      <div class="col-sm-2 text-right">
        <p class="button-list">
          <button type="button" class="close" data-ng-click="$ctrl.close()" aria-label="{{ 'Close' | translate }}"><i class="icon-cancel"></i></button>
        </p>
      </div>
    </header>
  </div>

  <div class="modal-body">
        <formly-form model="$ctrl.model" fields="$ctrl.itemForm.fields" form="itemForm" aria-label="{{ 'Blueprint map coordinate form' | translate }}"></formly-form>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-sm-12">
        <button unsaved-warning-clear type="submit"
            class="btn btn-success btn-raised"
        >{{ 'Set' | translate }}</button>
      </div>
    </div>
  </div>

</form>`,
  'app/components/blueprints/blueprintMaps.list.html': `<section class="wrapper">
    <header class="row">
        <kz-header actions="blueprintMapsCtrl.actions"><h1>{{ 'Blueprint Maps' | translate }}</h1></kz-header>
        <kz-simple-search list="blueprintMapsCtrl.list"></kz-simple-search>
        <kz-search-string list="blueprintMapsCtrl.list"></kz-search-string>

    </header>
    <kz-refine-filter
        list="blueprintMapsCtrl.list"
    ></kz-refine-filter>
  </section>


  <kz-list-view list="blueprintMapsCtrl.list" options="blueprintMapsCtrl.options">
  <list-slot item="item" options="options"></list-slot>
  </kz-list-view>
`,
  'app/components/blueprints/form.discrete.html': `<div class="row">
  <legend>{{ 'Blueprint categories' | translate }}</legend>
</div>

<!-- Nested node template -->
<script type="text/ng-template" id="blueprint-hierarchy.html">
  <div ui-tree-handle class="row tree-node tree-node-content">
    <div class="col-xs-10">
      <div class="form-group" data-ng-class="{ 'has-error has-feedback': form[category._id].$invalid && formIsSubmitted}">
        <label for="{{category._id}}-name">{{ 'Category name' | translate }} <i ng-class="{'icon-star required': blueprintCtrl.hasEditPermission, 'icon-lock disabled': !blueprintCtrl.hasEditPermission}"></i></label>
        <input data-nodrag data-ng-model="category.name" type="text" id="{{category._id}}-name" name="{{category._id}}-name" class="form-control" data-ng-required="true" aria-describedby="{{category._id + '-status'}}" ng-disabled="!blueprintCtrl.hasEditPermission">
        <div data-ng-if="form[category._id].$invalid && formIsSubmitted">
          <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
          <p id="{{category._id + '-status'}}" class="help-block text-gray">{{ 'The category name is required.' | translate }}</p>
        </div>
      </div>
      <p><button type="button" data-nodrag data-ng-click="blueprintCtrl.showDescription(this)" class="btn btn-sm btn-info">{{ (blueprintCtrl.shownDescriptions[category._id] ? 'Hide' : 'Show') | translate }} {{ 'description' | translate }}</button></p>
      <div data-ng-show="blueprintCtrl.shownDescriptions[category._id]" class="form-group">
        <label for="{{category._id}}-description">{{ 'Category description' | translate }}</label>
        <textarea data-nodrag data-ng-model="category.description" id="{{category._id}}-description" name="{{category._id}}-description" class="form-control"></textarea>
      </div>
    </div>
    <div class="col-xs-2 text-right">
      <br/>
      <ul class="list-inline list-unstyled list-icon-actions">
        <li><button type="button" class="btn-link text-gray" data-nodrag data-ng-click="blueprintCtrl.toggle(this)"><i data-ng-class="{'icon-right-open-big': collapsed, 'icon-down-open-big': !collapsed}" aria-label="{{ 'Show subcategories' | translate }}"></i></button></li>
        <li><button type="button" class="btn-link text-info" data-nodrag data-ng-click="blueprintCtrl.newSubNode(this)" data-ng-if="blueprintCtrl.hasEditPermission" aria-label="{{ 'New sub category' | translate }}"><i class="icon-plus"></i></button></li>
        <li><button type="button" class="btn-link text-danger" data-nodrag data-ng-click="blueprintCtrl.removeNode(this)" data-ng-if="blueprintCtrl.hasEditPermission" aria-label="{{ 'Remove category' | translate }}"><i class="icon-trash"></i></button></li>
      </ul>
    </div>
  </div>
  <ol ui-tree-nodes data-ng-model="category.categories" data-ng-class="{hidden: collapsed}">
    <li ng-repeat="category in category.categories track by category._id" ui-tree-node data-ng-include="'blueprint-hierarchy.html'">
    </li>
  </ol>
</script>

<div ui-tree id="tree-root">
  <ol ui-tree-nodes data-ng-model="blueprintCtrl.blueprint.categories">
    <li data-ng-repeat="category in blueprintCtrl.blueprint.categories track by category._id" ui-tree-node data-ng-include="'blueprint-hierarchy.html'"></li>
  </ol>
</div>

<p><button data-ng-click="blueprintCtrl.addCategory()" class="btn btn-sm btn-primary" data-ng-if="blueprintCtrl.hasEditPermission">{{ 'Add new category' | translate }}</button></p>
`,
  'app/components/blueprints/form.html': `<form novalidate unsaved-warning-form name="form" aria-label="{{ 'Edit blueprint details' | translate }}">

  <div class="wrapper">
    <header class="row">
      <div class="col-sm-6">
        <h1>{{ blueprintCtrl.title || ('Edit blueprint details' | translate) }}</h1>
      </div>
      <div class="col-sm-6">
        <p class="button-list">
          <button type="button" unsaved-warning-clear class="btn btn-warning btn-raised" data-ng-if="blueprintCtrl.hasEditPermission && blueprintCtrl.state == 'edit'" data-ng-click="blueprintCtrl.duplicate()">{{ 'Duplicate' | translate }}</button>
          <button type="button" unsaved-warning-clear class="btn btn-success btn-raised" data-ng-if="blueprintCtrl.hasEditPermission" data-ng-click="blueprintCtrl.save(form.$valid)" data-ng-disabled="form.$invalid">{{ 'Save' | translate }}</button>
          <button type="button" class="btn btn-info btn-raised" router-link="['/blueprints']">{{ 'Cancel' | translate }}</button>
        </p>
      </div>
      <audit-log-component ng-if="blueprintCtrl.blueprint._rev" entries="blueprintCtrl.auditlog" on-expand="blueprintCtrl.loadAuditlog()"></audit-log-component>
    </header>
    <div class="row" data-ng-if="error || (blueprintCtrl.eventTypes && blueprintCtrl.eventTypes.length)">
      <p data-ng-if="error" class="text-warning">{{ 'Cannot get blueprint usage in event types:' | translate }} {{ blueprintCtrl.error.message }}</p>
      <span data-ng-if="blueprintCtrl.eventTypes && blueprintCtrl.eventTypes.length">{{ 'This version of this blueprint is embedded inside event:' | translate }}</span>
      <ul class="list-inline list-unstyled">
        <li data-ng-repeat="et in blueprintCtrl.eventTypes">
          <span kz-event-type-usage event-types="et"></span>
        </li>
      </ul>
    </div>
    <div class="row">
      <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
    </div>

    <div class="row" kz-loading loaded="blueprintCtrl.loaded">

      <div class="form-group col-sm-7" data-ng-class="{ 'has-error has-feedback': form.blueprintName.$invalid && formIsSubmitted}">
        <label for="blueprintName">{{ 'Blueprint name' | translate }} <i ng-class="{'icon-star required': blueprintCtrl.hasEditPermission, 'icon-lock disabled': !blueprintCtrl.hasEditPermission}"></i></label>
        <input data-ng-model="blueprintCtrl.blueprint.name" type="text" id="blueprintName" name="blueprintName" class="form-control" data-ng-required="true" aria-describedby="blueprintNameStatus" ng-disabled="!blueprintCtrl.hasEditPermission">
        <div data-ng-if="form.blueprintName.$invalid && formIsSubmitted">
          <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
          <p id="blueprintNameStatus" class="help-block text-gray">{{ 'The blueprint name is required.' | translate }}</p>
        </div>
      </div>

      <div class="form-group col-sm-5" data-ng-class="{ 'has-error has-feedback': form.blueprintType.$invalid && formIsSubmitted}">
        <label for="blueprintType">{{ 'Blueprint type' | translate }} <i ng-class="{'icon-star required': blueprintCtrl.hasEditPermission, 'icon-lock disabled': !blueprintCtrl.hasEditPermission}"></i></label>
        <select name="blueprintType" id="blueprintType" class="form-control"
                data-ng-model="blueprintCtrl.blueprint.blueprintType"
                data-ng-options="type.name as type.label for type in blueprintCtrl.blueprintTypes"
                data-ng-required="true" aria-describedby="blueprintTypeStatus"
                ng-disabled="!blueprintCtrl.hasEditPermission"
                ng-change="blueprintCtrl.onChangeType(blueprintCtrl.blueprint.blueprintType)"
        ></select>
        <div data-ng-if="form.blueprintType.$invalid && formIsSubmitted">
          <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
          <p id="blueprintTypeStatus" class="help-block text-gray">{{ 'The blueprint type is required.' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="row" data-ng-if="blueprintCtrl.blueprint.blueprintType === 'tree' || blueprintCtrl.blueprint.blueprintType === 'discrete' || blueprintCtrl.blueprint.blueprintType === 'discrete_multiple'">
      <div class="col-xs-12">
        <h2 class="heading-4">{{ 'Blueprint settings' | translate }}</h2>
      </div>

      <div class="col-xs-12" data-ng-include="'app/components/blueprints/partials/settings.other.html'"></div>

    </div>

    <!-- if the user selected a discrete, show the appropriate form -->
    <div class="row">
      <div class="col-xs-12">
        <div data-ng-include="'app/components/blueprints/form.discrete.html'" data-ng-if="blueprintCtrl.blueprint.blueprintType === 'discrete' || blueprintCtrl.blueprint.blueprintType === 'discrete_multiple'"></div>
      </div>
    </div>


    <div data-ng-if="blueprintCtrl.blueprint.blueprintType === 'tree' && blueprintCtrl.tree" class="row" data-sequoia-tree="blueprintCtrl.blueprint.categories" data-node-template="blueprintCtrl.tree.template" data-options="blueprintCtrl.tree.options"></div>

    <!-- if the user selected a likert, show the appropriate form -->
    <div class="row">
      <div class="col-xs-12">
        <div data-ng-include="'app/components/blueprints/form.likert.html'" data-ng-if="blueprintCtrl.blueprint.blueprintType === 'likert'"></div>
      </div>
    </div>

  </div>

</form>
`,
  'app/components/blueprints/form.likert.html': `<legend>{{blueprintCtrl.blueprint.name }} {{ 'categories' | translate }}</legend>

<p class="text-info"><i class="icon-info"></i>{{ 'If you do not wish to assign a value to a response then please leave it empty' | translate }}</p>
<!-- Nested node template -->
<script type="text/ng-template" id="custom-fields-hierarchy.html">
  <div ui-tree-handle class="row tree-node tree-node-content">
    <div class="col-xs-6">
      <div class="form-group likert" data-ng-class="{ 'has-error has-feedback': form[category._id].$invalid && formIsSubmitted}">
        <label for="{{category._id}}-name">{{ 'Category name' | translate }} <i class="icon-star required" aria-label="{{ 'star' | translate }}"></i></label>
        <input data-nodrag data-ng-model="category.name" type="text" id="{{category._id}}-name" name="{{category._id}}-name" class="form-control" data-ng-required="true">
      </div>
      <div class="form-group likert" data-ng-class="{ 'has-error has-feedback': form[category._id].$invalid && formIsSubmitted}">
        <div data-ng-show="form[category._id].$invalid  && formIsSubmitted">
          <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
          <p class="help-block text-gray">{{ 'The category name is required.' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="col-xs-4">
      <div class="form-group likert" data-ng-class="{ 'has-error has-feedback': form[category._id].$invalid && formIsSubmitted}">
        <label for="{{category._id}}-value">{{ 'Value' | translate }} </label>
        <input data-nodrag data-ng-model="category.value" type="number" step=".001" id="{{category._id}}-value" name="{{category._id}}-value" class="form-control">
        <span class="text-danger" ng-if="form[category._id + '_value'].$error.step">{{ 'Only 3 decimal places maximum is allowed.' | translate }}</span>
      </div>
    </div>

    <div class="col-xs-2 text-right">
      <ul class="list-inline list-unstyled list-icon-actions">
        <li><button type="button" class="btn-link text-danger" data-nodrag data-ng-click="blueprintCtrl.removeNode(this)"><i class="icon-trash"></i></button></li>
      </ul>
    </div>
  </div>
</script>

<div ui-tree id="tree-root">
  <ol ui-tree-nodes data-ng-model="blueprintCtrl.blueprint.categories">
    <li ng-repeat="category in blueprintCtrl.blueprint.categories track by category._id" data-ui-tree-node data-ng-include="'custom-fields-hierarchy.html'"></li>
  </ol>
</div>

<p><button type="button" data-ng-click="blueprintCtrl.addCategory()" class="btn btn-sm btn-border btn-info">{{ 'Add new category' | translate }}</button></p>
`,
  'app/components/blueprints/list.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="blueprintsCtrl.actions"><h1>{{ 'Blueprints' | translate }}</h1></kz-header>
      <kz-simple-search list="blueprintsCtrl.list"></kz-simple-search>
      <kz-search-string list="blueprintsCtrl.list"></kz-search-string>

  </header>
  <kz-refine-filter
    list="blueprintsCtrl.list"
    refine-by="blueprintType"
  ></kz-refine-filter>
</section>


<kz-list-view list="blueprintsCtrl.list" options="blueprintsCtrl.options">
<blueprint-slot item="item"></blueprint-slot>
</kz-list-view>
`,
  'app/components/blueprints/partials/settings.other.html': `<div class="row">
  <div class="form-group col-xs-12">
    <label>{{ 'Select any additional purpose for this blueprint' | translate }}<i ng-class="{'icon-lock disabled': !blueprintCtrl.hasEditPermission}"></i></label>
    <ui-select multiple ng-model="blueprintCtrl.blueprint.usage" close-on-select="false" title="{{ 'Choose usage' | translate }}" ng-disabled="!blueprintCtrl.hasEditPermission">
      <ui-select-match placeholder="{{ 'Select usage...' | translate }}">{{$item.label}}</ui-select-match>
      <ui-select-choices repeat="item.value as item in blueprintCtrl.blueprintSettings.tree.usage | filter:$select.search ">
        {{item.label}}
      </ui-select-choices>
    </ui-select>
  </div>
  <div class="form-group col-xs-12">
    <div class="checkbox">
      <label>
        <input type="checkbox" data-ng-model="blueprintCtrl.blueprint.restrictable" ng-disabled="!blueprintCtrl.hasEditPermission">
        {{ 'Would you like to restrict this blueprint by relations?' | translate }}</label>
    </div>
  </div>
 </div>
`,
  'app/components/bulk-actions/bulk-action-create-or-edit.html': `<div class="wrapper" ng-if="bulkActionCtrl.taskActionChooserForm">
  <div class="row">
    <formly-form model="bulkActionCtrl.model" fields="bulkActionCtrl.taskActionChooserForm.fields" aria-label="Bulk Changes Type"></formly-form>
  </div>
</div>

<import-csv
  id="bulkActionCtrl.bulkActionId"
  bulk-action-name="bulkActionCtrl.bulkActionName"
  model="bulkActionCtrl.model"
  operation="bulkActionCtrl.operation"
  ng-if="bulkActionCtrl.operation === 'import' || bulkActionCtrl.operation === 'submit'">
</import-csv>

<bulk-action
  bulk-changes-params="bulkActionCtrl.model"
  action-name="bulkActionCtrl.model.taskAction"
  ng-if="bulkActionCtrl.operation === 'bulkAction'">
</bulk-action>
`,
  'app/components/bulk-actions/bulk-action-preview.html': `<div class="modal-header event-modal-header">
  <header class="row">
    <div class="col-sm-10">
      <h2>{{::name}}</h2>
    </div>
    <div class="col-sm-2 text-right">
      <button type="button" class="close" data-ng-click="dismiss()"><i class="icon-cancel"></i></button>
    </div>
  </header>
</div>

<div class="modal-body">
  <p>{{ 'The bulk action task ran with the following options' | translate }}</p>
  <options-used options="options"></options-used>

  <br/>

  <h3>{{ 'Results' | translate }}</h3>
  <results-overview meta="meta"></results-overview>
</div>

<div class="modal-footer">
  <div class="text-right">
    <button type="button" class="btn btn-primary" data-ng-click="dismiss()">{{ 'Close' | translate }}</button>
  </div>
</div>
`,
  'app/components/bulk-actions/bulk-action-slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-sm-7">
      <a router-link="['/bulk-actions/view', item._id]">
        <h2 class="entry-title" ng-if="item.data.name">{{::item.data.name}}</h2>
        <h2 class="entry-title" ng-if="!item.data.name">{{ctrl.TASKS_NAMES[item.action]}}</h2>
      </a>
      <div>
        <span class="label label-primary" ng-if="item.data.docType">{{ ::item.data.docType | uppercase }} DATA</span>
        <span class="label label-info">{{ ::item.meta.total }} RECORDS</span>
        <span ng-if="item.data.file.filename"> - {{::item.data.file.filename}}</span>
      </div>
      <div>
        <bulk-action-progress-info
            dryrun="ctrl.dryrun"
            state="item.state"
            processed="item.meta.processed"
            total="item.meta.total"
            output-summary="item.outputSummary"
            started-time="item.createdDate">
          </bulk-action-progress-info>
      </div>
    </div>

    <div class="col-sm-5 col-right">
      <kz-state map="ctrl.BULK_ACTIONS_STATES" state="item.state"></kz-state>
      <span>{{ 'Created on' | translate }} <span class="text-info">{{ ::item.createdDate | date:dateFormat }}</span></span>
    </div>
  </div>

  <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons"></kz-list-buttons>
</div>
`,
  'app/components/bulk-actions/bulk-action-view.html': `<div class="wrapper">
  <div class="row">
    <div class="col-xs-12">
      <bulk-action-view bulk-action-doc="bulkActionViewCtrl.bulkActionDoc"
                      on-download-output="bulkActionViewCtrl.downloadOutput(bulkActionId)"
                      on-abort="bulkActionViewCtrl.abortBulkAction(bulkActionId)"
                      on-retry="bulkActionViewCtrl.retryImport(bulkActionId)"
                      on-run-for-real="bulkActionViewCtrl.runForReal(bulkActionData, bulkActionId)"
                      output-filter-state="bulkActionViewCtrl.onFilterState(filterState)"
                      output-total="bulkActionViewCtrl.outputTotal"
                      output-page="bulkActionViewCtrl.outputPage"
                      output-limit="bulkActionViewCtrl.outputLimit"
                      output-start-key="bulkActionViewCtrl.outputStartKey"
                      on-go-to-page="bulkActionViewCtrl.goToPage(page)"
      >
      </bulk-action-view>
    </div>
  </div>
</div>
`,
  'app/components/bulk-actions/bulk-actions.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="bulkActionsCtrl.actions"><h1>{{ 'Bulk actions' | translate }}</h1></kz-header>
      <kz-simple-search list="bulkActionsCtrl.list"></kz-simple-search>
      <kz-search-string list="bulkActionsCtrl.list"></kz-search-string>
  </header>
  <kz-refine-filter
    list="bulkActionsCtrl.list"
    refine-by="addedDate"
  ></kz-refine-filter>
</section>


<kz-list-view list="bulkActionsCtrl.list" options="bulkActionsCtrl.options">
<bulk-action-slot item="item"></bulk-action-slot>
</kz-list-view>
`,
  'app/components/bulk-actions/components/bulk-action-view.html': `<div>
  <i class="icon-spin animate-spin" ng-if="!$ctrl.bulkActionDoc"></i>
  <div data-ng-if="$ctrl.bulkActionDoc">
    <div class="row">
      <div class="col-xs-8">
        <h1>
          <bulk-action-title
            name="$ctrl.bulkActionDoc.data.name || $ctrl.TASKS_NAMES[$ctrl.bulkActionDoc.action]"
            file-name="$ctrl.bulkActionDoc.data.file.name || $ctrl.bulkActionDoc.data.file.filename">
          </bulk-action-title>
        </h1>
      </div>
      <div class="col-xs-4 text-right">
        <!-- processing -->
        <span ng-if="['new', 'processing'].indexOf($ctrl.bulkActionDoc.state) > -1">
          <button type="button" class="btn btn-xs btn-danger" ng-click="$ctrl.onAbort({bulkActionId: $ctrl.bulkActionDoc._id})"><i class="icon-cancel"></i> {{ 'Quit' | translate }}</button>
        </span>
        <span ng-if="$ctrl.dryrun === true && ['new', 'processing'].indexOf($ctrl.bulkActionDoc.state) === -1">
          <button class="btn btn-xs btn-primary" ng-click="$ctrl.onRetry({bulkActionId: $ctrl.bulkActionDoc._id})"><i class="icon-reload"></i> {{ 'Retry' | translate }}</button>
          <button class="btn btn-xs btn-warning"
                  ng-click="$ctrl.onRunForReal({bulkActionData: {}, bulkActionId: $ctrl.bulkActionDoc._id})">
            <i class="icon-ok"></i> {{ 'Run import' | translate }}
          </button>
        </span>
      </div>
    </div>
    <div ng-if="$ctrl.dryrun && $ctrl.bulkActionDoc.meta.processed" class="row">
      <div class="col-xs-12">
        <p class="box box-warning"><i class="icon-warning"></i> <span ng-bind-html="$ctrl.mockRunInfoBelow"></span></p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12" ng-if="$ctrl.bulkActionDoc.meta.processed === undefined && $ctrl.bulkActionDoc.state !== 'failure'"><i class="icon-spin animate-spin"></i></div>
      <div class="col-xs-12" ng-if="$ctrl.bulkActionDoc.meta.processed">
        <kz-progress-bar description="Bulk action task progress"
                         numerator="$ctrl.bulkActionDoc.meta.processed" denominator="::$ctrl.bulkActionDoc.meta.total">
          <bulk-action-progress-info
            dryrun="$ctrl.dryrun"
            state="$ctrl.bulkActionDoc.state"
            processed="$ctrl.bulkActionDoc.meta.processed"
            total="$ctrl.bulkActionDoc.meta.total"
            output-summary="$ctrl.bulkActionDoc.outputSummary"
            started-time="$ctrl.bulkActionDoc.startDate">
          </bulk-action-progress-info>
        </kz-progress-bar>
      </div>
    </div>
    <div class="row" ng-if="$ctrl.bulkActionDoc.meta.processed">
      <div class="col-xs-12">
        <formly-form model="filterStateModel" fields="$ctrl.futureStateFilterForm.fields" aria-label="Filter"></formly-form>
        <div ng-if="$ctrl.bulkActionDoc.output && !$ctrl.bulkActionDoc.output.__fatal_error__ && !$ctrl.bulkActionDoc.output.__validation__ && !$ctrl.bulkActionDoc.output.__global__">
          <table class="table table-sm table-striped">
            <thead class="thead-light">
              <tr>
                <th scope="col">{{ 'CSV row number' | translate }}</th>
                <th scope="col">{{ 'Status' | translate }}</th>
                <th scope="col">{{ 'Results' | translate }}</th>
                <th scope="col" ng-if="$ctrl.bulkActionDoc.data.docType && $ctrl.bulkActionDoc.data.docType != 'booking'">{{ 'Action' | translate }}</th>
                <th scope="col" ng-if="$ctrl.dryrun"><i class="icon-warning" aria-label="Note"></i></th>
              </tr>
            </thead>
            <tbody>
                <tr ng-repeat="(lineNumber, result) in $ctrl.bulkActionDoc.output">
                  <td>{{ lineNumber }}</td>
                  <td ng-class="{
                    'text-success': result.state === 'created',
                    'text-info': result.state === 'not_created' || result.state === 'exists',
                    'text-warning': result.state === 'updated',
                    'text-success': result.state === 'submitted',
                    'text-danger': result.state === 'deleted' || result.state === 'errors'
                  }">{{$ctrl.getReadableState(result.state) | uppercase}}</td>
                  <td>
                    {{$ctrl.getReadableResult(result.state)}}
                    <ul ng-if="result.errors">
                      <li ng-repeat="error in result.errors track by $index">{{ error }}</li>
                    </ul>
                  </td>
                  <td ng-if="$ctrl.bulkActionDoc.data.docType && $ctrl.bulkActionDoc.data.docType != 'booking'">
                    <a href="" ng-click="$ctrl.preview(lineNumber)" ng-if="result.state === 'created' || result.state === 'updated' || result.state === 'submitted'">
                      {{$ctrl.getPreviewLabel($ctrl.dryrun, result.state)}}
                    </a>
                    <a href="" ng-click="$ctrl.preview(lineNumber)" ng-if="result.state === 'exists' || result.state === 'no_changes'">
                      {{$ctrl.getPreviewLabel($ctrl.dryrun, result.state)}}
                    </a>
                  </td>
                  <td ng-if="$ctrl.dryrun"><strong class="text-warning">{{ 'Mock run' | translate }}</strong></td>
                </tr>
            </tbody>
          </table>
          <kz-pagination
            ng-if="$ctrl.bulkActionDoc.output && !$ctrl.bulkActionDoc.output.__fatal_error__ && !$ctrl.bulkActionDoc.output.__validation__ && !$ctrl.bulkActionDoc.output.__global__"
            total="$ctrl.outputTotal"
            startkey="$ctrl.outputStartKey"
            per-page="$ctrl.outputLimit"
            to="$ctrl.goToPage(page)">
          </kz-pagination>
        </div>
        <p ng-if="!$ctrl.bulkActionDoc.output">{{ 'They are no output for this task with this filter' | translate }}</p>

      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div ng-repeat="attr in ['__fatal_error__', '__validation__', '__global__']">
          <div class="alert alert-danger" ng-if="$ctrl.bulkActionDoc.output[attr]">
            {{ 'Error:' | translate }}
            <ul ng-repeat="error in $ctrl.bulkActionDoc.output[attr]"><li>{{error}}</li></ul>
          </div>
        </div>
        <div ng-if="$ctrl.bulkActionDoc.state === 'failure'">
          <div class="alert alert-danger">{{ 'An error occured:' | translate }} {{ $ctrl.bulkActionDoc.output.__global__ }}</div>
        </div>
      </div>
    </div>

    <!-- finished -->
    <div ng-if="['success', 'failure', 'aborted'].indexOf($ctrl.bulkActionDoc.state) > -1 && $ctrl.bulkActionDoc.action == 'import_file'">
      <a class="text-info" href="" ng-click="$ctrl.onDownloadOutput({bulkActionId: $ctrl.bulkActionDoc._id})"><i class="icon-download"></i> {{ 'Download CSV output' | translate }}</a>
    </div>

    <div ng-if="$ctrl.dryrun && $ctrl.bulkActionDoc.meta.processed" class="row">
      <div class="col-xs-12">
        <p class="box box-warning"><i class="icon-warning"></i> <span ng-bind-html="$ctrl.mockRunInfoAbove"></span></p>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/bulk-actions/components/bulk-action.html': `<form novalidate name="form" aria-label="New users merging" kz-loading loaded="$ctrl.loaded">
  <div class="wrapper">
    <div class="row">
      <div class="col-xs-12">
        <h1>{{$ctrl.bulkActionConstants.name}}</h1>
      </div>
    </div>
  </div>
  <div class="wrapper">
    <div class="row">
      <div class="col-xs-12">
        <div class="alert alert-info">
          <i class="icon-info"></i>
            <span ng-bind-html="$ctrl.bulkActionConstants.helpTextHtml"></span>
            <span ng-if="$ctrl.bulkActionConstants.CSVTemplate">
              You can download a template by clicking here:
              <a href="" ng-click="$ctrl.downloadTemplate()">{{$ctrl.bulkActionConstants.CSVTemplate.name}}</a>
            </span>
        </div>
        <div>
          <div data-ng-repeat="element in $ctrl.bulkActionConstants.formElements track by $index">
            <div ng-if="element.type === 'csv'">
              <div class="control-label">{{element.label}} <i class="icon-star required"></i></div>
              <input type="file" name="csvfile" ng-upload-change="readFile($event)" accept=".csv">
              <p class="text-danger" ng-if="$ctrl.fileError"><i class="icon-warning"></i>{{$ctrl.fileError}}</p>
            </div>
            <div ng-if="element.type === 'formly-form'">
              <formly-form model="$ctrl.bulkChangesParams" fields="$ctrl.forms[$index].fields" form="$ctrl.forms[$index]" aria-label="bulkChangeForm"></formly-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="wrapper">
    <div class="row">
      <div class="col-xs-12">
        <button class="btn btn-primary" data-ng-disabled="form.$invalid || !$ctrl.bulkChangesParams.csv" ng-click="$ctrl.startBulkAction($ctrl.bulkChangesParams, false)">{{$ctrl.bulkActionConstants.actionButtonTitle}}</button>
      </div>
    </div>
  </div>
</form>
`,
  'app/components/bulk-actions/components/options-used.html': `<ul class="item-list item-list-bordered">
  <li class="item row" ng-repeat="(optionName, optionValue) in $ctrl.readableOptions">
    <div class="col-xs-6">{{::optionName}}</div>
    <div class="col-xs-6 text-right font-bold">{{optionValue}}</div>
  </li>
</ul>
`,
  'app/components/bulk-actions/components/progress-info.html': `<div>
  <span class="text-info" ng-if="::$ctrl.dryrun">{{ 'MOCK RUN:' | translate }}</span> {{ 'The bulk action task' | translate }}
  <b>{{$ctrl.readableState}}</b>.
  <span ng-bind-html="$ctrl.readableSummary"></span>
  <span ng-if='["success", "failure", "aborted"].indexOf($ctrl.state) === -1 && $ctrl.estimatedTimeFinished' >
    {{ 'Estimated time:' | translate }} {{$ctrl.estimatedTimeFinished}}
  </span>
</div>

`,
  'app/components/bulk-actions/components/results-overview.html': `<ul class="item-list item-list-bordered">
  <li class="item row" ng-repeat="item in $ctrl.readableMeta">
    <div class="col-xs-10">
      <span ng-class="item.class">
        {{::item.name}}
      </span>
    </div>
    <div class="col-xs-2 text-right font-bold">
      <span ng-class="item.class">
        {{item.value}}
      </span>
    </div>
  </li>
</ul>
`,
  'app/components/bulk-actions/import-csv/components/columns-mapping.html': `<div class="row">
  <div class="col-xs-12">
    <p class="box box-info">
      {{ 'risr/advance can either create all rows within the CSV as new records or create only those records which do not already exist in risr/advance. If you would like this process to determine whether a record already exists please select a combination of fields that risr/advance should use when searching for existing records.' | translate }} <br/><br/>

      <span ng-if="$ctrl.docType === 'user'">{{ 'Only a single unique field can be selected. Only user fields which have been configured as unique fields are available to select.' | translate }}</span>
      <span ng-if="$ctrl.docType === 'event'">
        {{ 'If multiple user fields are selected to identify the user, the first field is prioritised. The import process evaluates the first field and attempts to find the user based upon this data. Where there is no data for this field provided in the data file, it will evaluate the subsequent selected user field.' | translate }}
        <br/><br/>
        {{ 'When searching for existing events, it is possible to search by either a Unique Transaction ID or through a combination of event fields.' | translate }}
      </span>
    </p>
    <p class="box box-info" ng-if="$ctrl.totalColumnsInFile" ng-bind-html="'We were able to find <strong>{{autoMap}} out of {{total}} columns</strong> that can be automatically mapped in your uploaded file.' | translate:{ autoMap: $ctrl.autoMapNumber, total: $ctrl.totalColumnsInFile }">
    </p>
    <table class="table table-sm table-striped">
      <thead class="thead-light">
        <tr>
          <th scope="col">{{ 'Event type field' | translate }}</th>
          <th scope="col" id="input-data">{{ 'Imported data column' | translate }}</th>
          <th scope="col" id="imported-value">{{ 'Example imported value' | translate }}</th>
          <th scope="col">{{ 'Matched' | translate }}</th>
          <th scope="col">{{ 'Mandatory fields' | translate }}</th>
          <th scope="col" ng-if="!kzField.title && $ctrl.action !== 'forceCreate' && $ctrl.action !== 'submit'">
            {{ 'Use to ensure unique value' | translate }}
          </th>
          <th scope="col">{{ 'Constant value' | translate }}</th>
          <th scope="col">{{ 'Mapping' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          ng-class="{
            'warning': $ctrl.isLocked[kzField._id],
            'danger': kzField.inputField
                && !internalMapping[kzField._id]
                && kzField.required === true
                && ['createOnlyIfNotExists', 'forceCreate', 'createOrUpdate'].indexOf($ctrl.action) > -1
          }"
          ng-show="!($ctrl.action === 'forceCreate' && kzField._id === 'idempotencyKey')"
          ng-repeat="kzField in $ctrl.kzFields"
        >
          {{kzField}}
          <td colspan="7" ng-if="kzField.title"><h3>{{kzField.title}}</h3></td>
          <td ng-if="!kzField.title">{{kzField.name}} <span ng-if="kzField.required === true  && !!(field.restricted || {}).by"><i class="icon-star required"></i></span></td>
          <td ng-if="!kzField.title">
            <span ng-if="internalMapping[kzField._id].type == 'constant'">{{ 'Set all imported data for this column:' | translate }} </span>
            <select ng-if="internalMapping[kzField._id].type == 'column' || internalMapping[kzField._id] === undefined || internalMapping[kzField._id].type === undefined" id="select-field" aria-labelledby="heading-your-data" ng-disabled="$ctrl.isLocked[kzField._id]" class="form-control" data-ng-model="internalMapping[kzField._id].value" data-ng-change="$ctrl.onChange(kzField._id)" data-ng-options="option.id as option.name for option in $ctrl.availableMappingOptions"></select>
          </td>
          <td class="text-center">
            <formly-form
              ng-disabled="$ctrl.forms[kzField._id]"
              ng-if="internalMapping[kzField._id].type == 'constant'"
              model="formsModels[kzField._id]"
              fields="$ctrl.forms[kzField._id].fields"
              form="form"></formly-form>
          </td>
          <td class="text-center" ng-if="!kzField.title">
            <i class="icon-check text-success" ng-if="internalMapping[kzField._id]"></i>
            <i class="icon-cancel text-danger" ng-if="!internalMapping[kzField._id]"></i>
          </td>
          <td class="text-center" ng-if="!kzField.title">
            <span ng-if="kzField.required === true && !(kzField.restricted || {}).by" class="text-danger">{{ 'YES' | translate }}</span>
            <span ng-if="(kzField.restricted || {}).by" class="text-warning">{{ 'Dependent on another field' | translate }}</span>
            <span ng-if="!kzField.required && !(kzField.restricted || {}).by">{{ 'NO' | translate }}</span>
          </td>
          <td class="text-center" ng-if="!kzField.title && $ctrl.action !== 'forceCreate' && $ctrl.action !== 'submit'">
            <input aria-labelledby="heading-search-existing-records"
                   type="checkbox"
                   ng-model="entryUniquenessSelectedFields[kzField._id]"
                   ng-if="entryUniquenessFieldShown[kzField._id]"
                   ng-disabled="entryUniquenessFieldDisabled[kzField._id]">
          </td>
          <td ng-if="!kzField.title">
              <button class="btn btn-sm btn-primary"
                    ng-if="!$ctrl.isLocked[kzField._id] && internalMapping[kzField._id].type == 'constant'"
                    ng-click="$ctrl.setColumn(kzField._id)" aria-label="Select column for {{kzField['name']}}">
              {{ 'Select column' | translate }}
              </button>
              <button class="btn btn-sm btn-primary"
                      ng-if="!$ctrl.isLocked[kzField._id]
                      && kzField.can_set_constant
                      && (internalMapping[kzField._id].type == 'column' || internalMapping[kzField._id] == undefined)
                      && $ctrl.form_types.includes(kzField.type)"
                      ng-click="$ctrl.setConstant(kzField._id, kzField)"
                      aria-label="Set value for {{kzField['name']}}">
              {{ 'Set value' | translate }}
              </button>
          </td>
          <td class="text-center" ng-if="!kzField.title">
            <button class="btn btn-sm btn-primary"
                    ng-if="!$ctrl.isLocked[kzField._id] && (internalMapping[kzField._id].value || internalMapping[kzField._id].type == 'constant')"
                    ng-click="$ctrl.setColumn(kzField._id)"
                    aria-label="Reset {{kzField['name']}}">
              {{ 'Reset' | translate }}
              </button>
              <button class="btn btn-sm btn-warning"
                    ng-if="$ctrl.stateOptions.locked.mapping == 'soft' && $ctrl.isLocked[kzField._id]"
                    ng-click="$ctrl.unlock(kzField._id, kzField)"
                    aria-label="Unlock {{kzField['name']}}">
                <i class="icon-lock-open"></i> {{ 'Unlock' | translate }}
              </button>
              <i class="icon-lock disabled" ng-if="$ctrl.stateOptions.locked.mapping == 'hard'"></i>
          </td>
      </tbody>
    </table>
  </div>
</div>
`,
  'app/components/bulk-actions/import-csv/components/import-CSV.html': `<form novalidate name="form" aria-label="Bulk action" kz-loading loaded="$ctrl.loaded">
  <div class="wrapper">
    <div class="row">
      <div class="col-xs-12">
        <h1>{{$ctrl.title}}</h1>
      </div>
    </div>
  </div>
  <div class="wrapper">
    <div class="row" ng-if="$ctrl.partHasLocking(import.stateOptions.locked.header)">
      <div class="col-xs-9" ng-if="import.stateOptions.locked.header == 'hard'">
        <p><i class="icon-lock disabled"></i> {{ 'This import section is locked.' | translate }}</p>
      </div>
      <div class="col-xs-3 text-right" ng-if="import.stateOptions.locked.header === 'soft' && !$ctrl.partUnlocked.header">
        <button
          class="btn btn-sm unlock-button bg-white border border-primary text-primary"
          ng-click="$ctrl.unlockPart('header')"
        >
          {{ 'Unlock' | translate }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <formly-form model="import" fields="$ctrl.basicForm.fields" aria-label="Import CSV"></formly-form>
        <div class="box box-info" ng-if="$ctrl.lastCompletedImport">
          {{ 'You\'ve already published results for this exam. The last was on' | translate }} {{$ctrl.lastCompletedImport.startDate | date: $ctrl.dateFormat}} <a href="" data-ng-click="$ctrl.redirectView($ctrl.lastCompletedImport._id)"><strong>{{ 'Review imported data' | translate }}</strong></a>.
          <br>
          <br>
          {{ 'You can re-run the import with the following options:' | translate }}
          <br>
          <br>
          <ul>
            <li>{{ 'Only create new records that don\'t exist, without modifying any existing data' | translate }}</li>
            <li>{{ 'Create new records that don\'t exist and update existing data' | translate }}</li>
            <li>{{ 'Only update existing data without creating new records' | translate }}</li>
            <li>{{ 'Disregard existing data and create all the records in the new import' | translate }}</li>
          </ul>
        </div>
        <div>
          <div class="text-gray">
            {{ 'Depending on the type of import you wish to make, you will be provided with a template to help you format the import file.' | translate }}
          </div>
          <a class="text-info"
             href=""
             ng-click="$ctrl.downloadCSVTemplate(import)"
             ng-if="$ctrl.isBasicFormFullyFilledIn">
            <i class="icon-download"></i> {{ 'Download Template' | translate }}
          </a>
          <span class="disabled" ng-if="!$ctrl.isBasicFormFullyFilledIn"><i class="icon-download"></i> {{ 'Download Template' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="wrapper" ng-if="$ctrl.actionForm && $ctrl.emailsForm">
    <div class="row" ng-if="$ctrl.partHasLocking(import.stateOptions.locked.options)">
      <div class="col-xs-9" ng-if="import.stateOptions.locked.options == 'hard'">
        <p><i class="icon-lock disabled"></i> {{ 'This import section is locked.' | translate }}</p>
      </div>
      <div class="col-xs-3 text-right" ng-if="import.stateOptions.locked.options === 'soft' && !$ctrl.partUnlocked.options">
        <button
          class="btn btn-sm unlock-button bg-white border border-primary text-primary"
          ng-click="$ctrl.unlockPart('options')"
        >
          {{ 'Unlock' | translate }}
        </button>
      </div>
    </div>
    <div class="row" ng-if="$ctrl.actionForm && $ctrl.actionForm.fields.length > 0">
      <div class="col-xs-12">
        <h2 class="heading-3">{{ 'Import behaviour' | translate }}</h2>
        <div class="text-gray">{{ 'Here you can control whether this import should create new entries, update existing entries, or both. The criteria for existing data can be chosen during the CSV column matching process in the following section.' | translate }}</div>
        <formly-form model="import.options" fields="$ctrl.actionForm.fields" aria-label="Can create and can update" class="inline"></formly-form>
      </div>
    </div>
    <div class="row" ng-if="$ctrl.emailsForm && $ctrl.emailsForm.fields.length > 0">
      <div class="col-xs-12">
        <h3>{{ 'Email notifications' | translate }}</h3>
        <div class="text-gray">
          <span ng-if="import.docType === 'event'">
            <span ng-bind-html="'This option only has an effect when the event section being submitted is the final section in the event workflow. If this option is enabled, <b>risr/advance</b> will send a <b>completed event</b> notification email to the owner of the event.' | translate"></span>
            <br/><br/>
            {{ 'Where there is a subsequent section of the event, those users will always receive an email inviting them to fill in the next section in the event workflow irrespective of this email setting.' | translate }}
            <br/><br/>
          </span>
          <span ng-if="import.docType === 'user'">
             {{ 'If this option is enabled, risr/advance will send an' | translate }} <b>{{ 'invitation to risr/advance' | translate }}</b> {{ 'email when a local login credential is added.' | translate }}
          </span>
          <div class="text-warning" ng-if="$ctrl.orgEmailsDisabled">{{ 'It looks like your org has disabled the emails, only administrators will receive those emails.' | translate }}</div>
        </div>
        <formly-form model="import.options" fields="$ctrl.emailsForm.fields" aria-label="Emails"></formly-form>
      </div>
    </div>
    <div class="row" ng-if="$ctrl.eventTypesContainingGoals.indexOf(import.eventTypeId) > -1 && ['createOnlyIfNotExists', 'forceCreate', 'createOrUpdate'].indexOf(import.options.action) > -1">
      <div class="col-xs-12">
        <h3>{{ 'Link existing events to targets' | translate }}</h3>
        <div class="text-gray">
          {{ "The event you have chosen contains embedded goals. As part of creating these events you can choose whether or not you wish to search and link existing events of the owner to each target. The events which will be linked are those which match the linking filter set within each target\'s achievement configuration." | translate }}
        </div>
        <formly-form model="import.options" fields="$ctrl.linkExistingEventsToTargetsForm.fields" aria-label="Link existing events to targets"></formly-form>
      </div>
    </div>
  </div>

<!--  <div class="wrapper" ng-if="$ctrl.eventTypesContainingGoals.indexOf(import.eventTypeId) > -1 && ['createOrUpdate', 'updateOnly'].indexOf(import.options.action) > -1">-->
<!--    <div class="row">-->
<!--      <div class="col-xs-12">-->
<!--        <h3>Apply the last version of the goal set to existing ones if necessary</h3>-->
<!--        <div class="text-gray">TODO: This will be shown only if the event contains a goal field and if you want to update</div>-->
<!--        <formly-form model="import.options" fields="$ctrl.applyLastGoalSetVersionForm.fields" aria-label="Apply last goal set version"></formly-form>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

  <div class="wrapper" ng-if="$ctrl.isBasicFormFullyFilledIn">
    <div class="row" ng-if="$ctrl.partHasLocking(import.stateOptions.locked.files)">
      <div class="col-xs-9" ng-if="import.stateOptions.locked.files == 'hard'">
        <p><i class="icon-lock disabled"></i> {{ 'This import section is locked.' | translate }}</p>
      </div>
      <div class="col-xs-3 text-right" ng-if="import.stateOptions.locked.files === 'soft' && !$ctrl.partUnlocked.files">
        <button
          class="btn btn-sm unlock-button bg-white border border-primary text-primary"
          ng-click="$ctrl.unlockPart('files')"
        >
          {{ 'Unlock' | translate }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <h3>{{ 'Upload your data file' | translate }}</h3>
        <div class="form-field">
          <label for="csvfile" class="control-label">{{ 'Select the file you wish to upload.' | translate }} <i class="icon-star required"></i></label>
          <div ng-if="import.stateOptions.locked.files === 'hard' || (import.stateOptions.locked.files === 'soft' && !$ctrl.partUnlocked.files)">
            <p><b>{{ 'File Name:' | translate }}</b> {{import.file.filename}}</p>
            <p><b>{{ 'File Size:' | translate }}</b> {{import.file.size}}</p>
          </div>

          <file-widget
          model="import.file"
          ng-model="import.file"
          doc-id="import._id"
          label="'Select the file you wish to upload.' | translate",
          file-options="$ctrl.dataFileOptions"
          on-model-updated="$ctrl.fileSaved(files)"
          accept=".csv"
          ng-if="$ctrl.partUnlocked.files"
        ></file-widget>
        </div>
      </div>
      <div class="col-xs-12" ng-if="$ctrl.containsFileField">
        <h3>{{ 'Upload your zip file containing the files to attach' | translate }}</h3>
        <div ng-if="import.stateOptions.locked.files === 'hard' || (import.stateOptions.locked.files === 'soft' && !$ctrl.partUnlocked.files)">
          <p><b>{{ 'File Name:' | translate }}</b> {{import.attachedFiles.filename}}</p>
          <p><b>{{ 'File Size:' | translate }}</b> {{import.attachedFiles.size}}</p>
        </div>
        <formly-form model="import" fields="$ctrl.attachedFilesForm.fields" aria-label="Upload attached files" ng-if="$ctrl.partUnlocked.files"></formly-form>
      </div>
    </div>
  </div>

  <div class="wrapper" ng-if="$ctrl.loaded && $ctrl.fileColumns.length > 0 && $ctrl.kzFields.length > 0">
    <div class="row">
      <div class="col-xs-12">
        <h3>{{ 'Match the columns in your uploaded file' | translate }}</h3>
        <columns-mapping
          state-options="$ctrl.model.stateOptions"
          file-columns="$ctrl.fileColumns"
          kz-fields="$ctrl.kzFields"
          mapping="$ctrl.mapping"
          entry-uniqueness="$ctrl.entryUniqueness"
          doc-type="import.docType"
          action="import.options.action"
        >
        </columns-mapping>
      </div>
    </div>
  </div>

  <div class="wrapper">

  </div>

  <div class="wrapper">
    <div class="row">
      <div class="col-xs-12">
        <button class="btn btn-primary" data-ng-disabled="form.$invalid || !import.file || !$ctrl.fileColumns || !$ctrl.kzFields" ng-click="$ctrl.startImport(import, false)">{{ 'Import' | translate }}</button>
        <button class="btn bg-white border border-warning text-warning" data-ng-disabled="form.$invalid || !import.file || !$ctrl.fileColumns || !$ctrl.kzFields" ng-click="$ctrl.startImport(import, true)">{{ 'Mock run' | translate }}</button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <p class="text-info"><i class="icon-info"></i> {{ 'During a mock run, we will upload the file and test the import without actually importing anything, providing you with the results of what will likely happen if you were to run the actual import.' | translate }}</p>
      </div>
    </div>
  </div>
</form>
`,
  'app/components/dashboard-templates/directives/dashboard-template-selector.html': `<div ng-class="{'title-select': showAsTitle}" uib-dropdown>
  <a href="" uib-dropdown-toggle>
    {{currentTemplate.title}}
    <span class="caret"></span>
  </a>
  <ul class="dropdown-menu" uib-dropdown-menu role="menu">
    <li ng-repeat="template in templates track by $index" ng-class="{'active': template._id === currentTemplate._id}">
      <a href="" ng-click="handleChangeSelected({ id: template._id })">
        {{template.title}}
      </a>
    </li>
  </ul>
</div>
`,
  'app/components/dashboard-templates/directives/form.html': `<formly-form
  class="template-basic-form"
  model="template"
  fields="ctrl.form.fields"
  aria-label="Template basic fields">
</formly-form>
`,
  'app/components/dashboard-templates/directives/template.slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-sm-7">
      <h2>
        <span ng-if="!ctrl.canEditTemplate">{{ ::item.title }}</span>
        <a ng-if="ctrl.canEditTemplate" router-link="ctrl.editRoute" title="{{ 'Edit template' | translate }}">{{ ::item.title }}</a>
      </h2>
      <ul class="list-inline list-unstyled">
        <li>
          <span class="label label-default">{{ 'Assigned to:' | translate }} </span>
        </li>
        <li ng-if="item.isDefault">
          <span class="text-info">{{ 'All users without a role-specific template' | translate }}</span>
        </li>
        <li ng-if="item.visibleForRoles.length && !item.isDefault">
          <span class="text-info" ng-repeat="role in ::item.visibleForRoles | limitTo: ctrl.showLimit">
            <epf-role-title user-role="{{ ::role }}"></epf-role-title><span ng-if="!$last">, </span>
          </span>
          <span ng-if="item.visibleForRoles.length > ctrl.showLimit && !item.isDefault">
            <span class="text-info"> {{ 'and' | translate }} {{ item.visibleForRoles.length - ctrl.showLimit }} {{ 'more' | translate }}</span>
          </span>
        </li>
        <li ng-if="!item.visibleForRoles.length && !item.isDefault">
          <span class="text-danger">{{ 'No user can see this template. Please make sure you assign it to at least one user role!' | translate }}</span>
        </li>
      </ul>
    </div>

    <div class="col-sm-5 col-right">
      <ul class="list-inline list-unstyled">
        <li>
          <span class="label label-default">{{ 'Created on:' | translate }} </span>
          <span class="text-info">{{ ::item.createdDate | date: ctrl.dateFormat }}</span>
        </li>
      </ul>
    </div>
  </div>

  <kz-audit-log id="{{ctrl.auditLogId}}" dates="::item.dates" ng-if="ctrl.shownDescription"></kz-audit-log>

  <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons"></kz-list-buttons>
</div>
`,
  'app/components/dashboard-templates/form.html': `<form novalidate unsaved-warning-form name="templateForm">

  <div class="wrapper">
    <header class="row">
      <div class="col-sm-9">
        <h1>{{ templateFormCtrl.isNew ? ('New' | translate) : ('Edit' | translate) }} {{templateFormCtrl.templateType}} {{ 'template' | translate }}</h1>
      </div>
      <div class="col-sm-3 button-list">

        <button type="button" class="btn btn-success btn-raised" unsaved-warning-clear ng-click="templateFormCtrl.save(templateForm)">{{ 'Save' | translate }}</button>

        <p>
          <ul class="list-inline list-unstyled">
            <li ng-if="!templateFormCtrl.isEditingCopy && templateFormCtrl.canRemoveDefault">
              <a href="" ng-click="templateFormCtrl.remove()" class="text-danger" ng-disabled="templateFormCtrl.submitted" unsaved-warning-clear>{{ 'Delete' | translate }}</a>
            </li>
            <li>
              <a ng-if="templateFormCtrl.templateType === 'dashboard'" router-link="['/dashboard-templates']" class="text-warning" ng-disabled="templateFormCtrl.submitted">{{ 'Cancel' | translate }}</a>
              <a ng-if="templateFormCtrl.templateType === 'summary'" router-link="['/profile-templates']" class="text-warning" ng-disabled="templateFormCtrl.submitted">{{ 'Cancel' | translate }}</a>
            </li>
          </ul>
        </p>
      </div>
    </header>

    <div class="row">
      <div class="col-xs-12">
        <p class="text-gray" ng-bind-html="'Fields marked with <i class=&quot;icon-star required&quot; aria-hidden=&quot;true&quot;></i> are required.' | translate"></p>
      </div>
    </div>

    <div class="row" kz-loading loaded="templateFormCtrl.loaded">
      <div class="col-xs-12">
        <dashboard-template-basic-form
          template="templateFormCtrl.template">
        </dashboard-template-basic-form>
        <dashboard-template-extras-form
          ng-if="!templateFormCtrl.template.isDefault"
          type="templateFormCtrl.templateType"
          template="templateFormCtrl.template">
        </dashboard-template-extras-form>
      </div>
    </div>

  </div>

  <div kz-loading loaded="templateFormCtrl.loaded">
    <adf-dashboard
      name="{{templateFormCtrl.template.title}}"
      edit-mode="true"
      collapsible="true"
      categories="true"
      adf-widget-filter="templateFormCtrl.filterWidgets"
      structure="templateFormCtrl.template.template.structure"
      adf-model="templateFormCtrl.template.template">
    </adf-dashboard>

    <div class="wrapper">
      <div class="row">
        <div class="col-xs-12 button-list">
          <button type="button" class="btn btn-success btn-raised" unsaved-warning-clear ng-click="templateFormCtrl.save(templateForm)">{{ 'Save' | translate }}</button>
        </div>
      </div>
    </div>
  </div>

</form>
`,
  'app/components/dashboard-templates/list-reorder.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="templateReorderCtrl.actions"><h1>{{ 'Dashboard templates' | translate }}</h1></kz-header>
  </header>
</section>
<div kz-loading loaded="templateReorderCtrl.loaded">
  <p class="box box-info" ng-bind-html="templateReorderCtrl.reorderInfo"></p>
  <div hidden id="dashboard-template-move-instructions">{{ 'Use the arrow up and down keys to move this dashboard template' | translate }}</div>
  <div ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost', onUpdate: templateReorderCtrl.reorder }">
    <div class="wrapper" data-ng-repeat="item in templateReorderCtrl.templates track by item._id">
      <div class="row event progress-border progress-border-complete">
        <div class="col-xs-12">
          <div class="row event-inner">
            <div class="col-xs-8">
              <h2>{{ item.name || item.title}}</h2>
            </div>
            <div class="col-xs-4 button-list">
              <ul class="list-inline list-unstyled list-icon-actions">
                <li>
                  <button type="button" class="btn-link text-success drag-handle" aria-label="Move {{ item.name || item.title  }}" aria-describedby="dashboard-template-move-instructions">
                    <i class="icon-move"></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/dashboard-templates/list.html': `<section class="wrapper">
  <header class="row">
    <kz-header actions="templatesListCtrl.actions"><h1>{{ templatesListCtrl.pageTitle }}</h1></kz-header>
    <kz-simple-search list="templatesListCtrl.list"></kz-simple-search>
    <kz-search-string list="templatesListCtrl.list"></kz-search-string>
  </header>
    <kz-refine-filter list="templatesListCtrl.list"></kz-refine-filter>
</section>

<kz-list-view list="templatesListCtrl.list" options="templatesListCtrl.options" ng-if="templatesListCtrl.templateType === 'dashboard'">
  <dashboard-template-slot item="item"></dashboard-template-slot>
</kz-list-view>

<kz-list-view list="templatesListCtrl.list" options="templatesListCtrl.options" ng-if="templatesListCtrl.templateType === 'profile'">
  <profile-template-slot item="item"></profile-template-slot>
</kz-list-view>
`,
  'app/components/dashboard/partials/dashboard-addwidget.html': `<div class="modal-header">
  <button type="button" class="close" ng-click="closeDialog()" aria-hidden="true">&times;</button>
  <h4 class="modal-title" ng-bind="translate('ADF_WIDGET_ADD_HEADER')">Add a new widget</h4>
</div>
<div class="modal-body">

  <p>{{ 'What type of widget would you like to add?' | translate }}</p>

  <input type="text" class="form-control" id="widgetFilter" ng-model="widgetFilter" placeholder="{{ 'Filter widgets by title' | translate }}">

  <!-- dashboard categories enabled -->
  <div ng-if="createCategories && !widgetFilter">
    <div uib-accordion class="widget-categories" ng-init="categorized = createCategories(widgets)">
      <div uib-accordion-group heading="{{category.name}}" ng-repeat="category in categorized | adfOrderByObjectKey: 'name'">
        <ul class="item-list item-list-bordered">
          <li class="item" ng-repeat="widget in category.widgets | adfOrderByObjectKey: 'key' | filter: widgetFilter">
            <a href="" ng-click="addWidget(widget.key)">{{widget.title}}</a>
            <br/>
            <span class="text-gray">{{widget.description}}</span>
          </li>
        </ul>
      </div uib-accordion-group>
    </div>
  </div>

  <!-- dashboard categories disabled -->
  <div style="display: inline-block;" ng-if="!createCategories || widgetFilter">
    <ul class="item-list item-list-bordered">
      <li class="item" ng-repeat="widget in widgets | adfOrderByObjectKey: 'key' | filter: widgetFilter">
        <a href="" ng-click="addWidget(widget.key)">{{widget.title}}</a>
        <br/>
        <span class="text-gray">{{widget.description}}</span>
      </li>
    </ul>
  </div>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" ng-click="closeDialog()" ng-bind="translate('ADF_COMMON_CLOSE')">Close</button>
</div>
`,
  'app/components/dashboard/partials/dashboard-edit.html': `<div class="modal-header">
  <button type="button" class="close" ng-click="closeDialog()" aria-hidden="true">&times;</button>
  <h4 class="modal-title" ng-bind="translate('ADF_COMMON_EDIT_DASHBOARD')">Edit Dashboard</h4>
</div>
<div class="modal-body">
  <form role="form">
    <div class="form-group">
      <label ng-bind="translate('ADF_EDIT_DASHBOARD_STRUCTURE_LABEL')">Structure</label>
      <div class="row" ng-init="splitted = split(structures, 3)">
        <div class="col-lg-4" ng-repeat="structureColumn in splitted">
          <div class="radio" ng-repeat="(key, structure) in structureColumn">
            <div class="row">
              <div class="col-sm-2">
                <label>
                  <input type="radio" value="{{key}}" ng-model="model.structure" ng-change="changeStructure(key, structure)">
                </label>
              </div>
              <button type="button" class="btn-link col-sm-9" ng-click="changeStructure(key, structure)">
                  <adf-structure-preview
                    name="key"
                    structure="structure"
                    selected="model.structure == key">
                  </adf-structure-preview>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" ng-click="closeDialog()" ng-bind="translate('ADF_COMMON_CLOSE')">Close</button>
</div>
`,
  'app/components/dashboard/partials/dashboard-title-buttons.html': `<div class="wrapper" ng-if="options.editable">
  <div class="row">
    <div class="col-sm-8">
      <h3>model.title</h3>
    </div>
    <div ng-if="options.editable" class="col-sm-4">
      <div class="button-list">
        <ul class="list-inline list-unstyled">
          <li>
            <a href="" class="btn btn-xs btn-primary" title="{{ translate('ADF_DASHBOARD_TITLE_TOOLTIP_ADD') }}" ng-click="addWidgetDialog()">
              {{ 'New widget' | translate }}
            </a>
          </li>
          <li>
            <a href="" class="btn btn-xs btn-info" title="{{ translate('ADF_COMMON_EDIT_DASHBOARD') }}" ng-click="editDashboardDialog()">
              {{ 'Settings' | translate }}
            </a>
          </li>
          <li>
            <a href="" class="btn btn-xs btn-success" ng-if="options.editable && !model.options.disableEditModeToggle" title="{{ translate('ADF_DASHBOARD_TITLE_TOOLTIP_SAVE') }}" ng-click="toggleEditMode()">
              {{ 'Save' | translate }}
            </a>
          <li>
            <a href="" class="btn btn-xs btn-warning" ng-if="!model.options.disableEditModeToggle" title="{{ translate('ADF_DASHBOARD_TITLE_TOOLTIP_UNDO') }}" ng-click="cancelEditMode()">
              {{ 'Cancel' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/dashboard/partials/dashboard-title.html': `<div class="wrapper" ng-if="!model.options.hideTitle || options.editable">
  <div class="row">
    <div class="col-sm-8">
      <h2 class="heading-3" ng-if="model.options.hideTitle && editMode">{{ 'Edit the template structure' | translate }}</h2>
      <h2 class="heading-3" ng-if="!model.options.hideTitle && !editMode">{{ model.title }}</h2>
    </div>
    <div ng-if="options.editable" class="col-sm-4">
      <div class="button-list">
        <ul class="list-inline list-unstyled">
          <li>
            <a href="" class="btn btn-xs btn-primary" ng-if="editMode" title="{{ translate('ADF_DASHBOARD_TITLE_TOOLTIP_ADD') }}" ng-click="addWidgetDialog()">
              {{ 'New widget' | translate }}
            </a>
          </li>
          <li>
            <a href="" class="btn btn-xs btn-info" ng-if="editMode" title="{{ translate('ADF_COMMON_EDIT_DASHBOARD') }}" ng-click="editDashboardDialog()">
              {{ 'Settings' | translate }}
            </a>
          </li>
          <li>
            <a href="" class="btn btn-xs btn-success" ng-if="options.editable && !model.options.disableEditModeToggle" title="{{editMode ? translate('ADF_DASHBOARD_TITLE_TOOLTIP_SAVE') :     translate('ADF_DASHBOARD_TITLE_TOOLTIP_EDIT_MODE') }}" ng-click="toggleEditMode()">
              {{ editMode ? ('Save' | translate) : ('Edit' | translate) }}
            </a>
          <li>
            <a href="" class="btn btn-xs btn-warning" ng-if="editMode && !model.options.disableEditModeToggle" title="{{ translate('ADF_DASHBOARD_TITLE_TOOLTIP_UNDO') }}" ng-click="cancelEditMode()">
              {{ 'Cancel' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/dashboard/partials/widget-title.html': `<h2 class="panel-title" ng-if="!config.options.hidePanelHeader">
  {{config.options.hideTitle ? '' : definition.title}}

  <span class="sr-only" ng-if="config.options.hideTitle">
    {{ definition.title }}
  </span>

  <p ng-class="{'pull-right': !config.options.hideTitle, 'text-right': config.options.hideTitle}">
    <a href="" title="{{ 'Reload widget content' | translate }}" ng-if="widget.reload" ng-click="reload()">
      <i class="glyphicon glyphicon-refresh"></i>
    </a>
    <!-- collapse -->
    <a href="" title="{{ 'Collapse widget' | translate }}" ng-show="options.collapsible && !widgetState.isCollapsed && !config.options.cannotCollapse" ng-click="widgetState.isCollapsed = !widgetState.isCollapsed">
      <i class="glyphicon glyphicon-minus"></i>
    </a>
    <!-- expand -->
    <a href="" title="{{ 'Expand widget' | translate }}" ng-show="options.collapsible && widgetState.isCollapsed && !config.options.cannotCollapse" ng-click="widgetState.isCollapsed = !widgetState.isCollapsed">
      <i class="glyphicon glyphicon-plus"></i>
    </a>
    <!-- change widget location -->
    <a href="" title="{{ 'Change widget location' | translate }}" class="adf-move" ng-if="editMode && !config.options.cannotSort">
      <i class="glyphicon glyphicon-move"></i>
    </a>
    <!-- open edit mode -->
    <a href="" title="{{ 'Edit widget configuration' | translate }}" ng-click="edit()" ng-if="editMode && !config.options.cannotEdit">
      <i class="glyphicon glyphicon-cog"></i>
    </a>
    <a href="" title="{{ 'Fullscreen widget' | translate }}" ng-click="openFullScreen()" ng-show="options.maximizable && !config.options.cannotMaximize">
     <i class="glyphicon glyphicon-fullscreen"></i>
   </a>
    <!-- remove widget -->
    <a href="" title="{{ 'Remove widget' | translate }}" ng-click="remove()" ng-if="editMode && !config.options.cannotRemove">
      <i class="glyphicon glyphicon-remove"></i>
    </a>
  </p>
</h2>
`,
  'app/components/dashboard/partials/widget.html': `<div adf-id="{{definition.wid}}" adf-widget-type="{{definition.type}}" ng-class="widgetClasses(widget, definition)" class="widget">
  <div class="panel-heading clearfix" ng-if="!widget.frameless || editMode">
    <div ng-include src="definition.titleTemplateUrl"></div>
  </div>
  <div id="{{definition.wid}}-panel" ng-class="{'panel-body':!widget.frameless || editMode}" ng-show="!widgetState.isCollapsed">
    <adf-widget-content adf-model="adfModel" model="definition" content="widget" data-ng-if="widget"/>
    <div data-ng-if="!widget">
      <p class="box box-warning">
        {{ 'Please refresh the page in order to see the contents of this new tile' | translate }}
      </p>
    </div>
  </div>
</div>
`,
  'app/components/dashboard/view.html': `<!-- Such a shame we have to trick the screen reader because we don't have access to widget.titleTemplateUrl -->
<h1 class="sr-only">{{ 'Dashboard' | translate }}</h1>
<h2 class="sr-only">{{templateCtrl.template.title}}</h2>

<div class="wrapper" ng-if="templateCtrl.templates.length > 1">
  <div class="row">
    <div class="col-xs-12">
      <dashboard-template-selector
        show-as-title="true"
        current-template="templateCtrl.template"
        templates="templateCtrl.templates"
        handle-change-selected="templateCtrl.onTemplateChange(id)">
      </dashboard-template-selector>
    </div>
  </div>
</div>

<kz-inbox-notifications data-ng-if="templateCtrl.showNotifications"></kz-inbox-notifications>

<adf-dashboard
  ng-if="templateCtrl.template"
  name="{{templateCtrl.name}}"
  collapsible="true"
  editable="false"
  adf-model="templateCtrl.template">
</adf-dashboard>
`,
  'app/components/drafts/draft-slot.html': `<div class="col-xs-12">
  <div class="row">
    <div ng-class="{'col-xs-10': canDelete, 'col-xs-12': !canDelete}">
      <ul class="list-unstyled">
        <li>
          <a href="" ng-click="openPreview()" title="Preview">
            <span>Autosave {{ idx + 1 }}</span>
          </a>
          <span class="text-warning" data-ng-if="active"> - This is what you are currently working on</span>
        </li>
        <li class="text-gray">
          <span data-ng-show="false">{{ draft._id }}</span>
          <span class="label label-default">Last edited: </span>
          <span>{{ draft.saveInfo.lastSaved | date:dateFormat }} using {{ identifier }}</span>
        </li>
      </ul>
    </div>
    <div ng-if="canDelete" class="col-xs-2 text-right">
      <a href="" ng-click="remove(draft)" class="text-danger"><i title="Delete draft" class="icon-trash"></i></a>
    </div>
  </div>
</div>
`,
  'app/components/drafts/drafts-list.html': `<div>
  <ul class="item-list item-list-bordered" ng-if="!list.isLoading && messages">
    <li class="item row">
      <div class="col-xs-12">
        <p ng-if="list.items.length" class="text-gray">
          {{ messages.default }}
        </p>

        <p ng-if="!list.items.length" class="box box-info">
          {{ messages.empty }}
        </p>
      </div>
    </li>
  </ul>

  <ul class="item-list item-list-bordered" ng-if="list.ready && !list.isLoading">
    <li class="item row"
      kz-draft-slot
      ng-repeat="draft in list.items track by draft._id"
      draft="draft"
      info="info"
      can-delete="canDeleteDraft"
      idx="$index"
      >
    </li>
  </ul>

  <kz-pagination
    ng-if="list.ready && !list.isLoading && list.items.length"
    total="list.found_count"
    startkey="list.startkey"
    per-page="list.findOptions.limit"
    to="goToPage(page)">
  </kz-pagination>
</div>
`,
  'app/components/drafts/last-saved.html': `<div>
  <span class="label label-info" ng-show="lastSaved && !unsavedChanges">Last saved: {{ lastSaved }}</span>
  <span class="label label-info" ng-show="unsavedChanges">Unsaved changes...</span>
</div>
`,
  'app/components/drafts/revisions-toggle.html': `<li ng-show="showToggle">
  <a href="" class="text-danger" ng-click="toggleRevisions()"><i class="icon-autosave"></i> {{ 'Autosaves' | translate }}</a>
</li>
`,
  'app/components/drafts/revisions.html': `<div class="row" ng-show="info.showRevisions">
  <div class="col-xs-12" data-ng-if="info.showRevisions">
    <!-- FIXME: This needs better wording -->
    <p class="alert alert-info">
      We couldn't automatically save your changes because the event has
      modifications saved from another user or device. We have created a
      separate revision of your event and saved it there. You can either
      continue to work normally or choose to switch the revision you are
      working on below.
    </p>

    <p>
      <ul class="item-list item-list-bordered">
        <li class="item row">
          <div class="col-xs-12">
            <ul class="list-unstyled">
              <li>
                <a href="" data-ng-click="openPreview()">Original</a>
                <span class="text-warning" data-ng-if="active"> - This is what you are currently working on</span>
              </li>
              <li>
                <span class="label label-default">Last edited: </span>
                <span>{{ saveInfo.lastSaved | date: dateFormat }} using {{ identifier }}</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </p>

    <kz-drafts-list drafts="revisions" info="info"></kz-drafts-list>
  </div>
</div>
`,
  'app/components/drafts/widgets/event-drafts/edit.html': `<form role="form">
  <div class="form-group">
    <label for="eventOwner" class="control-label">
      Select whose drafts to show
      <i class="icon-star required" aria-label="star"></i>
    </label>

    <ui-select multiple="true" ng-model="config.eventOwner" close-on-select="true" title="Select whose drafts to show" required>

      <ui-select-match placeholder="Select whose drafts to show" allow-clear="true">
        {{$item.name}}
      </ui-select-match>

      <ui-select-choices repeat="option.id as option in eventDraftsEditCtrl.options">
        <div ng-bind-html="option.name | highlight: $select.search"></div>
      </ui-select-choices>

    </ui-select>
  </div>
</form>
`,
  'app/components/drafts/widgets/event-drafts/view.html': `<div>
  <uib-tabset ng-if="eventDraftsCtrl.hasMultipleDraftGroups">
    <uib-tab index="0" heading="Your drafts">
      <kz-drafts-list
        drafts="eventDraftsCtrl.drafts.yourDrafts"
        messages="eventDraftsCtrl.yourDraftsMessages">
      </kz-drafts-list>
    </uib-tab>

    <uib-tab index="1" heading="Drafts for other users">
      <kz-drafts-list
        drafts="eventDraftsCtrl.drafts.userDrafts"
        messages="eventDraftsCtrl.userDraftsMessages">
      </kz-drafts-list>
    </uib-tab>
  </uib-tabset>

  <kz-drafts-list
    ng-if="!eventDraftsCtrl.hasMultipleDraftGroups"
    drafts="eventDraftsCtrl.drafts"
    messages="eventDraftsCtrl.messages">
  </kz-drafts-list>
</div>
`,
  'app/components/email-logs/email-log-resend.html': `<div class="modal-header">
    <div class="modal-title">
        <button type="button" class="close" data-ng-click="$dismiss()" aria-label="Close"><i class="icon-cancel"></i></button>
        <h3>{{ 'Send email again' | translate }}</h3>
    </div>
</div>

<div class="modal-body">
    <div ng-if="ctrl.originalEmail && ctrl.originalEmail !== ctrl.currentEmail">
        <p ng-bind-html="ctrl.emailChangedInfo">
        </p>
        <div class="form-group">
            <input id="useCurrentEmail" type="checkbox" ng-model="ctrl.data.useCurrentEmail">
            <label for="useCurrentEmail">{{ctrl.sendToLabel}}</label>
        </div>
    </div>
    <div ng-if="ctrl.allowRegenerate">
        <p>
            {{ 'If the email template has been modified since the email was sent you can override the content using the most up to date template.' | translate }}
        </p>

        <div class="form-group">
            <input id="useCurrentTemplate" type="checkbox" ng-model="ctrl.data.useCurrentTemplate">
            <label for="useCurrentTemplate">{{ 'Regenerate the email using the current email template' | translate }}</label>
        </div>
    </div>
    <div ng-if="!ctrl.allowRegenerate">
        <p>{{ 'Use this to send an exact copy of this email.' | translate }}</p>
    </div>

</div>

<div class="modal-footer">
    <div class="row">
        <div class="col-sm-8">
            <button type="button" class="btn btn-success" ng-click="$close(ctrl.data)">{{ 'Send again' | translate }}</button>
            <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{ 'Cancel' | translate }}</button>
        </div>
    </div>
</div>
`,
  'app/components/email-logs/email-log-slot.html': `<div class="col-xs-12" >
    <div class="row event-inner">
        <div class="col-sm-7">
            <h2>
              <a ng-if="$ctrl.canViewEmailSent" href="" ng-click="$ctrl.preview()">{{ 'Sent to' | translate }} <span ng-repeat="recipient in $ctrl.emailLog.doc.recipients">{{ recipient }}</span></a>
              <span ng-if="!$ctrl.canViewEmailSent">{{ 'Sent to' | translate }} <span ng-repeat="recipient in $ctrl.emailLog.doc.recipients">{{ recipient }}</span></span>
            </h2>
            <p>{{ 'Type:' | translate }} {{ $ctrl.emailLog.doc.email_type.name }}</p>
        </div>


        <div class="col-sm-5 col-right">
          <ul class="list-inline list-unstyled">
            <li>
              <span class="label label-default">{{ 'Sent on:' | translate }} </span><span class="text-info">{{ $ctrl.emailLog.doc.createdDate | kzDateFormat:'datetime' }}</span>
            </li>
          </ul>
        </div>

        <div class="col-sm-12">
          <div ng-if="$ctrl.shownDetails">
            <ul class="list-unstyled">
              <li>{{ 'Template:' | translate }} {{ $ctrl.emailLog.doc.email_template.name }}</li>
              <li>{{ 'Real recipients:' | translate }} <span ng-repeat="recipient in $ctrl.emailLog.doc.real_recipients">{{ recipient }}, </span></li>
              <li>{{ 'Message ID:' | translate }} {{ $ctrl.emailLog.doc.messageId }}</li>
              <li ng-if="$ctrl.related.route">{{ 'Related:' | translate }} <a router-link="$ctrl.related.route">{{ 'Link to related object' | translate }}</a></li>
            </ul>
            <p ng-if="$ctrl.emailLog.doc.state_log.length">
              <span>{{ 'Delivery log:' | translate }}</span>
              <ul class="list-unstyled">
                <li ng-repeat="log in $ctrl.emailLog.doc.state_log">
                  <span ng-class="{ 'text-danger': log.reason_code === 'bounced' }">
                  {{ log.timestamp | kzDateFormat:'datetime' }}: {{ log.recipient }} - {{ log.reason_code }}
                  <span ng-if="log.reason_code === 'bounced'"><br/><pre style="margin: 0 20px">{{ log.reason}}</pre></span>
                  </span>
                </li>
                <li ng-repeat="log in $ctrl.emailLog.doc.auditLog" class="text-warning">
                  <span ng-if="log.action === 'email_resent'">
                    {{ 'This email was sent because of a re-send of' | translate }} {{ log.reason.messageId }} {{ 'and was triggered by:' | translate }}
                    <span class="meta-author" event-filled-by user="log.actor"></span>
                  </span>
                  <span ng-if="log.action === 'email_log_resend'">{{ 'This email has been re-sent' | translate }}</span>
                </li>
              </ul>
            </p>
          </div>

      </div>
    </div>

    <kz-list-buttons ng-if="$ctrl.actionButtons" actions="$ctrl.actionButtons" secondary-actions="$ctrl.secondaryActionButtons"></kz-list-buttons>
</div>
`,
  'app/components/email-logs/email-logs.html': `<section class="wrapper">
    <header class="row">
        <kz-header actions="$ctrl.actions"><h1>{{ 'Sent emails' | translate }}</h1></kz-header>
        <kz-simple-search list="$ctrl.list"></kz-simple-search>
        <kz-search-string list="$ctrl.list"></kz-search-string>
    </header>
    <kz-refine-filter list="$ctrl.list"></kz-refine-filter>
</section>


<kz-list-view list="$ctrl.list" options="$ctrl.options">
    <email-log-slot email-log="item" options="options"></email-log-slot>
</kz-list-view>
`,
  'app/components/email-templates/cards/placeholders.html': `<p>{{ 'Placeholders will be replaced with the actual data for each email sent.' | translate }}</p>

<div class="row row-bordered" ng-repeat="placeholder in placeholders track by placeholder.id">
  <div class="col-xs-12">
    <div class="row">
      <div class="col-xs-12 col-sm-8">
        <span class="font-semibold heading-4">%{{placeholder.id}}%</span>
      </div>
      <div class="col-xs-12 col-sm-4 text-right">
        <a href="" kz-copy-to-clipboard text="%{{placeholder.id}}%">{{ 'Copy to clipboard' | translate }}</a>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <p class="py-1 my-1" ng-if="placeholder.description">{{placeholder.description}}</p>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/email-templates/email-template.html': `<form novalidate unsaved-warning-form name="$ctrl.form" aria-label="Edit email template" ng-submit="$ctrl.submit()">
  <section class="wrapper">
    <header class="row">
      <div class="col-sm-8"><h1 ng-if="$ctrl.emailType">{{ 'Email template for' | translate }} {{ $ctrl.emailType.doc.name }}</h1></div>
      <div class="col-sm-4">
        <p class="button-list" *ngIf="$ctrl.emailType">
          <button type="submit" ng-disabled="$ctrl.submitted" class="btn btn-success btn-raised">{{ 'Apply changes' | translate }}</button>
          <a class="btn btn-danger btn-raised"
            router-link="['/emails', $ctrl.emailTypeId]"
          >{{ 'Back to overview' | translate }}</a>
        </p>
      </div>
    </header>
  </section>

  <section class="wrapper" ng-if="$ctrl.templateForm">
    <div class="row">
      <formly-form model="$ctrl.templateModel" fields="$ctrl.templateForm.fields" aria-label="Template form"></formly-form>
    </div>
    <p class="px-4 pb-4">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.preview()">{{ 'Preview' | translate }}</button>
      <button type="button" class="btn btn-warning" ng-click="$ctrl.restore()">{{ 'Reset to default' | translate }}</button>
    </p>
  </section>
</form>
`,
  'app/components/email-templates/email-type-preview.html': `<div class="modal-header" ng-if="$ctrl.showHeader">
  <div class="modal-title">
    <button type="button" class="close" data-ng-click="$ctrl.onClose({})" aria-label="Close"><i class="icon-cancel"></i></button>
    <h3>{{ $ctrl.subject }}</h3>
  </div>
</div>

<div class="modal-body">
  <iframe style="width: 100%; height: 500px; border: 0;"></iframe>
</div>
`,
  'app/components/email-templates/email-type-slot.html': `<div class="col-xs-12" >
    <div class="row event-inner">
        <div class="col-sm-7">
            <h2>
              <router-link [router-link]="['emails', $ctrl.emailType.doc.id]">{{ ::$ctrl.emailType.doc.name }}</router-link>
            </h2>
            <div class="text-gray">
                {{ ::$ctrl.emailType.doc.description }}
            </div>
        </div>

        <div class="col-sm-5 col-right">
          <ul class="list-inline list-unstyled">
            <li><span class="label label-default">{{ 'Template:' | translate }}</span> <span class="text-info">{{ $ctrl.emailType.doc.defaultTemplate.name }}</span></li>
          </ul>
        </div>
    </div>

    <kz-list-buttons ng-if="$ctrl.actionButtons" actions="$ctrl.actionButtons" secondary-actions="$ctrl.secondaryActionButtons"></kz-list-buttons>
</div>
`,
  'app/components/email-templates/email-type.html': `<section class="wrapper">
  <header class="row">
    <div class="col-sm-8">
      <h1 ng-if="$ctrl.emailType">{{ $ctrl.emailType.doc.name }}</h1>
    </div>

    <div ng-if="$ctrl.emailTypeActions" class="col-sm-4 text-right">
      <p class="button-list">
        <kz-page-buttons actions="$ctrl.emailTypeActions"></kz-page-buttons>
      </p>
    </div>
  </header>
  <div class="row">
    <div class="col-xs-12">
      <p>{{ $ctrl.emailType.doc.description }}</p>
    </div>
    <div class="row" ng-if="$ctrl.emailType.isDisabled()">
      <div class="col-xs-12">
        <p class="alert alert-warning">{{ 'Sending of this email is disabled. To enable it please select a template to use.' | translate }}</p>
      </div>
    </div>
  </div>
</section>

<section class="wrapper" ng-if="!$ctrl.emailType.isDisabled()">
  <div class="row">
    <div class="col-xs-8">
      <h3>{{ 'Preview' | translate }}</h3>
    </div>
    <div ng-if="$ctrl.emailTemplateActions" class="col-xs-4 text-right">
      <kz-page-buttons actions="$ctrl.emailTemplateActions"></kz-page-buttons>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <email-type-preview
        ng-if="$ctrl.emailType"
        email-type-id="$ctrl.emailType.doc.id"
        preferred-template-id="$ctrl.emailType.doc.defaultTemplate.id"
        show-header="false">
      </email-type-preview>
    </div>
  </div>
</section>
`,
  'app/components/email-templates/email-types.html': `<section class="wrapper">
<header class="row">
    <kz-header actions="$ctrl.actions"><h1>{{ 'Email types' | translate }}</h1></kz-header>
    <kz-simple-search list="$ctrl.list"></kz-simple-search>
    <kz-search-string list="$ctrl.list"></kz-search-string>
</header>
<kz-refine-filter list="$ctrl.list"></kz-refine-filter>
</section>

<kz-list-view list="$ctrl.list" options="$ctrl.options">
<email-type-slot email-type="item" options="options"></email-type-slot>
</kz-list-view>
`,
  'app/components/email-templates/email-view.html': `<div class="modal-header">
  <div class="modal-title">
    <button type="button" class="close" data-ng-click="$ctrl.onClose({})" aria-label="Close"><i class="icon-cancel"></i></button>
    <h3>{{ $ctrl.subject }}</h3>
    <p>
      <ul class="list-unstyled">
        <li>{{ 'From:' | translate }} <b>{{ $ctrl.email_from}}</b></li>
        <li>{{ 'To:' | translate }} <b><span ng-repeat="rec in $ctrl.recipients">{{ rec }}</b></li>
        <li>{{ 'Date:' | translate }} <b>{{ $ctrl.date | kzDateFormat:'datetime'}}</b></li>
        <li>{{ 'Message ID:' | translate }} <b>{{ $ctrl.messageId }}</b></li>
      </ul>
      <div ng-if="$ctrl.shownDetails || 1">
        <p ng-if="$ctrl.state_log.length">
          <span>{{ 'Delivery log:' | translate }}</span>
          <ul class="list-unstyled">
            <li ng-repeat="log in $ctrl.state_log">
              <span ng-class="{ 'text-danger': log.reason_code === 'bounced' }">
              {{ log.timestamp | kzDateFormat:'datetime' }}: {{ log.recipient }} - {{ log.reason_code }}
              </span>
            </li>
          </ul>
        </p>
      </div>
    </p>
  </div>
</div>

<div class="modal-body">
  <iframe style="width: 100%; height: 98%; border: 0;"></iframe>
</div>
`,
  'app/components/event-types/directives/dependent-sections-permissions.html': `<div class="row">
  <div class="col-xs-12">
    <div class="row">
      <div class="col-xs-12">
        <p class="text-gray">
          {{ 'Allows the user filling in this section to modify previous sections in the workflow.' | translate }}<br/>
          <span ng-bind-html="'Use <strong>Edit section responses</strong> when you need the user to edit the content of previous sections.' | translate"></span><br/>
          <span ng-bind-html="'Use <strong>Remove multi source responses</strong> when you need the user to remove entire responses collected when the section is filled by more than one person.' | translate"></span>
        </p>
      </div>
    </div>
    <div class="row" ng-repeat="sectionPerm in model.dependentSectionsPerms track by $index" data-ng-if="model.visibilityType !== 'never'">
      <div class="col-xs-9">
        <formly-form class="inline" model="sectionPerm" fields="forms[$index].fields" form="form" aria-label="Dependant section permissions"></formly-form>
      </div>
      <div class="col-xs-3">
        <div class="button-list">
          <ul class="list-inline list-unstyled list-icon-actions">
            <li data-ng-if="!readOnly"><a href="" ng-click="removeDependency($index)" aria-label="Remove dependent section"><i class="icon-trash"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row" data-ng-if="!readOnly">
      <div class="col-xs-12">
        <button type="button" class="btn btn-info btn-sm" ng-click="addDependency()">{{ 'Add permission' | translate }}</button>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/event-types/directives/registration-and-approval.html': `<div class="row">
  <epf-role-title class="col-xs-3" user-role="{{ model.roleId }}"></epf-role-title>
  <formly-form class="inline col-xs-9" model="model" fields="form.fields" form="form"
  aria-label="Registration and approval"></formly-form>
</div>
`,
  'app/components/event-types/directives/section-visibility.html': `<div class="row">
  <div class="col-xs-12 section-visibility">
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <div class="radio">
            <label>
              <input type="radio" value="never" ng-disabled="readOnly" ng-model="model.visibilityType">
              {{ 'Always show this section' | translate }}
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" value="and" ng-disabled="readOnly" ng-model="model.visibilityType">
              <ng-container ng-bind-html="'Skip this section if <strong>ALL</strong> of the conditions below are met' | translate"></ng-container>
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" value="or" ng-disabled="readOnly" ng-model="model.visibilityType">
              <ng-container ng-bind-html="'Skip this section if <strong>ANY</strong> of the conditions below are met' | translate"></ng-container>
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" value="notand" ng-disabled="readOnly" ng-model="model.visibilityType">
              <ng-container ng-bind-html="'Show this section if <strong>ALL</strong> of the conditions below are met' | translate"></ng-container>
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" value="notor" ng-disabled="readOnly" ng-model="model.visibilityType">
              <ng-container ng-bind-html="'Show this section if <strong>ANY</strong> of the conditions below are met' | translate"></ng-container>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row" data-ng-if="hasMultiSource">
      <div class="col-xs-12">
        <p class="box box-warning">
          {{ 'Each condition for multi source sections will be satisfied if at least one response matches the condition' | translate }}
        </p>
      </div>
    </div>

    <div class="row" ng-repeat="frm in forms" data-ng-if="model.visibilityType !== 'never'">
      <div class="col-xs-9">
        <formly-form data-ng-if="!readOnly" class="inline" model="frm.model" fields="frm.form.fields" form="form" aria-label="Section visibility"></formly-form>
        <kz-readonly-form data-ng-if="readOnly" class="inline" fields="frm.form.fields" model="frm.model" options="{passTemplateOptions: true}"></kz-readonly-form>
      </div>
      <div class="col-xs-3">
        <div class="button-list">
          <ul class="list-inline list-unstyled list-icon-actions">
            <li data-ng-if="!readOnly"><a href="" ng-click="removeCondition($index)" aria-label="Remove"><i class="icon-trash"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row" data-ng-if="!readOnly && model.visibilityType !== 'never'">
      <div class="col-xs-12" data-ng-if="model.visibilityType !== 'never'">
        <button type="button" class="btn btn-info btn-sm" ng-click="addCondition()">{{ 'Add condition' | translate }}</button>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/event-types/event-type-section-field.html': `<form novalidate unsaved-warning-form name="form" aria-label="Edit section field">
  <div kz-loading loaded="fieldCtrl.loaded">
    <div class="wrapper">
      <header class="row">
        <div class="col-sm-6">
          <h1>{{ 'Edit section field' | translate }}</h1>
        </div>
        <div class="col-sm-6">
          <p class="button-list">
            <button type="submit" class="btn btn-success btn-raised" data-ng-click="fieldCtrl.save(form.$valid)" data-ng-disabled="form.$invalid">{{ 'Save' | translate }}</button>

            <button type="button" class="btn btn-info btn-raised" data-ng-click="fieldCtrl.cancel()">{{ 'Cancel' | translate }}</button>
            <button type="button" class="btn btn-danger btn-raised" data-ng-if="fieldCtrl.canEdit" data-ng-if="fieldCtrl.showDelete" data-ng-click="fieldCtrl.remove()">{{ 'Delete' | translate }}</button>
          </p>
        </div>

        <div class="col-sm-12 box box-warning" data-ng-if="fieldCtrl.errors.length">
          <ul class="list-unstyled">
            <li data-ng-repeat="error in fieldCtrl.errors track by $index">
              {{ error }}
            </li>
          </ul>
        </div>
      </header>

      <div class="row">
        <div class="col-xs-12">
          <p class="text-gray">{{ 'Fields marked with' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i><span class="sr-only">{{ fieldCtrl.canEdit ? ('star' | translate) : ('lock' | translate) }}</span> {{ 'are' | translate }} {{ fieldCtrl.canEdit ? ('required' | translate) : ('locked' | translate) }}.</p>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-xs-12" data-ng-if="fieldCtrl.field.type" data-ng-include="'app/components/event-types/partials/field.' + fieldCtrl.field.type + '.html'"></div>
      </div>
    </div>

    <div class="wrapper">
      <div class="row" >
        <div class="col-xs-12">
          <h2 class="heading-4">{{ 'Field properties' | translate }}</h2>
        </div>
      </div>

      <div class="row" data-ng-if="fieldCtrl.field.type !== 'text'">
        <div class="col-xs-12" data-ng-include="'app/components/event-types/partials/field.properties.html'"></div>
      </div>

      <div class="row" data-ng-if="fieldCtrl.field.type === 'text'">
        <div class="col-xs-12" data-ng-include="'app/components/event-types/partials/field.restrictedBy.html'"></div>
      </div>

    </div>
  </div>

</form>
`,
  'app/components/event-types/event-type-section-predefined-fields.html': `<div class="wrapper">

  <header class="row">
    <div class="col-sm-6">
      <h1>{{ 'Choose a predefined field' | translate }}</h1>
    </div>
    <div class="col-sm-6">
      <p class="button-list">
        <button type="button" class="btn btn-success btn-raised" ng-class="{disabled: predefinedFieldsCtrl.actionSelected}" data-ng-click="predefinedFieldsCtrl.new()" >{{ 'New custom field' | translate }}</button>
        <button type="button" class="btn btn-info btn-raised" router-link="['/event-types', predefinedFieldsCtrl.eventType._id, 'section', predefinedFieldsCtrl.section._id]">{{ 'Cancel' | translate }}</button>
      </p>
    </div>
  </header>

  <div class="row" data-ng-if="predefinedFieldsCtrl.fields.length">
    <div class="row">
      <div class="col-xs-12">
        <p class="text-gray">{{ 'Choose a predefined field.' | translate }}</p>
      </div>
    </div>

    <div class="row" data-ng-repeat="field in predefinedFieldsCtrl.fields track by field._id">
      <div class="col-xs-9">
        <p data-ng-bind="::field.name"></p>
        <p class="text-gray">{{field.blueprintType | uppercase}} {{field.fieldType | uppercase}}</p>
      </div>
      <div class="col-xs-3">
        <div class="button-list">
          <ul class="list-inline list-unstyled">
            <li><button type="button" data-ng-click="predefinedFieldsCtrl.select(field._id)" class="btn btn-sm btn-border btn-primary" ng-class="{disabled: predefinedFieldsCtrl.actionSelected}">{{ 'Select' | translate }}</button></li>
            <li><button type="button" data-ng-click="predefinedFieldsCtrl.remove(field._id)" href="" class="btn btn-sm btn-border btn-danger" ng-class="{disabled: predefinedFieldsCtrl.actionSelected}">{{ 'Delete' | translate }}</button></li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="row" data-ng-if="!predefinedFieldsCtrl.fields.length">
    <p class="text-warning"><i class="icon-warning"></i> {{ 'There are no predefined fields available.' | translate }}</p>
  </div>

</form>
`,
  'app/components/event-types/event-type-section.html': `<div>
  <div kz-loading loaded="sectionCtrl.loaded">
    <form novalidate unsaved-warning-form name="form" aria-label="Edit event type section">
      <div class="wrapper">

        <header class="row header-fixed">
          <div class="col-sm-6">
            <h1>{{ 'Edit event type section' | translate }}</h1>
          </div>
          <div class="col-sm-6">
            <p class="button-list">
              <button type="submit" class="btn btn-success btn-raised" data-ng-disabled="form.$invalid"  data-ng-click="sectionCtrl.save(form.$valid)">{{ 'Save' | translate }}</button>
              <button type="button" class="btn btn-info btn-raised" data-ng-click="sectionCtrl.cancel()">{{ sectionCtrl.canEdit ? ('Cancel' | translate) : ('Back' | translate) }}</button>
              <button type="button" class="btn btn-danger btn-raised" data-ng-if="sectionCtrl.showDelete && sectionCtrl.canEdit" data-ng-click="sectionCtrl.remove()">{{ 'Delete' | translate }}</button>
            </p>
          </div>

          <div class="col-sm-12 box box-warning" data-ng-if="sectionCtrl.errors.length">
            <ul class="list-unstyled">
              <li data-ng-repeat="error in sectionCtrl.errors track by $index">
                {{ error }}
              </li>
            </ul>
          </div>
        </header>

        <div class="row bg-gray-300 text-gray-700 ">
          <div class="col-xs-12">{{ 'Roles and approvals' | translate }}</div>
        </div>
        <div class="row">
          <div class="col-xs-12 form-group">
            <label for="filledBy">{{ 'This section is filled in by' | translate }} <i ng-class="{'icon-star required': sectionCtrl.canEdit, 'icon-lock disabled': !sectionCtrl.canEdit}"></i></label>
            <ui-select multiple ui-validate="{ anon: 'validateFilledBy($value)' }" data-ng-required="true" data-ng-disabled="!sectionCtrl.canEdit" ng-model="sectionCtrl.section.filledBy" close-on-select="false" title="{{ 'Choose roles' | translate }}">
              <ui-select-match placeholder="{{ 'Select roles...' | translate }}">{{$item.doc.title}}</ui-select-match>
              <ui-select-choices repeat="role.doc._id as role in sectionCtrl.roles | filter:$select.search" >
                {{role.doc.title}}
              </ui-select-choices>
            </ui-select>
            <p class="text-gray">
              {{ 'Choose which role(s) are capable of filling in and completing this section. Use' | translate }} <strong>{{ 'Timeline Owner' | translate }}</strong> {{ 'when you need to specify the individual user on whose timeline this event sits.' | translate }}
            </p>
             <p class="text-gray" data-ng-if="sectionCtrl.section.filledBy.indexOf('system:anonymous-external') !== -1">
              {{ 'You have chosen' | translate }} <strong>{{ 'anonymous external user' | translate }}</strong>. {{ 'Upon submission of the previous section this event will automatically generate a unique URL visible to the owner. This URL can then be distributed to any persons wishing to provide a response. No other roles can be specified to fill in this section whilst anonymous external user is selected.' | translate }}
            </p>
         </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-info">
              {{ 'Submissions matching these settings will need to be approved from the pending sections area before the event can continue' | translate }}
            </div>
          </div>

          <div class="col-xs-12" data-ng-if="sectionCtrl.invitableForm">
            <div class="row">
              <div class="col-xs-12">
                <p>
                  {{ 'Invitations can be sent externally with' | translate }} <strong><span epf-roles-title roles="sectionCtrl.invitable"></span></strong>{{ '. The following settings will apply to responses to these external invitations.' | translate }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <formly-form class="inline col-xs-9" model="sectionCtrl.section.invitationSettings" fields="sectionCtrl.invitableForm.fields" form="form" aria-label="Invitation settings"></formly-form>
              </div>
            </div>
            <div class="row" data-ng-if="sectionCtrl.invitable.length > 1">
              <div class="col-cs-12">
                <p>
                  {{ 'You have selected' | translate }} {{ sectionCtrl.invitable.length }} {{ 'invitable roles, both will be assigned to the user automatically' | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="row">
              <div class="col-xs-12">
                <p>
                  {{ 'The following settings will apply to responses made by users with existing user accounts.' | translate }}
                </p>
              </div>
            </div>
             <div class="row" data-ng-repeat="filledBySetting in sectionCtrl.section.filledBySettings track by filledBySetting.roleId">
               <div class="col-xs-12">
                <registration-and-approval is-first-section="sectionCtrl.isFirstSection" read-only="!sectionCtrl.canEdit" model="filledBySetting"></registration-and-approval>
               </div>
            </div>
          </div>
        </div>

        <div class="row bg-gray-300 text-gray-700 ">
          <div class="col-xs-12">{{ 'Filling and editing' | translate }}</div>
        </div>

        <div class="row" data-ng-class="{ 'has-error has-feedback': form['filledBy'].$invalid && formIsSubmitted}">
          <div class="col-xs-12">
            <div class="form-group">
              <div>
                <label>
                  {{ 'Name of action button shown to user when submitting this section' | translate }}<i class="icon-lock" ng-if="!sectionCtrl.canEdit"></i>
                </label>
                <input type="text" class="form-control" data-ng-model="sectionCtrl.section.actionTitle" ng-disabled="!sectionCtrl.canEdit">
              </div>
            </div>
          </div>

          <div class="col-xs-12">
            <div class="form-group">
              <label for="editableRoles">{{ 'Completed section can be edited by role' | translate }}</label>
              <ui-select multiple ng-model="sectionCtrl.section.editableRoles" close-on-select="false" title="{{ 'Choose roles' | translate }}">
                <ui-select-match placeholder="{{ 'Select roles...' | translate }}">{{$item.name}}</ui-select-match>
                <ui-select-choices repeat="role._id as role in sectionCtrl.editableRoles | filter:$select.search" >
                  {{role.name}}
                </ui-select-choices>
              </ui-select>
              <p class="text-gray">{{ 'Choose which role(s) have the capability to edit this section once the entire event workflow is complete. Use' | translate }} <strong>{{ 'Section author' | translate }}</strong> {{ 'when you need to specify the individual user who originally completed this section.' | translate }}</p>
            </div>
          </div>

          <div class="col-xs-12">
            <div class="form-group">
              <div class="checkbox">
                <label>
                  <input type="checkbox" data-ng-model="sectionCtrl.section.multiSource" type="checkbox" ng-disabled="!sectionCtrl.canEdit || sectionCtrl.disallowAnonymize">
                  {{ 'This section can be filled by more than one person' | translate }} <i class="icon-lock" ng-if="!sectionCtrl.canEdit || sectionCtrl.disallowAnonymize"></i>
                </label>
              </div>
              <p class="text-gray">{{ 'Allows responses to be collected from more than one person. The user submitting the previous section is able to send invitations to multiple users.' | translate }} <strong>{{ 'Timeline owner' | translate }}</strong>
                {{ 'cannot fill in this section if this setting is enabled.' | translate }}</p>
            </div>
          </div>

          <div class="col-xs-12">
            <div class="form-group">
              <div class="checkbox">
                <label>
                  <input type="checkbox" data-ng-model="sectionCtrl.section.anonymize" type="checkbox" ng-disabled="!sectionCtrl.canEdit || sectionCtrl.disallowAnonymize">
                  {{ 'Anonymise responses' | translate }} <i class="icon-lock" ng-if="!sectionCtrl.canEdit || sectionCtrl.disallowAnonymize"></i>
                </label>
              </div>
              <p class="text-gray">
                {{ 'Hides the name of the user(s) who filled in this section from the section details and audit log. The event audit log always shows which user(s) have been invited to fill in the section.' | translate }}
              </p>
            </div>
          </div>

          <div class="col-xs-12">
            <div class="form-group">
              <div class="checkbox">
                <label>
                  <input type="checkbox" data-ng-model="sectionCtrl.section.publishOnComplete" type="checkbox" ng-disabled="!sectionCtrl.canEdit">
                  {{ 'Hide responses until the event is completed.' | translate }} <i class="icon-lock" ng-if="!sectionCtrl.canEdit"></i>
                </label>
              </div>
              <p class="text-gray">{{ 'Hides the content of responses to this section until the entire event workflow is complete.' | translate }}</p>
            </div>
          </div>

          <div class="col-xs-12" ng-if="!sectionCtrl.isFirstSection">
            <div class="form-group">
              <div class="checkbox">
                <label>
                  <input type="checkbox" data-ng-model="sectionCtrl.section.fillOnSameDevice.enabled" type="checkbox" ng-disabled="!sectionCtrl.canEdit || sectionCtrl.section.multiSource">
                  {{ 'Fill in on same device enabled' | translate }}<i class="icon-lock" ng-if="!sectionCtrl.canEdit"></i>
                </label>
              </div>
              <p class="text-gray">{{ 'This section can be filled on the same device together with the previous section.' | translate }}</p>
            </div>
          </div>
        </div>

        <div class="row" data-ng-show="sectionCtrl.section.fillOnSameDevice.enabled">
          <formly-form class="col-xs-12" model="sectionCtrl.section.fillOnSameDevice" fields="sectionCtrl.fosdForm.fields" form="form" aria-label="Fill on same device settings"></formly-form>
        </div>

        <div class="row" data-ng-if="sectionCtrl.section.multiSource">
          <div class="col-xs-12">
            <div class="form-group">
              <div class="row">
                <div class="col-xs-12">
                  <label for="minimum" class="control-label">{{ 'Minimum submissions' | translate }} <i ng-class="{'icon-star required': sectionCtrl.canEdit, 'icon-lock disabled': !sectionCtrl.canEdit}"></i></label>
                  <input type="number" required name="minimum" data-ng-model="sectionCtrl.section.multiSourceMin" class="form-control" ng-disabled="!sectionCtrl.canEdit">
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <label for="maximum" class="control-label">{{ 'Maximum submissions' | translate }}</label>
                  <input type="number" name="maximum" data-ng-model="sectionCtrl.section.multiSourceMax" class="form-control" ng-disabled="!sectionCtrl.canEdit">
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <label for="auto" class="control-label">{{ 'Auto publish threshold' | translate }}</label>
                  <input type="number" name="auto" data-ng-model="sectionCtrl.section.multiSourceAuto" class="form-control" ng-disabled="!sectionCtrl.canEdit">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row bg-gray-300 text-gray-700 " data-ng-if="!sectionCtrl.isFirstSection">
          <div class="col-xs-12">{{ 'Visibility and workflow' | translate }}</div>
        </div>

        <section-visibility data-ng-if="!sectionCtrl.isFirstSection && sectionCtrl.visibilityModel" model="sectionCtrl.visibilityModel"
          event-type="sectionCtrl.eventType" read-only="!sectionCtrl.canEdit" current-section="{{ sectionCtrl.section._id }}"></section-visibility>

        <div class="row bg-gray-300 text-gray-700 " data-ng-if="!sectionCtrl.isFirstSection">
          <div class="col-xs-12">{{ 'Section specific editing permissions' | translate }}</div>
        </div>

        <dependent-sections-permissions
          model="sectionCtrl.section"
          event-type="sectionCtrl.eventType"
          read-only="!sectionCtrl.canEdit"
          current-section="{{ sectionCtrl.section._id }}"
          data-ng-if="!sectionCtrl.isFirstSection"
        ></dependent-sections-permissions>

        <div class="row bg-gray-300 text-gray-700 " data-ng-if="!sectionCtrl.isFirstSection">
          <div class="col-xs-12">{{ "Section's fields" | translate }}</div>
        </div>

        <div hidden id="event-type-section-fields-move-instructions">{{ 'Use the arrow up and down keys to move this field' | translate }}</div>
        <div class="row" data-ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost' }">
          <div class="col-xs-12 field-border" data-ng-repeat="field in sectionCtrl.section.fields track by field._id">
            <div class="row">
              <div class="col-xs-9" data-ng-switch on="field.type">
                <div data-ng-switch-when="text">
                  <div data-ng-bind-html="field.content | nl2br | a2nt | videoUrlToIframe" class="readonly"></div>
                  <p class="text-gray" data-ng-bind="::field.textType | uppercase"></p>
                </div>

                <div data-ng-switch-when="blueprint">
                  <div ng-if="field.name">
                    <p ng-bind="::field.name"></p>
                    <p class="text-gray">
                      <span data-ng-bind="::field.type | uppercase"></span>
                      - <span>{{sectionCtrl.preLoadedExternalFieldNames[field.blueprint]}}</span>
                    </p>
                  </div>
                  <div ng-if="!field.name">
                    <p>{{sectionCtrl.preLoadedExternalFieldNames[field.blueprint]}}</p>
                    <p class="text-gray">
                      <span data-ng-bind="::field.type | uppercase"></span>
                    </p>
                  </div>
                </div>

                <div data-ng-switch-when="relation">
                  <p>{{sectionCtrl.preLoadedExternalFieldNames[field.relation]}}</p>
                  <p class="text-gray" data-ng-bind="::field.type | uppercase"></p>
                </div>

                <div data-ng-switch-when="role">
                  <p>{{sectionCtrl.preLoadedExternalFieldNames[field.role]}}</p>
                  <p class="text-gray" data-ng-bind="::field.type | uppercase"></p>
                </div>

                <div data-ng-switch-when="report">
                  <p kz-object-title id="::field.report"></p>
                  <p class="text-gray" data-ng-bind="::field.type | uppercase"></p>
                </div>

                <div data-ng-switch-when="sqlreport">
                  <p kz-report-title id="::field.sqlreport"></p>
                  <p class="text-gray">{{ 'REPORT' | translate }}</p>
                </div>

                <div data-ng-switch-default>
                  <p data-ng-bind="::field.name"></p>
                  <p class="text-gray"><span data-ng-bind="::field.blueprintType | uppercase"></span> <span data-ng-bind="::field.type | uppercase"></span></p>
                </div>
              </div>

              <div class="col-xs-3">
                <div class="button-list">
                  <ul class="list-inline list-unstyled list-icon-actions" data-ng-if="sectionCtrl.canEdit">
                    <li><a router-link="['/event-types', sectionCtrl.eventType._id, 'section', sectionCtrl.section._id, 'field', field._id]" class="btn btn-sm btn-border btn-primary">{{ 'Edit' | translate }}</a></li>
                    <li>
                      <button type="button" class="btn-link text-info drag-handle" aria-label="Move {{ field.name }}" aria-describedby="event-type-section-fields-move-instructions">
                        <i class="icon-move"></i>
                      </button>
                    </li>
                    <li><a href="" data-ng-click="sectionCtrl.removeEventTypeSectionField(field._id)" aria-label="Remove"><i class="icon-trash"></i></a></li>
                  </ul>
                  <ul class="list-inline list-unstyled list-icon-actions" data-ng-if="!sectionCtrl.canEdit">
                    <li><a router-link="['/event-types', sectionCtrl.eventType._id, 'section', sectionCtrl.section._id, 'field', field._id]" class="btn btn-sm btn-border btn-primary">{{ 'View' | translate }}</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" data-ng-if="sectionCtrl.canEdit">
          <ul class="list-inline list-unstyled text-center" >
            <li><button unsaved-warning-clear data-ng-click="sectionCtrl.addEventTypeSectionField(form.$valid, 'text')" class="btn btn-xs btn-primary"><i class="icon-plus"></i> {{ 'Add text' | translate }}</button></li>
            <li><button unsaved-warning-clear data-ng-click="sectionCtrl.addEventTypeSectionField(form.$valid, 'blueprint')" class="btn btn-xs btn-primary"><i class="icon-plus"></i> {{ 'Add blueprint' | translate }}</button></li>
            <li><button unsaved-warning-clear data-ng-click="sectionCtrl.addEventTypeSectionField(form.$valid, 'relation')" class="btn btn-xs btn-primary"><i class="icon-plus"></i> {{ 'Add relation' | translate }}</button></li>
            <li><button unsaved-warning-clear data-ng-click="sectionCtrl.addEventTypeSectionField(form.$valid, 'customField')" class="btn btn-xs btn-primary"><i class="icon-plus"></i> {{ 'Add custom field' | translate }}</button></li>
            <li><button unsaved-warning-clear data-ng-click="sectionCtrl.addEventTypeSectionField(form.$valid, 'role')" class="btn btn-xs btn-primary"><i class="icon-plus"></i> {{ 'Add role' | translate }}</button></li>
            <li><button unsaved-warning-clear data-ng-click="sectionCtrl.addEventTypeSectionField(form.$valid, 'report')" class="btn btn-xs btn-primary"><i class="icon-plus"></i> {{ 'Add legacy report' | translate }}</button></li>
            <li kz-feature-enabled feature="reporting"><button unsaved-warning-clear data-ng-click="sectionCtrl.addEventTypeSectionField(form.$valid, 'sqlreport')" class="btn btn-xs btn-primary"><i class="icon-plus"></i> {{ 'Add report' | translate }}</button></li>
            <li><button unsaved-warning-clear data-ng-click="sectionCtrl.addEventTypeSectionField(form.$valid, 'goal')" class="btn btn-xs btn-primary" data-ng-if="!sectionCtrl.goalFieldExists"><i class="icon-plus"></i> {{ 'Add goal' | translate }}</button></li>
            <li><button unsaved-warning-clear data-ng-click="sectionCtrl.addEventTypeSectionField(form.$valid, 'signature')" class="btn btn-xs btn-primary"><i class="icon-plus"></i> {{ 'Add signature' | translate }}</button></li>
          </ul>
        </div>
      </div>
    </form>
  </div>
</div>
`,
  'app/components/event-types/event-type.slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-sm-12">
      <a router-link="['/event-types', ctrl.headVersion.id, 'edit']">
        <h2 class="entry-title">
          {{ ::item.doc.name }}
        </h2>
      </a>

      <div class="text-gray" ng-bind-html="item.doc.description | nl2br"></div>
      <p class="text-gray">
        <span>{{ 'CURRENT VERSION:' | translate }} {{::ctrl.headVersion.version}} </span>
        <version-state version="ctrl.headVersion"></version-state>
      </p>
      <p class="text-success" ng-if="ctrl.published">
        <span>{{ 'PUBLISHED VERSION:' | translate }} {{::ctrl.published.version}}
          <span ng-if="item.doc.name !== ctrl.published.name">({{::ctrl.published.name}})</span>
        </span>
      </p>
    </div>
  </div>

  <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons" version="item" options="options"></kz-list-buttons>
</div>
`,
  'app/components/event-types/form.html': `<form novalidate name="form" ng-if="eventTypeCtrl.loaded">
  <div kz-loading loaded="eventTypeCtrl.loaded">

  <div class="wrapper">

    <header class="row">
      <div class="col-sm-6">
        <h1>{{eventTypeCtrl.eventType.doc._rev ? eventTypeCtrl.eventType.doc.name : ('New event type' | translate)}}</h1>
      </div>
      <div class="col-sm-6">
        <p class="button-list">
          <button type="button" class="btn btn-success btn-raised" data-ng-if="eventTypeCtrl.hasEditPerm" data-ng-click="eventTypeCtrl.save(form.$valid)">{{ 'Save' | translate }}</button>
          <button type="button" class="btn btn-info btn-raised" data-ng-click="eventTypeCtrl.preview(form.$valid)">{{ 'Preview' | translate }}</button>
          <button type="button" class="btn btn-info btn-raised" router-link="['/event-types']">{{ 'Cancel' | translate }}</button>
        </p>
      </div>
      <audit-log-component ng-if="eventTypeCtrl.eventType.doc._rev" entries="eventTypeCtrl.auditlog" on-expand="eventTypeCtrl.loadAuditlog()"></audit-log-component>
    </header>

    <version-widget data-ng-if="eventTypeCtrl.loaded" version="eventTypeCtrl.version"></version-widget>

    <!--<div class="row">-->
      <!--<p class="text-gray">-->
        <!--Fields marked with <i class="icon-star required" aria-label="star"></i> are required.-->
        <!--<span data-ng-if="eventTypeCtrl.formIsSaved">Form saved successfully. <a router-link="['/event-types/preview', eventTypeCtrl.eventType.doc._id]">View preview</a></span>-->
      <!--</p>-->
    <!--</div>-->
    <div class="row" data-ng-if="eventTypeCtrl.errors.length">
      <div class="col-sm-12 box box-warning">
        <ul class="list-unstyled">
          <li data-ng-repeat="error in eventTypeCtrl.errors track by $index">
            {{ error }}
          </li>
        </ul>
      </div>
    </div>

    <div class="row">
      <formly-form model="eventTypeCtrl.eventType.doc" fields="eventTypeCtrl.basicForm.fields" aria-label="Event type"></formly-form>
    </div>

  </div>

  <div class="wrapper">
    <div class="row">
      <h2 class="heading-4">{{ 'Event properties' | translate }}</h2>
        <div class="row">
          <div class="col-sm-6">
            <formly-form model="eventTypeCtrl.eventType.doc" fields="eventTypeCtrl.eventPropertiesLeftForm.fields" aria-label="Event type properties"></formly-form>
          </div>
          <div class="col-sm-6">
            <p>{{ 'Automatically populate information about the event owner' | translate }} <i ng-if="eventTypeCtrl.eventType.doc.state !== 'draft'" class="icon-lock disabled"></i></p>
            <p class="text-gray">{{ 'Any user fields specified here will be shown on the event once the event is complete. All data relates to the owner of the event. All data will be visible to anyone with permissions to view the event, irrespective of the visibility settings of the individual user fields.' | translate }}</p>

            <ui-select multiple ng-model="eventTypeCtrl.eventType.doc.prefilledFields" close-on-select="false" title="{{ 'Choose prefilled fields' | translate }}" ng-disabled="eventTypeCtrl.eventType.doc.state !== 'draft'">
              <ui-select-match placeholder="{{ 'Select prefilled fields...' | translate }}">{{$item.doc.name}}</ui-select-match>
              <ui-select-choices repeat="field.doc._id as field in eventTypeCtrl.prefilledFields | filter:$select.search ">
                {{field.doc.name}}
              </ui-select-choices>
            </ui-select>
            <p>{{ 'Add tags to this event' | translate }}</p>
            <p class="text-gray">{{ 'Tags provide a useful way to group related events together and to quickly tell users where an event fits within a blueprint. Tags also make it easier for trainees to quickly find events.' | translate }}</p>

            <div data-sequoia-tree="eventTypeCtrl.tagsTree.tree" data-ng-model="eventTypeCtrl.eventType.doc.tags" data-node-template="eventTypeCtrl.tagsTree.template" data-options="eventTypeCtrl.tagsTree.options"></div>

            <formly-form data-ng-if="false" model="eventTypeCtrl.eventType.doc" fields="eventTypeCtrl.eventPropertiesRightForm.fields" aria-label="Event type properties extra"></formly-form>

            <div ng-if="eventTypeCtrl.blueprintMaps.length > 0">
              <p>{{ 'Apply automatic tagging' | translate }}</p>
              <ui-select multiple ng-model="eventTypeCtrl.eventType.doc.blueprintMaps" close-on-select="false" title="{{ 'Choose automatic tagging maps' | translate }}" ng-disabled="eventTypeCtrl.eventType.doc.state !== 'draft'">
                <ui-select-match placeholder="{{ 'Choose automatic tagging maps...' | translate }}">{{$item.doc.name}}</ui-select-match>
                <ui-select-choices repeat="field.doc._id as field in eventTypeCtrl.blueprintMaps | filter:$select.search ">
                  {{field.doc.name}}
                </ui-select-choices>
              </ui-select>
            </div>
          </div>
        </div>
    </div>
  </div>

  <div class="wrapper" >
    <div class="row" data-ng-if="eventTypeCtrl.eventType.doc.sections">
      <h4>{{ 'Sections' | translate }}</h4>
    </div>
    <div hidden id="event-type-section-move-instructions">{{ 'Use the arrow up and down keys to move this section' | translate }}</div>
    <div class="row" data-ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost', onSort: eventTypeCtrl.handleSort }">
      <div class="col-xs-12 field-border" data-ng-repeat="section in eventTypeCtrl.eventType.doc.sections track by section._id">
        <div class="row">
          <div class="col-xs-9">
            <p>{{ 'This section is filled in by' | translate }}
            <span epf-roles-title roles="section.filledBy"></span>
            </p>
            <p class="text-gray">
              {{ 'The section contains' | translate }} {{section.fields.length}} {{ 'fields' | translate }}
              <span class="text-info" data-ng-if="section.skipCondition"> | {{ 'This section can be skipped' | translate }}</span>
              <span class="text-info" data-ng-if="section.dependentSectionsPerms && section.dependentSectionsPerms.length > 0"> | {{ 'Section specific editing permissions applied' | translate }}</span>
            </p>
          </div>
          <div class="col-xs-3">
          <div class="button-list">
            <ul class="list-inline list-unstyled list-icon-actions" data-ng-if="eventTypeCtrl.isDraft">
              <li><a href="" data-ng-click="eventTypeCtrl.addOrEditSection('edit', form.$valid, section._id)" class="btn btn-sm btn-border btn-primary">{{ 'Edit' | translate }}</a></li>
              <li>
                <button type="button" class="btn-link text-info drag-handle" aria-label="Move section" aria-describedby="event-type-section-move-instructions">
                  <i class="icon-move"></i>
                </button>
              </li>
              <li><a href="" data-ng-click="eventTypeCtrl.removeEventTypeFormSection(section._id)" aria-label="Remove"><i class="icon-trash"></i></a></li>
            </ul>
            <ul class="list-inline list-unstyled list-icon-actions" data-ng-if="!eventTypeCtrl.isDraft">
              <li><a router-link="['/event-types', eventTypeCtrl.eventType.doc._id, 'section', section._id]" class="btn btn-sm btn-border btn-primary">{{ 'View' | translate }}</a></li>
            </ul>
          </div>
        </div>
        </div>
      </div>
    </div>

    <div class="row text-center" data-ng-if="eventTypeCtrl.isDraft">
      <button type="button" data-ng-click="eventTypeCtrl.addOrEditSection('new', form.$valid)" class="btn btn-xs btn-primary" ng-disabled="form.$invalid">{{ 'Add new section' | translate }}</button>
    </div>
  </div>
</div>
</form>
`,
  'app/components/event-types/form.preview.html': `<form novalidate name="form">

  <div class="wrapper">

    <header class="row">
      <div class="col-sm-8">
        <h1>{{eventTypePreviewCtrl.eventType.doc.name}}{{ "'s Preview" | translate }}</h1>
      </div>
      <div class="col-sm-4">
        <p class="button-list">
          <button type="button" class="btn btn-info btn-raised" router-link="['/event-types']">{{ 'Go to list' | translate }}</button>
          <button type="button" class="btn btn-info btn-raised" router-link="['/event-types', eventTypePreviewCtrl.eventTypeId, 'edit']">{{ 'Go to editor' | translate }}</button>
        </p>
      </div>
    </header>
    <version-widget version="eventTypePreviewCtrl.eventType"></version-widget>
  </div>

  <div class="wrapper">
    <div class="row" data-ng-if="eventTypePreviewCtrl.loaded">

      <div class="col-sm-12">
        <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
      </div>

    </div>
  </div>

  <div kz-loading loaded="eventTypePreviewCtrl.loaded">
    <div class="wrapper" data-ng-repeat="section in eventTypePreviewCtrl.eventType.doc.sections track by $index">
      <div class="row">
        <h4>{{ 'Section' | translate }} {{ $index + 1 }}</h4>
      </div>
      <div class="row">
        <section-response-form
          model="{}"
          def="section"
          event-type="eventTypePreviewCtrl.eventType.doc._id",
          form="form",
          options="eventTypePreviewCtrl.displayOptions"></section-response-form>
      </div>
    </div>
  </div>

</form>
`,
  'app/components/event-types/list.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="eventTypesCtrl.actions"><h1>{{ 'Event Types' | translate }}</h1></kz-header>
      <kz-simple-search list="eventTypesCtrl.list"></kz-simple-search>
      <kz-search-string list="eventTypesCtrl.list"></kz-search-string>
  </header>
  <kz-refine-filter
    list="eventTypesCtrl.list"
    refine-by="state"
  ></kz-refine-filter>
</section>


<kz-list-view list="eventTypesCtrl.list" options="eventTypesCtrl.options">
<event-type-slot item="item" options="options"></event-type-slot>
</kz-list-view>
`,
  'app/components/event-types/partials/blueprint-maps.html': ``,
  'app/components/event-types/partials/discrete.custom-blueprint.html': `<legend>{{ 'Blueprint custom categories' | translate }}</legend>

<div data-sequoia-tree="fieldCtrl.field.categories" data-node-template="fieldCtrl.tree.template" data-options="fieldCtrl.tree.options" ng-disabled="!fieldCtrl.canEdit"></div>
`,
  'app/components/event-types/partials/discrete.custom-field.html': `<legend>{{fieldCtrl.field.name || ('Custom field' | translate)}} {{ 'categories' | translate }}</legend>

<!-- Nested node template -->
<script type="text/ng-template" id="custom-fields-hierarchy.html">
  <div data-ui-tree-handle class="row tree-node tree-node-content">
    <div class="col-xs-9">
      <div class="form-group" data-ng-class="{ 'has-error has-feedback': form[category._id].$invalid && formIsSubmitted}">
        <label for="{{category._id}}">{{ 'Category name' | translate }} <i class="icon-star required" aria-label="star"></i></label>
        <input data-ng-model="category.name" type="text" id="{{category._id}}" name="{{category._id}}" class="form-control" data-ng-required="true">
        <div data-ng-show="form[category._id].$invalid  && formIsSubmitted">
          <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
          <p class="help-block text-gray">{{ 'The category name is required.' | translate }}</p>
        </div>
      </div>
    </div>
    <div class="col-xs-3 text-right">
      <ul class="list-inline list-unstyled list-icon-actions">
        <li><button type="button" class="btn btn-link text-gray" data-nodrag ng-click="fieldCtrl.eventTypeSectionFieldCategoryToggle(this)"><i data-ng-class="{'icon-right-open-big': collapsed, 'icon-down-open-big': !collapsed}"></i></button></li>
        <li><button type="button" class="btn btn-link text-info" data-nodrag data-ng-click="fieldCtrl.eventTypeSectionFieldCategoryNewSubNode(this)" aria-label="Add"><i class="icon-plus"></i></button></li>
        <li><button type="button" class="btn btn-link text-danger" data-nodrag data-ng-click="fieldCtrl.eventTypeSectionFieldCategoryRemoveNode(this)" aria-label="Remove"><i class="icon-trash"></i></button></li>
      </ul>
    </div>
  </div>
  <ol data-ui-tree-nodes data-ng-model="category.categories" data-ng-class="{hidden: collapsed}">
    <li data-ng-repeat="category in category.categories track by category._id" data-ui-tree-node data-ng-include="'custom-fields-hierarchy.html'">
    </li>
  </ol>
</script>

<div data-ui-tree id="tree-root">
  <ol data-ui-tree-nodes data-ng-model="fieldCtrl.field.categories">
    <li data-ng-repeat="category in fieldCtrl.field.categories track by category._id" data-ui-tree-node data-ng-include="'custom-fields-hierarchy.html'"></li>
  </ol>
</div>

<p><button type="button" data-ng-click="fieldCtrl.addEventTypeSectionCustomFieldCategory(fieldCtrl.field._id)" class="btn btn-sm btn-border btn-info">{{ 'Add new category' | translate }}</button></p>
`,
  'app/components/event-types/partials/event-type-tag.html': `<div>
  <div  data-ng-repeat="tagform in ctrl.forms">
    <div class="col-xs-10 col-sm-11">
      <formly-form unsaved-warning-form model="tagform.tag" fields="tagform.form.fields" aria-label="Event tag"></formly-form>
    </div>

    <div class="col-xs-2 col-sm-1">
      <ul class="list-inline list-unstyled list-icon-actions">
        <li><button type="button" class="btn btn-link text-danger" data-ng-click="ctrl.removeEventTypeTag(tagform.tag._id)" aria-label="Remove"><i class="icon-trash"></i></button></li>
      </ul>
    </div>
  </div>

  <p><button type="button" data-ng-click="ctrl.addEventTypeTag()" class="btn btn-sm btn-primary">{{ 'Add event tag' | translate }}</button></p>

</div>
`,
  'app/components/event-types/partials/field.blueprint.html': `<div class="row">
  <div class="alert alert-info" data-ng-if="fieldCtrl.usedObjs.length && fieldCtrl.objs.length > 0">
    {{ 'Some of the blueprints have been removed from the list below because they have already been used in this section' | translate }}
  </div>

  <div class="alert alert-info" data-ng-if="fieldCtrl.usedObjs.length && fieldCtrl.objs.length === 0">
    {{ 'There are no further blueprints available to choose from in the list below' | translate }}
  </div>

  <div class="form-group col-sm-12" data-ng-class="{ 'has-error has-feedback': form[fieldCtrl.field._id].$invalid && formIsSubmitted}">
    <label for="{{fieldCtrl.field._id}}">{{ 'Blueprint' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
    <select name="{{fieldCtrl.field._id}}" id="{{fieldCtrl.field._id}}" class="form-control" data-ng-change="fieldCtrl.blueprintChanged()" data-ng-model="fieldCtrl.field.blueprint" data-ng-options="blueprint.doc._id as blueprint.doc.name for blueprint in fieldCtrl.objs | orderBy:'doc.name'" data-ng-required="true" ng-disabled="!fieldCtrl.canEdit"></select>
    <div data-ng-show="form[fieldCtrl.field._id].$invalid  && formIsSubmitted">
      <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
      <p class="help-block text-gray">{{ 'The blueprint is required.' | translate }}</p>
    </div>
  </div>

  <div class="form-group col-sm-12" data-ng-class="{ 'has-error has-feedback': form[fieldCtrl.field._id + '-fieldName'].$invalid && formIsSubmitted}">
    <label for="{{fieldCtrl.field._id + '-fieldName'}}">{{ 'Visible label on the form' | translate }} <i ng-class="{'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
    <input type="text" data-ng-model="fieldCtrl.field.name" name="{{fieldCtrl.field._id + '-fieldName'}}" id="{{fieldCtrl.field._id + '-fieldName'}}" class="form-control" placeholder="{{ fieldCtrl.blueprintPlaceholder }}" ng-disabled="!fieldCtrl.canEdit">
    <p class="text-gray">{{ 'If left empty the blueprint name will be displayed' | translate }}</p>
    <div data-ng-show="form[fieldCtrl.field._id + '-fieldName'].$invalid  && formIsSubmitted">
      <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
      <p class="help-block text-gray">{{ 'The field name is required.' | translate }}</p>
    </div>
  </div>
</div>
`,
  'app/components/event-types/partials/field.customField.html': `<div class="row">
  <div class="form-group col-sm-4" data-ng-class="{ 'has-error has-feedback': form[fieldCtrl.field._id + '-fieldType'].$invalid && formIsSubmitted}">
    <label for="{{fieldCtrl.field._id + '-fieldType'}}">{{ 'Custom field type' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
    <select id="{{fieldCtrl.field._id + '-fieldType'}}" name="{{fieldCtrl.field._id + '-fieldType'}}" class="form-control" data-ng-model="fieldCtrl.field.blueprintType" data-ng-options="type.name as type.label for type in fieldCtrl.blueprintTypes" data-ng-required="true" data-ng-change="fieldCtrl.changeBlueprintFieldType()" ng-disabled="!fieldCtrl.canEdit">></select>
    <div data-ng-show="form[fieldCtrl.field._id + '-fieldType'].$invalid  && formIsSubmitted">
      <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
      <p class="help-block text-gray">{{ 'The custom field type is required.' | translate }}</p>
    </div>
  </div>

  <div class="form-group col-sm-8" data-ng-class="{ 'has-error has-feedback': form[fieldCtrl.field._id + '-fieldName'].$invalid && formIsSubmitted}">
    <label for="{{fieldCtrl.field._id + '-fieldName'}}">{{ 'Name' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
    <input type="text" data-ng-model="fieldCtrl.field.name" id="{{fieldCtrl.field._id + '-fieldName'}}" name="{{fieldCtrl.field._id + '-fieldName'}}" class="form-control" data-ng-required="true" ng-disabled="!fieldCtrl.canEdit">
    <div data-ng-show="form[fieldCtrl.field._id + '-fieldName'].$invalid  && formIsSubmitted">
      <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
      <p class="help-block text-gray">{{ 'The custom field name is required.' | translate }}</p>
    </div>
  </div>
</div>
`,
  'app/components/event-types/partials/field.goal.html': `<div class="row">
  <div class="col-xs-12">
    <h3>{{ 'Custom goals' | translate }}</h3>

    <p class="text-gray">
      {{ 'Allow users to define goals when creating the event.' | translate }}
    </p>
    <formly-form model="fieldCtrl.field.customsSettings" fields="fieldCtrl.customGoalsForm.fields" form="form" aria-label="Custom goals"></formly-form>
    <formly-form data-ng-if="fieldCtrl.field.customsSettings.canAddCustoms" class="inline" model="fieldCtrl.field.customsSettings" fields="fieldCtrl.customGoalsPermissionsForm.fields" form="form" aria-label="Custom goals settings"></formly-form>
    <formly-form data-ng-if="fieldCtrl.field.customsSettings.canAddCustomsInProgress || fieldCtrl.field.customsSettings.canEditCustomsInProgress || fieldCtrl.field.customsSettings.canDeleteCustomsInProgress"
      model="fieldCtrl.field.customsSettings" fields="fieldCtrl.customGoalsPermissionsOwnersForm.fields" form="form" aria-label="Custom goals settings permission owners"></formly-form>
  </div>

  <div class="col-xs-12">
    <h3>{{ 'Defined periods' | translate }}</h3>

    <p class="text-gray">
      {{ 'Measure progress against targets separately across each period that is defined here. The order of the periods set below will be the order displayed on the goals list, with the first being the default selection.' | translate }}
    </p>

    <goalset-periods model="fieldCtrl.field" readonly="!fieldCtrl.canEdit">
    </goalset-periods>
  </div>

  <div class="col-xs-12">
    <h3>{{ 'Predefined goals' | translate }}</h3>
    <p class="text-gray">
      {{ 'Any goals created here will automatically be assigned to the event owner during completion of this event section' | translate }}
    </p>

    <goals-define model="fieldCtrl.field.definition" readonly="!fieldCtrl.canEdit" event-type-id="fieldCtrl.eventTypeId" goal-set-periods="fieldCtrl.field.periods"></goals-define>
    <formly-form model="fieldCtrl.field" fields="fieldCtrl.arePredefinedRedefinableForm.fields" form="form" class="inline" data-ng-if="fieldCtrl.field.definition.length" aria-label="Goal definiton"></formly-form>
  </div>


  <div class="col-xs-12">
    <h3>{{ 'Settings' | translate }}</h3>
    <formly-form model="fieldCtrl.field" fields="fieldCtrl.closeSettingsForm.fields" form="form" aria-label="Mark as settings"></formly-form>
  </div>
</div>
`,
  'app/components/event-types/partials/field.properties.html': `<div class="row">
  <div class="col-xs-12">
    <div class="row">
      <div class="form-group col-xs-12">
        <label for="{{fieldCtrl.field._id + '-fieldHelpText'}}">{{ 'Help text' | translate }} <i data-ng-if="!fieldCtrl.canEdit" class="icon-lock disabled"></i></label>
        <textarea id="{{fieldCtrl.field._id + '-fieldHelpText'}}" msd-elastic data-ng-model="fieldCtrl.field.helpText" name="{{fieldCtrl.field._id + '-fieldHelpText'}}" class="form-control" ng-disabled="!fieldCtrl.canEdit"></textarea>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xs-6"
           data-ng-show="fieldCtrl.field.blueprintType !== 'boolean' && fieldCtrl.currentBlueprintType !== 'boolean' && fieldCtrl.field.type !== 'report' && fieldCtrl.field.type !== 'sqlreport'">
        <div class="checkbox">
          <label>
            <input name="event-type-default" data-ng-model="fieldCtrl.field.isRequired" type="checkbox" data-ng-checked="fieldCtrl.field.isRequired" ng-disabled="!fieldCtrl.canEdit"> {{ 'Make this a required field?' | translate }} <i data-ng-if="!fieldCtrl.canEdit" class="icon-lock disabled"></i>
          </label>
        </div>
      </div>
      <div class="form-group col-xs-6" data-ng-show="fieldCtrl.field.type === 'customField' && (fieldCtrl.showForm || fieldCtrl.usingPredefinedField)">
        <div class="checkbox">
          <label>
            <input name="saveAsPredefinedField" data-ng-model="fieldCtrl.saveAsPredefinedField" type="checkbox" ng-disabled="!fieldCtrl.canEdit"> {{ 'Save this field as a predefined field?' | translate }} <i data-ng-if="!fieldCtrl.canEdit" class="icon-lock disabled"></i>
          </label>
        </div>
      </div>
      <div class="form-group col-xs-6">
        <div class="checkbox">
          <label>
            <input name="showOnTimeline" data-ng-model="fieldCtrl.field.showOnTimeline" type="checkbox" ng-disabled="!fieldCtrl.canEdit"> {{ 'Show this field on timelines' | translate }} <i data-ng-if="!fieldCtrl.canEdit" class="icon-lock disabled"></i>
          </label>
        </div>
      </div>
      <div class="form-group col-xs-6" data-ng-if="fieldCtrl.field.type === 'relation'">
        <div class="checkbox">
          <label>
            <input name="multiple" data-ng-model="fieldCtrl.field.multiple" type="checkbox" ng-disabled="!fieldCtrl.canEdit"> {{ 'User can select multiple options' | translate }} <i data-ng-if="!fieldCtrl.canEdit" class="icon-lock disabled"></i>
          </label>
        </div>
      </div>
    </div>

    <div class="col-xs-12" data-ng-include="'app/components/event-types/partials/field.restrictedBy.html'"></div>
  </div>

</div>

<div class="row" data-ng-switch on="fieldCtrl.field.type">
  <div class="col-xs-12" data-ng-switch-when="customField">
    <div class="row" data-ng-if="['discrete', 'discrete_multiple', 'tree'].indexOf(fieldCtrl.field.blueprintType) > -1">
      <div class="col-xs-12" data-ng-include="'app/components/event-types/partials/tree.custom-field.html'"></div>
    </div>
    <div class="row" data-ng-if="['likert'].indexOf(fieldCtrl.field.blueprintType) > -1">
      <div class="col-xs-12" data-ng-include="'app/components/event-types/partials/likert.custom-field.html'"></div>
    </div>
    <div class="row" data-ng-if="['file'].indexOf(fieldCtrl.field.blueprintType) > -1">
      <div class="col-xs-12" data-ng-include="'app/components/event-types/partials/file.custom-field.html'"></div>
    </div>
  </div>
  <div class="col-xs-12" data-ng-switch-when="blueprint">
    <div class="row" ng-if="fieldCtrl.currentType() === 'file'">
      <div class="col-xs-12" data-ng-include="'app/components/event-types/partials/file.custom-field.html'"></div>
    </div>
  </div>

</div>


<div class="row" kz-feature-enabled feature="turnitin">
  <div class="form-group col-xs-6" data-ng-if="fieldCtrl.showTurnitinSection()">
    <div class="checkbox">
      <label>
        <input name="enableAntiPlagiarism" data-ng-model="fieldCtrl.field.enableAntiPlagiarism" type="checkbox" ng-disabled="!fieldCtrl.canEdit">
          {{ 'Enable anti-plagiarism checking' | translate }}
          <i data-ng-if="!fieldCtrl.canEdit" class="icon-lock disabled"></i>
      </label>
    </div>

    <div data-ng-if="fieldCtrl.field.enableAntiPlagiarism">
      <label for="enableAntiPlagiarismAttempts">{{ 'Maximum number of attempts' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
      <input id="enableAntiPlagiarismAttempts" type="number" data-ng-model="fieldCtrl.field.enableAntiPlagiarismAttempts" name="enableAntiPlagiarismAttempts" class="form-control" data-ng-required="true" ng-disabled="!fieldCtrl.canEdit">
      <p class="text-gray">{{ 'Set to 0 for unlimited number of attempts.' | translate }}</p>
    </div>

    <div class="checkbox" data-ng-if="fieldCtrl.field.enableAntiPlagiarism">
      <label>
        <input name="enableAntiPlagiarismRequired" data-ng-model="fieldCtrl.field.enableAntiPlagiarismRequired" type="checkbox" ng-disabled="!fieldCtrl.canEdit"> {{ 'Anti-plagiarism score is required' | translate }} <i data-ng-if="!fieldCtrl.canEdit" class="icon-lock disabled"></i>
      </label>
    </div>
    <div class="form-group col-xs-6" data-ng-if="fieldCtrl.field.enableAntiPlagiarism">
      <label for="enableAntiPlagiarismTitle"> {{ 'Anti-plagiarism button title' | translate }}</label>
      <input id="enableAntiPlagiarismTitle" type="text" data-ng-model="fieldCtrl.field.enableAntiPlagiarismTitle" name="enableAntiPlagiarismTitle" class="form-control">
    </div>
  </div>
</div>
`,
  'app/components/event-types/partials/field.relation.html': `<div class="row">
  <div class="alert alert-info" data-ng-if="fieldCtrl.usedObjs.length && fieldCtrl.objs.length > 0">
    {{ 'Some of the relations have been removed from the list below because they have already been used in this section' | translate }}
  </div>

  <div class="alert alert-info" data-ng-if="fieldCtrl.usedObjs.length && fieldCtrl.objs.length === 0">
    {{ 'There are no further relations available to choose from in the list below' | translate }}
  </div>

  <div class="form-group col-xs-12" data-ng-class="{ 'has-error has-feedback': form[fieldCtrl.field._id].$invalid && formIsSubmitted}">
    <label for="{{fieldCtrl.field._id}}">{{ 'Relation' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
    <select id="{{fieldCtrl.field._id}}" name="{{fieldCtrl.field._id}}" class="form-control" data-ng-model="fieldCtrl.field.relation" data-ng-options="relation.doc._id as relation.doc.name for relation in fieldCtrl.objs | orderBy: 'doc.name'" data-ng-required="true" ng-disabled="!fieldCtrl.canEdit"></select>
    <div data-ng-show="form[fieldCtrl.field._id].$invalid  && formIsSubmitted">
      <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
      <p class="help-block text-gray">{{ 'The relation is required.' | translate }}</p>
    </div>
  </div>
</div>
`,
  'app/components/event-types/partials/field.report.html': `<div class="row">
  <div class="col-xs-12">
    <div class="row" data-ng-if="fieldCtrl.field.type !== 'text'">
      <div class="col-xs-12">
        <h4>{{ 'Embedded report' | translate }}</h4>
      </div>
    </div>

    <kz-report-conf-view model="fieldCtrl.field" options="{ disabled: !fieldCtrl.canEdit }"></kz-report-conf-view>
  </div>


  <div class="col-xs-12" data-ng-if="fieldCtrl.showReportFormSection">
    <div class="row" data-ng-if="fieldCtrl.field.type !== 'text'">
      <div class="col-xs-12">
        <h4>{{ 'Report form' | translate }}</h4>
      </div>
    </div>

    <div class="box box-info">
        {{ 'It is possible to allow the user to update the following fields when generating the report. Select the default values here and optionally allow the user permission to change the value.' | translate }}
      </div>

    <div class="row">
      <kz-report-form class="col-xs-8" report-id="{{fieldCtrl.field.report}}" model="fieldCtrl.field.reportData" disabled="!fieldCtrl.canEdit" data-ng-if="fieldCtrl.isReportDataEmpty"></kz-report-form>
      <kz-report-form class="col-xs-8" report-id="{{fieldCtrl.field.report}}" model="fieldCtrl.field.reportData" disabled="!fieldCtrl.canEdit" default-model="fieldCtrl.field.reportData" data-ng-if="!fieldCtrl.isReportDataEmpty"></kz-report-form>
      <div class="col-xs-4">
        <formly-form model="fieldCtrl.field" fields="fieldCtrl.reportDataOverridableForm.fields" form="form" aria-label="Report data overridable by user"></formly-form>
      </div>
    </div>
  </div>
</div>

`,
  'app/components/event-types/partials/field.restrictedBy.html': `<div>
  <div class="form-group" data-ng-if="fieldCtrl.sectionFields.length && !fieldCtrl.saveAsPredefinedField">
    <label for="only-show">{{ 'Only show this field when the user fills in' | translate }} <i ng-class="{'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
    <select id="only-show" class="form-control" data-ng-model="fieldCtrl.field.restricted.by" data-ng-options="field._id as field.name for field in fieldCtrl.sectionFields" data-ng-change="fieldCtrl.changeFieldRestriction()" ng-disabled="!fieldCtrl.canEdit">
        <option value=""> --- </option>
    </select>
  </div>
  <div class="form-group" data-ng-if="fieldCtrl.fieldRestrictions.length">
    <label>{{ 'And the following value(s)' | translate }}  <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>

    <div data-ng-if="fieldCtrl.showTree" class="row" data-ng-model="fieldCtrl.field.restricted.to" data-sequoia-tree="fieldCtrl.fieldRestrictions" data-node-template="fieldCtrl.treeRestrictions.template" data-options="fieldCtrl.treeRestrictions.options" required></div>

    <ui-select multiple data-ng-if="!fieldCtrl.showTree" data-ng-required="true" data-ng-disabled="!fieldCtrl.canEdit" ng-model="fieldCtrl.field.restricted.to" close-on-select="false" title="{{ 'Select values' | translate }}">
      <ui-select-match placeholder="{{ 'Select values...' | translate }}">{{$item.name}}</ui-select-match>
      <ui-select-choices repeat="option._id as option in fieldCtrl.fieldRestrictions | filter:$select.search" >
        {{option.name}}
      </ui-select-choices>
    </ui-select>
  </div>
</div>
`,
  'app/components/event-types/partials/field.role.html': `<div class="row">
  <div class="alert alert-info" data-ng-if="fieldCtrl.usedObjs.length && fieldCtrl.objs.length > 0">
    {{ 'Some of the roles have been removed from the list below because they have already been used in this section' | translate }}
  </div>

  <div class="alert alert-info" data-ng-if="fieldCtrl.usedObjs.length && fieldCtrl.objs.length === 0">
    {{ 'There are no further roles available to choose from in the list below' | translate }}
  </div>

  <div class="form-group col-xs-12" data-ng-class="{ 'has-error has-feedback': form[fieldCtrl.field._id].$invalid && formIsSubmitted}">
    <label for="{{fieldCtrl.field._id}}">{{ 'Role' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
    <select id="{{fieldCtrl.field._id}}" name="{{fieldCtrl.field._id}}" class="form-control" data-ng-model="fieldCtrl.field.role" data-ng-options="role.doc._id as role.doc.title for role in fieldCtrl.objs" data-ng-required="true" ng-disabled="!fieldCtrl.canEdit"></select>
    <div data-ng-show="form[fieldCtrl.field._id].$invalid  && formIsSubmitted">
      <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
      <p class="help-block text-gray">{{ 'The role is required.' | translate }}</p>
    </div>
  </div>
</div>
`,
  'app/components/event-types/partials/field.signature.html': `<div class="row">
  <div class="form-group col-sm-8" data-ng-class="{ 'has-error has-feedback': form[fieldCtrl.field._id + '-fieldName'].$invalid && formIsSubmitted}">
    <label for="{{fieldCtrl.field._id + '-fieldName'}}">{{ 'Name' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
    <input type="text" data-ng-model="fieldCtrl.field.name" id="{{fieldCtrl.field._id + '-fieldName'}}" name="{{fieldCtrl.field._id + '-fieldName'}}" class="form-control" data-ng-required="true" ng-disabled="!fieldCtrl.canEdit">
    <div data-ng-show="form[fieldCtrl.field._id + '-fieldName'].$invalid  && formIsSubmitted">
      <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
      <p class="help-block text-gray">{{ 'The signature name is required.' | translate }}</p>
    </div>
  </div>
</div>
`,
  'app/components/event-types/partials/field.sqlreport.html': `<div class="row">
  <div class="col-xs-12">
    <div class="row" data-ng-if="fieldCtrl.field.type !== 'text'">
      <div class="col-xs-12">
        <h4>{{ 'Embedded report' | translate }}</h4>
      </div>
    </div>

    <sql-report-select [config]="{report: fieldCtrl.field.sqlreport}" (config-change)="fieldCtrl.sqlReportChanged($event)"></sql-report-select>

  </div>

</div>

`,
  'app/components/event-types/partials/field.text.html': `<div class="row">
  <div class="form-group col-xs-12" data-ng-class="{ 'has-error has-feedback': form[fieldCtrl.field._id + '-fieldType'].$invalid && formIsSubmitted}">
    <label for="{{fieldCtrl.field._id + '-fieldType'}}">{{ 'Text type' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
    <select id="{{fieldCtrl.field._id + '-fieldType'}}" name="{{fieldCtrl.field._id + '-fieldType'}}" class="form-control" data-ng-model="fieldCtrl.field.textType" data-ng-options="type.name as type.label for type in fieldCtrl.textTypes" data-ng-required="true" ng-disabled="!fieldCtrl.canEdit"></select>
    <div data-ng-show="form[fieldCtrl.field._id + '-fieldType'].$invalid  && formIsSubmitted">
      <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
      <p class="help-block text-gray">{{ 'The text type is required.' | translate }}</p>
    </div>
  </div>
</div>

<div class="row">
  <div class="form-group col-xs-12" data-ng-if="fieldCtrl.field.textType" data-ng-class="{ 'has-error has-feedback': form[fieldCtrl.field._id + '-fieldName'].$invalid && formIsSubmitted}">
    <label for="{{fieldCtrl.field._id + '-fieldName'}}">{{ 'Content' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>

    <div data-ng-switch on="fieldCtrl.field.textType">
      <input data-ng-switch-when="heading" type="text" data-ng-model="fieldCtrl.field.content" id="{{fieldCtrl.field._id + '-fieldName'}}" name="{{fieldCtrl.field._id + '-fieldName'}}" class="form-control" data-ng-required="true" ng-disabled="!fieldCtrl.canEdit">
      <div data-ng-switch-when="text">
        <ng-quill-editor ng-model="fieldCtrl.field.content" toolbar="true" toolbar-entries="size bold list bullet italic underline strike align color background link image" link-tooltip="true" class="form-control wysiwyg-editor" image-tooltip="true" editor-required="true" required="required" error-class="input-error" ></ng-quill-editor>
      </div>
      <div data-ng-switch-default></div>
    </div>

    <div data-ng-show="form[fieldCtrl.field._id + '-fieldName'].$invalid  && formIsSubmitted">
      <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
      <p class="help-block text-gray">{{ 'The content field is required.' | translate }}</p>
    </div>
  </div>
</div>
`,
  'app/components/event-types/partials/field.tree.html': `<div class="row">
  <div class="form-group col-xs-12" data-ng-class="{ 'has-error has-feedback': form[fieldCtrl.field._id].$invalid && formIsSubmitted}">
    <label for="{{fieldCtrl.field._id}}">{{ 'Blueprint' | translate }} <i class="icon-star required" aria-label="star"></i></label>
    <select id="{{fieldCtrl.field._id}}" name="{{fieldCtrl.field._id}}" class="form-control" data-ng-model="fieldCtrl.field.blueprint" data-ng-options="blueprint.key as blueprint.value for blueprint in fieldCtrl.blueprints" data-ng-required="true" data-ng-change="fieldCtrl.changeBlueprintName()"></select>
    <div data-ng-show="form[fieldCtrl.field._id].$invalid  && formIsSubmitted">
      <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
      <p class="help-block text-gray">{{ 'The blueprint is required.' | translate }}</p>
    </div>
  </div>
</div>
`,
  'app/components/event-types/partials/file.custom-field.html': `<div class="row" data-ng-show="fieldCtrl.currentType() === 'file'">
  <div class="col-xs-12">
    <div class="form-group">
      <label for="fileTypes">{{ 'Allowed file types' | translate }}<i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
      <ui-select id="fileTypes" multiple data-ng-required="true" data-ng-disabled="!fieldCtrl.canEdit" ng-model="fieldCtrl.field.fileTypes" close-on-select="false" title="{{ 'Pick allowed types' | translate }}">
        <ui-select-match placeholder="{{ 'Select allowed types...' | translate }}">{{$item.title}}</ui-select-match>
        <ui-select-choices repeat="item.id as item in fieldCtrl.availableTypes | filter:$select.search" >
          {{item.title}}
        </ui-select-choices>
      </ui-select>
    </div>

    <div class="form-group">
      <label for="sizeLimit">{{ 'Maximum size in MB per file (up to 1000MB)' | translate }} <i
          ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
      <input id="sizeLimit" type="number" data-ng-model="fieldCtrl.field.sizeLimit"
        name="sizeLimit" class="form-control" data-ng-required="true"
        min="0" max="1000"
        ng-disabled="!fieldCtrl.canEdit"
      >
      <p class="text-gray">{{ 'The maximum file size risr/advance allows is 1000MB (1GB).' | translate }}
      </p>
    </div>

    <div class="form-group checkbox">
      <label>
        <input name="multiple" data-ng-model="fieldCtrl.field.multiple" type="checkbox" ng-disabled="!fieldCtrl.canEdit">
        {{ 'Allow multiple files to be uploaded' | translate }}
          <i data-ng-if="!fieldCtrl.canEdit" class="icon-lock disabled"></i>
      </label>
    </div>
    <div class="form-group" data-ng-if="fieldCtrl.field.multiple">
      <label for="fileLimit">{{ 'Maximum number of files' | translate }} <i ng-class="{'icon-star required': fieldCtrl.canEdit, 'icon-lock disabled': !fieldCtrl.canEdit}"></i></label>
      <input id="fileLimit" type="number" data-ng-model="fieldCtrl.field.fileLimit"
        name="fileLimit" class="form-control" data-ng-required="true"
        min="0" max="1000"
        ng-disabled="!fieldCtrl.canEdit"
      >
      <p class="text-gray">{{ 'Set to 0 for unlimited number of files.' | translate }}
      </p>
    </div>
  </div>
</div>
`,
  'app/components/event-types/partials/likert.custom-field.html': `<legend>{{fieldCtrl.field.name || ('Custom field' | translate)}} {{ 'categories' | translate }}</legend>

<p class="text-info"><i class="icon-info"></i>{{ 'If you do not wish to assign a value to a response then please leave it empty' | translate }}</p>
<!-- Nested node template -->
<script type="text/ng-template" id="custom-fields-hierarchy.html">
  <div data-ui-tree-handle class="row tree-node tree-node-content">
    <div class="col-xs-6">
      <div class="form-group likert" data-ng-class="{ 'has-error has-feedback': form[category._id].$invalid && formIsSubmitted}">
        <label for="{{category._id}}">{{ 'Category name' | translate }} <i class="icon-star required" aria-label="star"></i></label>
        <input data-ng-model="category.name" type="text" id="{{category._id}}" name="{{category._id}}" class="form-control" data-ng-required="true">
      </div>
      <div class="form-group likert" data-ng-class="{ 'has-error has-feedback': form[category._id].$invalid && formIsSubmitted}">
        <div data-ng-show="form[category._id].$invalid  && formIsSubmitted">
          <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
          <p class="help-block text-gray">{{ 'The category name is required.' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="col-xs-4">
      <div class="form-group likert" data-ng-class="{ 'has-error has-feedback': form[category._id].$invalid && formIsSubmitted}">
        <label for="{{category._id}}">{{ 'Value' | translate }} </label>
        <input data-ng-model="category.value" step=".001" type="number" id="{{category._id}}" name="{{category._id}}_value" class="form-control">
        <span class="text-danger" ng-if="form[category._id + '_value'].$error.step">{{ 'Only 3 decimal places maximum is allowed.' | translate }}</span>
      </div>
    </div>

    <div class="col-xs-2 text-right">
      <ul class="list-inline list-unstyled list-icon-actions">
        <li><button type="button" class="btn btn-link text-danger" data-nodrag data-ng-click="fieldCtrl.eventTypeSectionFieldCategoryRemoveNode(this)"><i class="icon-trash"></i></button></li>
      </ul>
    </div>
  </div>
</script>

<div data-ui-tree id="tree-root">
  <ol data-ui-tree-nodes data-ng-model="fieldCtrl.field.categories">
    <li data-ng-repeat="category in fieldCtrl.field.categories track by category._id" data-ui-tree-node data-ng-include="'custom-fields-hierarchy.html'"></li>
  </ol>
</div>

<p><button type="button" data-ng-click="fieldCtrl.addEventTypeSectionCustomFieldCategory(fieldCtrl.field._id)" class="btn btn-sm btn-border btn-info">{{ 'Add new category' | translate }}</button></p>
`,
  'app/components/event-types/partials/preview.section.html': `<div class="form-group col-sm-12" data-ng-repeat="field in section.fields track by field._id">

  <div data-ng-if="field.type === 'text'">
    <div data-ng-switch on="field.textType">
      <h4 data-ng-switch-when="heading">{{field.content}}</h4>
      <div class="readonly" data-ng-switch-default data-ng-bind-html="field.content | nl2br | a2nt | videoUrlToIframe"></div>
    </div>
  </div>

  <div data-ng-if="field.type !== 'text'">

    <label for="{{field._id}}" data-ng-if="!field.restricted || (form[field.restricted.by].$valid && eventTypePreviewCtrl.form[field.restricted.by] === field.restricted.to) || (form[field.restricted.by].$valid && field.restricted.to === 'any')">{{field.name}} <i data-ng-show="field.isRequired" class="icon-star required"></i></label>

    <div data-ng-if="!field.restricted || (form[field.restricted.by].$valid && eventTypePreviewCtrl.form[field.restricted.by] === field.restricted.to) || (form[field.restricted.by].$valid && field.restricted.to === 'any')" data-ng-switch on="field.blueprintType">

      <div data-ng-switch-when="text">
        <textarea id="{{field._id}}" data-ng-model="eventTypePreviewCtrl.form[field._id]" name="{{field._id}}" class="form-control" data-ng-required="{{field.isRequired}}"></textarea>
      </div>

      <div data-ng-switch-when="datetime">
        <input id="{{field._id}}" data-ng-model="eventTypePreviewCtrl.form[field._id]" data-pick-a-date="eventTypePreviewCtrl[field.name]" type="text" name="{{field.name}}" class="form-control" data-ng-required="true">
      </div>

      <div data-ng-switch-when="discrete">
        <select id="{{field._id}}" data-ng-model="eventTypePreviewCtrl.form[field._id]" name="{{field._id}}" class="form-control" data-ng-options="option._id as option.name for option in field.categories" data-ng-required="{{field.isRequired}}" data-ng-model="dummy"></select>
      </div>

      <div data-ng-switch-when="discrete_multiple">
        <select id="{{field._id}}" data-ng-model="eventTypePreviewCtrl.form[field._id]" name="{{field._id}}" class="form-control" multiple data-ng-options="option._id as option.name for option in field.categories" data-ng-required="{{field.isRequired}}" data-ng-model="dummy"></select>
      </div>

     <div data-ng-switch-when="boolean">
        <select id="{{field._id}}" data-ng-model="eventTypePreviewCtrl.form[field._id]" name="{{field._id}}" class="form-control" data-ng-required="{{field.isRequired}}">
          <option value="?"></option>
          <option value="1">{{ 'Yes' | translate }}</option>
          <option value="0">{{ 'No' | translate }}</option>
        </select>
      </div>

      <div data-ng-switch-default>
        <input id="{{field._id}}" data-ng-model="eventTypePreviewCtrl.form[field._id]" type="text" name="{{field._id}}" class="form-control" data-ng-required="{{field.isRequired}}">
      </div>

    </div>

    <span class="help-block" data-ng-if="field.helpText">{{field.helpText}}</span>

  </div>

</div>
`,
  'app/components/event-types/partials/tree.custom-field.html': `<legend>{{fieldCtrl.field.name || ('Custom field' | translate)}} {{ 'categories' | translate }}</legend>

<div data-ng-if="fieldCtrl.tree" data-sequoia-tree="fieldCtrl.field.categories" data-node-template="fieldCtrl.tree.template" data-options="fieldCtrl.tree.options"></div>
`,
  'app/components/events/allevents.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="eventsCtrl.actions">
      <h1>{{ 'All events of other users' | translate }}</h1>
        <p>{{ 'What you see here is a global timeline containing all events from all users that you have permissions to view.' | translate }}</p>
      </kz-header>
      <kz-simple-search list="eventsCtrl.list"></kz-simple-search>
      <kz-search-string list="eventsCtrl.list"></kz-search-string>
  </header>
</section>

<kz-refine-filter
  list="eventsCtrl.list"
  refine-by="state"
></kz-refine-filter>

<kz-list-view list="eventsCtrl.list" options="eventsCtrl.options">
  <event-group-slot item="item" options="options"></event-group-slot>
</kz-list-view>
`,
  'app/components/events/applytags.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="eventsCtrl.actions">
        <h1>{{ 'Apply tags' | translate }}</h1>
      </kz-header>
      <kz-simple-search list="eventsCtrl.list"></kz-simple-search>
      <kz-search-string list="eventsCtrl.list"></kz-search-string>
  </header>
  <kz-refine-filter list="eventsCtrl.list" refine-by="state"></kz-refine-filter>
</section>

<kz-list-view list="eventsCtrl.list" options="eventsCtrl.options">
  <event-group-slot item="item" options="options"></event-group-slot>
</kz-list-view>
`,
  'app/components/events/cards/bulktagging.card.html': `<div>
  <div class="row row-bordered" data-ng-show="model.length > 0" ng-repeat="item in model track by $index">
    <div class="col-xs-10">
      <span kz-blueprint-category-title category="item"></span><br />
      <span class="text-gray" kz-blueprint-category-path category="item"></span>
    </div>
    <div class="col-xs-2 text-right">
      <a href="" data-ng-click="remove(item)" class="text-danger"><i title="{{ 'Remove filter' | translate }}" class="icon-trash"></i></a>
    </div>
  </div>
  <div class="row row-bordered">
    <div class="col-xs-8">
      <ng-pluralize count="model.length"
      when="{'0': 'No tag selected',
             '1': '1 tag selected',
             'other': '{} tags selected'}">
      </ng-pluralize>
    </div>
    <div class="col-xs-4 text-right">
      <a href="" data-ng-if="model.length > 0" data-ng-click="removeAll()" class="btn btn-xs btn-danger">{{ 'Deselect all' | translate }}</a>
    </div>
  </div>
</div>
`,
  'app/components/events/cards/eventfillin.card.html': `<div>
  <p ng-if="!event.isMine()">
    {{ 'This event belongs to' | translate }} <span epf-fullnames user="event.doc.user"></span>.
  </p>
  <p ng-if="event.doc.state !== 'complete'">
    {{ 'This event has' | translate }} {{ event.allSections.length }} <ng-pluralize count="event.allSections.length" when="{'1': 'section', 'other': 'sections'}"></ng-pluralize>{{ '. You are now filling in section' | translate }} {{ event.completedSections.length }}.
  </p>

  <p ng-if="event.doc.state === 'complete'">
    {{ 'This event has' | translate }} {{ event.allSections.length }} <ng-pluralize count="event.allSections.length" when="{'1': 'section', 'other': 'sections'}"></ng-pluralize>.
  </p>
</div>
`,
  'app/components/events/cards/files.card.html': `<div>
  <kz-files-table model="model" doc-id="eventId" ng-if="model"></kz-files-table>
</div>
`,
  'app/components/events/cards/linkingtargets.card.html': `<div>
  <button type="button" data-ng-click="linkTarget(target)" class="btn-link row row-bordered" ng-repeat="target in targets track by $index">
    <div class="col-xs-1">
      <input type="checkbox" data-ng-checked="isLinked(target)" />
    </div>
    <div class="col-xs-10" >
      <div ng-class="{'text-gray': !isLinked(target), 'text-success': isLinked(target)}">
        {{target.goal.doc.title}} <span ng-if="target.conditions.length">: <target-title target="::target"></target-title></span>
      </div>
      <div class="text-gray" ng-class="{'text-gray': !isLinked(target), 'text-success': isLinked(target)}">{{ 'Due date:' | translate }} {{target.goal.doc.dueDate | date: dateFormat}}</div>
    </div>
  </button>
  <div data-ng-if="generalTargets.length > 0" class="row row-bordered">
    <div class="col-sm-12">
      <span class="text-gray">{{ 'Other targets' | translate }}</span>
    </div>
  </div>
  <button type="button" data-ng-click="linkTarget(target)" class="btn-link row row-bordered" ng-repeat="target in generalTargets track by $index">
    <div class="col-xs-1">
      <input type="checkbox" data-ng-checked="isLinked(target)" />
    </div>
    <div class="col-xs-10" >
      <div ng-class="{'text-gray': !isLinked(target), 'text-success': isLinked(target)}">
        {{target.goal.doc.title}} <span ng-if="target.conditions.length">: <target-title target="::target"></target-title></span>
      </div>
      <div class="text-gray" ng-class="{'text-gray': !isLinked(target), 'text-success': isLinked(target)}">{{ 'Due date:' | translate }} {{target.goal.doc.dueDate | date: dateFormat}}</div>
    </div>
  </button>
  <div class="row row-bordered" data-ng-if="!isLoading && (targets.length + generalTargets.length > 0) ">
    <div class="col-sm-12 text-right">
      <span class="text-gray" ng-pluralize count="eventSection.doc.meta.linkedTargets.length || 0"
      when="{'0': 'No targets selected',
             '1': '1 target selected',
             'other': '{} targets selected'}">
      </span>
    </div>
  </div>
  <div class="row row-bordered" data-ng-if="!isLoading && (targets.length + generalTargets.length === 0) ">
    <div class="col-sm-12">
      <p>{{ 'No suggested targets available for linking' | translate }}</p>
    </div>
  </div>
  <div data-ng-if="isLoading">
    <p class="text-center"><i class="icon-spin animate-spin"></i></p>
  </div>

  <p data-ng-if="!generalTargetsLoaded"><a href="" data-ng-click="loadTargets({generalTargets: true})">{{ 'Click here to show more available targets' | translate }}</a></p>
</div>
`,
  'app/components/events/directives/event-actions-header.html': `<div>
  <ul class="list-inline list-unstyled">
    <li data-ng-if="sectionStates.length">
        <kz-event-progress states="sectionStates"></kz-event-progress>
    </li>
    <li ng-if="eventSection.eventTypeVersion">
      <span class="label label-default">{{ 'version' | translate }} {{ eventSection.eventTypeVersion }}</span>
    </li>
    <li data-ng-if="options.allowBasicFormExtras">
      <button type="button" class="btn btn-sm btn-link text-link" data-ng-click="eventSection.openTagsPopup(eventExtras)">
        <i class="icon-tags"></i> {{ 'Add tags' | translate }}
        <span data-ng-if="eventExtras.blueprints.length">
          ({{ eventExtras.blueprints.length }})
        </span>
      </button>
    </li>

    <li data-ng-if="options.allowLinking">
      <div kz-loading loaded="goalsCategoriesLoaded">
        <div data-ng-if="!goalCategories || goalCategories.length === 0">
          <button type="button" class="btn btn-sm btn-link text-link" data-ng-click="openLinkingTargetsPopup()">
            <i class="icon-goal"></i>
            {{ 'Link to goals' | translate }}
            <span data-ng-if="eventSection.doc.meta.linkedTargets.length || 0">
              ({{ eventSection.doc.meta.linkedTargets.length || 0 }})
            </span>
          </button>
        </div>
        <div data-ng-if="goalCategories.length === 1">
          <button type="button" class="btn btn-sm btn-link text-link" data-ng-click="openLinkingTargetsPopup(goalCategories[0].id)">
            {{ 'Link to' | translate }} {{ goalCategories[0].name }} <span data-ng-if="totalCount > 0">({{ totalCount }})</span>
          </button>
        </div>
        <div data-ng-if="goalCategories.length > 1">
          <div class="dropdown">
            <button type="button" class="btn btn-sm btn-link text-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ 'Link to ...' | translate }}  <span data-ng-if="totalCount > 0">({{ totalCount }})</span>
              <span class="caret"></span>
            </button>
            <ul class="dropdown-menu">
              <li ng-repeat="cat in goalCategories">
                <button type="button" class="btn btn-sm btn-link text-link"
                   data-ng-click="openLinkingTargetsPopup(cat.id)">
                  {{ cat.name }} <span data-ng-if="cat.count > 0">({{ cat.count }})</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </li>
    <li
      data-ng-if="!options.allowLinking && eventSection.doc.meta.linkedTargets.length">
      <span><i class="icon-goal"></i>
        {{ 'Link to goals' | translate }}
        <span
          data-ng-if="eventSection.doc.meta.linkedTargets.length || 0">({{ eventSection.doc.meta.linkedTargets.length || 0 }})
        </span>
      </span>
    </li>
    <kz-auto-save-revisions-toggle info="options.autoSaveInfo"></kz-auto-save-revisions-toggle>
  </ul>
</div>
`,
  'app/components/events/directives/event-ai-filler.component.html': `<div data-ng-if="$ctrl.def">
    <ai-form-filler [form-definition]="$ctrl.def" (form-data-change)="$ctrl.changed($event)"></ai-form-filler>
</div>
`,
  'app/components/events/directives/event-autosave.html': `<div class="text-right">
  <span class="label label-info" ng-if="isSaving">{{ 'Saving...' | translate }}</span>
  <span class="label label-info" ng-if="model.date.modified && !isSaving">{{ 'Last saved:' | translate }} {{lastModified}}</span>
  <a href="#" class="text-danger" ng-disabled="!model.date.modified" ng-show="showDeleteButton && model.date.modified" ng-click="delete({model: model, dbType: 'private', showDialog: true})" aria-label="Remove"><i class="icon-trash"></i></a>
</div>
`,
  'app/components/events/directives/event-basic-form.html': `<div class="col-xs-12">
  <p class="box" ng-class="{'box-info': model.visibility === 'public', 'box-warning': model.visibility === 'private'}" data-ng-if="ctrl.eventType._id && !readOnly">
    <i class="icon-info"></i>
    <span class="text-gray" data-ng-if="model.visibility === 'public' && ctrl.isMine">
      {{ 'This event will be added onto your timeline as a shared event. Only users with permissions to view this event on your timeline will be able to view this event.' | translate }}
    </span>
    <span class="text-gray" data-ng-if="model.visibility === 'public' && !ctrl.isMine">
      {{ 'This event will be added onto the timeline of' | translate }} <span epf-fullname user="user"></span> {{ 'as a shared event. Only users with permissions to view this event on their timeline will be able to view this event.' | translate }}
    </span>
    <span class="text-gray" data-ng-if="model.visibility === 'private' && ctrl.isMine">
      {{ 'This event will be added onto your timeline as a private event. Only you will be able to view this event and its contents.' | translate }}
    </span>
    <span class="text-gray" data-ng-if="model.visibility === 'private' && !ctrl.isMine">
      {{ 'This event will be added onto the timeline of' | translate }} <span epf-fullname user="user"></span> {{ 'as a private event. Only they will be able to view this event and its contents.' | translate }}
    </span>

    <span class="text-gray" data-ng-if="ctrl.canChangeVisibility()">
      {{ 'Click here to change to' | translate }} <a href="" data-ng-click="ctrl.updateVisibility()">{{ model.visibility === 'private' ? ('shared' | translate) : ('private' | translate) }}</a>
    </span>
  </p>

  <kz-readonly-form data-ng-if="readOnly" class="event-basic-form" fields="ctrl.form.fields" model="model"></kz-readonly-form>
  <formly-form data-ng-if="!readOnly" class="event-basic-form" model="model" fields="ctrl.form.fields" options="ctrl.options" form="form" aria-label="Event basic form"></formly-form>
</div>
`,
  'app/components/events/directives/event-buttons.html': `<div data-ng-class="{'btn-group': ctrl.buttons.length > 2 && !ctrl.displayInline}">
  <button type="button" data-ng-if="ctrl.buttons.length > 2 && !ctrl.displayInline" data-target="#" class="btn btn-primary btn-raised dropdown-toggle" data-toggle="dropdown">
    {{ 'Actions' | translate }}
    <span class="caret"></span>
  </button>
  <ul data-ng-class="{'dropdown-menu': ctrl.buttons.length > 2 && !ctrl.displayInline, 'list-inline list-unstyled': ctrl.buttons.length > 0 || ctrl.displayInline}">
    <li data-ng-repeat="action in ctrl.buttons">
      <a href="" data-ng-href="{{action.href}}" data-ng-if="action.href" ng-class="{'{{action.klass}}': ctrl.buttons.length > 2 && !ctrl.forceButtons, 'btn {{action.btnClass}}': ctrl.forceButtons}" title="{{action.label}}" data-ng-mouseup="ctrl.closeModal()"><i data-ng-if="action.icon" data-ng-class="action.icon"></i> {{action.label}}</a>
      <a href="" data-ng-if="!action.href" data-ng-click="ctrl.doAction(action)" ng-class="{'{{action.klass}}': ctrl.buttons.length > 2 && !ctrl.forceButtons, 'btn {{action.btnClass}}': ctrl.forceButtons}" title="{{action.label}}"><i data-ng-if="action.icon" data-ng-class="action.icon"></i> {{action.label}}</a>
    </li>
  </ul>
</div>
`,
  'app/components/events/directives/event-comment.html': `<div id="new-comment-form" class="row">

  <div class="col-xs-12">
    <div class="row">
      <div class="col-sm-9">
        <p class="text-info"><strong>{{ 'Add new comment or tag' | translate }}</strong></p>
      </div>
      <div class="col-sm-3 text-right">
        <p>
          <button type="button" id="submit-button" class="btn btn-success" ng-disabled="commentForm.$invalid" ng-click="save(commentForm)">{{ 'Save' | translate }}</button>
        </p>
      </div>
    </div>
  </div>

  <div class="col-xs-12">
    <event-auto-save-directive is-saving="isSaving" model="extra" show-delete-button="true" delete="delete(model, dbType, showDialog)"></event-auto-save-directive>
  </div>

  <div class="col-xs-12">
    <formly-form model="extra" fields="form.fields" form="commentForm" aria-label="Comment"></formly-form>
  </div>
  <div class="col-xs-12">
    <button type="button" class="btn btn-sm btn-border btn-info" ng-disabled="tagTreeIsVisible" ng-click="showTagsTree()">{{ 'Add tags' | translate }}</button>
  </div>

</div>
`,
  'app/components/events/directives/event-extras-form.html': `<div class="row">
  <div class="col-xs-12">
    <div class="row has-border-bottom">
      <div class="col-sm-9">
        <p class="text-info"><strong>{{ 'Add tags' | translate }}</strong></p>
      </div>
      <div class="col-xs-3 text-right">
        <ul class="list-inline list-unstyled">
          <li class="label label-default"><i class="icon-tags"></i> {{event.doc.blueprints.length}} {{ 'tags' | translate }}</li>
        </ul>
      </div>
    </div>
  </div>

  <div id="section-extra-{{$index}}" class="col-xs-12 has-border-bottom" ng-show="ctrl.isExpanded[$index]">
    <formly-form class="event-extras-form" model="extras" fields="ctrl.form.fields" form="extrasForm" aria-label="Event extras"></formly-form>
  </div>

  <div class="row" ng-if="ctrl.displayOptions.collapsible">
    <div class="col-xs-12 text-center">
      <button type="button" class="btn btn-sm btn-link text-info" aria-contrals="section-extra-{{$index}}" aria-expanded="{{ctrl.isExpanded[$index]}}" ng-click="ctrl.isExpanded[$index] = !ctrl.isExpanded[$index]">
        <span ng-if="!ctrl.isExpanded[$index]">
          {{ 'Show more' | translate }} <i class="icon-down-open-big"></i>
        </span>
        <span ng-if="ctrl.isExpanded[$index]">
          {{ 'Show less' | translate }} <i class="icon-up-open-big"></i>
        </span>
      </button>
    </div>
  </div>
</div>
`,
  'app/components/events/directives/event-featured.html': `<div class="custom-fields" data-ng-if="ctrl.form">
    <kz-readonly-form fields="ctrl.form.fields" model="ctrl.submodel" event-type-id="ctrl.event.doc.eventType" highlight="ctrl.highlight" event-id="ctrl.event.doc._id" options="ctrl.formOptions" user="user"></kz-readonly-form>
</div>`,
  'app/components/events/directives/event-group-slot.html': `<div>
  <event-section-slot data-ng-if="item.main.doc.type === 'eventSection'" event-section="item.main" dates="item.event.doc.dates || item.main.doc.dates" options="options"></event-section-slot>
  <event-slot data-ng-if="item.main.doc.type === 'event'" event="item.main" options="options"></event-slot>
</div>
`,
  'app/components/events/directives/event-header.html': `<div class="wrapper">

  <event-users event="event.doc"></event-users>

  <div class="row" ng-if="!event.doc.linkedEvents">
    <div ng-class="{'col-sm-8': event.doc.dates, 'col-xs-12': !event.doc.dates}">
      <ul class="list-inline list-unstyled no-print">
        <li>
          <kz-event-progress states="sectionStates"></kz-event-progress>
        </li>
        <li data-ng-show="event.doc.state">
          <kz-state map="EVENT_STATES" state="event.doc.state.toUpperCase()"></kz-state>
        </li>
        <li data-ng-if="event.isPrivate()" class="text-danger">{{ 'PRIVATE' | translate }}</li>
        <li data-ng-if="event.doc.msfIncomplete" class="text-danger">{{ 'Minimum responses not reached' | translate }}</li>
        <li data-ng-if="event.doc.progress.comment !== 'Completed'" class="label label-default">{{event.doc.progress.comment}}</li>
        <li class="label" sync-state doc="event.doc"></li>
      </ul>

      <ul class="list-unstyled" data-ng-if="!conf.showEditForm">
        <li data-ng-if="event.doc.startDate !== event.doc.endDate">
          <span class="text-gray">{{ 'Event occured on:' | translate }} </span> {{event.doc.startDate | date: dateFormat }} <span class="text-gray">{{ 'to' | translate }}</span> {{event.doc.endDate | date: dateFormat }}
        </li>
        <li data-ng-if="event.doc.startDate === event.doc.endDate">
          <span class="text-gray">{{ 'Event occured on:' | translate }}</span> {{event.doc.startDate | date: dateFormat }}
        </li>
        <li><span class="text-gray">{{ 'Created on:' | translate }}</span> {{event.doc.date.added | date: dateFormat }}</li>

      </ul>

      <form class="no-print" name="form" data-ng-if="conf.showEditForm" aria-label="Edit event">
        <formly-form
          class="event-basic-form"
          model="model"
          fields="basicForm.fields"
          form="form"
          aria-label="Event"
        ></formly-form>
      </form>
    </div>

    <div ng-if="event.doc.dates || event.eventTypeVersion" class="col-sm-4 text-right no-print">
      <ul class="list-inline list-unstyled">
          <li ng-if="event.eventTypeVersion">
            <span class="label label-default">{{ 'version' | translate }} {{ event.eventTypeVersion }}</span>
          </li>
          <li ng-if="event.doc.dates">
          <button class="btn-link" aria-expanded="{{conf.auditLogShown}}" aria-controls="event-header__audit-log" ng-click="conf.auditLogShown = !conf.auditLogShown">
              <i class="icon-history"></i> {{ conf.auditLogShown ? ('Hide' | translate) : ('Show' | translate) }} {{ 'audit log' | translate }}
            </a>
          </li>
        </ul>
    </div>
    <div class="col-xs-12 no-print" queue-process-box ng-if="['complete'].indexOf(event.doc.state) === -1" obj="event" on-update="reloadEvent()"></div>
  </div>

  <div class="row no-print" data-ng-if="sectionsToFillIn.length">
    <div class="col-xs-12">
      <ul class="list-unstyled">
        <li data-ng-repeat="item in sectionsToFillIn track by $index">
          <span class="text-danger">{{ 'You are currently working on a response to this event.' | translate }} <a router-link="['events', 'fillin', item.id]">{{ 'Click here to fill in' | translate }}</a></span>
        </li>
      </ul>
    </div>
  </div>

  <div class="row" data-ng-if="!conf.showEditForm && event.doc.description">
    <div class="col-xs-12">
      <p class="text-gray">{{event.doc.description}}</p>
    </div>
  </div>

  <div class="row no-print" ng-if="allowActions && showActionButtons">
    <div class="col-xs-12">
      <div class="box box-default">
        <kz-list-buttons use-contextual-menu="false" actions="actionButtons"></kz-list-buttons>
      </div>
    </div>
  </div>

  <div class="row no-print" data-ng-if="event.categories.length">

  <div class="col-xs-12">
      <ul class="list-inline list-unstyled">
        <li ng-show="event.categories.length">
          <p class="text-gray">
            <i class="icon-tags"></i> {{ 'Tags:' | translate }}
            <a href="" class="btn btn-xs btn-border btn-info" ng-click="topTagsShown = !topTagsShown">
              {{ topTagsShown ? ('Hide' | translate) : ('Show' | translate) }} {{event.categories.length}} {{ 'tags' | translate }}
            </a>
          </p>
        </li>
      </ul>
    </div>

    <div class="col-xs-12">
      <div data-ng-if="event.categories.length">
        <ul ng-show="topTagsShown" class="list-inline list-unstyled list-tags">
          <li data-ng-repeat="category in event.categories">
            <span data-ng-if="category | kzIsArray">
              <span data-ng-repeat="cat in category" class="tag tag-no-count">
                <span class="tag-name" kz-category-title category="cat"></span>
              </span>
            </span>
            <span data-ng-if="category | kzIsString" class="tag tag-no-count">
              <span class="tag-name" kz-category-title category="category"></span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div id="event-header__audit-log" class="row no-print" data-ng-if="conf.auditLogShown">
    <div class="col-xs-12">
      <kz-audit-log dates="event.doc.dates" doc="event.doc" data-ng-if="event.doc.dates"></kz-audit-log>
    </div>
  </div>

  <div class="row" data-ng-if="event.eventType.prefilledFields.length">
    <div class="col-xs-12">
      <div class="row has-border-bottom">
        <div class="col-xs-12">
          <ul class="list-unstyled list-inline">
            <li><kz-avatar class="avatar" username="event.doc.user"></kz-avatar></li>
            <li>{{ 'About' | translate }} <span class="meta-author" epf-fullname user="event.doc.user"></span></li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12" data-ng-repeat="fieldId in event.eventType.prefilledFields">
          <span class="text-gray" epf-user-field-title field="{{ fieldId }}"></span>:
          <span epf-user-field-title field="{{ event.doc.prefilledFields[fieldId]}}"></span>
        </div>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/events/directives/event-invitees.html': `<div>
  <div class="alert alert-info" data-ng-if="ctrl.counts">
    <i class="icon icon-info"></i> {{ 'Here is the invitations breakdown by state:' | translate }}
    <ul>
      <li data-ng-repeat="(state, count) in ctrl.counts">
        <b>{{ ctrl.inviteesState[state]['name'] }}</b>: {{ count }}
      </li>
    </ul>

    <p>{{ 'If you would like more accurate figures such as know waiting for approval or rejected invites, please go online.' | translate }}</p>
  </div>

  <ul class="nav nav-tabs" data-ng-if="ctrl.tabs">
    <li ng-repeat="tab in ctrl.tabs"
        ng-class="{ active: ctrl.currentTab.id === tab.id }"
        ng-click="ctrl.goTo(tab.id)"
        ng-if="tab.invitees.length > 0">
      <a href="">{{ tab.name }} ({{ tab.invitees.length || 0 }})</a>
    </li>
  </ul>

  <div class="row" data-ng-if="!ctrl.loading">
    <div class="col-xs-12" data-ng-if="ctrl.currentTab.invitees">
      <div class="row" style="padding:10px" ng-repeat="invitee in ctrl.currentTab.invitees">
        <div class="col-sm-5">
          <ul class="list-unstyled list-inline">
            <li><event-filled-by type="invitee.section_type" user="invitee.user || invitee.email" display-options="{showAvatar: true}"></event-filled-by></li>
            <li> {{ ctrl.currentTab.filledByText }}
              <event-filled-by class="meta-author" type="invitee.section_type" user="invitee.user || invitee.email" email="invitee.email"></event-filled-by></li>
          </ul>
        </div>
        <div class="col-sm-3"
             style="padding-top: 7px"
             data-ng-class="{'col-sm-3': ctrl.currentTab.id === 'waiting' && ctrl.isOwner, 'col-sm-5': ctrl.currentTab.id !== 'waiting' || !ctrl.isOwner }">
          <ul class="list-unstyled">
            <li ng-repeat="date in invitee.dates" data-ng-if="date.action === 'request_created'">
              <span class="label label-info">{{ ctrl.actionMapping[date.action] }}:</span> {{ date.date | date:ctrl.dateFormat }}
            </li>
          </ul>
        </div>
        <div class="col-sm-2" style="padding-top: 7px"><span class="label label-{{ ctrl.inviteesState[invitee.state].style }}">{{ ctrl.inviteesState[invitee.state].name }}</span></div>
        <div class="col-sm-2" data-ng-if="ctrl.currentTab.id === 'waiting' && ctrl.isOwner">
          <a href="" class="btn btn-xs btn-warning" ng-click="ctrl.remind(invitee)"><i class="icon icon-bell"></i> {{ 'Remind' | translate }}</a>
          <a href="" class="btn btn-xs btn-danger" ng-click="ctrl.retract(invitee._id)"><i class="icon icon-trash"></i> {{ 'Retract' | translate }}</a>
        </div>
      </div>
    </div>

    <div class="col-xs-12">
      <div class="alert alert-info" data-ng-if="ctrl.currentInvitees.length === 0">
        <i class="icon icon-info"></i> {{ 'There are no responses' | translate }}
      </div>
    </div>
  </div>

  <span data-ng-if="ctrl.loading">
    <i class="icon-spin animate-spin"></i> {{ 'Loading' | translate }}
  </span>
</div>
`,
  'app/components/events/directives/event-linked-view.html': `<div>

  <div class="wrapper">
    <div class="row">
      <event-basic-form read-only="true" event="ctrl.event"></event-basic-form>
    </div>
  </div>

  <div class="wrapper" ng-repeat="section in ctrl.event.allSections track by section.def._id" ng-show="ctrl.event.allSections.length > 0">
    <event-section-form
      ng-if="section.section"
      section="section.section"
      event="ctrl.event"
      def="section.def"
      options="{readOnly: true}"
      form="form"
      original-event="original"
      display-options="{ collapsible: true, isExpanded: !section.def.multiSource }">
    </event-section-form>
  </div>

</div>
`,
  'app/components/events/directives/event-pending-sections.html': `  <div class="row">
    <div class="col-xs-12" data-ng-if="show">
      <p>
        <ul class="list-unstyled">
          <li data-ng-repeat="item in inner.pending track by item.id">
            {{ item.id }} - {{ item.doc.state}}
            <button type="button" data-ng-if="item.doc.state === 'new'" class="btn btn-sm btn-success" ladda="processing[item.id]" data-ng-click="accept(item)">{{ 'Accept' | translate }}</button>
          </li>
        </ul>
      </p>
    </div>
  </div>
`,
  'app/components/events/directives/event-preview.html': `  <div class="row" data-ng-if="eventObj.loaded">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-10">
          <h4>
            <span data-ng-if="!eventObj.doc.title || eventObj.doc.title === 'Quick draft'" kz-event-type-title event-type="eventObj.doc.eventType"></span>
          <span data-ng-if="eventObj.doc.title && eventObj.doc.title !== 'Quick draft'">{{ eventObj.doc.title }}</span>
          <span class="label label-info" data-ng-bind="eventObj.doc.state | eventState | nounderscore"></span>
          </h4>

          <p class="box box-danger" data-ng-if="original.currentSection._id !== eventObj.currentSection._id">
            {{ 'The original event is not accepting the response. Please click' | translate }}
            <a href="" target="_blank" router-link="/users/edit', eventObj.doc.user, 'events', eventObj.doc._id">{{ 'here' | translate }}</a>
            {{ 'to view the original event in a new tab.' | translate }}
          </p>

          <p>{{ 'Owner:' | translate }} <span epf-fullname user="event.user"></span></p>
          <p data-ng-if="original">
            {{ 'Original event state:' | translate }} {{ original.doc.state | eventState }}
          </p>


          <p>
            {{ 'Required roles:' | translate }}
            <span data-ng-repeat="role in roles">
              <span>{{ role.title }}</span>
              <span data-ng-show="role.invitable">
               <button type="button" data-ng-show="user.roles.indexOf(role._id) === -1" class="btn btn-sm btn-link text-link" data-ng-click="grant(role)">{{ 'grant' | translate }}</button>
               <button type="button" data-ng-show="user.roles.indexOf(role._id) > -1" class="btn btn-sm btn-link text-link" data-ng-click="revoke(role)">{{ 'revoke' | translate }}</button>
              </span>
              <span data-ng-if="!$last">,</span>
            </span>
            <span data-ng-show="!hasNeededRoles()" class="text-danger"> {{ '- User does not have the required roles' | translate }}</span>
          </p>
        </div>
        <div class="col-md-2 text-right">
          <button type="button" class="btn btn-sm btn-border btn-danger" data-ng-click="makeObsolete()">{{ 'Reject' | translate }}</button>
          <button type="button" class="btn btn-sm btn-border btn-primary" data-ng-click="showDetail = !showDetail">{{ showDetail ? ('Hide' | translate) : ('Show' | translate) }}</button>
          <a class="btn btn-sm btn-border btn-primary" target="_blank" router-link="['/users/edit', eventObj.doc.user, 'events', eventObj.doc._id]">{{ 'View original event' | translate }}</a>
        </div>
      </div>

      <div data-ng-show="showDetail">
        <div class="wrapper">
          <div class="row">
            <div class="col-cs-12">
              <event-basic-form event="eventObj" read-only="true"></event-basic-form>
            </div>
          </div>
        </div>

        <div class="wrapper" data-ng-show="eventObj.allSections.length > 0">
          <div class="row" data-ng-if="section.section" data-ng-repeat="section in eventObj.allSections track by section.def._id">
            <event-section-form section="section.section" event="eventObj" def="section.def" options="{readOnly: true}"></event-section-form>
          </div>
        </div>
      </div>

    </div>
  </div>
`,
  'app/components/events/directives/event-progress.html': `<div class="inline-block">
  <ul class="list-inline list-unstyled" data-ng-if="states.length">
    <li ng-repeat="state in states track by $index">
      <span title="{{SUBMAPPING[state.substate]}}" class="event-section-progress-state event-section-progress-state--{{state.state}}"></span>
    </li>
  </ul>
</div>
`,
  'app/components/events/directives/event-reject-message.html': `<div class="row">
  <div class="col-xs-12" data-ng-if='ctrl.latestAuditLog && ctrl.latestAuditLog.action === "section_reject"'>
    <h5>
      <span epf-fullname user="ctrl.latestAuditLog.actor"></span> {{ 'Rejected your request to fill in this event on' | translate }} {{ ctrl.latestAuditLog.date | kzDateFormat:'datetime' }}
    </h5>
    <div class="alert alert-warning">{{ctrl.latestAuditLog.message}}</div>
  </div>
</div>
`,
  'app/components/events/directives/event-report.html': `<div class="row">
  <div class="col-xs-12" kz-loading loaded="ctrl.loaded">
    <div data-ng-repeat="field in ctrl.fields track by $index">
      <div data-ng-switch="field.type">
        <div data-ng-switch-when="heading">
          <h4 data-ng-bind="::field.content"></h4>
        </div>
        <div data-ng-switch-when="text">
          <div data-ng-bind-html="field.content | nl2br | a2nt | videoUrlToIframe" class="readonly"></div>
        </div>
        <div data-ng-switch-when="systemField">
          <div class="row">
            <div class="col-xs-12">
              <label class="control-label">
                {{ ::field.title }}:
              </label>
              <span kz-form-title item="field.value" type="{{ ::field.fieldType }}"></span>
            </div>
          </div>

        </div>
        <div data-ng-switch-when="sectionField">
          <div class="row">
            <div class="col-xs-12">
              <label class="control-label" ng-if="field.title !== '__hide__'">
                {{ ::field.title }}:
              </label>
              <ul>
                <li data-ng-repeat="item in field.value | kzFilterEmpty track by $index">
                    <span kz-form-title item="item" type="{{ ::field.def.blueprintType }}" kz-type="{{ field.def.type }}" field-id="{{ field.field }}" event-type-id="{{ ctrl.event.doc.eventType }}"></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div data-ng-switch-when="aggField">
          <div class="row">
            <div class="col-xs-12">
              <label class="control-label">
                {{ ::field.title }}:
              </label>
              {{ ::field.value | number:field.precision }}

              <span data-ng-if="::field.showCount && field.extra.count">({{ctrl.getRatersLabel(field.extra.count)}})</span>
              <span data-ng-if="::field.showRange && field.extra.dates">{{ctrl.getDateRangeLabel(field.extra.dates.start | date:dateFormat, field.extra.dates.end | date:dateFormat)}}</span>
            </div>
          </div>
        </div>
        <div data-ng-switch-when="chart">
          <div class="row" data-ng-if="field.hasErrorBar">
            <div class="col-xs-12 text-center">
              {{ 'The graph below includes error bars that represent 95% confidence interval of the mean.' | translate }}
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <canvas epf-chartjs-bar chart-data="field.data" height="250" chart-options="field.options" chart-legend="legend"></canvas>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <ol data-ng-if="!field.keyNotNumbered">
                <li data-ng-repeat="leg in field.legend track by $index">{{ ::leg }}</li>
              </ol>
              <ul data-ng-if="field.keyNotNumbered">
                <li data-ng-repeat="leg in field.legend track by $index">{{ ::leg }}</li>
              </ul>
            </div>
          </div>

        </div>
        <div data-ng-switch-when="countDistinctDiscreteCategories">
          <div class="row">
            <div class="col-xs-12">
              <div ng-repeat="(fieldName, CatCounts) in field.value">
                <label class="control-label">{{ ::fieldName }}:</label>
                <div ng-repeat="cat in CatCounts">
                  {{cat.name}}: {{cat.count}}
                </div>
              </div>
            </div>
          </div>

        </div>
        <div data-ng-switch-when="distinctDiscreteCategoriesChart">
          <div class="row">
            <div class="col-xs-12">
              <canvas epf-chartjs-bar chart-data="field.data" height="250" chart-options="field.options" chart-legend="legend"></canvas>
            </div>
          </div>
        </div>
        <div data-ng-switch-default>
          {{ ::field }}
        </div>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/events/directives/event-response-view.html': `<div class="col-xs-12">
  <div class="row has-border-bottom" ng-if="item.filledBy || item.publishedAt">
    <div class="col-sm-9" ng-if="item.filledBy">
      <ul class="list-unstyled list-inline">
        <li><event-filled-by user="item.filledBy" event="event.doc" display-options="{showAvatar: true}" /></li>
        <li>
          <span>{{ 'Section filled in by' | translate }} <event-filled-by class="meta-author" user="item.filledBy" event="event.doc" email="item.email" is-anonymised-section="def.anonymize"/></span>
          <span ng-if="item.filledOnSameDevice"> {{ '- Filled on the same device' | translate }}</span>
          <!-- <span ng-if="item.noConfirmationNeeded"> without confirmation</span> -->
        </li>
      </ul>
    </div>

    <div class="col-sm-3 text-right" ng-if="item.publishedAt">
      <p><span class="label label-default">{{ 'Filled in on' | translate }} <span class="text-info">{{ item.publishedAt | date:dateFormat }}</span></span></p>
    </div>
  </div>

  <div id="section-response-view" class="row has-border-bottom" ng-show="helpers.isExpanded">
    <div class="col-xs-12" ng-if="item.filledByDetails.roles.length > 0 || !(item.filledByDetails.relations | kzIsEmpty)">
      <div class="text-gray box box-info" ng-if="item.filledByDetails.roles.length > 0 || !(item.filledByDetails.relations | kzIsEmpty)">
        <ul class="list-unstyled">
          <li ng-if="item.filledByDetails.roles.length > 0">
            <span class="text-gray">{{ 'Role:' | translate }}</span> <span epf-roles-title roles="item.filledByDetails.roles"></span>
          </li>

          <li ng-if="item.filledByDetails.relations" data-ng-repeat="(relation, category) in item.filledByDetails.relations">
            <span class="text-gray" epf-relation-title relation="{{ relation }}"></span>: <span epf-relation-categories categories="category"></span>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-xs-12">
      <event-section-fields data-ng-if="edited"
        event="event"
        model="item"
        edited="edited"
        fields="fields"
        form="form"
        def="def"
        original-event="originalEvent"
        parent="parent"
        read-only="!allowActions || helpers.readOnly"
      ></event-section-fields>
      <div data-ng-if="item.files && item.files.length">
          <h5>{{ 'Attached files' | translate }}</h5>
          <file-widget
            doc-id="event.doc._id"
            model="item.files"
            ng-model="item.files"
            read-only="!allowActions || helpers.readOnly"
            remove-only="true"
            file-options="fileOptions"
            ></file-widget>
      </div>

    </div>

    <div class="col-xs-12">
      <div class="box box-default" ng-if="allowActions && showActionButtons">
        <kz-list-buttons use-contextual-menu="false" actions="actionButtons"></kz-list-buttons>
      </div>
    </div>

  </div>

  <div class="row no-print" ng-if="displayOptions.collapsible">
    <div class="col-xs-12 text-center">
      <button type="button" aria-controls="section-response-view" aria-expanded="{{helpers.isExpanded}}" class="btn btn-sm btn-link text-info" ng-click="helpers.isExpanded = !helpers.isExpanded">
        <span ng-if="!helpers.isExpanded">
          {{ 'Show more' | translate }} <i class="icon-down-open-big"></i>
        </span>
        <span ng-if="helpers.isExpanded">
          {{ 'Show less' | translate }} <i class="icon-up-open-big"></i>
        </span>
      </button>
    </div>
  </div>
</div>
`,
  'app/components/events/directives/event-section-close.html': `<div class="row" data-ng-show="ctrl.show">
  <div class="col-xs-12" data-ng-if="ctrl.show">
    <div class="row">
      <div class="col-xs-12" data-ng-if="def">
        <p>
          {{ 'The next section of this form can be filled in by users with these roles:' | translate }}
          <span epf-roles-title roles="def.filledBy"></span>
        </p>
        <invite-form data-ng-if="def" def="def" model="ctrl.invites" source="source(filledBy, search)" allow-fill="false" form="form" options="ctrl.options"></invite-form>
      </div>
      <div class="col-xs-12">
        <p>{{ 'This will complete and close this section to further responses' | translate }}</p>
        <button type="button" class="btn btn-success" data-ng-click="ctrl.close()">{{ 'Close this section' | translate }}</button>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/events/directives/event-section-extra.html': `<div class="row">

  <div class="row">
    <div class="col-xs-12">
      <ul class="list-inline list-unstyled">
        <li class="label label-default"><i class="icon-tags"></i> {{total.tags}} {{ 'tags' | translate }}</li>
        <li class="label label-default"><i class="icon-comment"></i> {{total.comments}} {{ 'comments' | translate }}</li>
      </ul>
    </div>
  </div>

  <div id="tags-and-comments" class="row has-border-bottom" ng-show="opts.isExpanded">

    <div class="col-xs-12 has-border-bottom" data-ng-repeat="ex in extras | orderBy: 'date.modified';">

      <div class="row">
        <div class="col-xs-8 col-sm-9">
          <p class="text-gray">
            <event-filled-by user="ex.actor" display-options="{showAvatar: true}"></event-filled-by> <span class="meta-author" epf-fullname user="ex.actor"></span>
            <span ng-if="!ex.tags.length && !ex.blueprints.length">{{ 'commented' | translate }}</span>
            <span ng-if="ex.tags.length || ex.blueprints.length">{{ 'added' | translate }}</span>
            <span ng-if="ex.tags.length || ex.blueprints.length" ng-bind="::ex.tags.length + ex.blueprints.length + ' tags'"></span>
            <span ng-if="(ex.tags.length || ex.blueprints.length)"> {{ 'and' | translate }} </span>
          </p>
        </div>
        <div class="col-xs-8 col-sm-3 text-right">
          <p>
            <span class="label label-info" data-ng-if="!ex.date.modified" data-ng-bind="::ex.date | date: dateFormat"></span>
            <span class="label label-info" data-ng-if="ex.date.modified" data-ng-bind="::ex.date.modified | date: dateFormat"></span>
          </p>
        </div>
      </div>

      <p style="white-space:pre-wrap;" data-ng-if="ex.comment.length > 0" data-ng-bind="::ex.comment"></p>

      <div class="comment-meta" data-ng-if="::(ex.tags.length > 0 || ex.blueprints.length > 0 || ex.events.length > 0)">
        <div data-ng-if="::(ex.tags.length > 0 || ex.blueprints.length > 0)">
          <p class="text-gray">
            <ul class="list-inline list-unstyled">
              <li>{{ 'Tags:' | translate }}</li>
              <li class="tag tag-no-count" data-ng-repeat="tag in ex.tags">
                <span class="tag-name" kz-blueprint-category-title category="::tag.tag"></span>
              </li>
              <li class="tag tag-no-count" data-ng-repeat="tag in ex.blueprints">
                <span class="tag-name" kz-blueprint-category-title category="::tag"></span>
              </li>
            </ul>
          </p>
        </div>

        <div data-ng-if="::(ex.events.length > 0)">
          <p class="text-gray">
            <ul class="list-unstyled">
              <li>{{ 'Linked to:' | translate }}</li>
              <li data-ng-repeat="eventId in ex.events" kz-event-title event-id="{{ ::eventId }}"></li>
            </ul>
          </p>
        </div>
      </div>
      <p data-ng-if="canDelete(ex)">
        <button type="button" class="btn btn-xs btn-danger" data-ng-click="delete(ex, 'shared', true)">{{ 'Delete' | translate }}</button>
      </p>
    </div>

    <div class="col-xs-12">
      <event-comment event="event" on-save="addPendingEventExtra(newExtra)" auto-expand="{{opts.autoExpand}}"></event-comment>
    </div>

  </div>

  <div class="row" ng-if="opts.collapsible">
    <div class="col-xs-12 text-center">
      <button type="button" class="btn btn-sm btn-link text-info" aria-expanded="{{opts.isExpanded}}" aria-controls="tags-and-comments" ng-click="opts.isExpanded = !opts.isExpanded">
        <span ng-if="!opts.isExpanded">
          {{ 'Show more' | translate }} <i class="icon-down-open-big"></i>
        </span>
        <span ng-if="opts.isExpanded">
          {{ 'Show less' | translate }} <i class="icon-up-open-big"></i>
        </span>
      </a>
    </div>
  </div>

</div>
`,
  'app/components/events/directives/event-section-fields.html': `<div>
  <div data-ng-if="ready && readOnly && localModel.fields">
    <kz-readonly-form class="form-readonly form-readonly--fancy" fields="fields" model="localModel.fields"
      event-type-id="event.doc.eventType" event-id="event.doc._id" section-id="def._id" user="event.doc.user"
      data-ng-if="!error && !info" parent="parent.doc._id"></kz-readonly-form>
    <p data-ng-if="error">{{ error }}</p>
    <p data-ng-if="info">{{ info }}</p>
  </div>

  <div data-ng-if="ready && !readOnly && localModel.fields">
    <formly-form data-ng-if="localModel.fields" model="localModel.fields" fields="fields" options="localOptions"
      form="form" data-ng-if="!error && !info" aria-label="Event section form"></formly-form>
    <p data-ng-if="error">{{ error }}</p>
    <p data-ng-if="info">{{ info }}</p>
  </div>
</div>
`,
  'app/components/events/directives/event-section-form.html': `<div class="row">
  <div class="col-2xs-12"
       data-ng-if="remainingResponsibles.length &&
                   !event.isDraft() && !options.readOnly &&
                   def.filledBy.indexOf('system:anonymous-external') === -1"
  >
    <div class="row">
      <div class="col-xs-12">
        <p data-ng-if="!anonymized">
          <span class="text-primary">{{ 'Next section is awaiting response from:' | translate }} </span>
          <span data-ng-repeat="responsible in remainingResponsibles">
            <span data-ng-if="responsible.type === 'user'" epf-fullname user="responsible.username"></span>
            <span data-ng-if="responsible.type === 'request'">{{ responsible.email }}</span>
            <span data-ng-if="!$last">, </span>
          </span>
        </p>
        <p data-ng-if="anonymized">
          <span class="text-primary">{{ 'Next section is awaiting response' | translate }}</span>
        </p>
        <hr/>
      </div>
    </div>
  </div>

  <div class="col-xs-12" ng-if="def.multiSource">
    <p data-ng-if="section.state === 'draft'" class="text-primary">{{ 'Next section is awaiting responses from multiple users.' | translate }}</p>
    <p data-ng-if="section.state !== 'draft'" class="text-primary">{{ 'This section has responses from multiple users.' | translate }}</p>
  </div>

  <div class="col-xs-12" ng-if="section.state === 'skipped'">
    <p>{{ 'This section is skipped' | translate }}</p>
  </div>

  <div class="col-xs-12" ng-if="section.state !== 'skipped' && cons.items.length === 0">
    <p>{{ 'There are no responses' | translate }}</p>
  </div>

  <div class="col-xs-12" ng-if="cons.items.length">
    <div class="row" data-ng-repeat="item in cons.items track by $index">
      <event-response-view
        event="event"
        section="section"
        item="item"
        def="def"
        parent="parent"
        form="form"
        fields="ctrl.form.fields"
        allow-actions="allowActions"
        options="options"
        display-options="displayOptions">
      </event-response-view>
    </div>
  </div>
</div>
`,
  'app/components/events/directives/event-section-header.html': `<div class="wrapper">

  <event-users event="eventSection.doc"></event-users>
  <div class="row" ng-if="!eventSection.doc.linkedEvents">
    <div class="col-xs-12 col-sm-8">
      <ul class="list-inline list-unstyled">
        <li>
          <kz-event-progress states="sectionStates"></kz-event-progress>
        </li>
        <li data-ng-show="eventSection.doc.state">
          <kz-state map="eventViewCtrl.EVENT_STATES" state="eventSection.doc.state.toUpperCase()"></kz-state>
        </li>
        <li data-ng-if="eventSection.isPrivate()" class="text-danger">{{ 'PRIVATE' | translate }}</li>
        <li data-ng-if="eventSection.doc.msfIncomplete" class="text-danger">{{ 'Minimum responses not reached' | translate }}</li>
        <li data-ng-if="eventSection.doc.progress.comment !== 'Completed'" class="label label-default">{{eventSection.doc.progress.comment}}</li>
        <li class="label" sync-state doc="eventSection.doc"></li>
      </ul>
    </div>

    <div ng-if="eventSection.doc.dates || eventSection.eventTypeVersion" class="col-xs-12 col-sm-4 text-right">
      <ul class="list-inline list-unstyled">
        <li ng-if="eventSection.eventTypeVersion">
          <span class="label label-default">{{ 'version' | translate }} {{ eventSection.eventTypeVersion }}</span>
        </li>
        <li ng-if="eventSection.doc.dates">
          <a href="" ng-click="conf.auditLogShown=! conf.auditLogShown ">
            <i class="icon-history "></i> {{ eventViewCtrl.conf.auditLogShown ? ('Hide' | translate) : ('Show' | translate) }} {{ 'audit log' | translate }}
          </a>
        </li>
      </ul>
    </div>
    <div class="col-xs-12 " queue-process-box ng-if="[ 'merged', 'obsolete'].indexOf(eventSection.doc.state)===- 1
          " obj="eventSection " on-update="reloadEvent() "></div>
  </div>

  <div class="row " data-ng-if="eventSection.meta.description ">
    <div class="col-xs-12 ">
      <p class="text-gray ">{{eventSection.meta.description}}</p>
    </div>
  </div>

  <div class="row " data-ng-if="eventSection.categories.length">

    <div class="col-xs-12 ">
      <ul class="list-inline list-unstyled ">
        <li ng-show="eventSection.categories.length ">
          <p class="text-gray ">
            <i class="icon-tags "></i> {{ 'Tags:' | translate }}
            <a href="" class="btn btn-xs btn-border btn-info " ng-click="topTagsShown=! topTagsShown ">
              {{ topTagsShown ? ('Hide' | translate) : ('Show' | translate) }} {{eventSection.categories.length}} {{ 'tags' | translate }}
            </a>
          </p>
        </li>
      </ul>
    </div>

    <div class="col-xs-12 ">
      <div data-ng-if="eventSection.categories.length ">
        <ul ng-show="topTagsShown " class="list-inline list-unstyled list-tags ">
          <li data-ng-repeat="category in eventSection.categories ">
            <span data-ng-if="category | kzIsArray ">
              <span data-ng-repeat="cat in category " class="tag tag-no-count ">
                <span class="tag-name " kz-category-title category="cat "></span>
              </span>
            </span>
          </li>
          <li data-ng-repeat="category in eventSection.categories | filter:isString ">
            <span class="tag tag-no-count " data-ng-if="category | kzIsString ">
              <span class="tag-name " kz-category-title category="category "></span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <kz-reject-message dates="eventSection.doc.dates"></kz-reject-message>

  <kz-audit-log dates="eventSection.doc.dates " ng-show="conf.auditLogShown " doc="eventSection.doc " data-ng-if="eventSection.doc.dates "></kz-audit-log>
</div>
`,
  'app/components/events/directives/event-section-invite.html': `<div class="row" data-ng-show="ctrl.show">
  <div class="col-xs-12" data-ng-if="ctrl.show">
    <div class="row">
      <p>
        {{ 'You can invite more users who have one of following roles to fill in this section:' | translate }}
        <span epf-roles-title roles="def.filledBy"></span>
      </p>
      <form name="inviteForm">
        <invite-form def="def" model="ctrl.invites" source="source(filledBy, search)" allow-fill="false" form="form" options="ctrl.options"></invite-form>
      </form>
    </div>
    <div class="col-xs-12">
      <button type="button" class="btn btn-success" data-ng-click="ctrl.invite(inviteForm)">{{ 'Invite' | translate }}</button>
    </div>
  </div>
</div>
`,
  'app/components/events/directives/event-section-next-update.html': `<span>
  <a href="" ng-if="ctrl.show && ctrl.style === 'link'" ng-click="ctrl.showUpdateNextResponsiblePopup()">
    {{ 'Update the next responsible person' | translate }}
  </a>
</span>
`,
  'app/components/events/directives/event-section-next.html': `<div>
  <div class="row" data-ng-if="show && !eventSection.currentDefSection.multiSource">
    <div class="col-xs-12">
      <div data-ng-show="def.multiSource">

        <p>
        {{ 'The next section of this form has been designed to be completed by multiple people. Please indicate who you would like to invite using the boxes below. The minimum number of responses you must achieve is' | translate }} {{ def.multiSourceMin }}{{ '. Invitations can be sent now and also after this form has been submitted by returning to this page.' | translate }}
        </p>

        {{ 'The next section of this form can be filled in by users with these roles:' | translate }}
        <span epf-roles-title roles="def.filledBy"></span>
      </div>
      <p data-ng-if="!def.multiSource">
        <span data-ng-if="!ctrl.returning">
          {{ 'The next section of this form can be filled in by users with these roles:' | translate }}
          <span epf-roles-title roles="def.filledBy"></span>
        </span>
        <span data-ng-if="ctrl.returning">
          {{ 'The next section of this form will be filled in by' | translate }}
          <span epf-fullnames user="eventSection.doc.eventOwner"></span>
        </span>
      </p>
      <invite-form def="def" model="model" source="source(filledBy, search)"
                   allow-fill="showFOSDToggle" form="form" options="ctrl.options" idx="nextIdx"></invite-form>
    </div>
  </div>
</div>
`,
  'app/components/events/directives/event-section-view.html': `<div>

  <div class="wrapper">
    <div class="row">
      <event-basic-form
        model="eventSection.meta"
        user="eventSection.doc.eventOwner"
        read-only="true">
      </event-basic-form>
    </div>
  </div>

  <div data-ng-if="!eventSection.doc.meta.quickDraft">
    <div>
      <!-- Display sections -->
      <div class="wrapper" data-ng-show="eventSection.originalEvent.completedSections.length > 0" data-ng-repeat="section in eventSection.originalEvent.completedSections">
        <event-section-form
          section="section.section"
          event="eventSection.originalEvent"
          def="section.def"
          options="{readOnly: true}"
          parent="eventSection"
          display-options="{ collapsible: true, isExpanded: $last }">
        </event-section-form>
      </div>
    </div>

    <div class="wrapper wrapper-highlighted" data-ng-if="eventSection.currentDefSection && eventViewCtrl.isFilled()">
      <div class="row">
        <div class="col-xs-12" data-ng-if="eventSection.doc.state === 'pending'">
          <div class="row has-border-bottom">
            <div class="col-sm-9">
              <ul class="list-unstyled list-inline">
                <li><event-filled-by type="eventSection.doc.section_type || 'user'" user="eventSection.getFilledBy()" display-options="{showAvatar: true}"></event-filled-by></li>
                <li>{{ 'Section filled in by' | translate }} <event-filled-by class="meta-author" type="eventSection.doc.section_type || 'user'" user="eventSection.getFilledBy()" event="eventSection.doc" email="eventSection.doc.email"></event-filled-by></li>
              </ul>
            </div>

            <div class="col-sm-3 text-right">
              <p><span class="label label-default">{{ 'Filled in on' | translate }} <span class="text-info">{{ eventSection.getDateFor('section_publish') | date:dateFormat }}</span></span></p>
            </div>
          </div>
        </div>
        <section-response-form
          model="eventSection.doc.data"
          doc-id="eventSection.doc.event"
          def="eventSection.currentDefSection"
          event-type="eventSection.doc.eventType"
          read-only="true"
          allow-actions="eventViewCtrl.allowActions"
          parent="eventSection"
          form="eventViewCtrl.form"
          for-user="eventSection.doc.eventOwner"
          >
        </section-response-form>
      </div>

      <div class="row" data-ng-if="eventViewCtrl.showInvitation">
        <section-response-invitation
          event-section="eventSection"
          invitation="eventSection.doc.invitation"
          next-def-section="eventSection.getDefSection(eventSection.getNextSection())"
          read-only="true"
          allow-actions="eventViewCtrl.allowActions"
          on-save="eventViewCtrl.saveInvitation(invitation)"
          next-idx="0"
        ></section-response-invitation>
      </div>

      <div class="row" data-ng-if="eventSection.doc.invitation.filledOnSameDevice">
        <section-response-form
          model="eventSection.doc.nextSection"
          doc-id="eventSection.doc.event"
          def="eventSection.nextDefSection"
          event-type="eventSection.doc.eventType"
          read-only="true"
          allow-actions="eventViewCtrl.allowActions"
          parent="eventSection"
          form="eventViewCtrl.form">
        </section-response-form>
    </div>

    <div class="row" data-ng-if="eventViewCtrl.showNextInvitation">
      <section-response-invitation
        event-section="eventSection"
        invitation="eventSection.doc.nextInvitation"
        next-def-section="eventSection.getDefSection(eventSection.getNextNextSection())"
        read-only="true"
        allow-actions="eventViewCtrl.allowActions"
        on-save="eventViewCtrl.saveNextInvitation(invitation)"
        next-idx="1"
      ></section-response-invitation>
    </div>

    <div class="wrapper wrapper-highlighted" data-ng-if="eventSection.currentDefSection && !eventViewCtrl.isFilled()">
      <div class="row">
        {{ 'This form has not been filled yet.' | translate }}
        <a ng-if="!fillIn" router-link="['/events', 'fillin', eventSection.doc._id]" ng-click="eventViewCtrl.fillIn(evt)">{{ 'Click here to fill in' | translate }}</a>
        <button type="button" ng-if="fillIn" class="btn btn-sm btn-link text-link" ng-click="eventViewCtrl.fillIn(evt)">{{ 'Click here to fill in' | translate }}</button>
      </div>
    </div>
  </div>
`,
  'app/components/events/directives/event-slot.html': `<div class="col-xs-12">

  <event-users event="ctrl.event.doc"></event-users>

  <div class="row event-inner">
    <div class="col-sm-7">
      <a router-link="ctrl.event.route" title="{{ 'View event details' | translate }}">
        <h2 class="entry-title">
          <span kz-event-title event="ctrl.event" event-id="{{ctrl.event.doc._id}}" for-user="ctrl.username" highlight="ctrl.highlight"></span>
          <span kz-event-icons event="ctrl.event"></span>
        </h2>
      </a>

      <p class="hidden-xs">
        <queue-process ng-if="['complete'].indexOf(ctrl.event.doc.state) === -1" obj="ctrl.event" on-update="ctrl.updateEvent()"></queue-process>
      </p>

      <div class="row hidden-xs" data-ng-if="false">
        <div class="col-xs-12">
          <p>
            <span class="text-gray">{{ 'Occurred on:' | translate }}</span> <span data-ng-bind="::ctrl.event.doc.startDate | date:ctrl.dateFormat"></span> <span data-ng-if="ctrl.event.doc.startDate !== ctrl.event.doc.endDate"><span class="text-gray">{{ 'to' | translate }}</span> <span data-ng-bind="::ctrl.event.doc.endDate | date:ctrl.dateFormat"></span></span>
            <span data-ng-if="ctrl.event.doc.date.added">
              {{ 'and' | translate }} <span class="text-gray">{{ 'created on:' | translate }}</span> <span data-ng-bind="::ctrl.event.doc.date.added | date:ctrl.dateFormat"></span>
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="col-sm-5 col-right">
      <ul class="list-inline list-unstyled">
        <li data-ng-if="ctrl.sectionStates.length">
          <kz-event-progress states="ctrl.sectionStates"></kz-event-progress>
        </li>
        <li data-ng-if="ctrl.event.isPrivate()" class="text-danger">{{ 'PRIVATE' | translate }}</li>
        <li>
          <span data-ng-if="['startDate', 'endDate'].indexOf(options.search.orderBy || 'addedDate') !== -1">
            <span class="label label-default">{{ 'Occurred on:' | translate }}</span>
            <span>{{::ctrl.event.doc.startDate | date:ctrl.dateFormat}}</span>
            <span data-ng-if="ctrl.event.doc.startDate !== ctrl.event.doc.endDate">
              <span class="label label-default">{{ 'to' | translate }}</span>
              <span>{{::ctrl.event.doc.endDate | date:ctrl.dateFormat}}</span>
            </span>
          </span>
          <span class="label label-default" data-ng-if="['startDate', 'endDate'].indexOf(options.search.orderBy || 'addedDate') === -1">{{ 'created on:' | translate }} <span class="text-info">{{::ctrl.event.doc.date.added | date:ctrl.dateFormat}}</span>
          </span>
        </li>
        <li sync-state doc="ctrl.event.doc"></li>
        <li data-ng-if="ctrl.event.loaded && (ctrl.actionButtons || ctrl.secondaryActionButtons) && ctrl.useCompactView">
          <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons" left-slot-size="9" dots="true"></kz-list-buttons>
        </li>
      </ul>
      <ul class="list-inline list-unstyled">
        <event-linked-targets data-ng-if="options.showLinkedTargets && ctrl.event.linkedTargets.length" linked-targets="ctrl.event.linkedTargets" event="ctrl.event"></event-linked-targets>
        <li data-ng-if="ctrl.event.doc.msfIncomplete" class="text-danger">{{ 'Minimum responses not reached' | translate }}</li>
        <li data-ng-if="ctrl.event.doc.progress.comment !== 'Completed'" class="text-gray" data-ng-bind-html="ctrl.event.doc.progress.comment | kzHighlight:ctrl.highlight"></li>
      </ul>
    </div>
  </div>


  <div data-ng-if="ctrl.sectionsToFillIn.length " class="text-danger">
    <div data-ng-repeat="item in ctrl.sectionsToFillIn track by $index">
      {{ 'You are currently working on a response to this event.' | translate }} <a router-link="['/events', 'fillin', item.id]">{{ 'Click here to fill in' | translate }}</a>
    </div>
  </div>
  <div class="custom-fields" data-ng-if="ctrl.tokens.length > 0">
    <div class="row" data-ng-repeat="token in ctrl.tokens track by token.url">
      <div class="col-sm-12">
        <p>
        {{ 'Please arrange to distribute the following URL to people who you wish to gather responses from:' | translate }}
        <a target="_blank" href="{{ token.url }}">{{ token.url }}</a>
        </p>
      </div>
    </div>
  </div>
  <div class="custom-fields" data-ng-if="ctrl.event">
    <event-featured event="event" hightlight="ctrl.highlight" user="ctrl.user"></event-featured>
  </div>

  <kz-audit-log id="{{ctrl.auditLogId}}" dates="event.doc.dates" doc="event.doc" data-ng-if="ctrl.shownDescription && event.doc.dates"></kz-audit-log>

  <kz-list-buttons data-ng-if="ctrl.event.loaded && (ctrl.actionButtons || ctrl.secondaryActionButtons) && !ctrl.useCompactView" actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons" left-slot-size="9"></kz-list-buttons>
</div>
`,
  'app/components/events/directives/event-users.html': `<div class="row event-users no-print" data-ng-show="ctrl.users">
  <div class="col-xs-12">
      {{ 'This shows an event section that has been filled in and submitted to the event owner:' | translate }}

      <span data-ng-repeat="user in ctrl.users">
        <span data-ng-if="user.canView">
          <a router-link="['/users/edit', user.user, 'events']">
            <span epf-fullname user="user.user"></span>
          </a>
        </span>
        <span data-ng-if="!user.canView" epf-fullname user="user.user"></span>
        <span data-ng-if="!$last">,</span>
      </span>
    </span>
  </div>
</div>
`,
  'app/components/events/directives/event-view.html': `<div>
  <div ng-repeat="linkedEvent in eventViewCtrl.event.doc.linkedEvents track by linkedEvent._id">
    <event-linked-view event="linkedEvent" original="eventViewCtrl.event"></event-linked-view>
  </div>

  <div class="wrapper" data-ng-if="eventViewCtrl.event.currentSection.def.multiSource && !eventViewCtrl.event.isDraft()">
    <div class="row">
      <div class="col-xs-12">
        <div class="row">
          <ul class="nav nav-tabs">
            <li ng-repeat="tab in eventViewCtrl.tabs"
                ng-class="{ active: eventViewCtrl.currentActive === tab.id }"
                ng-click="eventViewCtrl.goTo(tab.id)"
            >
              <a href="">{{ tab.name }} ({{ tab.count }})</a>
            </li>
          </ul>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <h1>{{ 'Response summary' | translate }}</h1>

            <p class="text-gray">{{ 'You need a minimum of' | translate }} {{ eventViewCtrl.event.currentSection.def.multiSourceMin }} {{ 'responses.' | translate }}</p>
            <event-invitees
              event="eventViewCtrl.event"
              data-ng-if="eventViewCtrl.event">
            </event-invitees>
          </div>
        </div>
      </div>
    </div>
    <div data-ng-if="!noEdit && eventViewCtrl.event.loaded">
      <div class="wrapper" data-ng-if="eventViewCtrl.event.currentSection.def">
        <event-section-invite class="" section="eventViewCtrl.event" event="eventViewCtrl.event" def="eventViewCtrl.event.currentSection.def"></event-section-invite>
      </div>
    </div>
  </div>

  <div class="wrapper" data-ng-if="eventViewCtrl.event.loaded && eventViewCtrl.tokens.length > 0">
    <div class="row" data-ng-repeat="token in eventViewCtrl.tokens track by token.url">
      <div class="col-sm-8">
        {{ 'Please arrange to distribute the following URL to people who you wish to gather responses from:' | translate }}
        <a target="_blank" href="{{ token.url }}">{{ token.url }}</a>
      </div>
      <div class="col-sm-4 text-right">
        <a router-link="['/events', 'tearoff', eventViewCtrl.event.doc._id]">{{ 'Print tear off page' | translate }}</a>
      </div>
    </div>
  </div>

  <div class="wrapper" data-ng-if="0 && eventViewCtrl.event.loaded">
    <event-pending-sections section="eventViewCtrl.event.currentSection" event="eventViewCtrl.event"></event-pending-sections>
  </div>

  <!-- Display sections -->
  <div class="wrapper" data-ng-show="eventViewCtrl.event.allSections.length > 0" data-ng-repeat="section in eventViewCtrl.event.allSections | filter:{state:'!missing'}" data-ng-if="section.section">
    <event-section-form
      data-ng-if="section.section.state !== 'skipped'"
      section="section.section"
      event="eventViewCtrl.event"
      parent="eventViewCtrl.parent"
      def="section.def"
      allow-actions="eventViewCtrl.allowActions"
      display-options="{ collapsible: true, isExpanded: !section.def.multiSource }">
    </event-section-form>
  </div>

  <div class="wrapper" ng-if="eventViewCtrl.event.doc.files.length > 0">
    <div class="row">
      <div class="col-sm-12">
        <h5>{{ 'Documents attached to comments' | translate }}</h5>
        <file-widget
          doc-id="eventViewCtrl.event.doc._id"
          model="eventViewCtrl.event.doc.files"
          ng-model="eventViewCtrl.event.doc.files"
          multiple="true"
          read-only="true"
        ></file-widget>
      </div>
    </div>
  </div>

  <div data-ng-if="!noEdit && eventViewCtrl.event.loaded">
    <div class="wrapper" data-ng-if="eventViewCtrl.event.currentSection.def.multiSource">
      <event-section-close class="" section="eventViewCtrl.event" event="eventViewCtrl.event" def="eventViewCtrl.event.nextSection.def"></event-section-close>
    </div>

    <div class="wrapper" data-ng-if="eventViewCtrl.event.doc.state === 'inProgress'">
      <section-close-goal class="" section="eventViewCtrl.event" event="eventViewCtrl.event" def="eventViewCtrl.event.nextSection.def"></section-close-goal>
    </div>
  </div>
</div>
`,
  'app/components/events/directives/event.define.filters.html': `<div>
<!--  <span class="text-gray">You have <ng-pluralize count="ctrl.totalActiveFilters" when="{'0': 'no active filters', '1': '1 active filter', 'other': '{} active filters'}"></ng-pluralize>.</span>-->
  <target-filters-description target-filters="ctrl.filters" data-ng-if="readonly && ctrl.filters"></target-filters-description>
  <button type="button" data-ng-if="!readonly" class="btn btn-xs btn-border btn-success" ng-click="ctrl.openFiltersDefinitionModal()">{{ ctrl.totalActiveFilters > 0 ? ('Add more filters' | translate) : ('Add filters' | translate) }}</button>
</div>
`,
  'app/components/events/directives/eventsection-slot-compact.html': `<div class="col-xs-12">

  <div class="row event-inner vertical-center">
    <div class="col-xs-10 col-sm-8">
      <div class="row">
        <div class="col-xs-12">
          <a router-link="ctrl.eventSection.route" title="{{ 'View event details' | translate }}">
            <h2 class="entry-title">
              <span data-ng-if="ctrl.eventSection.doc.state === 'merged'">{{ 'Section of' | translate }} </span><span kz-event-title event="ctrl.eventSection" event-id="{{ctrl.eventSection.doc._id}}" for-user="ctrl.username" highlight="ctrl.highlight"></span>
              <span kz-event-icons event="ctrl.eventSection"></span>
            </h2>
          </a>
          <p class="text-gray" data-ng-if="ctrl.eventSection.meta.quickDraft">{{ ctrl.eventSection.meta.description|truncate:10 }}</p>
          <p>
            <queue-process ng-if="['merged'].indexOf(ctrl.eventSection.doc.state) === -1" obj="ctrl.eventSection" on-update="ctrl.update()"></queue-process>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <ul class="list-inline list-unstyled">
            <li data-ng-if="ctrl.sectionStates.length">
              <kz-event-progress class="compact" states="ctrl.sectionStates"></kz-event-progress>
            </li>
            <li>
              <span data-ng-if="ctrl.dateToShow === 'occured'">
                <span class="label label-default">{{ 'Occurred on:' | translate }}</span>
                <span data-ng-bind="::ctrl.eventSection.meta.startDate | date:ctrl.dateFormat"></span>
                <span data-ng-if="ctrl.eventSection.meta.startDate !== ctrl.eventSection.meta.endDate">
                  <span class="label label-default">{{ 'to' | translate }}</span>
                  <span data-ng-bind="::ctrl.eventSection.meta.endDate | date:ctrl.dateFormat"></span>
                </span>
              </span>
              <span class="label label-default" data-ng-if="ctrl.dateToShow === 'createdDate'">{{ 'created on:' | translate }} <span class="text-info" data-ng-bind="::ctrl.eventSection.doc.createdDate | date:ctrl.dateFormat"></span>
              </span>
              <span class="label label-default" data-ng-if="ctrl.dateToShow === 'modifiedDate'">{{ 'modified on:' | translate }} <span class="text-info" title="{{ctrl.eventSection.doc.saveInfo.lastSaved || ctrl.eventSection.doc.createdDate | date:ctrl.dateFormat }}" data-ng-bind="::ctrl.eventSection.doc.saveInfo.lastSaved || ctrl.eventSection.doc.createdDate | date:ctrl.dateFormat"></span>
              </span>
            </li>
          </ul>
          <ul class="list-inline list-unstyled" data-ng-if="ctrl.eventSection.doc.progress.comment && ctrl.eventSection.doc.progress.comment !== 'Completed'">
            <li class="text-gray" data-ng-bind-html="ctrl.eventSection.doc.progress.comment | kzHighlight:ctrl.highlight"></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-xs-2 col-sm-4 text-right">
      <ul class="list-inline list-unstyled">
        <li data-ng-if="false">
          <kz-event-progress class="hidden-xs" states="ctrl.sectionStates"></kz-event-progress>
        </li>
        <li>
          <kz-list-buttons data-ng-if="ctrl.eventSection.loaded && (ctrl.actionButtons || ctrl.secondaryActionButtons)"
            featured-actions="ctrl.featuredButtons"
            left-slot-size="9" dots="true"></kz-list-buttons>
        </li>
      </ul>
    </div>
  </div>

  <kz-audit-log id="{{ctrl.auditLogId}}" dates="dates || eventSection.doc.dates" doc="eventSection.doc" data-ng-if="ctrl.shownDescription && (dates || eventSection.doc.dates)"></kz-audit-log>
</div>
`,
  'app/components/events/directives/eventsection-slot.html': `<div class="col-xs-12">

  <div class="row event-inner">
    <div class="col-sm-7">
      <a router-link="ctrl.eventSection.route" title="{{ 'View event details' | translate }}">
        <h2 class="entry-title">
          <span data-ng-if="ctrl.eventSection.doc.state === 'merged'">{{ 'Section of' | translate }} </span><span kz-event-title event="ctrl.eventSection"
            event-id="{{ctrl.eventSection.doc._id}}" for-user="ctrl.username" highlight="ctrl.highlight"></span>
          <span kz-event-icons event="ctrl.eventSection"></span>
        </h2>
      </a>
      <p>
        <queue-process ng-if="['merged'].indexOf(ctrl.eventSection.doc.state) === -1" obj="ctrl.eventSection" on-update="ctrl.update()"></queue-process>
      </p>
    </div>

    <div class="col-sm-5 col-right">
      <ul class="list-inline list-unstyled">
        <li data-ng-if="ctrl.sectionStates.length">
          <kz-event-progress states="ctrl.sectionStates"></kz-event-progress>
        </li>
        <li>
          <span data-ng-if="ctrl.dateToShow === 'occured'">
            <span class="label label-default">{{ 'Occurred on:' | translate }}</span>
            <span data-ng-bind="::ctrl.eventSection.meta.startDate | date:ctrl.dateFormat"></span>
            <span data-ng-if="ctrl.eventSection.meta.startDate !== ctrl.eventSection.meta.endDate">
              <span class="label label-default">{{ 'to' | translate }}</span>
              <span data-ng-bind="::ctrl.eventSection.meta.endDate | date:ctrl.dateFormat"></span>
            </span>
          </span>
          <span class="label label-default" data-ng-if="ctrl.dateToShow === 'createdDate'">{{ 'created on:' | translate }} <span class="text-info"
              data-ng-bind="::ctrl.eventSection.doc.createdDate | date:ctrl.dateFormat"></span>
          </span>
          <span class="label label-default" data-ng-if="ctrl.dateToShow === 'modifiedDate'">{{ 'modified on:' | translate }} <span class="text-info"
              title="{{ctrl.eventSection.doc.saveInfo.lastSaved || ctrl.eventSection.doc.createdDate | date:ctrl.dateFormat }}"
              data-ng-bind="::ctrl.eventSection.doc.saveInfo.lastSaved || ctrl.eventSection.doc.createdDate | date:ctrl.dateFormat"></span>
          </span>
        </li>
      </ul>
      <ul class="list-inline list-unstyled" data-ng-if="ctrl.eventSection.doc.progress">
        <li data-ng-if="ctrl.eventSection.doc.progress.comment" class="text-gray" data-ng-bind-html="ctrl.eventSection.doc.progress.comment | kzHighlight:ctrl.highlight"></li>
      </ul>

    </div>
  </div>

  <p data-ng-if="ctrl.eventSection.meta.quickDraft">{{ ctrl.eventSection.meta.description }}</p>
  <div class="custom-fields" data-ng-if="ctrl.eventSection">
    <event-featured event="ctrl.eventSection" hightlight="ctrl.highlight"></event-featured>
  </div>

  <kz-audit-log id="{{ctrl.auditLogId}}" dates="dates || eventSection.doc.dates" doc="eventSection.doc" data-ng-if="ctrl.shownDescription && (dates || eventSection.doc.dates)"></kz-audit-log>
  <kz-list-buttons data-ng-if="ctrl.eventSection.loaded && (ctrl.actionButtons || ctrl.secondaryActionButtons)" actions="ctrl.actionButtons"
    secondary-actions="ctrl.secondaryActionButtons" left-slot-size="9"></kz-list-buttons>
</div>
`,
  'app/components/events/directives/invite.form.html': `<div>
  <formly-form model="model" form="form" fields="ctrl.form.fields" options="ctrl.options" aria-label="Invite users"></formly-form>

  <div class="box box-info" ng-show="model.invites.length">
    {{ 'By continuing, you will invite the following users to fill in the next section:' | translate }} <span ng-repeat="email in model.invites">{{ email }}<span ng-if="!$last">, </span></span>
  </div>
</div>
`,
  'app/components/events/directives/kz-group-title.html': `<div data-ng-show="title || value" class="wrapper event-group-title">
  <p class="details" data-ng-if="!templateUrl">{{title}} {{value}}</p>
</div>
`,
  'app/components/events/directives/response-form.html': `<div class="col-xs-12">
  <div class="alert alert-info" data-ng-if="additionalActions.length">
    {{ 'You have made' | translate }}
    <b>{{ additionalActions.length }}
      <ng-pluralize count="additionalActions.length" when="{'1': 'change', 'other': 'changes'}"></ng-pluralize>
    </b> {{ 'to the previous section(s). These changes will be applied when you submit.' | translate }}
    <button type="button" class="btn btn-xs btn-warning" ng-click="clearActions()">{{ 'Cancel all changes' | translate }}</button>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <kz-list-buttons data-ng-if="actionButtons && allowActions" actions="actionButtons" use-contextual-menu="false"></kz-list-buttons>
      <div data-ng-if="!helpers.readOnly">
        <div kz-feature-enabled feature="ai-form-filler">
          <div class="box box-info px-4 py-2">
            <event-ai-filler model="model" section="def._id" event-type="eventType"></event-ai-filler>
          </div>
        </div>
        <formly-form model="model.fields" fields="responseForm.fields" form="form" aria-label="Response form"></formly-form>
      </div>
      <div data-ng-if="helpers.readOnly">
        <kz-readonly-form
          fields="responseForm.fields" model="localFields"
          event-type-id="eventType"
          event-id="parent.doc.event" section-id="def._id" user="forUser"></kz-readonly-form>
      </div>
      <div data-ng-if="model.files && model.files.length">
        <h5>{{ 'Attached files' | translate }}</h5>
        <file-widget
          doc-id="parent.doc.event"
          model="model.files"
          ng-model="model.files"
          read-only="helpers.readOnly"
          remove-only="true"
          file-options="fileOptions"
          ></file-widget>
    </div>
    </div>
  </div>
</div>
`,
  'app/components/events/directives/response.invitation.form.html': `<div class="col-xs-12">

    <div class="row">
      <div class="col-xs-12">
        <kz-list-buttons data-ng-if="$ctrl.actionButtons && $ctrl.allowActions" actions="$ctrl.actionButtons" use-contextual-menu="false"></kz-list-buttons>
        <div data-ng-if="!$ctrl.helpers.readOnly">
            <event-section-next
                event-section="$ctrl.eventSection" form="form"
                def-section="$ctrl.nextDefSection"
                invitation-model="$ctrl.model"
                allow-fill-on-same-device="false"
                next-idx="0"
                ></event-section-next>
        </div>
        <div data-ng-if="$ctrl.helpers.readOnly">
            <ul class="list-unstyled list-inline">
            <li ng-repeat="item in $ctrl.parsedInvitation track by $index">
                <ul class="list-unstyled list-inline">
                <li><event-filled-by type="item.type" user="item.username" email="item.email" display-options="{showAvatar: true}"></event-filled-by></li>
                <li>{{ 'Invited' | translate }} <event-filled-by class="meta-author" type="item.type" user="item.username" email="item.email"></event-filled-by></li>
                </ul>
            </li>
            </ul>
        </div>
      </div>
    </div>

</div>
`,
  'app/components/events/directives/section-close-goal.html': `<div class="row">
  <div class="col-xs-12">
    <div class="row" data-ng-if="!sectionCloseGoalCtrl.show">
      <div class="col-xs-12" data-ng-if="!sectionCloseGoalCtrl.notEnoughPermission && !sectionCloseGoalCtrl.goalSet.isAutoCloseEnabled">
        {{ 'In order to close the goals for this event section, you need to mark its goals individually by clicking on each one in the list above.' | translate }}
      </div>
      <div class="col-xs-12" data-ng-if="!sectionCloseGoalCtrl.notEnoughPermission && sectionCloseGoalCtrl.goalSet.isAutoCloseEnabled">
        {{ 'You need to fulfill the following conditions:' | translate }}
        <ul>
          <li ng-if="sectionCloseGoalCtrl.goalSet.autoCloseConditions.indexOf('allAchievementsMet') > -1">{{ 'All achievements have been met' | translate }}</li>
          <li ng-if="sectionCloseGoalCtrl.goalSet.autoCloseConditions.indexOf('overdue') > -1">{{ 'The goalset is Overdue' | translate }}</li>
        </ul>
      </div>
      <div class="col-xs-12 alert alert-danger" data-ng-if="sectionCloseGoalCtrl.notEnoughPermission">
        {{ "You don't have the permission to close goals for others." | translate }}
      </div>
    </div>
    <div class="row" data-ng-if="sectionCloseGoalCtrl.show">
      <form novalidate name="form" aria-label="Close goal">
      <div class="col-xs-12" data-ng-if="sectionCloseGoalCtrl.nextSection">
        <p>
          {{ 'The next section of this form can be filled in by users with these roles:' | translate }}
          <span epf-roles-title roles="sectionCloseGoalCtrl.nextSection.def.filledBy"></span>
        </p>
        <invite-form def="def" model="sectionCloseGoalCtrl.invites" source="source(filledBy, search)" allow-fill="false" form="form" options="sectionCloseGoalCtrl.options"></invite-form>
      </div>
      <div class="col-xs-12">
        <button type="button" class="btn btn-success" data-ng-click="sectionCloseGoalCtrl.closeGoal(goals)" data-ng-disabled="!form.$valid">{{ 'Close Goals' | translate }}</button>
      </div>
      </form>
    </div>
  </div>
</div>

`,
  'app/components/events/directives/tagspopup.html': `<div class="modal-header">
  <button type="button" class="close" data-ng-click="ctrl.dismiss()" aria-label="Close"><i class="icon-cancel"></i></button>
  <div class="modal-title">
    <h3>
      {{ 'Select tags' | translate }}
    </h3>
  </div>
</div>

<div class="modal-body">
  <p class="box box-info" data-ng-if="ctrl.nodata">
    {{ 'There are no tags currently available for you to use' | translate }}
  </p>

  <form name="extrasForm">
    <formly-form class="event-extras-form" model="ctrl.eventExtras" fields="ctrl.form.fields" form="extrasForm" aria-label="Event extras"></formly-form>
  </form>
</div>


<div class="modal-footer" data-ng-if="ctrl.actions.length || ctrl.secondaryActions.length">
  <div class="row">
    <div class="col-sm-8">
      <kz-list-buttons data-ng-if="ctrl.secondaryActions.length" class="" actions="ctrl.secondaryActions" use-contextual-menu="false"></kz-list-buttons>
    </div>
    <div class="col-sm-4 text-right">
      <kz-page-buttons data-ng-if="ctrl.actions.length"class="" actions="ctrl.actions" use-contextual-menu="false"></kz-page-buttons>
    </div>
  </div>
</div>
`,
  'app/components/events/eventsection.edit.html': `<div class="sweet-overlay" tabIndex="-1" style="display: block" data-ng-if="eventCtrl.submitted"></div>
<div kz-loading loaded="eventCtrl.authorized">
  <form novalidate name="eventCtrl.form" aria-label="Event section">
    <span unsaved-warning-form data-ng-if="!eventCtrl.options.autosaveisEnabled"></span>

    <div class="wrapper">
      <div class="row">
        <header ng-class="{'col-sm-8': eventCtrl.eventSection.isQuickEvent(), 'col-sm-12': !eventCtrl.eventSection.isQuickEvent()}">
          <h1>{{ eventCtrl.isNew ? (('New' | translate) + ' ' + eventCtrl.eventSection.eventType.name) : (eventCtrl.eventSection.eventType.name || ('Quick note' | translate)) }}
            <span data-ng-if="!eventCtrl.eventSection.isEventOwners()">{{ 'for' | translate }}
              <span epf-fullname user="::eventCtrl.eventSection.doc.eventOwner"></span>
            </span>
            <span ng-if="eventCtrl.eventSection.eventType && eventCtrl.progress" class="badge badge-info">
              {{ eventCtrl.progress}}
            </span>
          </h1>
          <event-actions-header
            event-section="eventCtrl.eventSection"
            event-owner="eventCtrl.eventOwner"
            event-extras="eventCtrl.eventExtras"
            options="eventCtrl.options">
          </event-actions-header>
        </header>
      </div>

      <kz-reject-message dates="eventCtrl.eventSection.doc.dates"></kz-reject-message>

      <kz-auto-save-exit ng-if="eventCtrl.options.autosaveisEnabled" info="eventCtrl.options.autoSaveInfo"></kz-auto-save-exit>

      <kz-auto-save-revisions ng-if="eventCtrl.options.autosaveisEnabled" info="eventCtrl.options.autoSaveInfo" id="eventCtrl.eventSection.doc._id"></kz-auto-save-revisions>
      <div class="row" data-ng-if="eventCtrl.eventSection.loaded">

        <div class="col-sm-8">
          <p class="text-gray" ng-bind-html="'Fields marked with <i class=&quot;icon-star required&quot; aria-hidden=&quot;true&quot;></i> are required.' | translate"></p>
        </div>

        <div class="col-sm-4 text-right-sm">
          <kz-last-saved ng-if="eventCtrl.options.autosaveisEnabled" info="eventCtrl.options.autoSaveInfo"></kz-last-saved>
        </div>

      </div>

      <!-- Let's auto-save -->
      <kz-auto-save ng-if="eventCtrl.eventSection.loaded && eventCtrl.options.autosaveisEnabled" info="eventCtrl.options.autoSaveInfo" skip-initial-save="eventCtrl.isNew"
        handle-save="eventCtrl.onAutosave()">
      </kz-auto-save>


      <div class="row" data-ng-if="eventCtrl.eventSection.loaded && eventCtrl.eventSection.doc.meta">
        <event-basic-form model="eventCtrl.eventSection.doc.meta" user="eventCtrl.eventSection.doc.eventOwner" section-data="eventCtrl.eventSection.data"
          read-only="false" form="eventCtrl.form" event-type="eventCtrl.eventSection.eventType">
        </event-basic-form>
      </div>

    </div>

    <div class="wrapper" data-ng-if="eventCtrl.loaded && eventCtrl.originalEvent && ! eventCtrl.eventSection.doc.meta">
      <div class="row">
        <event-basic-form model="eventCtrl.originalEvent.doc" user="eventCtrl.eventSection.doc.eventOwner" read-only="true">
        </event-basic-form>
      </div>
    </div>

    <div>
      <!-- Display sections -->
      <div class="wrapper" data-ng-show="eventCtrl.originalEvent.completedSections.length > 0" data-ng-repeat="section in eventCtrl.originalEvent.completedSections">
        <event-section-form
          section="section.section"
          event="eventCtrl.originalEvent"
          def="section.def"
          allow-actions="true"
          options="{postponeActions: true}"
          display-options="{ collapsible: true, isExpanded: $last }"
          >
        </event-section-form>
      </div>
    </div>

    <div class="wrapper wrapper-highlighted" data-ng-if="eventCtrl.eventSection.currentDefSection">
      <div class="row">
        <section-response-form
          model="eventCtrl.eventSection.doc.data"
          doc-id="eventCtrl.eventSection.doc.event"
          additional-actions="eventCtrl.eventSection.doc.additionalActions"
          def="eventCtrl.eventSection.currentDefSection"
          event-type="eventCtrl.eventSection.doc.eventType"
          for-user="eventCtrl.eventSection.doc.eventOwner"
          form="eventCtrl.form">
        </section-response-form>
      </div>

      <div class="row" data-ng-if="eventCtrl.showNextSection">
        <event-section-next class="col-xs-12"
          event-section="eventCtrl.eventSection" form="eventCtrl.form"
          def-section="eventCtrl.nextDefSection"
          invitation-model="eventCtrl.eventSection.doc.invitation"
          allow-fill-on-same-device="true"
          next-idx="0"
        ></event-section-next>
      </div>
    </div>

    <div class="wrapper wrapper-highlighted"  data-ng-if="eventCtrl.eventSection.doc.invitation.filledOnSameDevice && eventCtrl.nextDefSection">
      <div class="row">
        <section-response-form
          model="eventCtrl.eventSection.doc.nextSection"
          doc-id="eventCtrl.eventSection.doc.event"
          def="eventCtrl.nextDefSection"
          event-type="eventCtrl.eventSection.doc.eventType"
          for-user="eventCtrl.eventSection.doc.eventOwner"
          form="eventCtrl.form"
        >
        </section-response-form>
      </div>
      <div class="row">
        <event-section-next class="col-xs-12"
          event-section="eventCtrl.eventSection"
          form="eventCtrl.form"
          def-section="eventCtrl.nextNextDefSection"
          invitation-model="eventCtrl.eventSection.doc.nextInvitation"
          allow-fill-on-same-device="false"
          next-idx="1"
        ></event-section-next>
      </div>
    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-xs-12">
          <button ng-if="eventCtrl.eventSection.isQuickEvent()" unsaved-warning-clear type="button" class="btn btn-success btn-raised" ng-click="eventCtrl.quickDraftToEvent()">
            {{ 'Turn into event' | translate }}
          </button>

          <button unsaved-warning-clear type="button" class="btn btn-success btn-raised" ng-disabled="!eventCtrl.eventSection.doc.eventType || eventCtrl.submitted"
            ng-if="eventCtrl.eventSection.doc.eventType && !eventCtrl.eventSection.isQuickEvent()" ng-click="eventCtrl.save(eventCtrl.form, 'publish')" indicator="loading">
            <span>{{ eventCtrl.actionTitle }}</span>
          </button>

          <a href="" class="btn btn-xs border border-warning text-warning ml-4" data-ng-disabled="eventCtrl.submitted" data-ng-click="eventCtrl.save(eventCtrl.form, 'save')" unsaved-warning-clear>{{ eventCtrl.eventSection.isQuickEvent() ? ('Save' | translate) : ('Save as draft' | translate) }}</a>
        </div>
      </div>
    </div>
  </form>
</div>
`,
  'app/components/events/eventsection.preview.html': `<div class="modal-header event-modal-header">

  <header class="row">
    <div class="col-sm-12">
      <button type="button" class="close" data-ng-click="eventPreviewCtrl.close()"><i class="icon-cancel"></i></button>
      <h3>
        <span kz-event-title event="eventPreviewCtrl.eventSection" event-id="{{eventPreviewCtrl.eventSection.doc._id}}" for-user="eventPreviewCtrl.eventSection.doc.eventOwner"></span>
      </h3>
      <a router-link="eventPreviewCtrl.eventSection.route" target="_blank" unsaved-warning-clear>{{ 'Open in a new tab' | translate }}</a>
    </div>
  </header>
</div>

<div class="modal-body event-modal-body" kz-loading loaded="eventPreviewCtrl.loaded">
  <div data-ng-if="eventPreviewCtrl.mode === 'read'">
    <event-section-header event-section="eventPreviewCtrl.eventSection"></event-section-header>
    <div>
      <event-section-view event-section="eventPreviewCtrl.eventSection" no-edit="true" fill-in="eventPreviewCtrl.fillIn()"></event-section-view>
    </div>
  </div>
  <form novalidate name="eventPreviewCtrl.form" data-ng-if="eventPreviewCtrl.mode === 'fillin'">
    <div class="wrapper">
      <header class="row vertical-center-xs" data-ng-if="eventPreviewCtrl.options.allowBasicFormExtras || eventPreviewCtrl.options.allowLinking || eventPreviewCtrl.options.autosaveisEnabled">
        <div class="col-xs-6">
          <event-actions-header
            event-section="eventPreviewCtrl.eventSection"
            event-owner="eventPreviewCtrl.eventOwner"
            event-extras="eventPreviewCtrl.eventExtras"
            options="eventPreviewCtrl.options">
          </event-actions-header>
        </div>
        <div class="col-xs-6 text-right">
          <div>
            <ul class="list-inline list-unstyled">
              <li>
                <kz-last-saved ng-if="eventPreviewCtrl.options.autosaveisEnabled" info="eventPreviewCtrl.options.autoSaveInfo"></kz-last-saved>
              </li>
            </ul>
          </div>
        </div>
        <kz-auto-save-revisions ng-if="eventPreviewCtrl.options.autosaveisEnabled" info="eventPreviewCtrl.options.autoSaveInfo" id="eventPreviewCtrl.eventSection.doc._id"></kz-auto-save-revisions>
      </header>

      <div class="row" data-ng-if="eventPreviewCtrl.eventSection.loaded">
        <div class="col-sm-12">
          <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
        </div>
      </div>

      <div class="row" data-ng-if="eventPreviewCtrl.eventSection.loaded && eventPreviewCtrl.eventSection.doc.meta">
        <event-basic-form
          model="eventPreviewCtrl.eventSection.doc.meta"
          user="eventPreviewCtrl.eventSection.doc.eventOwner"
          section-data="eventPreviewCtrl.eventSection.data"
          read-only="false"
          form="eventPreviewCtrl.form">
        </event-basic-form>
      </div>
    </div>

    <div>
      <!-- Display sections -->
      <div class="wrapper" data-ng-show="eventPreviewCtrl.originalEvent.completedSections.length > 0" data-ng-repeat="section in eventPreviewCtrl.originalEvent.completedSections">
        <event-section-form
          section="section.section"
          event="eventPreviewCtrl.originalEvent"
          def="section.def"
          allow-actions="true"
          options="{postponeActions: true}"
          display-options="{ collapsible: true, isExpanded: $last }">
        </event-section-form>
      </div>
    </div>

    <div class="wrapper wrapper-highlighted" data-ng-if="eventPreviewCtrl.eventSection.currentDefSection">
      <kz-auto-save ng-if="eventPreviewCtrl.eventSection.loaded && eventPreviewCtrl.options.autosaveisEnabled" info="eventPreviewCtrl.options.autoSaveInfo" skip-initial-save="false"
        handle-save="eventPreviewCtrl.onAutosave()">
      </kz-auto-save>


      <div class="row">

        <section-response-form
          model="eventPreviewCtrl.eventSection.doc.data"
          doc-id="eventPreviewCtrl.eventSection.doc.event"
          additional-actions="eventPreviewCtrl.eventSection.doc.additionalActions"
          def="eventPreviewCtrl.eventSection.currentDefSection"
          event-type="eventPreviewCtrl.eventSection.doc.eventType"
          for-user="eventPreviewCtrl.eventSection.doc.eventOwner"
          form="eventPreviewCtrl.form">
        </section-response-form>
      </div>

      <div class="row" data-ng-if="eventPreviewCtrl.showNextSection">
        <event-section-next class="col-xs-12"
          event-section="eventPreviewCtrl.eventSection" form="eventPreviewCtrl.form"
          def-section="eventPreviewCtrl.nextDefSection"
          invitation-model="eventPreviewCtrl.eventSection.doc.invitation"
          allow-fill-on-same-device="true"
          next-idx="0"
        ></event-section-next>
      </div>
    </div>

    <div class="wrapper wrapper-highlighted"  data-ng-if="eventPreviewCtrl.eventSection.doc.invitation.filledOnSameDevice && eventPreviewCtrl.nextDefSection">
      <div class="row">
        <section-response-form
          model="eventPreviewCtrl.eventSection.doc.nextSection"
          doc-id="eventPreviewCtrl.eventSection.doc.event"
          def="eventPreviewCtrl.nextDefSection"
          event-type="eventPreviewCtrl.eventSection.doc.eventType"
          for-user="eventPreviewCtrl.eventSection.doc.eventOwner"
          form="eventPreviewCtrl.form"
        >
        </section-response-form>
      </div>
      <div class="row">
        <event-section-next class="col-xs-12"
          event-section="eventPreviewCtrl.eventSection" i
          form="eventPreviewCtrl.form"
          def-section="eventPreviewCtrl.nextNextDefSection"
          invitation-model="eventPreviewCtrl.eventSection.doc.nextInvitation"
          allow-fill-on-same-device="false"
          next-idx="1"
        ></event-section-next>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" data-ng-if="eventPreviewCtrl.actions.length || eventPreviewCtrl.secondaryActions.length">
  <div class="row">
    <div class="col-sm-8">
      <kz-list-buttons data-ng-if="eventPreviewCtrl.secondaryActions.length && eventPreviewCtrl.mode === 'read'" class="" actions="eventPreviewCtrl.secondaryActions" use-contextual-menu="false"></kz-list-buttons>
    </div>
    <div class="col-sm-4 text-right">
      <kz-page-buttons data-ng-if="eventPreviewCtrl.actions.length"class="" actions="eventPreviewCtrl.actions" use-contextual-menu="false"></kz-page-buttons>
      <button class="btn btn-success btn-sm"
           data-ng-click="eventPreviewCtrl.switchMode('fillin')"
           data-ng-if="eventPreviewCtrl.canFillIn && eventPreviewCtrl.mode === 'read'">
        <i class="icon-edit"></i> {{ 'Fill in' | translate }}
      </button>
      <div data-ng-if="eventPreviewCtrl.mode === 'fillin'">
        <a href="" class="text-warning" data-ng-disabled="eventPreviewCtrl.submitted"
           data-ng-click="eventPreviewCtrl.save(eventPreviewCtrl.form, 'save')"
           unsaved-warning-clear>{{ 'Save as draft' | translate }}</a>
        <button unsaved-warning-clear type="button"
                class="btn btn-success btn-raised"
                ng-disabled="!eventPreviewCtrl.eventSection.doc.eventType || eventPreviewCtrl.submitted"
                ng-if="!eventPreviewCtrl.eventSection.isQuickEvent()"
                ng-click="eventPreviewCtrl.save(eventPreviewCtrl.form, 'publish')"
                indicator="loading">
          <span>{{ eventPreviewCtrl.actionTitle }}</span>
        </button>
        <button unsaved-warning-clear type="button"
                class="btn btn-success btn-raised"
                ng-if="eventPreviewCtrl.eventSection.isQuickEvent()"
                ng-click="">
          {{ 'Turn into event' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/events/eventsection.view.html': `<div>

  <div kz-loading loaded="eventViewCtrl.loaded">
    <div class="wrapper">

      <header class="row" kz-reload obj="eventViewCtrl.eventSection">
        <div class="col-sm-8">
          <h1>
            <span kz-event-title event="eventViewCtrl.eventSection" event-id="{{eventViewCtrl.eventSection.doc._id}}" for-user="eventViewCtrl.eventSection.doc.eventOwner" show-version="true"></span>
          </h1>
        </div>

        <div class="col-sm-4 text-right">
          <p class="button-list">
            <kz-page-buttons actions="eventViewCtrl.actionButtons"></kz-page-buttons>
          </p>
        </div>
      </header>

      <event-section-header event-section="eventViewCtrl.eventSection"></event-section-header>
    </div>

    <div data-ng-if="eventViewCtrl.eventSection.loaded">
      <event-section-view event-section="eventViewCtrl.eventSection" no-edit="true"></event-section-view>
    </div>

    <div class="wrapper" ng-class="{'wrapper-highlighted': eventViewCtrl.extraIsExpanded}" data-ng-if="eventViewCtrl.eventSection.loaded && eventViewCtrl.commentAllowed">
      <event-section-extra
        event="eventViewCtrl.eventSection"
        display-options="{ collapsible: true, isExpanded: eventViewCtrl.extraIsExpanded, autoExpand: eventViewCtrl.scrollTo }">
      </event-section-extra>
    </div>
  </div>

</div>
`,
  'app/components/events/list.html': `<offline-limit></offline-limit>
<section class="wrapper">
  <header class="row">
      <kz-header actions="eventsCtrl.actions">
        <h1>{{ eventsCtrl.resolvedFilter.name || ('Timeline' | translate) }}</h1>
      </kz-header>
      <kz-simple-search list="eventsCtrl.list"></kz-simple-search>
      <kz-search-string list="eventsCtrl.list"></kz-search-string>
  </header>
  <kz-refine-filter list="eventsCtrl.list" refine-by="state"></kz-refine-filter>
</section>

<kz-list-view list="eventsCtrl.list" options="eventsCtrl.options">
  <event-group-slot item="item" options="options"></event-group-slot>
</kz-list-view>
`,
  'app/components/events/manage-timelines.html': `<section class="wrapper">
  <header class="row">
    <h1>{{ 'Manage timeline categories' | translate }}</h1>
  </header>
</section>

<div>
  <form name="ctrl.wrapperForm" aria-label="ctrl.wrapperForm" unsaved-warning-form>
    <div hidden id="timeline-categories-move-instructions">{{ 'Use the arrow up and down keys to move this timeline category' | translate }}</div>
    <div data-ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost' }">
      <div class="wrapper" id="section-{{ item.id }}" data-ng-repeat="item in ctrl.sections track by $index">
        <div class="row">
          <div class="col-xs-12">
            <div class="row">
              <div class="col-xs-8">
                <h2 class="heading-5">
                  {{ item.name || ('Unnamed' | translate) }} ({{ item.id }})
                </h2>
              </div>
              <div class="col-xs-4 button-list">
                <ul class="list-inline list-unstyled list-icon-actions">
                  <li><a href="" title="{{ 'Remove section' | translate }}" data-ng-click="ctrl.removeSection(item)" class="text-danger"><i class="icon-trash"></i></a></li>
                  <li>
                    <button type="button" class="btn-link text-success drag-handle" aria-label="Move {{ item.name || 'Unnamed' }}" aria-describedby="timeline-categories-move-instructions">
                      <i class="icon-move"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <form name="ctrl.forms[item.id || item.uid]">
              <div class="row">
                <div class="col-xs-12">
                  <formly-form class="event-basic-form" model="item" fields="ctrl.basicform.fields" form="ctrl.forms[item.id || item.uid]" aria-label="Timeline categories"></formly-form>
                </div>
              </div>

            </form>
          </div>

        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-xs-12">
          <button type="button" class="btn btn-info" ng-click="ctrl.add()">{{ 'Add a new category' | translate }}</button>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-xs-12">
          <button type="button" class="btn btn-success btn-raised"
            ng-click="ctrl.save()" unsaved-warning-clear indicator="loading">
            {{ 'Save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
`,
  'app/components/events/new.html': `<div kz-loading loaded="newEventCtrl.loaded">
  <offline-limit></offline-limit>

  <div class="wrapper">
    <header class="row">
      <div class="col-xs-12">
        <h1>{{ 'What would you like to create?' | translate }}</h1>
      </div>
      <div class="col-xs-12" ng-if="newEventCtrl.convertingADraft">
        <p class="box box-info">{{ 'You are turning a Quick note into an event. Want to create new event instead? Go' | translate }} <a router-link="['/events', 'new']">{{ 'here' | translate }}</a>.</p>
      </div>
    </header>

    <div class="row" ng-if="!newEventCtrl.eventTypeGroups">
      <div class="col-xs-12">
        <div class="box box-warning">
          {{ 'You cannot create any events' | translate }}{{ newEventCtrl.eventOwner === newEventCtrl.currentUser ? '' : (' for this user' | translate) }}!
        </div>
      </div>
    </div>
  </div>

  <div class="wrapper" ng-if="newEventCtrl.eventTypeGroups && group.eventTypes.length" ng-repeat="(eventTypeGroupId, group) in newEventCtrl.eventTypeGroups track by eventTypeGroupId">

    <div class="row" ng-if="newEventCtrl.hasMultipleEventTypeGroups">
      <div class="col-xs-12">
        <p>{{ group.name }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <ul class="list-unstyled">
          <li>
            <ul class="list-unstyled" ng-class="{'list-columns-2': group.eventTypes.length > 5}">
              <li ng-repeat="eventType in group.eventTypes">
                <a href="" ng-click="newEventCtrl.getRouteForEventType(eventType._id)">{{ eventType.name }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

  </div>

</div>
`,
  'app/components/events/partials/audit-log.include.html': `<div class="row">
  <div class="col-xs-12">
    <!-- Any better solution than this? That's the issue when you ng-include -->
    <kz-audit-log id="{{goalCtrl.auditLogId}}" dates="goalCtrl.goal.doc.dates" doc="goalCtrl.goal.doc" data-ng-if="goalCtrl.goal.doc.dates"></kz-audit-log>
    <kz-audit-log dates="eventCtrl.event.doc.dates" doc="eventCtrl.event.doc" data-ng-if="eventCtrl.event.doc.dates"></kz-audit-log>
    <kz-audit-log dates="eventPreviewCtrl.event.doc.dates" doc="eventPreviewCtrl.event.doc" data-ng-if="eventPreviewCtrl.event.doc.dates"></kz-audit-log>
    <kz-audit-log dates="event.doc.dates" doc="event.doc" data-ng-if="event.doc.dates"></kz-audit-log>
  </div>
</div>
`,
  'app/components/events/partials/event-filters-definition.html': `<form novalidate name="eventFilter" aria-label="Event filters">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title">
      <h4>{{ 'Define your filters' | translate }}</h4>
    </div>
  </div>
  <div class="modal-body">
    <div class="row" ng-repeat="filter_ in filters track by $index">
      <div class="col-xs-9 col-sm-10">
        <formly-form class="form--flex" model="filter_" fields="filterForms[$index].fields" aria-label="Define filter"></formly-form>
      </div>
      <div class="col-xs-3 col-sm-2">
        <p class="button-list">
          <a href="" class="btn btn-xs btn-border btn-danger" ng-click="removeFilter($index)">{{ 'Delete' | translate }}</a>
        </p>
      </div>
    </div>
    <p>
      <a href="" class="btn btn-xs btn-info" ng-click="addFilter()">{{ 'Add new filter' | translate }}</a>
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-raised" data-ng-disabled="eventFilter.$invalid" data-ng-click="save(eventFilter.$valid)">{{ 'Apply changes' | translate }}</button>
    <button type="button" class="btn btn-warning" data-ng-click="dismiss()">{{ 'Cancel' | translate }}</button>
  </div>
</form>
`,
  'app/components/events/partials/event-link-goals.html': `<form novalidate name="linkBlueprint" aria-label="Link blueprint">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
      <h4 id="myModalLabel">{{ options.title }}</h4>
      <div>{{ 'Any targets set to be link automatically will be linked upon submission' | translate }}</div>
    </div>
  </div>
  <div class="modal-body" style="height: 400px;">
    <simple-goals-list
      goals="suggestedGoals"
      options="opts"
      model="links"
      data-ng-if="!allGoalsShown"
    >
    </simple-goals-list>
    <div class="text-center">
      <button type="button" class="btn btn-primary btn-xs" data-ng-if="!allGoalsShown" data-ng-click="showAllGoals()">{{ 'Show all my goals' | translate }}</button>
    </div>
    <simple-goals-list
      goals="allGoals"
      options="options"
      model="links"
      data-ng-if="allGoalsShown"
    >
    </simple-goals-list>
    <div data-ng-if="!allGoals && allGoalsShown">{{ 'No open goals' | translate }}</div>
  </div>
  <div class="modal-footer text-right">
    <button type="button" class="btn btn-info" data-ng-click="dismiss()">{{ 'Cancel' | translate }}</button>
    <button type="button" class="btn btn-success btn-raised" data-ng-disabled="linkBlueprint.$invalid" data-ng-click="save()">{{ 'Confirm' | translate }}</button>
  </div>
</form>
`,
  'app/components/events/partials/event-section-next-responsible-update.html': `<form novalidate name="linkBlueprint" aria-label="Link blueprint">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
      {{ 'Update next responsible person' | translate }}
    </div>
  </div>
  <div class="modal-body" style="height: 400px;">
    <event-section-next class="col-xs-12"
      event-section="eventSection" form="form"
      def-section="nextDefSection"
      invitation-model="newInvitation"
      allow-fill-on-same-device="false"
      next-idx="0"
    ></event-section-next>
  </div>
  <div class="modal-footer text-right">
    <button type="button" class="btn btn-info" data-ng-click="dismiss()">{{ 'Cancel' | translate }}</button>
    <button type="button" class="btn btn-success btn-raised" data-ng-disabled="form.$invalid" data-ng-click="save()">{{ 'Confirm' | translate }}</button>
  </div>
</form>
`,
  'app/components/events/partials/reject-section.html': `<form novalidate name="sectionRejectionForm" aria-label="Mark goal">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
      <h4 id="myModalLabel">{{ 'Why would you like to reject this invitation?' | translate }}</h4>
      <div class="text-gray"></div>
    </div>
  </div>
  <div class="modal-body" style="height: 300px">
    <formly-form model="model" fields="form.fields" aria-label="Rejection Message Form"></formly-form>
  </div>
  <div class="modal-footer text-right">
    <button type="button" class="btn btn-info" data-ng-click="dismiss()">{{ 'Cancel' | translate }}</button>
    <button type="button" class="btn btn-success btn-raised" data-ng-disabled="sectionRejectionForm.$invalid" data-ng-click="rejectSection(sectionRejectionForm.$valid)">{{ 'Reject this invitation' | translate }}</button>
  </div>
</form>
`,
  'app/components/events/preview.html': `<div class="modal-header event-modal-header">
  <header class="row">
    <div class="col-sm-10">
      <h3>
        <span kz-event-title event="eventPreviewCtrl.event" event-id="{{eventPreviewCtrl.event.doc._id}}" for-user="eventPreviewCtrl.username"></span>
        {{ 'owned by' | translate }} <span epf-fullname user="eventPreviewCtrl.event.doc.user"></span>
      </h3>
      <a router-link="eventPreviewCtrl.event.route" target="_blank" unsaved-warning-clear ng-if="!eventPreviewCtrl.dryrun">
        {{ 'Open in a new tab' | translate }}
      </a>
    </div>

    <div class="col-sm-2 text-right">
      <p class="button-list">
        <button type="button" class="close" data-ng-click="eventPreviewCtrl.close()" aria-label="Close"><i class="icon-cancel"></i></button>
      </p>
    </div>
  </header>
</div>

<div class="modal-body event-modal-body">
  <div data-ng-if="eventPreviewCtrl.mode === 'read'">
    <event-header event="eventPreviewCtrl.event"></event-header>

    <div class="wrapper" data-ng-if="eventPreviewCtrl.availableViews.length > 1">
      <div class="row">
        <div class="col-sm-8">
          <p>{{ 'You have permissions to switch the view of this event. Click the following button to cycle through the options.' | translate }}</p>
        </div>
        <div class="col-sm-4 text-right">
          <ul class="list-unstyled list-inline">
            <li data-ng-repeat="view in eventPreviewCtrl.availableViews|filter: { id: '!' + eventPreviewCtrl.displayView} track by $index">
              <a href="" class="btn btn-xs btn-info btn-border" ng-click="eventPreviewCtrl.displayView = view.id">{{ view.label }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="wrapper" data-ng-if="eventPreviewCtrl.displayView !== 'default'">
      <event-report event="eventPreviewCtrl.event" report="{{eventPreviewCtrl.displayView}}"></event-report>
    </div>

    <div data-ng-if="eventPreviewCtrl.displayView === 'default'">
      <event-view event="eventPreviewCtrl.event" no-edit="true" parent="eventPreviewCtrl.parent"></event-view>
    </div>
  </div>

  <form novalidate name="eventPreviewCtrl.form" data-ng-if="eventPreviewCtrl.mode === 'fillin'">
    <div class="wrapper">
      <header class="row vertical-center-xs" data-ng-if="eventPreviewCtrl.options.allowBasicFormExtras || eventPreviewCtrl.options.allowLinking || eventPreviewCtrl.options.autosaveisEnabled">
        <div class="col-xs-6">
          <event-actions-header
            event-section="eventPreviewCtrl.eventSection"
            event-owner="eventPreviewCtrl.eventOwner"
            event-extras="eventPreviewCtrl.eventExtras"
            options="eventPreviewCtrl.options">
          </event-actions-header>
        </div>
        <div class="col-xs-6 text-right">
          <div>
            <ul class="list-inline list-unstyled">
              <li>
                <kz-last-saved ng-if="eventPreviewCtrl.options.autosaveisEnabled" info="eventPreviewCtrl.options.autoSaveInfo"></kz-last-saved>
              </li>
            </ul>
          </div>
        </div>
        <kz-auto-save-revisions ng-if="eventPreviewCtrl.options.autosaveisEnabled" info="eventPreviewCtrl.options.autoSaveInfo" id="eventPreviewCtrl.eventSection.doc._id"></kz-auto-save-revisions>
      </header>

      <div class="row" data-ng-if="eventPreviewCtrl.eventSection.loaded">
        <div class="col-sm-12">
          <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
        </div>
      </div>

      <div class="row" data-ng-if="eventPreviewCtrl.eventSection.loaded && eventPreviewCtrl.eventSection.doc.meta">
        <event-basic-form
          model="eventPreviewCtrl.eventSection.doc.meta"
          user="eventPreviewCtrl.eventSection.doc.eventOwner"
          section-data="eventPreviewCtrl.eventSection.data"
          read-only="false"
          form="eventPreviewCtrl.form">
        </event-basic-form>
      </div>
    </div>

    <div>
      <!-- Display sections -->
      <div class="wrapper" data-ng-show="eventPreviewCtrl.event.completedSections.length > 0" data-ng-repeat="section in eventPreviewCtrl.event.completedSections">
        <event-section-form
          section="section.section"
          event="eventPreviewCtrl.eventSection.originalEvent"
          def="section.def"
          options="{readOnly: true}"
          display-options="{ collapsible: true, isExpanded: $last }">
        </event-section-form>
      </div>
    </div>

    <div class="wrapper wrapper-highlighted" data-ng-if="eventPreviewCtrl.eventSection.currentDefSection">
      <kz-auto-save ng-if="eventPreviewCtrl.eventSection.loaded && eventPreviewCtrl.options.autosaveisEnabled" info="eventPreviewCtrl.options.autoSaveInfo" skip-initial-save="false"
        handle-save="eventPreviewCtrl.onAutosave()">
      </kz-auto-save>

      <div class="row">
        <section-response-form
          model="eventPreviewCtrl.eventSection.doc.data"
          doc-id="eventPreviewCtrl.eventSection.doc.event"
          def="eventPreviewCtrl.eventSection.currentDefSection"
          event-type="eventPreviewCtrl.eventSection.doc.eventType"
          for-user="eventPreviewCtrl.eventSection.doc.eventOwner"
          form="eventPreviewCtrl.form">
        </section-response-form>
      </div>

      <div class="row" data-ng-if="eventPreviewCtrl.showNextSection">
        <event-section-next event-section="eventPreviewCtrl.eventSection" form="eventPreviewCtrl.form"></event-section-next>
      </div>

      <div class="row" data-ng-if="eventPreviewCtrl.eventSection.doc.invitation.filledOnSameDevice">
        <section-response-form
          model="eventPreviewCtrl.eventSection.doc.nextSection"
          doc-id="eventPreviewCtrl.eventSection.doc.event"
          def="eventPreviewCtrl.eventSection.nextDefSection"
          event-type="eventPreviewCtrl.eventSection.doc.eventType"
          for-user="eventPreviewCtrl.eventSection.doc.eventOwner"
          form="eventPreviewCtrl.form">
        </section-response-form>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" data-ng-if="eventPreviewCtrl.actions.length || eventPreviewCtrl.secondaryActions.length || eventPreviewCtrl.canFillIn">
  <div class="row">
    <div class="col-sm-8">
      <kz-list-buttons data-ng-if="eventPreviewCtrl.secondaryActions.length && eventPreviewCtrl.mode === 'read'" class="" actions="eventPreviewCtrl.secondaryActions" use-contextual-menu="false"></kz-list-buttons>
    </div>
    <div class="col-sm-4 text-right">
      <kz-page-buttons data-ng-if="eventPreviewCtrl.actions.length"class="" actions="eventPreviewCtrl.actions" use-contextual-menu="false"></kz-page-buttons>
      <button class="btn btn-success btn-sm"
           data-ng-click="eventPreviewCtrl.switchMode('fillin')"
           data-ng-if="eventPreviewCtrl.canFillIn && eventPreviewCtrl.mode === 'read'">
        <i class="icon-edit"></i> {{ 'Fill in' | translate }}
      </button>
      <div data-ng-if="eventPreviewCtrl.mode === 'fillin'">
        <a href="" class="text-warning" data-ng-disabled="eventPreviewCtrl.submitted"
           data-ng-click="eventPreviewCtrl.save(eventPreviewCtrl.form, 'save')"
           unsaved-warning-clear>{{ 'Save as draft' | translate }}</a>
        <button unsaved-warning-clear type="button"
                class="btn btn-success btn-raised"
                ng-disabled="!eventPreviewCtrl.eventSection.doc.eventType || eventPreviewCtrl.submitted"
                ng-if="!eventPreviewCtrl.eventSection.isQuickEvent()"
                ng-click="eventPreviewCtrl.save(eventPreviewCtrl.form, 'publish')"
                indicator="loading">
          <span data-ng-if="!eventPreviewCtrl.eventSection.containsGoal">{{ 'Submit' | translate }}</span>
          <span
            data-ng-if="eventPreviewCtrl.eventSection.containsGoal">{{ 'Start goals' | translate }}</span>
        </button>
        <button unsaved-warning-clear type="button"
                class="btn btn-success btn-raised"
                ng-if="eventPreviewCtrl.eventSection.isQuickEvent()"
                ng-click="">
          {{ 'Turn into event' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/events/selecttags.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="eventsCtrl.actions">
        <h1>{{ 'Select tags' | translate }}</h1>
        <p class="text-gray">{{ 'Please select tags' | translate }}</p>
      </kz-header>
  </header>
</section>

<div class="wrapper">
  <div class="row">
    <div class="col-xs-12">
      <div class="row" ng-if="eventsCtrl.bulkTags">
        <kz-tree nodes="eventsCtrl.bulkTags.tree" options="eventsCtrl.bulkTags.options" ng-model="eventsCtrl.model.selected"></kz-tree>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/events/tearoff.html': `<div>
    <div class="box box-info text-center no-print">
      <i class="icon-info"></i>
      {{ 'To print this page, please press CTRL+P (Windows) or CMD+P (Mac)' | translate }}
    </div>

    <div data-ng-if="eventViewCtrl.event.loaded && eventViewCtrl.tokens.length > 0">
      <div class="wrapper" data-ng-repeat="token in eventViewCtrl.tokens track by token.url">
        <div class="row tearoff-box" data-ng-repeat="xx in [1, 2, 3, 4, 5, 6]">
          <div class="col-xs-6">
            <div class="tearoff-text">{{ 'Please visit the following URL in any web browser to provide your feedback for' | translate }} <strong class="text-primary" epf-fullname user="::eventViewCtrl.event.doc.user"></strong>.</div>
            <div class="tearoff-url"><strong>{{ token.url }}</strong></div>
          </div>
          <div class="col-xs-6">
            <div class="tearoff-text">{{ 'Please visit the following URL in any web browser to provide your feedback for' | translate }} <strong class="text-primary" epf-fullname user="::eventViewCtrl.event.doc.user"></strong>.</div>
            <div class="tearoff-url"><strong>{{ token.url }}</strong></div>
          </div>
      </div>
    </div>
</div>
`,
  'app/components/events/view.html': `<div id="event-view">

  <div class="wrapper">
    <header class="row" kz-reload obj="eventViewCtrl.event">
      <div class="col-sm-8">
        <h1>
          <span kz-event-title event="eventViewCtrl.event" event-id="{{eventViewCtrl.event.doc._id}}" for-user="eventViewCtrl.event.doc.user" show-version="true"></span>
        </h1>
      </div>

      <div class="col-sm-4 text-right">
        <p class="button-list">
          <kz-print-pdf-button class="btn btn-xs btn-border btn-info no-print" button-title="{{ 'Download PDF' | translate }}" dom-element="event-view" filename="{{eventViewCtrl.pdfUrl}}.pdf"></kz-print-pdf-button>
          <kz-page-buttons actions="eventViewCtrl.actionButtons"></kz-page-buttons>
        </p>
      </div>
    </header>

    <event-header ng-if="eventViewCtrl.event.loaded" event="eventViewCtrl.event" allow-actions="true"></event-header>
  </div>

  <div class="wrapper" data-ng-if="eventViewCtrl.availableViews.length > 1">
    <div class="row">
      <div class="col-sm-8">
        <p>{{ 'You have permissions to switch the view of this event. Click the following button to cycle through the options.' | translate }}</p>
      </div>
      <div class="col-sm-4 text-right">
        <ul class="list-unstyled list-inline">
          <li data-ng-repeat="view in eventViewCtrl.availableViews|filter: { id: '!' + eventViewCtrl.displayView} track by $index">
            <a href="" class="btn btn-xs btn-info btn-border" ng-click="eventViewCtrl.displayView = view.id">{{ view.label }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="wrapper" data-ng-if="eventViewCtrl.event.loaded && eventViewCtrl.displayView !== 'default'">
    <event-report event="eventViewCtrl.event" report="{{eventViewCtrl.displayView}}"></event-report>
  </div>

  <div data-ng-if="eventViewCtrl.event.loaded && eventViewCtrl.displayView === 'default'">
    <event-view event="eventViewCtrl.event"></event-view>
  </div>

  <div class="wrapper no-print" ng-class="{'wrapper-highlighted': eventViewCtrl.extraIsExpanded}" data-ng-if="eventViewCtrl.event.loaded && !eventViewCtrl.event.doc.linkedEvents">
    <event-section-extra
      event="eventViewCtrl.event"
      display-options="{ collapsible: true, isExpanded: eventViewCtrl.extraIsExpanded, autoExpand: eventViewCtrl.scrollTo }">
    </event-section-extra>
  </div>

</div>
`,
  'app/components/events/widgets/draft-list/edit.html': `<form role="form" aria-label="Edit event draft">
  <formly-form fields="eventDraftsEditCtrl.form.fields" model="config" form="form" aria-label="Edit draft"></formly-form>
</form>
`,
  'app/components/events/widgets/draft-list/view.html': `<div class="row drafts-list">
  <div class="events-group">
    <kz-list-view list="eventDraftsCtrl.list" options="eventDraftsCtrl.options">
      <event-section-slot event-section="item.main" use-compact-view="true" options="options"></event-section-slot>
    </kz-list-view>
  </div>
</div>
`,
  'app/components/events/widgets/new-draft/view.html': `<form name="draftForm" novalidate data-ng-if="newDraftCtrl.authorized" aria-label="New draft">
<p>
{{ 'Clicking save here will add this note onto the timeline as a draft' | translate }}
</p>
<div class="row">
  <div class="col-xs-12">
    <div class="form-group">
      <formly-form fields="newDraftCtrl.form.fields" model="newDraftCtrl.model" form="draftForm" aria-label="Draft"></formly-form>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-xs-12 button-list">
    <ul class="list-inline list-unstyled">
      <li><button type="button" class="btn btn-warning btn-sm btn-raised" data-ng-click="newDraftCtrl.save(draftForm)"><i class="icon-check"></i> {{ 'Save' | translate }}</button></li>
    </ul>
  </div>
</div>
</form>
`,
  'app/components/events/widgets/new-event/view.html': `<div data-ng-if="newEventCtrl.authorised">
    <div data-ng-if="newEventCtrl.isItForMySelf === undefined">
      <div class="row button-list">
        <div class="col-xs-12 text-center">
          <p>{{ 'First, select who you want to create this for:' | translate }}</p>
          <a class="btn btn-sm btn-success btn-raised" router-link="['/events/new']">{{ 'MySelf' | translate }}</a>
          <button type="button" class="btn btn-sm btn-warning btn-raised" data-ng-click="newEventCtrl.setIsItForMySelf(false)">{{ 'Someone else' | translate }}</button>
        </div>
      </div>
    </div>
  <form name="eventForm" novalidate data-ng-submit="newEventCtrl.save(eventForm)" data-ng-if="newEventCtrl.isItForMySelf === false" aria-label="New event">
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <formly-form model="newEventCtrl.model" fields="newEventCtrl.form.fields" form="eventForm" aria-label="Event"></formly-form>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 button-list">
        <ul class="list-inline list-unstyled">
          <li><button type="submit" class="btn btn-sm btn-success btn-raised"  data-ng-disabled="eventForm.$invalid"><i class="icon-check"></i> {{ 'Create' | translate }}</button></li>
        </ul>
      </div>
    </div>
  </form>
  <div class="row" data-ng-if="newEventCtrl.isItForMySelf === true || newEventCtrl.isItForMySelf === 'remote'">
    <div class="col-xs-12 text-center">
        <button type="button" class="btn btn-sm btn-success btn-raised" data-ng-click="newEventCtrl.create()">{{ 'Create' | translate }}</button>
    </div>
  </div>
  <div class="col-xs-12" data-ng-if="newEventCtrl.loading">
    <p class="text-center"><i class="icon-spin animate-spin"></i></p>
  </div>
</div>

<div data-ng-if="!newEventCtrl.authorised">
  {{ 'You are not authorised to use this widget.' | translate }}
</div>
`,
  'app/components/faqs/faq.slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-xs-12 faq">
      <h2 class="heading-4">{{ ::item.question }}</h2>
    </div>
  </div>
  <div data-ng-if="ctrl.shownAnswer">
    <div class="row">
      <div class="col-xs-12">
        <div data-ng-bind-html="item.answer | nl2br | a2nt | videoUrlToIframe" class="readonly"></div>
      </div>
    </div>
  </div>

  <kz-list-buttons actions="ctrl.actionButtons"></kz-list-buttons>
</div>
`,
  'app/components/faqs/form.html': `<form novalidate unsaved-warning-form name="form" aria-label="Edit faq">

  <div class="wrapper">

    <header class="row">
      <div class="col-sm-6">
        <h1>{{ 'Edit faq' | translate }}</h1>
      </div>
      <div class="col-sm-6">
        <p class="button-list">
          <button type="submit" class="btn btn-success btn-raised" data-ng-click="faqCtrl.save(form.$valid)">{{ 'Save' | translate }}</button>
          <button type="button" class="btn btn-info btn-raised" data-ng-click="faqCtrl.cancel()">{{ 'Cancel' | translate }}</button>
          <button type="button" class="btn btn-danger btn-raised" data-ng-if="faqCtrl.showDelete" data-ng-click="faqCtrl.remove()">{{ 'Delete' | translate }}</button>
        </p>
      </div>
    </header>

    <div class="row">
      <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
    </div>

    <div class="row" kz-loading loaded="faqCtrl.loaded">
      <div class="form-group col-sm-12" data-ng-class="{ 'has-error has-feedback': form.question.$invalid && formIsSubmitted}">
        <label for="question">{{ 'Question' | translate }} <i class="icon-star required" aria-label="star"></i></label>
        <input data-ng-model="faqCtrl.faq.question" type="text" id="question" name="question" class="form-control" data-ng-required="true" aria-describedby="questionStatus">

        <div data-ng-if="form.question.$invalid && formIsSubmitted">
          <span class="icon-attention form-control-feedback" aria-hidden="true"></span>

          <p id="questionStatus" class="help-block text-gray">{{ 'The question is required.' | translate }}</p>
        </div>
      </div>
      <div class="form-group col-sm-12" data-ng-class="{ 'has-error has-feedback': form.answer.$invalid && formIsSubmitted}">
        <label for="answer">{{ 'Answer' | translate }} <i class="icon-star required" aria-label="star"></i></label>
        <ng-quill-editor id="answer" ng-model="faqCtrl.faq.answer" toolbar="true" toolbar-entries="size bold list bullet italic underline strike align color background link image" link-tooltip="true" image-tooltip="true" editor-required="true" required="required" class="form-control wysiwyg-editor" error-class="input-error">
        </ng-quill-editor>
        <p class="text-gray">{{ 'You can also embed videos from Youtube or Vimeo by copy/pasting the video URL.' | translate }}</p>
        <div data-ng-if="form.answer.$invalid && formIsSubmitted">
          <span class="icon-attention form-control-feedback" aria-hidden="true"></span>

          <p id="answerStatus" class="help-block text-gray">{{ 'The answer is required.' | translate }}</p>
        </div>
      </div>
    </div>

  </div>

</form>
`,
  'app/components/faqs/list.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="faqsCtrl.actions"><h1>{{ 'FAQs' | translate }}</h1></kz-header>
      <kz-simple-search list="faqsCtrl.list"></kz-simple-search>
      <kz-search-summary list="faqsCtrl.list"></kz-search-summary>
  </header>
  <kz-refine-filter list="faqsCtrl.list"></kz-refine-filter>
</section>

<div kz-loading loaded="faqsCtrl.loaded">
  <kz-list-view list="faqsCtrl.list" options="faqsCtrl.options">
    <faq-slot item="item"></faq-slot>
  </kz-list-view>
</div>
`,
  'app/components/files/file-preview.html': `<div class="modal-header event-modal-header">
    <header class="row">
      <div class="col-sm-10">
        <h2>{{::name}}</h2>
      </div>
      <div class="col-sm-2 text-right">
        <button type="button" class="close" data-ng-click="dismiss()"><i class="icon-cancel"></i></button>
      </div>
    </header>
  </div>

  <div class="modal-body">
    TODO: Show preview here!
  </div>

  <div class="modal-footer">
    <div class="text-right">
      <button type="button" class="btn btn-primary" data-ng-click="dismiss()">{{ 'Close' | translate }}</button>
    </div>
  </div>
`,
  'app/components/files/file.slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-sm-9">
      <div class="file-slot__title">
        <i class="icon-big icon-{{ ctrl.fileIcon || 'file-archive'}}"></i>
        <div>
          <h2 class="entry-title">{{::ctrl.fileName}}</h2>
          <span ng-if="item.doc.fileinfo.size">{{::item.doc.fileinfo.size | fileSize}}</span>
          <span>{{::item.doc.extension | uppercase}}</span>
        </div>
      </div>
    </div>

    <div class="col-sm-3 col-right">
      <ul class="list-unstyled">
        <li>
          <span class="label label-default">created on: <span class="text-info" data-ng-bind="::item.doc.createdDate | date:ctrl.dateFormat"></span></span>
        </li>
        <li>
          <span class="label label-default">{{ 'linked to:' | translate }} <span class="text-info">{{::ctrl.eventTypeName}}</span></span>
        </li>
      </ul>
    </div>
  </div>

  <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons" left-slot-size="9"></kz-list-buttons>
</div>
`,
  'app/components/files/files.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="filesCtrl.actions">
        <h1>
          <span ng-if="filesCtrl.user"><span epf-fullname user="filesCtrl.user"></span>'s</span>
          {{ 'Files' | translate }}
        </h1>
      </kz-header>
      <kz-simple-search list="filesCtrl.list"></kz-simple-search>
  </header>
  <kz-search-string list="filesCtrl.list"></kz-search-string>
  <kz-refine-filter
    list="filesCtrl.list"
    refine-by="addedDate"
  ></kz-refine-filter>
</section>

<kz-list-view list="filesCtrl.list" options="filesCtrl.options">
  <file-slot item="item"></file-slot>
</kz-list-view>
`,
  'app/components/goals/cards/goalset.card.html': `<div style="padding-left: 15px; padding-right: 15px;">
  <ul class="item-list item-list-bordered" ng-if="list.ready && !list.isLoading">
    <li class="item row" ng-repeat="goal in list.items track by goal.doc._id">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12">
            <a router-link="goal.route" title="{{ 'View goal details' | translate }}">{{ ::goal.doc.title }}</a>
            <i class="icon-view" ng-if="goal.doc._id === options.current"></i>
          </div>
          <div class="col-xs-12">
            <kz-state map="GOALS_STATES" state="goal.state"></kz-state>
          </div>
        </div>
      </div>
    </li>
  </ul>

  <kz-pagination
    ng-if="list.ready && !list.isLoading && list.items.length"
    total="list.found_count"
    startkey="list.startkey"
    per-page="list.findOptions.limit"
    to="goToPage(page)">
  </kz-pagination>
</div>
`,
  'app/components/goals/cards/list.card.html': `<div>
  <div class="row row-bordered" ng-if="goalsEventTypeAvailable.length" ng-repeat="eventType in goalsEventTypeAvailable track by eventType._id">
    <div class="col-xs-12">
      <div class="col-xs-8">
        <p class="item-title">{{eventType.name}}</p>
      </div>
      <div class="col-xs-4 text-right">
        <button class="btn btn-xs btn-info" data-ng-click="createTmpEvent(eventType._id)">{{ 'Create' | translate }}</button>
      </div>
    </div>
  </div>
  <span ng-if="!goalsEventTypeAvailable.length">
    {{ 'There are currently no events for you to create on your timeline which contain goals.' | translate }}
  </span>
</div>
`,
  'app/components/goals/cards/target.linking.card.html': `<div>
  <div class="row">
    <div class="col-sm-12" ng-if="::target.minEventsToBeLinked > 0">
      <kz-progress-bar numerator="target.progress" denominator="::target.minEventsToBeLinked" obj-name="{{ 'links' | translate }}"></kz-progress-bar>
    </div>
    <div class="col-sm-12 text-info" ng-if="::target.minEventsToBeLinked === 0">
      {{target.linkedEvents.length}} {{ 'links' | translate }}
    </div>
  </div>
  <div class="row row-bordered"  data-ng-show="target.linkedEvents.length > 0" ng-if="target">
    <div class="col-sm-12">
      <ul class="list-unstyled">
        <li data-ng-repeat="item in target.linkedEvents track by $index">
          <div class="row">
            <div class="col-xs-10">
              <h6>{{item.name}}</h6>
              <div class="text-gray">{{ 'Occured on:' | translate }} {{item.startDate | date: dateFormat}}</div>
            </div>
            <div class="col-xs-2">
              <a href="" data-ng-click="remove(item.id)" class="text-danger"><i title="{{ 'Remove filter' | translate }}" class="icon-trash"></i></a>
            </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="row row-bordered" ng-if="target">
    <div class="col-sm-8">
      <p>
      <span ng-if="target.linkedEvents.length === 0">{{ 'No event selected' | translate }}</span>
      <span ng-if="target.linkedEvents.length === 1">{{ '1 event selected' | translate }}</span>
      <span ng-if="target.linkedEvents.length > 1">{{ target.linkedEvents.length }} {{ 'events selected' | translate }}</span>
      </p>
    </div>
    <div class="col-sm-4">
      <a href="" data-ng-if="target.linkedEvents.length > 0" data-ng-click="removeAll()" class="btn btn-xs btn-danger">{{ 'UnLink all' | translate }}</a>
    </div>
  </div>
</div>
`,
  'app/components/goals/directives/goal.slot.html': `<div class="goal-inner" data-ng-class="{'goal-no-targets': ctrl.targets.length === 0}">
  <div class="row">
    <div class="col-xs-9">
      <h2 class="entry-title">
        <i class="icon-level-down"></i>
        <a href="" data-ng-click="ctrl.showTargets = true" data-ng-if="!ctrl.showTargets" aria-label="{{ ('Show targets for' | translate) + ' ' + goal.doc.title }}"><i class="icon-plus"></i></a>
        <a href="" data-ng-click="ctrl.showTargets = false" data-ng-if="ctrl.showTargets" aria-label="{{ ('Hide targets for' | translate) + ' ' + goal.doc.title }}"><i class="icon-minus"></i></a>
        <a router-link="ctrl.viewLink" title="{{ 'View event details' | translate }}">{{ ::goal.doc.title }}</a>
        <span data-ng-if="ctrl.targets.length === 0">{{ '(n/a)' | translate }}</span>

        <!-- <i class="icon-link" ng-if="goal.linked.eventId"></i> -->
        <i class="icon-view" ng-if="goal.doc._id === options.current"></i>
      </h2>
    </div>
    <div class="col-xs-3">
      <div class="row text-right">
        <div class="hidden-xs col-sm-10" style="margin-right: -15px" ng-if="!options.hideTargetInfo && ctrl.state === 'inProgress' && ctrl.totals.type === 'ratio'">
          <kz-progress-bar description="{{goal.doc.title}}" numerator="ctrl.completedTargets" denominator="goal.targets.length" rate="ctrl.totals.value"><span></span></kz-progress-bar>
        </div>
        <div class="col-xs-12 col-sm-1" ng-if="!options.hideTargetInfo && ctrl.state === 'inProgress' && ctrl.totals.type === 'ratio'">
          <kz-percentage rate="ctrl.totals.value"></kz-percentage>
        </div>
        <div class="hidden-xs col-sm-10" style="margin-right: -15px" ng-if="!options.hideTargetInfo && ctrl.state === 'inProgress' && ctrl.totals.type === 'total'">
        </div>
         <div class="col-xs-12 col-sm-1" ng-if="!options.hideTargetInfo && ctrl.state === 'inProgress' && ctrl.totals.type === 'total'">
          <span class="text-info">{{ ctrl.totals.value }}</span>
        </div>
        <div class="col-xs-12" ng-if="ctrl.state !== 'inProgress'">
          <ul class="list-inline list-unstyled">
            <li>
              <kz-state map="ctrl.GOALS_STATES" state="ctrl.state"></kz-state>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="goal-inner__targets">
    <div class="goal-inner__target row" ng-repeat="target in ctrl.targets" data-ng-if="ctrl.showTargets">
      <div class="col-sm-9">
        <h2 class="entry-title">
          <i class="icon-level-down"></i>
          <a router-link="goal.route" title="{{ 'View event details' | translate }}">{{ target.doc.title || ('Linked events' | translate) }}</a>
          <i class="icon-link" ng-if="goal.linked.eventId"></i>
          <i class="icon-view" ng-if="goal.doc._id === options.current"></i>
        </h2>
      </div>
      <div class="col-sm-3 text-right-sm">
        <kz-progress-new
          ng-if="ctrl.progresses[target.id].max > 0"
          inline="true"
          show-bar="true"
          stats="fractional"
          completed="ctrl.progresses[target.id].progress"
          needed="ctrl.progresses[target.id].max">
        </kz-progress-new>
        <span class="text-info" ng-if="ctrl.progresses[target.id].max === 0">
          {{ctrl.progresses[target.id].progress}}
            <span data-ng-if="ctrl.progresses[target.id].progress > 0" class="text-success"><i class="icon-ok"></i></span>
        </span>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/goals/directives/goal.wrapper.html': `<div>
  <div class="wrapper-top progress-border" data-ng-class="ctrl.borderClass" class="col-xs-12 wrapper-top-inner" ng-if="templateType === 'pre'">
    <div class="row event">
      <div class="col-sm-7">
        <h5 class="entry-title">
          <i ng-class="{'icon-lock text-success': goal.goalSet.isClosed, 'icon-lock-open text-warning': !goal.goalSet.isClosed}"></i>
          <span class="text-gray"> {{goal.event.eventType.name || goal.doc.eventType_name || goal.eventType.name}}</span>
          <span class="label label-default" ng-if="goal.isPrivate()"> {{ 'PRIVATE' | translate }}</span>
          <event-section-next-update
            ng-if="goal.goalSet.isAutoCloseEnabled === true && ctrl.eventSection"
            event-section="ctrl.eventSection"
            next-def-section=""
          >
          </event-section-next-update>
        </h5>
        <div class="custom-fields">
          <div ng-repeat="field in goal.event.doc.featured">
            <b class="text-primary">{{field.label}}:</b> <span class="text-gray">{{field.text_value}}</span>
          </div>
        </div>
      </div>
      <div class="col-sm-5 text-right">
        <ul class="list-inline list-unstyled" data-ng-if="ctrl.loaded">
          <li ng-if="goal.doc.periods">
            <goalset-periods-select
              goal="goal"
              selected-period-id="ctrl.selectedPeriod">
            </goalset-periods-select>
          </li>
          <li>
            <p>
              <button ng-if="ctrl.tooltipHtml.length > 0" class="btn-link" type="button" uib-tooltip-html="ctrl.tooltipHtml" tooltip-placement="top" tooltip-trigger="'click outsideClick'" aria-label="{{ ('Toggle tooltip for' | translate) + ' ' + (goal.event.eventType.name || goal.doc.eventType_name || goal.eventType.name) }}">
                <i class="icon-info"></i>
              </button>
              <span class="label" ng-class="{'label-danger': ctrl.overdueAndNotClosed, 'label-default': !ctrl.overdueAndNotClosed}">{{ 'Due date:' | translate }}</span>&nbsp
              <span class="label" ng-class="{'label-danger': ctrl.overdueAndNotClosed, 'label-info': !ctrl.overdueAndNotClosed}">{{goal.doc.dueDate | date: ctrl.dateFormat}}</span>
            </p>
          </li>
       </ul>
      </div>
    </div>
  </div>
  <div ng-if="templateType === 'pre' && goal.goalSet.canAutoClose && goal.goalSet.errorMessage.autoClose" class="alert-danger text-danger" style="padding-left:10px">
    <i class="icon-warning"></i> {{ 'An error occured while auto closing this goalset:' | translate }} {{goal.goalSet.errorMessage.autoClose}}
  </div>

  <div data-ng-if="templateType === 'post'">
    <div class="col-xs-12 wrapper-bottom-inner">
      <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons" left-slot-size="7"></kz-list-buttons>
    </div>
  </div>
</div>
`,
  'app/components/goals/directives/goal.wrapper.no-featured.html': `<div>
    <div class="wrapper-top progress-border" data-ng-class="ctrl.borderClass" class="col-xs-12 wrapper-top-inner" ng-if="templateType === 'pre'">
        <div class="row event">
        <div class="col-sm-7">
            <h2 class="entry-title">
            <span class="text-gray"> {{goal.event.eventType.name || goal.doc.eventType_name}}</span>
            <span class="label label-default" ng-if="goal.isPrivate()"> {{ 'PRIVATE' | translate }}</span>
            </h2>
        </div>
        <div class="col-sm-5 text-right">
            <ul class="list-inline list-unstyled" data-ng-if="ctrl.loaded">
            <li ng-if="goal.doc.periods">
                <goalset-periods-select
                goal="goal"
                selected-period-id="ctrl.selectedPeriod">
                </goalset-periods-select>
            </li>
            <li>
              <p>
                <span class="label" ng-class="{'label-danger': ctrl.overdueAndNotClosed, 'label-default': !ctrl.overdueAndNotClosed}">{{ 'Due date:' | translate }}</span>&nbsp
                <span class="label" ng-class="{'label-danger': ctrl.overdueAndNotClosed, 'label-info': !ctrl.overdueAndNotClosed}">{{goal.doc.dueDate | date: ctrl.dateFormat}}</span>
              </p>
            </ul>
        </div>
        </div>
    </div>

    <div data-ng-if="templateType === 'post' && goal.doc._id === goal.lastGoalId">
        <div class="col-xs-12 wrapper-bottom-inner">
        <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons" left-slot-size="7"></kz-list-buttons>
        </div>
    </div>
</div>
`,
  'app/components/goals/directives/goals.define.filter.measurements.html': `<div class="ub-box">
  <div class="ub-box__header ub-box__header--transparent">
    <h4>{{ 'How many do you want to achieve' | translate }}</h4>
  </div>
  <div class="ub-box__content">
    <div ng-repeat="filterMeasurement in measurements track by $index">
      <formly-form class="form--flex" model="filterMeasurement" fields="ctrl.filterMeasurementForms[$index].fields" options="options" aria-label="{{ 'Goal achievement measurement' | translate }}"></formly-form>
    </div>
  </div>
</div>
`,
  'app/components/goals/directives/goals.define.html': `<div class="row">
  <div class="col-xs-12">
    <div class="col-xs-10"></div>
    <button type="button" class="btn btn-xs btn-primary col-xs-2" ng-click="ctrl.collapseAllGoals()" ng-if="model.length !== 0">{{ 'Collapse All' | translate }}</button>
    <div hidden id="goal-move-instructions">{{ 'Use the arrow up and down keys to move this goal' | translate }}</div>
    <div hidden id="target-move-instructions">{{ 'Use the arrow up and down keys to move this target' | translate }}</div>
    <div class="row" data-ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost' }">
      <div class="col-xs-12" ng-repeat="goal in model track by goal._id" ng-if="(!include && !exclude) || include.indexOf(goal._id) > -1 || exclude.indexOf(goal._id) === -1">
        <div class="ub-box ub-box--dotted">
          <div class="ub-box__header">
            <div>{{ 'Goal #' | translate }}{{ $index + 1 }} <span ng-if="goal.title">- {{goal.title}}</span></div>
            <div>
              <ul class="list-inline list-unstyled list-icon-actions">
                <li>
                  <a href ng-click="ctrl.linkBlueprint(goal)" ng-if="canLinkBlueprints && ctrl.isBlueprintTagToGoalsActive">
                    <i title="{{ 'Link Blueprint' | translate }}" class="icon-link"></i> <span ng-if="goal.linkedBlueprint">(1)</span>
                  </a>
                </li>
                <li>
                  <button type="button" class="btn-link text-info drag-handle" aria-label="{{ 'Move goal' | translate }}" aria-describedby="goal-move-instructions">
                    <i class="icon-move"></i>
                  </button>
                </li>
                <li>
                  <a href="" data-nodrag ng-click="ctrl.showGoal(goal._id)" ng-if="!ctrl.goalsShown[goal._id]">
                    <i title="{{ 'Show Goal' | translate }}" class="icon-plus"></i>
                  </a>
                </li>
                <li>
                  <a href="" data-nodrag ng-click="ctrl.hideGoal(goal._id)" ng-if="ctrl.goalsShown[goal._id]">
                    <i title="{{ 'Hide Goal' | translate }}" class="icon-minus"></i>
                  </a>
                </li>
                <li>
                  <a href="" ng-click="ctrl.remove('goal', model, goal._id)" ng-if="(!editMode && !readonly) && (!atLeastOne || (atLeastOne && $index !== 0))">
                    <i title="{{ 'Remove Goal' | translate }}" class="icon-trash"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="ub-box__content"  data-ng-if="ctrl.goalsShown[goal._id]">
            <formly-form model="goal" fields="ctrl.goalForms[goal._id].fields" options="options" aria-label="{{ 'Define goal' | translate }}"></formly-form>

            <div class="row">
              <div class="col-xs-12">

                <h2 class="heading-4">{{ 'Targets' | translate }}</h2>
                <p class="text-gray">
                  {{ 'Targets break down goals into smaller objectives. It is possible to have multiple targets attached to a single goal.' | translate }}
                </p>
                <div class="row" data-ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost' }">
                  <div class="col-xs-12"  ng-repeat="target in goal.targets track by target._id">
                    <form novalidate unsaved-warning-form name="ctrl.targetForms[target._id]" aria-label="{{ 'Define goal target' | translate }}">
                      <div class="col-xs-12" data-ng-if="goal.targets.length" data-ng-include="'app/components/goals/partials/define-target.html'"></div>
                    </form>
                  </div>
                </div>

                <button type="button" class="btn btn-xs btn-primary" ng-click="ctrl.add('target', goal.targets)" ng-if="!readonly && goal.targets.length === 0">{{ 'Add goal target (optional)' | translate }}</button>

              </div>
            </div>
          </div>
        </div>
        <div class="ub-box__footer text-center" data-ng-if="$last && !readonly && !editMode" >
          <button type="button" class="btn btn-xs btn-info" ng-click="ctrl.add('goal', model)"><i title="{{ 'Add another goal' | translate }}" class="icon-plus"></i> {{ 'Add another goal' | translate }}</button>
        </div>
      </div>
      <div class="col-xs-12" data-ng-if="!model || model.length === 0 || (exclude.length > 0 && exclude.length === model.length)">
        <button type="button" class="btn btn-xs btn-primary" ng-click="ctrl.add('goal', model)" ng-if="!editMode && !readonly">{{ 'Add Goal' | translate }}</button>
      </div>
    </div>
  </div>
  <div class="col-xs-12" ng-if="readonly && (!model || model.length === 0)">
    <span class="text-warning">{{ 'No goals have been defined' | translate }}</span>
  </div>
</div>
`,
  'app/components/goals/directives/goals.define.period.measurements.html': `<div class="ub-box">
  <div class="ub-box__header ub-box__header--transparent">
    <h5>{{ 'Periods Measurements' | translate }}</h5>
  </div>
  <div class="ub-box__content">
    <div class="ub-box ub-box--dotted" ng-repeat="periodMeasurement in measurements track by $index">
      <div class="ub-box__header ub-box__header--transparent">
        <h6>{{ 'Period' | translate }}</h6>
        <ul class="list-inline list-unstyled list-icon-actions" data-ng-if=" !options.formState.readOnly">
          <li><a href="" data-ng-click="ctrl.removePeriodMeasurement($index)"><i title="{{ 'Remove this period\'s filters' | translate }}" class="icon-trash"></i></a></li>
        </ul>
      </div>
      <div class="ub-box__content">
        <formly-form data-ng-if="!options.formState.readOnly" model="periodMeasurement" fields="ctrl.periodMeasurementForms[$index].fields" options="options" aria-label="{{ 'Period measurement' | translate }}"></formly-form>
        <kz-readonly-form data-ng-if="options.formState.readOnly" fields="ctrl.periodMeasurementForms[$index].fields" model="periodMeasurement" options="{passTemplateOptions: true}"></kz-readonly-form>
        <goals-define-filter-measurements
          measurements="periodMeasurement.filterMeasurements"
          ng-if="periodMeasurement.filterMeasurements"
          options="options"
        >
        </goals-define-filter-measurements>
      </div>
    </div>
    <button type="button" class="btn btn-xs btn-border btn-success" data-ng-click="ctrl.addPeriodMeasurement()" data-ng-if=" !options.formState.readOnly">
      <i title="{{ 'Define more Period' | translate }}" class="icon-plus"></i> {{ 'Define more periods' | translate }}
    </button>
  </div>

</div>
`,
  'app/components/goals/directives/goals.field.html': `<div class="row">
  <div class="col-xs-12">
    <div ng-if="def.predefinedGoals.length">
      <goalset-periods
        model="model"
        readonly="!def.arePredefinedGoalsRedefinable"
      >
      </goalset-periods>

      <div class="goal-targets">
        <goals-define model="model.definitions" readonly="true" include="ctrl.predefinedGoalsIds" ng-if="!def.arePredefinedGoalsRedefinable" event-type-id="def.eventTypeId" goal-set-periods="model.periods"></goals-define>
        <goals-define model="model.definitions" edit-mode="true" include="ctrl.predefinedGoalsIds" ng-if="def.arePredefinedGoalsRedefinable" event-type-id="def.eventTypeId" goal-set-periods="model.periods"></goals-define>
      </div>
    </div>

    <div data-ng-if="def.customsSettings.canAddCustoms">
      <h4>{{ 'Custom goals' | translate }}</h4>
      <p class="text-gray">
        {{ 'Here you are able to create a set of custom goals. Enter a goal title to begin and then optionally attach a target for this goal.' | translate }}
      </p>
      <div class="goal-targets">
        <goals-define model="model.definitions" at-least-one="def.predefinedGoals.length === 0" exclude="ctrl.predefinedGoalsIds" event-type-id="def.eventTypeId" goal-set-periods="model.periods"></goals-define>
      </div>
    </div>

    <formly-form model="model" fields="ctrl.dueDateForm.fields" options="options" form="form" aria-label="{{ 'Due date' | translate }}"></formly-form>
  </div>
</div>
`,
  'app/components/goals/directives/goalset.periods.html': `<div class="row">
  <div class="col-xs-12">
    <div hidden id="goal-period-move-instructions">{{ 'Use the arrow up and down keys to move this goal period' | translate }}</div>
    <div data-ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost' }">
      <div class="ub-box" ng-repeat="item in model.periods track by $index">
        <div class="ub-box__header ub-box__header--transparent">
          <h5>{{ 'Period' | translate }}</h5>
          <ul class="list-inline list-unstyled list-icon-actions">
            <li>
              <button type="button" class="btn-link text-info drag-handle" aria-label="{{ 'Move period' | translate }}" aria-describedby="goal-period-move-instructions">
                <i class="icon-move"></i>
              </button>
            </li>
            <li>
              <a href="" ng-click="ctrl.removePeriod($index)" ng-if="!readonly">
                <i title="{{ 'Remove period' | translate }}" class="icon-trash"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="ub-box__content">
          <formly-form
            model="item"
            fields="ctrl.periodForms[$index].fields"
            options="options"
            aria-label="{{ 'Period' | translate }}"
          ></formly-form>
        </div>
      </div>
    </div>
    <button type="button" class="btn btn-xs btn-primary" ng-click="ctrl.addPeriod()" ng-if="!readonly">{{ 'Add period' | translate }}</button>
  </div>
</div>
`,
  'app/components/goals/directives/goalset.periods.select.html': `<ul class="list-inline list-unstyled list-no-right-padding">
  <li><span class="label label-default">{{ 'Period:' | translate }}</span></li>
  <li ng-repeat="period in goal.doc.periods">
    <button class="btn-link list__filter" ng-class="{ 'list__filter--active': selectedPeriodId === period._id }" ng-click="selectPeriod(period._id)" aria-pressed="{{selectedPeriodId === period._id}}">{{period.name}}</button>
  </li>
  <li ng-if="goal.targetsByPeriods.others || goal.hasOneTargetWithoutPeriod">
    <button class="btn-link list__filter" ng-class="{ 'list__filter--active': selectedPeriodId === '__others__' }" ng-click="selectPeriod('__others__')" aria-pressed="{{selectedPeriodId === '__others__'}}">{{ 'Others' | translate }}</button>
  </li>
</ul>
`,
  'app/components/goals/directives/simple-goals-list.html': `<div>
  <div class="row" data-ng-if="ctrl.options.showSearch" style="padding-bottom: 20px">
    <div class="col-xs-12" >
      <span><input class="facetly-searchbox" style="width: 300px" type="search" ng-model="ctrl.searchTerm" placeholder="{{ 'Start typing to search...' | translate }}"/></span>
      <span><button type="button" class="facetly-button facetly-button-success" ng-click="ctrl.search(ctrl.searchTerm)">{{ 'Search' | translate }}</button></span>
      <span><button type="button" class="facetly-button facetly-button-danger" ng-click="ctrl.clearSearch()" data-ng-show="ctrl.searchTerm">{{ 'Clear' | translate }}</button></span>
    </div>
  </div>
  <div class="row" data-ng-if="goals">
    <div class="col-sm-12" data-ng-repeat="goal in ctrl.list.items track by $index">
      <div class="row bg-gray-300 text-gray-700 " ng-if="ctrl.list.items[$index - 1].doc.eventId !== goal.doc.eventId && (ctrl.options.showGoalSetName || goal.doc.periods)">
        <div class="col-md-12" ng-if="ctrl.options.showGoalSetName"
             ng-class="{'font-bold': goal.event.eventType.name.toLowerCase().includes(ctrl.searchTermToHighlight)}" >
          <span>{{goal.event.eventType.name}}</span>
        </div>
        <div class="col-md-12 text-right" data-ng-if="goal.doc.periods">
            <goalset-periods-select goal="goal"></goalset-periods-select>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-7">
          <input type="checkbox" ng-model="ctrl.model[goal.doc._id]" data-ng-if="ctrl.options.linkType === 'goal'"/>
          <span class="entry-title">
            <a router-link="goal.route"
               ng-class="{'font-bold': goal.doc.title.toLowerCase().includes(ctrl.searchTermToHighlight)}">
              {{ ::goal.doc.title }}
            </a>
          </span>
        </div>
        <div class="col-xs-5 text-right">
          <ul class="list-inline list-unstyled">
            <li>
            </li>
            <li data-ng-if="goal.totals.type === 'total' && goal.doc.state !== 'inProgress' && !goal.doc.state" class="text-info">
              {{goal.totals.value}}
            </li>
            <li data-ng-if="goal.totals.type === 'ratio' && goal.doc.state !== 'inProgress' && !goal.doc.state">
              <kz-percentage rate="goal.totals.value"></kz-percentage>
            </li>
            <!-- Mixed targets (type === 'mixed') intentionally render nothing. -->
            <li data-ng-if="goal.doc.state !== 'inProgress' && goal.doc.state">
              <kz-state map="ctrl.goalsStates" state="goal.state"></kz-state>
            </li>
          </ul>
        </div>
      </div>
      <div class="row" data-ng-repeat="target in goal.targets track by target.doc._id" data-ng-if="ctrl.options.showTargets">
        <div class="col-xs-12">
          <h5 class="entry-title text-gray">
            <i class="icon-level-down"></i>
            <span ng-if="ctrl.options.linkType === 'target'">
              <input type="checkbox" ng-model="ctrl.model[goal.doc._id + '|' + target.id + '|' + goal.event.eventType.versionGroupId]"/>
            </span>
            <span target-title target="::target"
                  ng-class="{'font-bold': target.title.toLowerCase().includes(ctrl.searchTermToHighlight)}">
                </span>
            <span data-ng-if="ctrl.options.highlightObjs.indexOf(target.id) > -1"><i class="icon-star" style="color: gold"></i></span>
          </h5>
        </div>
      </div>
    </div>
  </div>
  <div class="alert alert-info" data-ng-if="ctrl.options.linkType && ctrl.list.items.length === 0">
    <i class="icon-info"></i> {{ 'There is nothing available for you to link to' | translate }}
  </div>
</div>
`,
  'app/components/goals/directives/target-filter-popup.html': `<div class="modal-header">
  <button type="button" class="close" data-ng-click="ctrl.dismiss()" aria-label="{{ 'Close' | translate }}"><i class="icon-cancel"></i></button>
  <div class="modal-title">
    <h3>{{ 'How events are linked' | translate }}</h3>
  </div>
</div>

<div class="modal-body">
  <p class="box box-info">{{ 'When events meet the following criteria, they will be linked toward your goal targets and count towards your goal progress.' | translate }}</p>
  <div ng-repeat="(filterName, targetFilters) in ctrl.filtersByName">
    <h4 ng-if="ctrl.isProgressDifferent">{{filterName}} {{ 'Filters' | translate }}</h4>
    <h4 ng-if="!ctrl.isProgressDifferent">{{ 'Linking and Progress Filters' | translate }}</h4>
    <target-filters-description target-filters="targetFilters"></target-filters-description>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-info" data-ng-click="ctrl.dismiss()">{{ 'Close' | translate }}</button>
</div>
`,
  'app/components/goals/directives/target.filters.description.html': `<p>
  <div ng-repeat="subFilters in filters">
    <b data-ng-if="!$first" class="text-info" style="padding-left: 20px"><i></i> {{ 'AND' | translate }} </b>
    <div ng-repeat="prgFilter in subFilters">
      <b data-ng-if="!$first" class="text-info" style="padding-left: 20px"><i></i> {{ 'OR' | translate }} </b>
      <span data-ng-if="$first">{{ 'The' | translate }}</span><span data-ng-if="!$first">{{ 'the' | translate }}</span>
      <b>{{ prgFilter.key }}</b>
      <span ng-repeat="orfilters in prgFilter.values">
        <span ng-repeat="filter in orfilters">
          <b data-ng-if="$index > 0" class="text-info"> {{ 'OR' | translate }} </b>
          <span>{{ humanReadableConditions[filter.condition] }}</span>
          <span class="text-primary" kz-form-title item="filter.value" type="{{ filter.kzType }}" separator="OR" show-href="filter.showHref" ng-if="!filter.route"></span>
          <a router-link="filter.route" target="_blank" ng-if="filter.route">
            <span kz-form-title item="filter.value" type="{{ filter.kzType }}" separator="OR" ></span>
          </a>
        </span>
        <b data-ng-if="!$last" class="text-info"> {{ 'AND' | translate }} </b>
      </span>
    </div>
  </div>
</p>
`,
  'app/components/goals/directives/target.linkedEvents.html': `<div kz-loading loaded="targetLinkedEventsCtrl.loaded">
  <h4>{{ 'Links matching this target' | translate }}</h4>
  <kz-list-view list="targetLinkedEventsCtrl.countableList" options="targetLinkedEventsCtrl.options">
    <event-section-slot data-ng-if="item.doc.type === 'eventSection'" event-section="item" options="options"></event-section-slot>
    <event-slot data-ng-if="item.doc.type === 'event'" event="item" options="options"></event-slot>
  </kz-list-view>

  <div data-ng-show="targetLinkedEventsCtrl.othersList.items.length > 0">
    <h4>{{ 'Other links' | translate }}</h4>
    <kz-list-view list="targetLinkedEventsCtrl.othersList" options="targetLinkedEventsCtrl.options">
      <event-section-slot data-ng-if="item.doc.type === 'eventSection'" event-section="item" options="options"></event-section-slot>
      <event-slot data-ng-if="item.doc.type === 'event'" event="item" options="options"></event-slot>
    </kz-list-view>
  </div>

  <div ng-if="targetLinkedEventsCtrl.target.linkedEvents.length && targetLinkedEventsCtrl.loaded && (targetLinkedEventsCtrl.deletedCount !== 0 || targetLinkedEventsCtrl.privatesCount !== 0)">
     <p class="text-gray text-center text-warning">
      <i class="icon-warning"></i>
       <span data-ng-if="targetLinkedEventsCtrl.isOwn">
         {{ targetLinkedEventsCtrl.deletedCount }} {{ targetLinkedEventsCtrl.deletedCount === 1 ? ('previously linked event has been deleted.' | translate) : ('previously linked events have been deleted.' | translate) }}
       </span>
       <span data-ng-if="!targetLinkedEventsCtrl.isOwn">
         <span data-ng-if="targetLinkedEventsCtrl.privatesCount">
           {{ targetLinkedEventsCtrl.privatesCount }} {{ targetLinkedEventsCtrl.privatesCount === 1 ? ('event is private' | translate) : ('events are private' | translate) }}
         </span>
         <span data-ng-if="targetLinkedEventsCtrl.privatesCount && targetLinkedEventsCtrl.deletedCount"> {{ 'and' | translate }} </span>
         <span data-ng-if="targetLinkedEventsCtrl.deletedCount">
           {{ targetLinkedEventsCtrl.deletedCount }} {{ targetLinkedEventsCtrl.deletedCount === 1 ? ('previously linked event has been deleted.' | translate) : ('previously linked events have been deleted.' | translate) }}
         </span>
       </span>
    </p>
  </div>
</div>
`,
  'app/components/goals/directives/target.slot.html': `<section class="wrapper">
  <div class="row">

    <div class="col-sm-9" data-ng-class="{'col-sm-12': !ctrl.showActionButtons}">
      <h5 class="entry-title text-gray">
        <i class="icon-level-down"></i>
        <span class="text-info" style="font-size: 16px" target-title target="::target" options="ctrl.targetTitleOptions"></span>
      </h5>

      <div class="col-sm-12" ng-if="target.progress.max > 0">
        <kz-progress-bar description="{{ target.doc.title + ' ' + ('progress' | translate) }}" numerator="target.progress.progress" denominator="target.progress.max">
          <span>{{ target.progress.progress }} {{ 'of' | translate }} {{ target.progress.max }}</span>
          <span class="text-gray" data-ng-if="target.progress.other">{{ 'and' | translate }} <span ng-if="target.progress.other === 1">{{ '1 other link' | translate }}</span><span ng-if="target.progress.other > 1">{{ target.progress.other }} {{ 'other links' | translate }}</span></span>
          <button class="btn-link text-info" ng-click="ctrl.showFilters()"><i class="icon-info"></i> {{ 'How are events linked?' | translate }}</button>
        </kz-progress-bar>
      </div>
      <div class="col-sm-12 text-info" ng-if="target.progress.max === 0">
        {{ target.progress.progress }}<span data-ng-if="target.progress.progress > 0" class="text-success"><i class="icon-ok"></i></span>
        <button class="btn-link text-info" ng-if="target.doc.conditions.length > 0" ng-click="ctrl.showFilters()"><i class="icon-info"></i> {{ 'How are events linked?' | translate }}</button>
      </div>
    </div>

    <div class="col-sm-3 text-right" data-ng-if="ctrl.showActionButtons">
      <div class="row buttons">
        <ul class="list-inline list-unstyled">
          <li>
            <div class="btn-group">
              <button type="button" class="btn btn-xs btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-controls="link-action-menu">
                <i class="icon-link"></i>
                {{ 'Link event to this target' | translate }}
                <span class="caret"></span>
              </button>
              <ul id="link-action-menu" class="dropdown-menu">
                <li><a router-link="['/goals/targets/link', target.goal.doc._id, target._id, target.periodId]">{{ 'Select existing event' | translate }}</a></li>
                <li ng-if="ctrl.eventTypeLinks.length" role="separator" class="divider"></li>
                <li ng-if="ctrl.eventTypeLinks.length && !ctrl.eventTypeLinks[0].isNew" class="dropdown-header">{{ 'Create new' | translate }}</li>
                <li ng-if="ctrl.eventTypeLinks.length" ng-repeat="link in ctrl.eventTypeLinks">
                  <a router-link="['/events/new']" router-state="link.args" data-ng-if="!link.args.eventTypeId">{{link.name}}</a>
                  <a router-link="['/events/new-section', link.args.eventTypeId]" router-state="link.args" data-ng-if="link.args.eventTypeId">{{link.name}}</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 text-center">
      <button type="button" ng-click="ctrl.shownLinkedEvents = !ctrl.shownLinkedEvents" class="btn btn-link btn-sm text-info">
        <span ng-if="!ctrl.shownLinkedEvents">
          {{ 'Show more' | translate }} <i class="icon-down-open-big"></i>
        </span>
        <span ng-if="ctrl.shownLinkedEvents">
          {{ 'Show less' | translate }} <i class="icon-up-open-big"></i>
        </span>
      </button>
    </div>
  </div>

  <div class="row audit-log" data-ng-if="ctrl.shownLinkedEvents">
    <target-linked-events target="target" options="options"></target-linked-events>
  </div>
</section>
`,
  'app/components/goals/directives/target.title.html': `<span>
  <span ng-if="target.doc.title">
    <span>{{target.doc.title}}</span>
    <div class="text-gray" ng-if="target.conditions.length && opts.showDescription">
      {{ 'To demonstrate progress you should be linking' | translate }}
      <span ng-repeat="condition in target.conditions">
        <span ng-repeat="filter in condition.filters">
          <span ng-if="$index > 0">, </span>
          <!-- <strong>{{filter.dataType | separateByUppercase}}: </strong> -->
          <span data-ng-switch="filter.dataType">
            <span class="font-bold text-info text-pad-left" data-ng-switch-when="eventType_versionGroupId" kz-event-type-group-title event-type-group="filter.value"></span>
          </span>
        </span>
      </span>
    </div>
  </span>
  <span ng-if="!target.doc.title">
    <span ng-if="!target.conditions.length">{{ 'Linked events' | translate }}</span>
    <span ng-if="target.conditions.length">
      <span data-ng-if="includeGoal">{{:: target.goal.doc.title}} - </span>
      <span ng-repeat="condition in target.conditions">
        <span>
          <span ng-if="$index > 0">{{ 'OR' | translate }} </span>
          <span ng-repeat="filter in condition.filters">
            <span ng-if="$index > 0">, </span>
            <!-- <strong>{{filter.dataType | separateByUppercase}}: </strong> -->
            <span data-ng-switch="filter.dataType">
              <span data-ng-switch-when="blueprint" kz-form-title item="filter.value" type="tree" kzType="tree" watch="true"></span>

              <span data-ng-switch-when="eventType_versionGroupId" kz-event-type-group-title event-type-group="filter.value"></span>
              <span data-ng-switch-default kz-form-title item="filter.value" type="date"></span>
            </span>
          </span>
        </span>
      </span>
    </span>
  </span>
</span>
`,
  'app/components/goals/goal.html': `<section class="wrapper" ng-if="goalCtrl.goal">
  <header class="row">
    <div class="col-sm-7">
      <h1>{{::goalCtrl.goal.doc.title}}</h1>
    </div>
    <div class="col-sm-5 button-list" ng-if="goalCtrl.goal" style="padding-top: 15px;">
      <kz-list-buttons actions="goalCtrl.actionButtons" left-slot-size="12"></kz-list-buttons>
    </div>
  </header>
  <div class="row audit-log" data-ng-if="goalCtrl.shownDescription"
    data-ng-include="'app/components/events/partials/audit-log.include.html'"></div>
  <div class="row" ng-if="goalCtrl.isMarkStepEnabled">
    <div
      ng-class="{'col-sm-6': !goalCtrl.goal.isSetClosed(), 'col-sm-12': goalCtrl.goal.isSetClosed() || goalCtrl.goal.avgRate === undefined }">
      <p>
        <span ng-show="goalCtrl.goal.isResolved()">
          {{ 'This goal has been marked as' | translate }}
          <span
            class="badge badge-{{goalCtrl.GOALS_STATES[goalCtrl.goal.state].labelStyle}}">{{goalCtrl.GOALS_STATES[goalCtrl.goal.state].name}}</span>
        </span>
        <span ng-show="!goalCtrl.goal.isResolved()">
          {{ 'This goal is' | translate }} <kz-state map="goalCtrl.GOALS_STATES" state="goalCtrl.goal.state"></kz-state>
        </span>

        <span data-ng-if="goalCtrl.goal.isPrivate()" class="text-danger">/ {{ 'PRIVATE' | translate }}</span>

        <a href="" data-ng-if="::goalCtrl.canMark && goalCtrl.action === 'work'" ng-click="goalCtrl.markGoal()"
          ng-class="{'btn btn-xs btn-info': !goalCtrl.goal.isResolved(), 'text-info': goalCtrl.goal.isResolved()}">{{ (goalCtrl.goal.isResolved() ? 'Change' : 'Mark goal as') | translate }}</a>

      </p>
      <p class="box box-info" ng-if="::goalCtrl.isSetClosed">
        {{ 'The set containing this goal has been closed.' | translate }}
      </p>
    </div>
    <div class="col-sm-6" data-ng-if="goalCtrl.goal.avgRate !== undefined && !goalCtrl.isSetClosed">
      <kz-progress-bar description="{{ 'Overall goal progress' | translate }}" numerator="goalCtrl.goal.completedTargets.length" denominator="goalCtrl.goal.targets.length"
        rate="goalCtrl.goal.avgRate" obj-name="{{ 'Targets Completed' | translate }}">
        {{goalCtrl.goal.avgRate}}% {{ 'progress against this goal.' | translate }}
        {{goalCtrl.goal.completedTargets.length}}/{{goalCtrl.goal.targets.length}} <span ng-if="goalCtrl.goal.targets.length === 1">{{ 'target completed.' | translate }}</span><span ng-if="goalCtrl.goal.targets.length !== 1">{{ 'targets completed.' | translate }}</span>
      </kz-progress-bar>
    </div>
  </div>
  <div class="row" data-ng-if="goalCtrl.noEvent && goalCtrl.goal.canViewEvent">
    <div class="col-sm-12 alert alert-danger">
      {{ 'It looks like this goal has no event attached, you are able to delete it if you like.' | translate }}
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div data-ng-if="!goalCtrl.noEvent">{{ 'Created as part of' | translate }} <a
          router-link="goalCtrl.eventRoute">{{goalCtrl.goal.event.eventType.name}}</a></div>
      <div data-ng-if="goalCtrl.noEvent">{{ 'Created as part of' | translate }} {{goalCtrl.goal.goalSetSummary.name}}</a></div>
      <div>{{ 'Due date:' | translate }} <strong>{{goalCtrl.goal.doc.dueDate | date: goalCtrl.dateFormat}}</strong></div>
      <goalset-periods-select
        goal="goalCtrl.goal"
        selected-period-id="goalCtrl.periodId"
        data-ng-if="goalCtrl.goal.doc.periods"
      ></goalset-periods-select>
    </div>
  </div>
  <div class="row" ng-if="::goalCtrl.goal.doc.description">
    <div class="col-xs-12 form-readonly form-readonly--fancy">
      <p class="form-text__control-label">{{ 'Goal description:' | translate }}</p>
      <div class="form-text form-text__field-value" ng-bind-html="goalCtrl.goal.doc.description"></div>
    </div>
  </div>
  <div class="row" ng-if="::goalCtrl.goal.doc.resolveComment && goalCtrl.isMarkStepEnabled">
    <div class="col-xs-12 form-readonly form-readonly--fancy">
      <p class="form-text__control-label">{{ 'Resolution Comment:' | translate }}</p>
      <div class="form-text form-text__field-value">{{goalCtrl.goal.doc.resolveComment}}</div>
    </div>
  </div>

</section>

<section class="wrapper">
  <div class="row">
    <div class="col-sm-12">
      <h3>{{ 'Event targets' | translate }}</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12" ng-if="goalCtrl.goal.targets.length && !goalCtrl.goal.targets[0].conditions.length">
      {{ 'The following targets have been set for this goal. Please link events that you think best satisfy the aim of this goal.' | translate }}
    </div>
    <div class="col-sm-12" ng-if="goalCtrl.goal.targets.length && goalCtrl.goal.targets[0].conditions.length">
      {{ 'The following targets have been set for this goal. Please link at least the minimum number of events indicated that satisfy the individual criteria.' | translate }}
    </div>
    <div class="col-sm-12" data-ng-if="goalCtrl.goal.targets.length === 0">
      <div class="box box-danger">
        {{ 'No targets have been set for the selected period. Please select an alternative period to view its associated targets.' | translate }}
      </div>
    </div>
  </div>
</section>

<div ng-repeat="target in goalCtrl.goal.targets track by target._id">
  <target-slot target="target"></target-slot>
</div>
`,
  'app/components/goals/goal.preview.html': `<div class="modal-header event-modal-header">
  <header class="row">
    <div class="col-sm-10">
      <h3>
        {{::goalCtrl.goal.doc.title}}
      </h3>
      <a href="" target="_blank" unsaved-warning-clear ng-click="goalCtrl.open()">{{ 'Open in a new tab' | translate }}</a>
    </div>

    <div class="col-sm-2 text-right">
      <p class="button-list">
        <button type="button" class="close" data-ng-click="goalCtrl.close()" aria-label="{{ 'Close' | translate }}"><i class="icon-cancel"></i></button>
      </p>
    </div>
  </header>
</div>

<div class="modal-body event-modal-body">
  <div class="wrapper">
    <div class="row audit-log" data-ng-if="goalCtrl.shownDescription" data-ng-include="'app/components/events/partials/audit-log.include.html'"></div>
    <div class="row" ng-if="goalCtrl.isMarkStepEnabled">
      <div ng-class="{'col-sm-6': !goalCtrl.goal.isSetClosed(), 'col-sm-12': goalCtrl.goal.isSetClosed()}">
        <p>
          <span ng-show="goalCtrl.goal.isResolved()">
            {{ 'This goal has been marked as' | translate }}
            <span class="badge badge-{{goalCtrl.GOALS_STATES[goalCtrl.goal.state].labelStyle}}">{{goalCtrl.GOALS_STATES[goalCtrl.goal.state].name}}</span>
          </span>
          <span ng-show="!goalCtrl.goal.isResolved()">
            {{ 'This goal is' | translate }} <kz-state map="goalCtrl.GOALS_STATES" state="goalCtrl.goal.state"></kz-state>
          </span>

          <span data-ng-if="goalCtrl.goal.isPrivate()" class="text-danger">/ {{ 'PRIVATE' | translate }}</span>

          <a href="" data-ng-if="goalCtrl.canMark && goalCtrl.action === 'work'" ng-click="goalCtrl.markGoal()"
            ng-class="{'btn btn-xs btn-info': !goalCtrl.goal.isResolved(), 'text-info': goalCtrl.goal.isResolved()}">{{ (goalCtrl.goal.isResolved() ? 'Change' : 'Mark goal as') | translate }}</a>


        </p>
        <p class="box box-info" ng-if="::goalCtrl.isClosed">
          {{ 'The set containing this goal has been closed.' | translate }}
        </p>
      </div>
      <div class="col-sm-6" data-ng-if="goalCtrl.goal.avgRate !== undefined && !goalCtrl.isClosed">
        <kz-progress-bar numerator="goalCtrl.goal.completedTargets.length" denominator="goalCtrl.goal.targets.length"
          rate="goalCtrl.goal.avgRate" obj-name="{{ 'Targets Completed' | translate }}">
          {{goalCtrl.goal.avgRate}}% {{ 'progress against this goal.' | translate }}
          {{goalCtrl.goal.completedTargets.length}}/{{goalCtrl.goal.targets.length}} <span ng-if="goalCtrl.goal.targets.length === 1">{{ 'target completed.' | translate }}</span><span ng-if="goalCtrl.goal.targets.length !== 1">{{ 'targets completed.' | translate }}</span>
        </kz-progress-bar>
      </div>
    </div>
    <div class="row" data-ng-if="goalCtrl.noEvent && goalCtrl.goal.canViewEvent">
      <div class="col-sm-12 alert alert-danger">
        {{ 'It looks like this goal has no event attached, you are able to delete it if you like.' | translate }}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div data-ng-if="!goalCtrl.noEvent">{{ 'Created as part of' | translate }} <a router-link="goalCtrl.eventHref">{{goalCtrl.goal.event.eventType.name}}</a></div>
        <div data-ng-if="goalCtrl.noEvent">{{ 'Created as part of' | translate }} {{goalCtrl.goal.goalSetSummary.name}}</a></div>
        <div>{{ 'Due date:' | translate }} <strong>{{goalCtrl.goal.doc.dueDate | date: goalCtrl.dateFormat}}</strong></div>
        <goalset-periods-select
          goal="goalCtrl.goal"
          selected-period-id="goalCtrl.periodId"
          data-ng-if="goalCtrl.goal.doc.periods"
        ></goalset-periods-select>
      </div>
    </div>
    <div class="row" ng-if="::goalCtrl.goal.doc.description">
      <div class="col-xs-12 form-readonly form-readonly--fancy">
        <p class="form-text__control-label">{{ 'Goal description:' | translate }}</p>
        <div class="form-text form-text__field-value" ng-bind-html="goalCtrl.goal.doc.description"></div>
      </div>
    </div>
    <div class="row" ng-if="::goalCtrl.goal.doc.resolveComment && goalCtrl.isMarkStepEnabled">
      <div class="col-xs-12 form-readonly form-readonly--fancy">
        <p class="form-text__control-label">{{ 'Resolution Comment:' | translate }}</p>
        <div class="form-text form-text__field-value">{{goalCtrl.goal.doc.resolveComment}}</div>
      </div>
    </div>
  </div>
  <div class="wrapper">
    <div class="row">
      <div class="col-sm-12"><h3>{{ 'Event targets' | translate }}</h3></div>
    </div>
    <div class="row">
      <div class="col-sm-12" ng-if="!goalCtrl.goal.targets[0].conditions.length">
        {{ 'The following targets have been set for this goal. Please link events that you think best satisfy the aim of this goal.' | translate }}
      </div>
      <div class="col-sm-12" ng-if="goalCtrl.goal.targets[0].conditions.length">
        {{ 'The following targets have been set for this goal. Please link at least the minimum number of events indicated that satisfy the individual criteria.' | translate }}
      </div>
    </div>
  </div>
  <div ng-repeat="target in goalCtrl.goal.targets track by target._id">
    <target-slot target="target" options="{ hideButtons: true }"></target-slot>
  </div>
</div>
`,
  'app/components/goals/goals-definition.html': `<form novalidate name="form" aria-label="{{ 'Goals definition' | translate }}">
  <section class="wrapper">
    <div class="col-xs-12">
      <div class="row">
        <div class="col-sm-9">
          <p class="text-info"><h1>{{GoalsDefinitionCtrl.title}}</h1></p>
        </div>
        <div class="col-sm-3 text-right">
          <p>
            <button type="button"
              id="submit-button"
              class="btn btn-success"
              ng-click="GoalsDefinitionCtrl.saveDefinitions(GoalsDefinitionCtrl.definitions, form.$valid)"
              data-ng-disabled="!form.$valid"
            >
              Save
            </button>
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="wrapper">
    <goals-define
      model="GoalsDefinitionCtrl.definitions"
      edit-mode="GoalsDefinitionCtrl.action === 'edit'"
      at-least-one="true"
      event-type-id="GoalsDefinitionCtrl.eventTypeId"
      goal-set-periods="GoalsDefinitionCtrl.goal.doc.periods"
      data-ng-if="GoalsDefinitionCtrl.eventTypeId"></goals-define>
  </section>
</form>
`,
  'app/components/goals/list.html': `<offline-limit></offline-limit>
<section class="wrapper">
  <header class="row">
      <kz-header actions="actions"><h1>{{goalsCtrl.resolvedTitle }}</h1></kz-header>
      <kz-simple-search list="goalsCtrl.list"></kz-simple-search>
      <kz-search-string list="goalsCtrl.list"></kz-search-string>
  </header>
  <kz-refine-filter
    list="goalsCtrl.list"
    refine-by="event_state"
  ></kz-refine-filter>
</section>

<kz-list-view template="app/components/goals/listview.html" list="goalsCtrl.list" options="goalsCtrl.listOptions">
  <goal-slot goal="item" options="options"></goal-slot>
</kz-list-view>
`,
  'app/components/goals/listview-no-featured.html': `<div>
  <div data-ng-if="list.items.length || list.showFilters" data-infinite-scroll="list.doPaginate()" infinite-scroll-disabled='list.isLoading || list.finished || list.options.pagination === "links"'>
    <div class="goal-group" data-ng-repeat="item in list.items track by item | kzGetDotted:options.trackBy">
      <div
        data-kz-group-wrapper
        data-options="{ selectedPeriods: options.selectedPeriods }"
        data-group-item="item"
        data-prev-item="list.items[$index - 1]"
        data-next-item="list.items[$index + 1]"
        data-search-orders="list.search.orders"
        data-current-order-group="list.search.orderGroups[list.orderedBy()]"
        data-template-type="pre">

        <goal-wrapper goal="item" template="app/components/goals/directives/goal.wrapper.no-featured.html" template-type="pre" options="options"></goal-wrapper>
      </div>

      <div class="row goal">
        <div class="col-xs-12" kz-inject></div>
      </div>

      <div class="wrapper-bottom">
        <div
          class="row"
          data-kz-group-wrapper
          data-group-item="item"
          data-prev-item="list.items[$index - 1]"
          data-next-item="list.items[$index + 1]"
          data-search-orders="list.search.orders"
          data-current-order-group="list.search.orderGroups[list.orderedBy()]"
          data-template-type="post">
          <goal-wrapper goal="item" template="app/components/goals/directives/goal.wrapper.no-featured.html" template-type="post" options="options"></goal-wrapper>

        </div>
      </div>
    </div>
  </div>

  <!--the content placeholders-->
  <div data-ng-show="list.isLoading || !list.ready" data-ng-include="'app/layout/placeholders/list.html'"></div>
  <!--end placeholders-->

  <div class="row" data-ng-if="list.ready && list.finished && list.items.length > 0 && !options.hideEndOfListText">
    <div>
      <p class="text-gray-700 text-center">{{ 'You have reached the end of the list.' | translate }}</p>
    </div>
  </div>

  <div role="status">
    <div class="row" data-ng-if="list.ready">
      <div data-ng-if="!list.isLoading && !list.items.length">
        <p class="text-warning text-center"><i class="icon-warning">
          </i>
          <span data-ng-if="list.searchModel.filteredBy | kzIsEmpty:'deep'">
          {{ options.noItemsText ? options.noItemsText : ('There are no items available' | translate) }}
          </span>
          <span data-ng-if="!(list.searchModel.filteredBy | kzIsEmpty:'deep')">
          {{ options.noItemsFound ? options.noItemsFound : ('There are no items available' | translate) }}
          for <span kz-search-applied></span>
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/goals/listview.html': `<div>
  <div data-ng-if="list.items.length || list.showFilters" data-infinite-scroll="list.doPaginate()" infinite-scroll-disabled='list.isLoading || list.finished || list.options.pagination === "links"'>
    <div class="goal-group" data-ng-repeat="item in list.items track by item | kzGetDotted:options.trackBy">
      <div
        data-kz-group-wrapper
        data-options="{ selectedPeriods: options.selectedPeriods }"
        data-group-item="item"
        data-prev-item="list.items[$index - 1]"
        data-next-item="list.items[$index + 1]"
        data-search-orders="list.search.orders"
        data-current-order-group="list.search.orderGroups[list.orderedBy()]"
        data-template-type="pre">

        <goal-wrapper goal="item" template-type="pre" options="options"></goal-wrapper>

      </div>

      <div class="row goal">
        <div class="col-xs-12" kz-inject></div>
      </div>

      <div class="wrapper-bottom">
        <div
          class="row"
          data-kz-group-wrapper
          data-group-item="item"
          data-prev-item="list.items[$index - 1]"
          data-next-item="list.items[$index + 1]"
          data-search-orders="list.search.orders"
          data-current-order-group="list.search.orderGroups[list.orderedBy()]"
          data-finished="list.items.length >= list.total_count"
          data-template-type="post">

          <goal-wrapper goal="item" template-type="post" options="options"></goal-wrapper>

        </div>
      </div>
    </div>
  </div>

  <!--the content placeholders-->
  <div data-ng-show="list.isLoading || !list.ready" data-ng-include="'app/layout/placeholders/list.html'"></div>
  <!--end placeholders-->

  <div class="row" data-ng-if="list.ready && list.finished && list.items.length > 0 && !options.hideEndOfListText">
    <div>
      <p class="text-gray-700 text-center">{{ 'You have reached the end of the list.' | translate }}</p>
    </div>
  </div>

  <div role="status">
    <div class="row" data-ng-if="list.ready">
      <div data-ng-if="!list.isLoading && !list.items.length">
        <p class="text-warning text-center"><i class="icon-warning">
          </i>
          <span data-ng-if="list.searchModel.filteredBy | kzIsEmpty:'deep'">
          {{ options.noItemsText ? options.noItemsText : ('There are no items available' | translate) }}
          </span>
          <span data-ng-if="!(list.searchModel.filteredBy | kzIsEmpty:'deep')">
          {{ options.noItemsFound ? options.noItemsFound : ('There are no items available' | translate) }}
          for <span kz-search-applied></span>
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/goals/manage-categories.html': `<section class="wrapper">
  <header class="row">
    <h1>{{ 'Manage goal categories' | translate }}</h1>
  </header>
</section>

<div>
  <form name="ctrl.wrapperForm" unsaved-warning-form aria-label="{{ 'Manage goal categories' | translate }}">
    <div hidden id="goal-category-move-instructions">{{ 'Use the arrow up and down keys to move this goal category' | translate }}</div>
    <div data-ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost' }">
      <div class="wrapper" id="section-{{ item.id }}" data-ng-repeat="item in ctrl.sections track by $index">
        <div class="row">
          <div class="col-xs-12">
            <div class="row">
              <div class="col-xs-8">
                <h2 class="heading-5">
                  {{ item.name || ('Unnamed' | translate) }} ({{ item.id }})
                </h2>
              </div>
              <div class="col-xs-4 button-list">
                <ul class="list-inline list-unstyled list-icon-actions">
                  <li><a href="" title="{{ 'Remove section' | translate }}" data-ng-click="ctrl.removeSection(item)" class="text-danger"><i class="icon-trash"></i></a></li>
                  <li>
                    <button type="button" class="btn-link text-info drag-handle" aria-label="{{ ('Move' | translate) + ' ' + (item.name || ('Unnamed' | translate)) }}" aria-describedby="goal-category-move-instructions">
                      <i class="icon-move"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <form name="ctrl.forms[item.id || item.uid]" aria-label="ctrl.forms[item.id || item.uid]">
            <div class="row">
              <div class="col-xs-12">
                <formly-form class="event-basic-form" model="item" fields="ctrl.basicform.fields" form="ctrl.forms[item.id || item.uid]" aria-label="{{ 'Basic fields' | translate }}"></formly-form>
              </div>
            </div>

            <div class="row row-bordered">
              <div class="col-sm-11 col-md-10">
                <formly-form model="item.filter" fields="ctrl.addform.fields" form="ctrl.forms[item.id || item.uid]" aria-label="{{ 'Add form fileds' | translate }}"></formly-form>
              </div>
            </div>

            <div class="row row-bordered">
              <div class="col-sm-11 col-md-10">
                <formly-form model="item" fields="ctrl.extraForm.fields" form="ctrl.forms[item.id || item.uid]" aria-label="{{ 'Add extra fields' | translate }}"></formly-form>
              </div>
            </div>
             </form>
          </div>

        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-xs-12">
          <button type="button" class="btn btn-info" ng-click="ctrl.add()">{{ 'Add a new category' | translate }}</button>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-xs-12">
          <button type="button" class="btn btn-success btn-raised"
            ng-click="ctrl.save()" unsaved-warning-clear indicator="loading">
            {{ 'Save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
`,
  'app/components/goals/partials/close-event-section.html': `<div class="modal-header">
  <button type="button" class="close" data-ng-click="dismiss()" aria-label="{{ 'Close' | translate }}"><span aria-hidden="true">&times;</span></button>
  <div class="modal-title text-left">
    <h4 id="myModalLabel">{{ 'Please specify the person to send this event on to and then close and submit below.' | translate }}</h4>
    <div class="text-gray"></div>
  </div>
</div>
<div class="modal-body" style="height: 300px">
  <section-close-goal class="row" section="event" event="event" post-action="postAction()" def="event.nextSection.def"></section-close-goal>
</div>
`,
  'app/components/goals/partials/define-conditions.html': `<div class="row">
  <div class="col-xs-12">
    <formly-form model="target" fields="ctrl.targetBasicForms[target._id].fields" options="options"></formly-form>
  </div>
</div>

<div class="row" ng-repeat="condition in target.conditions track by condition._id">
  <div class="col-xs-12" data-ng-class="{'ub-box ub-box--dotted': target.conditions.length > 1 && target.isAdvanced}">
    <div class="ub-box ub-box--dotted">
      <div class="ub-box__header ub-box__header--transparent">
        <h5>{{ 'Achievement' | translate }}</h5>
        <ul class="list-inline list-unstyled list-icon-actions" ng-if="!readonly" ng-hide="condition.length">
          <li><a data-nodrag href="" data-ng-click="ctrl.remove('condition', target.conditions, condition._id, true)"><i title="{{ 'Remove achievement' | translate }}" class="icon-trash"></i></a></li>
        </ul>
      </div>

      <div class="ub-box__content">
        <div class="ub-box">
          <div class="ub-box__header ub-box__header--transparent">
            <h5>{{ 'How to link events' | translate }}</h5>
          </div>
          <div class="ub-box__content">
            <formly-form data-ng-if="!readonly" model="condition" fields="ctrl.linkingFiltersForms[condition._id].fields" options="options" aria-label="{{ 'How to link events' | translate }}"></formly-form>
            <kz-readonly-form data-ng-if="readonly" fields="ctrl.linkingFiltersForms[condition._id].fields" model="condition" options="{passTemplateOptions: true}"></kz-readonly-form>
          </div>
        </div>

        <div class="ub-box">
          <div class="ub-box__header ub-box__header--transparent">
            <h5>{{ 'How to measure progress' | translate }}</h5>
          </div>
          <div class="ub-box__content">
            <formly-form  model="condition" fields="ctrl.progressFiltersForms[condition._id].fields" options="options" aria-label="{{ 'How to measure progress' | translate }}"></formly-form>
            <button type="button" ng-if="!condition.periodMeasurements && !readonly && goalSetPeriods" class="btn btn-xs btn-primary" ng-click="ctrl.splitAchievementCount(condition)" >
              <i title="{{ 'Split by periods' | translate }}" class="icon-split"></i> Split by periods
            </button>
            <goals-define-period-measurements measurements="condition.periodMeasurements" goal-set-periods="goalSetPeriods" ng-if="condition.periodMeasurements" options="options"></goals-define-period-measurements>
            <goals-define-filter-measurements measurements="condition.filterMeasurements" ng-if="condition.filterMeasurements" options="options"></goals-define-filter-measurements>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-xs-12" data-ng-if="target.conditions.length < 1">
    <button type="button" class="btn btn-xs btn-primary" ng-click="ctrl.add('condition', target.conditions)" ng-if="!readonly">{{ 'Add achievement' | translate }}</button>
  </div>
</div>
`,
  'app/components/goals/partials/define-target.html': `
<!--<ul class="list-inline list-unstyled list-icon-actions text-right" ng-if="!readonly && target.isAdvanced" ng-hide="condition.length">-->
<!--<li><a data-nodrag href="" data-ng-click="ctrl.add('condition', target.conditions)"><i title="Split target" class="icon-split"></i></a></li>-->
<!--<li><a data-nodrag href="" data-ng-click="ctrl.remove('target', goal.targets, target._id)"><i title="{{ 'Remove Target' | translate }}" class="icon-trash"></i></a></li>-->
<!--</ul>-->

<div class="ub-box ub-box--dotted">
  <!-- Default panel contents -->
  <div class="ub-box__header">
    <div>{{ 'Target #' | translate }}{{ $index + 1 }} <span ng-if="target.title"> - {{target.title}}</span></div>
    <div>
      <ul class="list-inline list-unstyled list-icon-actions">
        <li>
          <button type="button" class="btn-link text-info drag-handle" aria-label="{{ 'Move target' | translate }}" aria-describedby="target-move-instructions">
            <i class="icon-move"></i>
          </button>
        </li>
        <li>
          <a href="" data-nodrag ng-click="ctrl.showTarget(target._id)" ng-if="!ctrl.targetsShown[target._id]">
            <i title="{{ 'Show Target' | translate }}" class="icon-plus"></i>
          </a>
        </li>
        <li>
          <a href="" data-nodrag ng-click="ctrl.hideTarget(target._id)" ng-if="ctrl.targetsShown[target._id]">
            <i title="{{ 'Hide Target' | translate }}" class="icon-minus"></i>
          </a>
        </li>
        <li>
          <a href="" data-nodrag ng-click="ctrl.remove('target', goal.targets, target._id)" ng-if="!readonly" ng-hide="condition.length">
            <i title="{{ 'Remove Target' | translate }}" class="icon-trash"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="ub-box__content" data-ng-if="ctrl.targetsShown[target._id]">
    <div data-ng-include="'app/components/goals/partials/define-conditions.html'"></div>
  </div>
</div>
<div class="ub-box__footer text-center" data-ng-if="$last && !readonly">
  <button type="button" class="btn btn-xs btn-info" ng-click="ctrl.add('target', goal.targets)"><i title="{{ 'Add another target for this goal' | translate }}" class="icon-plus"></i> {{ 'Add another target for this goal' | translate }}</button>
</div>
`,
  'app/components/goals/partials/event-linkedtargets.html': `<div class="modal-header">
  <button type="button" class="close" data-ng-click="dismiss()" aria-label="{{ 'Close' | translate }}"><span aria-hidden="true">&times;</span></button>
  <div class="modal-title text-left">
    <h4 id="myModalLabel">{{ 'This event is linked to' | translate }} {{linkedTargets.length}} {{ 'targets' | translate }}</h4>
    <div class="text-gray"></div>
  </div>
</div>
<div class="modal-body">
  <div ng-repeat="goal in goals">
    <section class="wrapper">
      <div class="row">
        <div class="col-sm-12">
          <h5>{{ 'Goal:' | translate }} {{goal.doc.title}}</h5>
          <div>{{ 'EVENT:' | translate }} <a router-link="['/events/view', goal.event.doc._id]">{{goal.event.eventType.name}}</a> {{ 'OCCURED ON' | translate }} <span class="text-info">{{goal.event.doc.startDate | date: dateFormat}}</span></div>
        </div>
      </div>
      <div class="row" ng-repeat="target in goal.targets">
        <div class="col-sm-11 col-sm-offset-1">
          <h5 target-title target="::target"></h5>
          <kz-progress-bar description="{{ target.doc.title + ' ' + ('progress' | translate) }}"
                           numerator="target.progress"
                           denominator="::target.minEventsToBeLinked"
                           obj-name="{{ 'links' | translate }}"
                           ng-if="::target.minEventsToBeLinked > 0"></kz-progress-bar>
          <span ng-if="::target.minEventsToBeLinked === 0">
            {{ target.linkedEvents.length }} {{ 'links' | translate }}
          </span>
        </div>
      </div>
    </section>
  </div>
</div>
`,
  'app/components/goals/partials/goal-resolve.html': `<form novalidate name="goalResolve" aria-label="{{ 'Mark goal' | translate }}">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="{{ 'Close' | translate }}"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
      <h4 id="myModalLabel">{{ 'Mark this goal' | translate }}</h4>
      <div class="text-gray"></div>
    </div>
  </div>
  <div class="modal-body" style="height: 300px">
    <formly-form model="goal.doc" fields="form.fields" aria-label="{{ 'Goal' | translate }}"></formly-form>
  </div>
  <div class="modal-footer text-right">
    <button type="button" class="btn btn-info" data-ng-click="dismiss()">{{ 'Cancel' | translate }}</button>
    <button type="button" class="btn btn-success btn-raised" data-ng-disabled="goalResolve.$invalid" data-ng-click="resolve(goalResolve.$valid)">{{ 'Mark this goal' | translate }}</button>
  </div>
</form>
`,
  'app/components/goals/partials/update-goalset-due-date.html': `<form novalidate name="goalResolve" aria-label="{{ 'Update the due date' | translate }}">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="{{ 'Close' | translate }}"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
      <h4 id="myModalLabel">{{ 'Update the due date' | translate }}</h4>
      <div class="text-gray"></div>
    </div>
  </div>
  <div class="modal-body">
    <formly-form model="model" fields="form.fields" aria-label="{{ 'Update due date' | translate }}"></formly-form>
  </div>
  <div class="modal-footer text-right">
    <button type="button" class="btn btn-info" data-ng-click="dismiss()">{{ 'Cancel' | translate }}</button>
    <button type="button" class="btn btn-success btn-raised" data-ng-disabled="goalResolve.$invalid" data-ng-click="save(goalResolve.$valid)">{{ 'Update' | translate }}</button>
  </div>
</form>
`,
  'app/components/goals/partials/update-goalset-periods.html': `<form novalidate name="goalResolve" aria-label="{{ 'Update the due date' | translate }}">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="{{ 'Close' | translate }}"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
      <h4 id="myModalLabel">{{ 'Update the periods' | translate }}</h4>
      <div class="text-gray"></div>
    </div>
  </div>
  <div class="modal-body">
    <goalset-periods model="model"></goalset-periods>
  </div>
  <div class="modal-footer text-right">
    <button type="button" class="btn btn-info" data-ng-click="dismiss()">{{ 'Cancel' | translate }}</button>
    <button type="button" class="btn btn-success btn-raised" data-ng-disabled="goalResolve.$invalid" data-ng-click="save(goalResolve.$valid)">{{ 'Update' | translate }}</button>
  </div>
</form>
`,
  'app/components/goals/targets.link.html': `<div class="wrapper">
  <div class="row">
    <div class="col-sm-8">
      <h3 target-title target="targetsLinkController.target"></h3>
    </div>
    <div class="col-sm-4">
      <p class="button-list text-right">
        <button type="button" class="btn btn-success btn-raised" data-ng-if="targetsLinkController.target" data-ng-click="targetsLinkController.doneLinking()">{{ "I'm done Linking" | translate }}</button>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">{{ 'Goal:' | translate }} <a router-link="['/goals/work', targetsLinkController.target.goal.doc._id]">{{targetsLinkController.target.goal.doc.title}}</a></div>
  </div>
</div>

<div kz-loading loaded="targetsLinkController.loaded"></div>

<section class="wrapper" data-ng-if="targetsLinkController.list && targetsLinkController.loaded">
  <div class="row box box-info" data-ng-if="targetsLinkController.target.doc.conditions.length">
    <div class="col-sm-7">
      <p>
        <i class="icon-info text-info"></i>
        <strong class="text-gray">
          {{ (targetsLinkController.isSuggestionSearch ? "Currently showing only events that match this goal\'s targets" : 'Currently showing all of your events') | translate }}
        </strong>
      </p>
    </div>
    <div class="col-sm-5 text-right">
      <ul class="list-inline list-unstyled">
        <li>
          <button type="button" data-ng-click="targetsLinkController.updateSearch()" class="btn btn-xs btn-info">
            {{ (targetsLinkController.isSuggestionSearch ? 'Show all events' : 'Show only events that match targets') | translate }}
          </button>
        </li>
      </ul>
    </div>
  </div>
  <header class="row" data-ng-if="targetsLinkController.loaded">
      <kz-simple-search list="targetsLinkController.list"></kz-simple-search>
      <kz-search-string list="targetsLinkController.list"></kz-search-string>
  </header>
  <kz-refine-filter
    list="targetsLinkController.list"
    refine-by="state"
    data-ng-if="targetsLinkController.loaded"
  ></kz-refine-filter>
</section>

<kz-list-view list="targetsLinkController.list" options="targetsLinkController.options"  data-ng-if="targetsLinkController.loaded">
  <event-group-slot item="item" options="options"></event-group-slot>
</kz-list-view>
`,
  'app/components/goals/widgets/goalsets/edit.html': `<form role="form" aria-label="{{ 'Goal set edit' | translate }}">
  <formly-form model="goalSetsEditWidgetCtrl.config" fields="goalSetsEditWidgetCtrl.queryForm.fields" form="form" aria-label="{{ 'Goal edit fields' | translate }}"></formly-form>
</form>
`,
  'app/components/goals/widgets/goalsets/view.html': `<div>
  <simple-goals-list goals="goalSetsViewWidgetCtrl.goals" options="goalSetsViewWidgetCtrl.options"></simple-goals-list>

  <div class="row" data-ng-if="goalSetsViewWidgetCtrl.loading">
    <p class="text-center"><i class="icon-spin animate-spin"></i></p>
  </div>

  <div class="row" data-ng-if="!goalSetsViewWidgetCtrl.loading && !goalSetsViewWidgetCtrl.goals">
    <p class="text-center">{{ 'No goal set selected' | translate }}</p>
  </div>

</div>


`,
  'app/components/goals/widgets/overview/edit.html': `<form role="form" aria-label="{{ 'Goals limit' | translate }}">
  <div class="form-group">
    <label for="limit">{{ 'How many goals do you want to display?' | translate }}</label>
    <input name="limit" type="number" class="form-control" ng-model="config.limit" />
    <p class="help-text">{{ 'Use 0 for no limit' | translate }}</p>
  </div>
</form>
`,
  'app/components/goals/widgets/overview/overview.html': `<div data-ng-if="goalsOverviewWidgetCtrl.authorized">

  <div class="row" data-ng-repeat="goal in goalsOverviewWidgetCtrl.goals | limitTo: goalsOverviewWidgetCtrl.displayLimit">

    <div class="col-xs-9">
      <h5 class="entry-title">
        <a router-link="goal.link" title="{{ 'View event details' | translate }}">{{ ::goal.title }}</a>
      </h5>
    </div>
    <div class="col-xs-3 text-right">
      <ul class="list-inline list-unstyled">
        <!-- Goals with no targets (type === 'none') and goals with mixed targets
             (type === 'mixed') intentionally render nothing, matching the goals list. -->
        <li data-ng-if="goal.totals.type === 'total' && goal.state !== 'inProgress' && !goal.state" class="text-info">
          {{::goal.totals.value}}
        </li>
        <li data-ng-if="goal.totals.type === 'ratio' && goal.state !== 'inProgress' && !goal.state">
          <kz-percentage rate="::goal.totals.value"></kz-percentage>
        </li>
        <li data-ng-if="goal.state !== 'inProgress' && goal.state">
          <kz-state map="goalsOverviewWidgetCtrl.GOALS_STATES" state="goal.state"></kz-state>
        </li>
      </ul>
    </div>
  </div>

  <div class="row" data-ng-if="!goalsOverviewWidgetCtrl.loading && !goalsOverviewWidgetCtrl.goals.length">
    <p class="text-center">{{ 'No goals have yet been created' | translate }}</p>
  </div>

</div>

<div class="row" data-ng-if="goalsOverviewWidgetCtrl.loading">
  <p class="text-center"><i class="icon-spin animate-spin"></i></p>
</div>

<div data-ng-if="!goalsOverviewWidgetCtrl.authorized && !goalsOverviewWidgetCtrl.loading">
  <p class="text-danger text-center">{{ 'You don\'t have the right permission.' | translate }}</p>
</div>
`,
  'app/components/organisations/addform.html': `<form novalidate unsaved-warning-form name="form" aria-label="{{ 'Add organisation' | translate }}">

  <div kz-loading loaded="orgCtrl.loaded">
    <div class="wrapper">

      <header class="row">
        <div class="col-sm-6">
          <h1>{{ 'Add organisation' | translate }}</h1>
        </div>
        <div class="col-sm-6">
          <p class="button-list">
            <button type="button" class="btn btn-success btn-raised" data-ng-click="orgCtrl.request(form.$valid)">{{ 'Save' | translate }}</button>
            <button type="button" class="btn btn-info btn-raised" router-link="['/organisations']">{{ 'Cancel' | translate }}</button>
          </p>
        </div>
      </header>

      <div class="row">
        <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
      </div>

      <div class="row">
        <div class="form-group col-sm-12" data-ng-class="{ 'has-error has-feedback': form.orgName.$invalid && formIsSubmitted}">
          <label for="orgName">{{ 'Short Name' | translate }} <i class="icon-star required" aria-label="{{ 'star' | translate }}"></i></label>
          <input data-ng-model="orgCtrl.organisation.shortName" type="text" name="orgShortName" class="form-control" data-ng-required="true" aria-describedby="orgShortNameStatus">
          <p class="text-gray">{{ 'This is a short version of the organisation name. It will be used to generate the id' | translate }}</p>
          <div data-ng-if="form.orgShortName.$invalid && formIsSubmitted">
            <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
            <p id="orgShortNameStatus" class="help-block text-gray">{{ 'The name is required.' | translate }}</p>
          </div>
        </div>

        <div class="form-group col-sm-12" data-ng-class="{ 'has-error has-feedback': form.orgName.$invalid && formIsSubmitted}">
          <label for="orgName">{{ 'Name' | translate }} <i class="icon-star required" aria-label="{{ 'star' | translate }}"></i></label>
          <input data-ng-model="orgCtrl.organisation.name" type="text" name="orgName" class="form-control" data-ng-required="true" aria-describedby="orgNameStatus">
          <div data-ng-if="form.orgName.$invalid && formIsSubmitted">
            <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
            <p id="orgNameStatus" class="help-block text-gray">{{ 'The name is required.' | translate }}</p>
          </div>
        </div>

        <div class="form-group col-sm-12">
          <label for="terms">{{ 'Terms and conditions' | translate }}</label>
          <textarea name="terms" id="terms" msd-elastic data-ng-model="orgCtrl.organisation.terms" class="form-control"></textarea>
        </div>
      </div>
    </div>
  </div>
</form>
`,
  'app/components/organisations/form.popup.component.html': `<div class="modal-header">
    <button type="button" class="close" data-ng-click="$ctrl.dismiss()" aria-label="{{ 'Close' | translate }}"><i class="icon-cancel"></i></button>
    <div class="modal-title">
        <h3>
        {{ $ctrl.resolve.options.title || ('Please fill the form below' | translate) }}
        </h3>
    </div>
</div>

<div class="modal-body">
    <form name="popupForm">
        <formly-form model="$ctrl.innerModel" fields="$ctrl.form.fields" form="popupForm" aria-label="$ctrl.title"></formly-form>
    </form>
</div>

<div class="modal-footer">
    <div class="row">
        <button type="button" class="btn btn-warning" data-ng-click="$ctrl.dismiss()">{{ $ctrl.resolve.options.cancelbutton || ('Cancel' | translate) }}</button>
        <button type="button" class="btn btn-info" ng-disabled="popupForm.$invalid" data-ng-click="$ctrl.submit(popupForm)">{{ $ctrl.resolve.options.okbutton || ('Submit' | translate)}}</button>
    </div>
</div>
`,
  'app/components/organisations/list.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="orgsCtrl.actions"><h1>{{ 'Organisations' | translate }}</h1></kz-header>
      <kz-simple-search list="orgsCtrl.list"></kz-simple-search>
      <kz-search-string list="orgsCtrl.list"></kz-search-string>
  </header>
  <kz-refine-filter list="orgsCtrl.list"></kz-refine-filter>
</section>


<kz-list-view list="orgsCtrl.list" options="orgsCtrl.options">
  <list-slot item="item" options="options"></list-slot>
</kz-list-view>
`,
  'app/components/organisations/organisation.controlpanel.component.html': `<div>
  <div kz-loading loaded="$ctrl.loaded">
    <section class="wrapper">

      <header class="row">
        <div class="col-sm-12">
          <h1>
            <div>Control panel of {{ $ctrl.org.name }}</div>
          </h1>
        </div>
      </header>
    </section>

    <section class="wrapper">
        <div kz-feature-enabled feature="turnitin">
            <div class="wrapper">
                <div class="row">
                    <div class="col-xs-12">
                        <turnitin-control-panel org="$ctrl.org"></turnitin-control-panel>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</div>
`,
  'app/components/organisations/settings.html': `<form novalidate unsaved-warning-form name="form" aria-label="{{ 'Edit organisation settings' | translate }}">
  <div kz-loading loaded="organisationSettingsCtrl.loaded">
    <section class="wrapper">

      <header class="row">
        <div class="col-sm-6">
          <h1>
            {{ 'Edit' | translate }} {{ organisationSettingsCtrl.orgId }} {{ 'organisation settings' | translate }}
          </h1>
        </div>
        <div class="col-sm-6">
          <p class="button-list">
            <button type="save" class="btn btn-success btn-raised" data-ng-click="organisationSettingsCtrl.save(form.$valid)">{{ 'Save' | translate }}</button>
            <button type="button" class="btn btn-info btn-raised" data-ng-click="organisationSettingsCtrl.cancel()">{{ 'Cancel' | translate }}</button>
          </p>
        </div>
      </header>

      <section class="wrapper-content">

        <div class="wrapper">

          <div class="row">
            <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
          </div>

          <div class="row">
            <formly-form model="organisationSettingsCtrl.settings" fields="organisationSettingsCtrl.generalForm.fields" form="form" aria-label="{{ 'General' | translate }}"></formly-form>
          </div>

          <div class="row">
            <formly-form model="organisationSettingsCtrl.settings.localizationSetup" fields="organisationSettingsCtrl.localizationForm.fields" form="form" aria-label="{{ 'Localization' | translate }}"></formly-form>
          </div>

          <div class="row">
            <formly-form model="organisationSettingsCtrl.emailSetup" fields="organisationSettingsCtrl.emailForm.fields" form="form" aria-label="{{ 'Email' | translate }}"></formly-form>
          </div>

          <div class="row">
            <formly-form model="organisationSettingsCtrl.settings.themeSetup" fields="organisationSettingsCtrl.themeForm.fields" form="form" aria-label="{{ 'Theme' | translate }}"></formly-form>
          </div>

        </div>

      </section>
    </section>
  </div>
</form>
`,
  'app/components/organisations/turnitin.controlpanel.component.html': `<div>
    <h2>{{ 'Turnitin settings' | translate }}</h2>

    <div ng-if="$ctrl.turnitinEnabled">
        <p>{{ 'Please ensure the settings follows the Turnitin account' | translate }}</p>

        <ul class="list-unstyled" ng-if="$ctrl.settings">
            <li class="has-border-bottom">
                <span class="text-info text-sm">{{ 'Integration name:' | translate }}</span>
                <span class="text-gray"> {{ $ctrl.settings.integration_name }}</span>
            </li>
            <li class="has-border-bottom">
                <span class="text-info text-sm">{{ 'Integration version:' | translate }}</span>
                <span class="text-gray"> {{ $ctrl.settings.integration_version }}</span>
            </li>
            <li class="has-border-bottom">
                <span class="text-info text-sm">{{ 'Turnitin URL:' | translate }}</span>
                <span ng-class="{'text-success': $ctrl.settings.connection_test === 'success',
                                 'text-danger': $ctrl.settings.connection_test !== 'success'}">
                                  {{ $ctrl.settings.server }}</span>
                <button class="btn btn-sm btn-border btn-white" ng-click="$ctrl.updateServer()"><i class="icon-edit"></i> {{ 'Update' | translate }}</button>
            </li>
            <li class="has-border-bottom">
                <span class="text-info text-sm">{{ 'Webhook URL:' | translate }}</span>
                <span class="text-gray"> {{ $ctrl.settings.webhook_url }}</span>
                <button class="btn btn-sm btn-border btn-white" ng-click="$ctrl.registerHook()"><i class="icon-reload"></i> {{ 'Register' | translate }}</button>
            </li>
            <li class="has-border-bottom">
                <span class="text-info text-sm">{{ 'Registered webhooks:' | translate }}</span>
                <div ng-repeat="webhook in $ctrl.settings.registered_webhooks track by $index"
                    class="text-gray"> {{ webhook.url }} ({{ webhook.description }})</div>
            </li>
        </ul>
    </div>
    <div ng-if="!$ctrl.turnitinEnabled">
        <p>{{ 'Turnitin feature is not enabled' | translate }}</p>
    </div>
</div>`,
  'app/components/relations/filters/kz-relations-fields-filter.html': `<formly-form unsaved-warning-form model="ctrl.formData" fields="ctrl.form.fields" form="kzSearchForm" aria-label="{{ 'Add relation' | translate }}">
  <button type="button" class="btn btn-xs btn-primary btn-border" data-ng-click="ctrl.addPair()">{{ 'Add new relation' | translate }}</button>
</formly-form>
`,
  'app/components/relations/form.html': `<form novalidate unsaved-warning-form name="form" aria-label="{{ 'Edit relation' | translate }}">

  <div kz-loading loaded="relationCtrl.loaded">
    <div class="wrapper">
      <header class="row">
        <div class="col-sm-6">
          <h1>{{relationCtrl.title || ('Edit relation' | translate)}}</h1>
        </div>
        <div class="col-sm-6">
          <p class="button-list">
            <button type="button" unsaved-warning-clear class="btn btn-warning btn-raised" data-ng-if="relationCtrl.hasEditPermission && relationCtrl.state == 'edit'" data-ng-click="relationCtrl.duplicate()">{{ 'Duplicate' | translate }}</button>
            <button type="submit" class="btn btn-success btn-raised" data-ng-if="relationCtrl.hasEditPermission" data-ng-disabled="form.$invalid" data-ng-click="relationCtrl.save(form.$valid)">{{ 'Save' | translate }}</button>
            <button type="button" class="btn btn-info btn-raised" router-link="['/relations']">{{ 'Cancel' | translate }}</button>
            <button type="button" class="btn btn-danger btn-raised" data-ng-if="relationCtrl.hasEditPermission && relationCtrl.state == 'edit'" data-ng-click="relationCtrl.remove()">{{ 'Delete' | translate }}</button>
          </p>
        </div>
        <audit-log-component ng-if="relationCtrl.relation._rev" entries="relationCtrl.auditlog" on-expand="relationCtrl.loadAuditlog()"></audit-log-component>
      </header>
      <div class="row" data-ng-if="error || (relationCtrl.eventTypes && relationCtrl.eventTypes.length)">
        <p data-ng-if="error" class="text-warning">{{ 'Cannot get relation usage in event types:' | translate }} {{ relationCtrl.error.message }}</p>
        <span data-ng-if="relationCtrl.eventTypes && relationCtrl.eventTypes.length">{{ 'This version of this relation is embedded inside event:' | translate }}</span>
        <ul class="list-inline list-unstyled">
          <li data-ng-repeat="et in relationCtrl.eventTypes">
            <span kz-event-type-usage event-types="et"></span>
          </li>
        </ul>
      </div>

      <div class="row">
        <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
      </div>

      <div class="row">
        <div class="form-group col-xs-12" data-ng-class="{ 'has-error has-feedback': form.name.$invalid && formIsSubmitted}">
          <label for="name">{{ 'Name' | translate }} <i ng-class="{'icon-star required': relationCtrl.hasEditPermission, 'icon-lock disabled': !relationCtrl.hasEditPermission}"></i></label>
          <input data-ng-model="relationCtrl.relation.name" type="text" id="name" name="name" class="form-control" data-ng-required="true" aria-describedby="titleStatus" ng-disabled="!relationCtrl.hasEditPermission">

          <div data-ng-if="form.name.$invalid && formIsSubmitted">
            <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
            <p id="titleStatus" class="help-block text-gray">{{ 'The name is required.' | translate }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <legend>{{ 'Add categories to this relation' | translate }}</legend>

        <div data-ng-include="'app/components/relations/partials/relations.hierarchy.html'"></div>
      </div>

    </div>
  </div>

</form>
`,
  'app/components/relations/list-reorder.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="relationsReorderCtrl.actions"><h1>{{ 'Relations' | translate }}</h1></kz-header>
      <p>{{relationsReorderCtrl.relations.length}} {{ 'relations.' | translate }}</p>
  </header>
</section>
<div kz-loading loaded="relationsReorderCtrl.loaded">
  <p class="box box-info" ng-bind-html="relationsReorderCtrl.reorderInfo"></p>
  <div hidden id="relations-move-instructions">{{ 'Use the arrow up and down keys to move this relation' | translate }}</div>
  <div ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost', onUpdate: relationsReorderCtrl.reorder }">
    <div class="wrapper" data-ng-repeat="item in relationsReorderCtrl.relations track by item.doc._id">
      <div class="row event progress-border progress-border-complete">
        <div class="col-xs-12">
          <div class="row event-inner">
            <div class="col-xs-8">
              <h2>{{ item.doc.name || item.doc.title}}</h2>
            </div>
            <div class="col-xs-4 button-list">
              <ul class="list-inline list-unstyled list-icon-actions">
                <li>
                  <button type="button" class="btn-link text-success drag-handle" aria-label="{{ 'Move' | translate }} {{ item.doc.name || item.doc.title }}" aria-describedby="relations-move-instructions">
                    <i class="icon-move"></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div class="row event-inner">
            <div class="col-xs-8">
              <div class="text-gray">{{ item.doc.description }}</div>
            </div>
            <div class="col-xs-4 col-right">
              <kz-state map="relationsReorderCtrl.options.stateMapping" state="item | kzGetDotted: relationsReorderCtrl.options.stateField"></kz-state>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/relations/list.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="relationsCtrl.actions"><h1>{{ 'Relations' | translate }}</h1></kz-header>
      <kz-simple-search list="relationsCtrl.list"></kz-simple-search>
      <kz-search-string list="relationsCtrl.list"></kz-search-string>

  </header>
  <kz-refine-filter list="relationsCtrl.list"
    ></kz-refine-filter>
</section>


<kz-list-view list="relationsCtrl.list" options="relationsCtrl.options">
  <list-slot item="item" options="options"></list-slot>
</kz-list-view>
`,
  'app/components/relations/partials/relations.hierarchy.html': `<script type="text/ng-template" id="relations-hierarchy.html">
  <div data-nodrag data-ui-tree-handle class="row tree-node tree-node-content" ng-class="{'alert alert-warning': category.disabled}">
    <div class="col-xs-10">
      <div class="row">
        <div class="form-group col-xs-12" data-ng-class="{ 'has-error has-feedback': form[category._id].$invalid && formIsSubmitted}">
          <label for="{{category._id}}-name">{{ 'Name' | translate }} <i ng-class="{'icon-star required': relationCtrl.hasEditPermission, 'icon-lock disabled': !relationCtrl.hasEditPermission || category.disabled}"></i></label>
          <input data-ng-model="category.name" type="text" id="{{category._id}}-name" name="{{category._id}}-name" class="form-control" data-ng-required="true" aria-describedby="{{category._id + '-status'}}" ng-disabled="!relationCtrl.hasEditPermission || category.disabled">
          <div data-ng-if="form[category._id].$invalid && formIsSubmitted">
            <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
            <p id="{{category._id + '-status'}}" class="help-block text-gray">{{ 'The name is required.' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-xs-6">
          <label for="{{category._id}}-blueprint-cats">{{ 'Blueprints' | translate }}</label>
          <div data-sequoia-tree="relationCtrl.blueprintTrees" data-ng-model="relationCtrl.bCategories[category._id].selectedCategories" data-node-template="relationCtrl.tree.template" data-options="relationCtrl.tree.options"></div>
        </div>
      </div>
    </div>
    <div class="col-xs-2 text-right">
      <br/>
      <ul class="list-inline list-unstyled list-icon-actions">
        <li><button type="button" class="btn-link text-gray" data-nodrag data-ng-click="relationCtrl.toggle(this)" aria-label="{{ 'Toggle' | translate }}"><i data-ng-class="{'icon-right-open-big': collapsed, 'icon-down-open-big': !collapsed}"></i></button></li>
        <li><button type="button" class="btn-link text-info" data-nodrag data-ng-click="relationCtrl.newSubNode(this)" data-ng-if="relationCtrl.hasEditPermission && !this.$modelValue.disabled" aria-label="{{ 'Add new sub category' | translate }}"><i class="icon-plus"></i></button></li>
        <li><button type="button" class="btn-link text-danger" data-nodrag data-ng-click="relationCtrl.updateNodeEnability(this, true)" data-ng-if="relationCtrl.hasEditPermission && !this.$modelValue.disabled" aria-label="{{ 'Turn off' | translate }}"><i class="icon-toggle-off"></i></button></li>
        <li><button type="button" class="btn-link text-success" data-nodrag data-ng-click="relationCtrl.updateNodeEnability(this, false)" data-ng-if="relationCtrl.hasEditPermission && this.$modelValue.disabled" aria-label="{{ 'Turn on' | translate }}"><i class="icon-toggle-on"></i></button></li>
      </ul>
    </div>
  </div>
  <ol data-ui-tree-nodes data-ng-model="category.categories" data-ng-class="{hidden: collapsed}">
    <li data-ng-repeat="category in category.categories" data-ui-tree-node data-ng-include="'relations-hierarchy.html'">
    </li>
  </ol>
</script>

<div data-ui-tree id="tree-root">
  <ol data-ui-tree-nodes data-ng-model="relationCtrl.relation.categories">
    <li data-ng-repeat="category in relationCtrl.relation.categories" data-ui-tree-node data-ng-include="'relations-hierarchy.html'"></li>
  </ol>
</div>

<p><button type="button" data-ng-click="relationCtrl.addCategory()" class="btn btn-sm btn-primary" data-ng-if="relationCtrl.hasEditPermission">{{ 'Add new category' | translate }}</button></p>
`,
  'app/components/reports/directives/multi-report-builder.html': `<form form="form" aria-label="{{ 'Edit multi report' | translate }}">
  <div class="wrapper">
    <div class="row">
      <div class="col-sm-12">
        <formly-form model="multiReportBuilderCtrl.multiReport.reportDoc" fields="multiReportBuilderCtrl.baseForm.fields" form="form" aria-label="{{ 'Multi report' | translate }}"></formly-form>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <h5>{{ 'Global filters' | translate }}</h5>
        <p class="text-gray">{{ 'Any filters defined here will apply across all reports in this multi report template. Events filters will apply to reports run on events, Users filters will apply to reports run on users and Goals filters will apply to reports run on goals. They will be combined with the filters set within each individual report.' | translate }}</p>
        <span ng-repeat="source in multiReportBuilderCtrl.availableSources" class="text-center">
          <button type="button" class="btn btn-xs btn-primary" data-ng-click="multiReportBuilderCtrl.openFiltersDefinitionModal(source[0])">
            {{ source[1] }} ({{ multiReportBuilderCtrl.multiReport.globalFilters[source[0]].filters.length || 0 }})
          </button>
        </span>
      </div>
    </div>
  </div>
  <div class="wrapper">
    <div class="row" data-ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost' }">
      <div class="col-xs-12 field-border" ng-repeat="element in multiReportBuilderCtrl.multiReport.elements track by element._id">
        <div class="row">
          <div class="col-xs-9" data-ng-switch on="element.type">
              <div data-ng-switch-when="text">
                <div ng-bind-html="element.text | nl2br | videoUrlToIframe" class="readonly"></div>
                <p class="text-gray">{{ element.type | uppercase }}</p>
              </div>
              <div data-ng-switch-when="report">
                <p>
                  <span ng-show="element.conf.description">{{ element.conf.description }}</span>
                </p>
                <p class="text-gray">{{ element.conf.source | uppercase }} {{ element.type | uppercase }}</p>
              </div>
              <div data-ng-switch-when="sqlreport">
                <p>
                  <span ng-show="element.conf.description">{{ element.conf.description }}</span>
                </p>
                <p class="text-gray">{{ 'REPORT' | translate }}</p>
              </div>
            </div>
          <div class="col-xs-3">
            <div class="button-list">
              <ul class="list-inline list-unstyled list-icon-actions" data-ng-if="multiReportBuilderCtrl.editMode">
                <li><button type="button" data-ng-click="multiReportBuilderCtrl.editElement(element._id)" class="btn btn-sm btn-border btn-primary">{{ 'Edit' | translate }}</button></li>
                <li><button type="button" class="btn btn-sm btn-link text-info drag-handle" aria-label="{{ 'Move' | translate }}"><i class="icon-move"></i></button></li>
                <li><button type="button" class="btn btn-sm btn-link text-danger" data-ng-click="multiReportBuilderCtrl.removeElement(element._id)" aria-label="{{ 'Remove' | translate }}"><i class="icon-trash"></i></button></li>
              </ul>
              <ul class="list-inline list-unstyled list-icon-actions" data-ng-if="!multiReportBuilderCtrl.editMode">
                <li><a router-link="['/report_templates', 'edit', 'multi-report', reportId, 'element', element._id]" class="btn btn-sm btn-border btn-primary">{{ 'View' | translate }}</a></li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row" data-ng-if="multiReportBuilderCtrl.editMode">
      <div class="col-sm-12 text-center">
        <span data-ng-repeat="elementType in multiReportBuilderCtrl.ELEMENT_TYPES">
          <button type="button" class="btn btn-xs btn-primary" ng-click="multiReportBuilderCtrl.addElement(elementType.id)" data-ng-if="multiReportBuilderCtrl.editMode"><i class="icon-plus"></i> {{ 'Add new' | translate }} {{elementType.name}}</button>
        </span>
      </div>
    </div>
  </div>
</form>
`,
  'app/components/reports/directives/report-builder.html': `<div>
  <div class="wrapper">
    <div class="row">
      <div class="col-sm-12">
        <formly-form model="reportBuilderCtrl.model" fields="reportBuilderCtrl.singleReportBasicForm.fields" form="form" aria-label="{{ 'Single report' | translate }}"></formly-form>
      </div>
    </div>
  </div>

  <div class="wrapper">
    <div class="row">
      <div class="col-sm-12">
        <h2 class="heading-4">{{ 'Define your report filters' | translate }}</h2>
        <p class="text-gray">{{ 'This section is for you to select which data you would like the system to search for when running this report. Use the AND and OR buttons to create layers of nested filters. SPLIT is useful when you want to turn one filter into many within a single layer of the expression, just like grouping within parentheses. The USER CAN OVERRIDE field allows you to specify whether any of these fields can be changed by the user running the report, or whether they should all be preset.' | translate }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <kz-report-single-filter filter="reportBuilderCtrl.model.filter" report="reportBuilderCtrl.singleReport" edit-mode="::reportBuilderCtrl.editMode"></kz-report-single-filter>
      </div>
    </div>
  </div>

  <div class="wrapper">
    <div class="row">
      <div class="col-sm-12">
        <h2 class="heading-4">{{ 'Define output properties' | translate }}</h2>
      </div>
      <div class="col-sm-10">
        <p class="text-gray">{{ 'This section is for you to choose which data should be shown in the report when it is run. AGGREGATION defines if and how the data is summarised. NO AGGREGATION will print each value on a separate row, GROUP BY THIS FIELD will print the title of the selected data in one single row, METRIC will allow you select what type of numerical aggregation should be calculated.' | translate }}</p>
      </div>
      <div class="col-sm-2">
        <formly-form model="reportBuilderCtrl.model" fields="reportBuilderCtrl.outputTypeForm.fields" form="form" aria-label="{{ 'Output' | translate }}"></formly-form>
      </div>
    </div>
    <div class="row" data-ng-if="reportBuilderCtrl.model.outputFields.length > 0">
      <div class="col-sm-12" data-ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost' }">
        <div data-ng-repeat="output in reportBuilderCtrl.model.outputFields track by $index">
          <kz-report-output-field
            report="reportBuilderCtrl.singleReport"
            field="output"
            edit-mode="::reportBuilderCtrl.editMode"
            pre-calculated-data="::reportBuilderCtrl.preCalculatedData"
            ng-if="reportBuilderCtrl.preCalculatedData">
          </kz-report-output-field>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center">
        <button type="button" class="btn btn-xs btn-info" data-ng-click="reportBuilderCtrl.addOutputField()" ng-if="reportBuilderCtrl.editMode"><i class="icon-plus"></i> {{ 'Add an output property' | translate }}</button>
      </div>
    </div>
  </div>

  <div class="wrapper">
    <div class="row">
      <div class="col-sm-12">
        <h2 class="heading-4">{{ 'Define order' | translate }}</h2>
        <p class="text-gray">{{ 'Use this section to define how you would like the output table to be organised. Selecting the same property as in the output section above allows you to then set whether that column should be shown in ascending or descending order. The priority of this list runs from top (highest) to bottom (lowest). All output properties set as GROUP BY THIS FIELD will always take highest priority over and above what you define here.' | translate }}</p>
      </div>
    </div>
    <div class="row" data-ng-if="reportBuilderCtrl.model.sortBy.length > 0">
      <div class="col-sm-12" data-ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost' }">
        <div data-ng-repeat="sort in reportBuilderCtrl.model.sortBy track by $index">
          <kz-report-sort
            report="reportBuilderCtrl.singleReport"
            field="sort"
            edit-mode="::reportBuilderCtrl.editMode">
          </kz-report-sort>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center">
        <button type="button" class="btn btn-xs btn-info" data-ng-click="reportBuilderCtrl.addSortField()" ng-if="reportBuilderCtrl.editMode"><i class="icon-plus"></i> {{ 'Add a sort by field' | translate }}</button>
      </div>
    </div>
  </div>

  <div class="wrapper">
    <div class="row">
      <div class="col-sm-12">
        <h2 class="heading-4">{{ 'Define chart output' | translate }}</h2>
      </div>
      <div class="col-sm-12">
        <p class="text-gray">{{ 'Here you can optionally add an output chart to this report. Please select which output properties to display for both the horizontal and vertical axes of the chart. The chart type is selected on each vertical axis which allows you to build up multiple display types on the same chart.' | translate }}</p>
      </div>
    </div>
    <div class="row" data-ng-if="reportBuilderCtrl.model.charts.length > 0">
      <div class="col-sm-12">
        <div class="col-sm-12">
          <div data-ng-repeat="chart in reportBuilderCtrl.model.charts track by $index">
            <kz-report-chart
              report="reportBuilderCtrl.singleReport"
              chart="chart"
              edit-mode="::reportBuilderCtrl.editMode">
            </kz-report-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center">
        <button type="button" class="btn btn-xs btn-info" data-ng-click="reportBuilderCtrl.addChart()" data-ng-if="!reportBuilderCtrl.model.charts.length && reportBuilderCtrl.editMode"><i class="icon-plus"></i> {{ 'Add Chart' | translate }}</button>
        <button type="button" class="btn btn-xs btn-danger" data-ng-click="reportBuilderCtrl.removeAllCharts()" data-ng-if="reportBuilderCtrl.model.charts.length && reportBuilderCtrl.editMode"><i class="icon-trash"></i> {{ 'Remove' | translate }}</button>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/reports/directives/report-chart-vertical-axis.html': `<div class="row">
  <div ng-class="{'col-sm-10': editMode, 'col-sm-12': !editMode}">
    <formly-form class="inline" model="y" fields="verticalAxisForm.fields" options="options" form="form" aria-label="{{ 'Chart vertical axis' | translate }}"></formly-form>
  </div>
  <div class="col-sm-2" ng-if="::editMode">
    <ul class="list-inline list-unstyled list-icon-actions">
      <li><button type="button" class="btn btn-link text-danger" aria-label="{{ 'Remove vertical axis' | translate }}" data-ng-click="removeVerticalAxis()">
        <i class="icon-trash"></i>
      </li>
    </ul>
  </div>
</div>
`,
  'app/components/reports/directives/report-chart.html': `<div>
  <div class="row">
    <div class="col-sm-12">
      <formly-form class="inline" model="chart" fields="chartForm.fields" options="options" form="form" aria-label="{{ 'Chart' | translate }}"></formly-form>
    </div>
    <!--<div class="col-sm-2">
      <ul class="list-inline list-unstyled list-icon-actions">
        <li><a href="" data-ng-click="removeChart()"><i title="Remove chart" class="icon-trash"></i></a></li>
      </ul>
    </div>
    -->
  </div>
  <div class="row">
    <div class="col-sm-12"><h4>{{ 'Horizontal' | translate }}</h4></div>
    <div class="col-sm-12">
      <formly-form class="inline" model="chart.x" fields="horizontalAxisForm.fields" options="options" form="form" aria-label="{{ 'Horizontal axis' | translate }}"></formly-form>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-9"><h4>{{ 'Vertical' | translate }}</h4></div>
    <div class="col-sm-3 text-right">
      <ul class="list-inline list-unstyled list-icon-actions">
        <li>
          <button type="button" class="btn btn-link text-into" aria-label="{{ 'Add a new vertical axis' | translate }}" data-ng-click="addVerticalAxis()" data-ng-if="report.canChartBeMulti(chart) && editMode">
            <i class="icon-plus"></i>
          </button>
        </li>
      </ul>
    </div>
  </div>
  <kz-report-chart-vertical-axis
    data-ng-repeat="y in chart.ys track by $index"
    report="report"
    y="y"
    chart="chart"
    edit-mode="::editMode"
  >
  </kz-report-chart-vertical-axis>
</div>
`,
  'app/components/reports/directives/report-eventtypes.html': `<div>
  <p data-ng-if="error" class="text-warning">{{ 'Cannot get report usage in event types:' | translate }} {{ error.message }}</p>
  <span data-ng-if="!isObjectEmpty(eventTypes)">{{ 'This version of this report is embedded inside event:' | translate }}</span>
  <ul class="list-inline list-unstyled">
    <li data-ng-repeat="et in eventTypes">
      <span kz-event-type-usage event-types="et"></span>
      <span data-ng-show="!$last">,</span>
    </li>
  </ul>
</div>
`,
  'app/components/reports/directives/report-field.html': `<div>
  <div data-ng-if="model.generatedAt === undefined">
    <kz-report-form report="baseReport" report-id="report-id" report-doc="report-doc" model="model.reportData" default-model="defaultModelWithUser" required="true"></kz-report-form>
    <button type="button" class="btn btn-primary btn-sm" data-ng-disabled="!modelValid" data-ng-click="generate()">{{ 'Generate report' | translate }}</button>
  </div>
  <div data-ng-if="model.generatedAt !== undefined">
    <div data-ng-show="status" class="box box-{{status.klass}}">{{ status.text }}</div>
    <kz-report-view
        report="baseReport"
        report-id="report-id"
        report-doc="report-doc"
        model="model.reportData"
        stored-result="model.reportResult"
        field="model"
        result-loaded="storeResult(result)"
        extra="extra"
        mode="edit"
        size="size"
        items-to-display="{display: options.display, charts: options.charts || [], tableColumns: options.tableColumns, chartsColumns: options.chartsColumns }">
      </kz-report-view>
    <button type="button" class="btn btn-info btn-sm" data-ng-if="fields.length > 0" data-ng-click="edit()">{{ 'Change report inputs' | translate }}</button>
    <button type="button" class="btn btn-info btn-sm" data-ng-if="fields.length === 0" data-ng-click="regenerate()">{{ 'Update report' | translate }}</button>
  </div>
</div>
`,
  'app/components/reports/directives/report-filter.html': `<div>
  <ul class="list-group">
    <li class="list-group-item border" data-ng-repeat="flt in filter.filters track by flt.id">
      <kz-report-single-filter filter="flt" report="report" parent="filter" edit-mode="::editMode"></kz-report-single-filter>

      <p class="text-uppercase" data-ng-if="!$last" data-ng-class="{'text-success': filter.operator === 'and', 'text-info': filter.operator === 'or'}">{{ filter.operator }}</p>
    </li>
  </ul>
</div>
`,
  'app/components/reports/directives/report-form.html': `<div>
  <div data-ng-if="loaded">
    <formly-form model="model" fields="reportForm.fields" form="form" aria-label="{{ 'Report' | translate }}"></formly-form>
    <div ng-if="reportForm.fields.length > 0 && hasChanged()">
      <a href="" data-ng-click="resetModel()">{{ 'Reset to default values' | translate }}</a>
    </div>
  </div>
</div>
`,
  'app/components/reports/directives/report-output-field.html': `<div class="row">
  <div ng-class="{'col-sm-10': editMode, 'col-sm-12': !editMode}">
    <formly-form class="inline" model="field" fields="ctrl.outputFields.fields" options="options" form="form" aria-label="{{ 'Output field' | translate }}"></formly-form>
  </div>
  <div class="col-sm-2 text-right" style="padding-top: 15px" ng-if="editMode">
    <ul class="list-inline list-unstyled list-icon-actions">
      <li><a href="" class="drag-handle" aria-label="{{ 'Move' | translate }}" ><i class="icon-move"></i></a></li>
      <li><a href="" data-ng-click="ctrl.removeOutputField()" aria-label="{{ 'Remove field' | translate }}"><i title="{{ 'Remove field' | translate }}" class="icon-trash"></i></a></li>
    </ul>
  </div>
</div>
`,
  'app/components/reports/directives/report-single-filter.html': `<div class="ub-box ub-box--dotted">
  <div data-ng-if="filter.filterType === 'compFilter'">
    <div class="row">
      <div class="col-sm-8">
      </div>
    </div>
  </div>

  <div data-ng-if="filter.filterType === 'fieldFilter'">
    <div class="row">
      <div class="col-sm-10">
        <formly-form class="inline" model="filter" fields="singleForm.fields" options="options" aria-label="{{ 'Filter' | translate }}"></formly-form>
      </div>
      <div class="col-sm-2">
        <br />
        <ul class="list-inline list-unstyled list-icon-actions">
          <li><a data-nodrag href="" data-ng-click="splitFilter()" aria-label="{{ 'Split' | translate }}" data-ng-if="::editMode"><i class="icon-split"></i></a></li>
          <li><a data-nodrag href="" data-ng-click="removeFilter()" aria-label="{{ 'Remove filter' | translate }}" data-ng-if="::editMode"><i title="{{ 'Remove filter' | translate }}" class="icon-trash"></i></a></li>
        </ul>
      </div>
    </div>
  </div>

  <div class="placeholder"></div>

  <div>
    <div class="row">
      <div class="col-sm-8">
    <span data-ng-if="filter.filters.length === 1 && parent">
      {{ 'There is only one filter in this group, and you can' | translate }} <button type="button" class="btn btn-sm btn-link text-link" data-ng-click="unsplitFilter()">{{ 'merge it' | translate }}</button>.
    </span>
    </div>
    </div>
  </div>

  <div>
    <div class="row">
      <div class="col-sm-12 text-center">
        <button type="button" class="btn btn-xs" data-ng-class="{'btn-success': filter.operator === 'and', 'btn-info': filter.operator === 'or'}" data-ng-if="filter.filterType === 'compFilter' && editMode" data-ng-click="addFilter()"><i class="icon-plus"></i> <span data-ng-if="filter.operator === 'and'">{{ 'and this filter' | translate }}</span><span data-ng-if="filter.operator === 'or'">{{ 'or this filter' | translate }}</span></button>
        <button type="button" class="btn btn-xs btn-danger" data-ng-if="parent && filter.filterType === 'compFilter' && editMode" data-ng-click="removeFilter()"><i class="icon-trash"></i> {{ 'Remove all' | translate }}</button>
        <button type="button" class="btn btn-xs" data-ng-class="{'btn-success': getNegOperator() === 'and', 'btn-info': getNegOperator() === 'or'}" data-ng-if="!parent && editMode" data-ng-click="insertFilter()">
          <i class="icon-plus"></i> <span data-ng-if="getNegOperator() === 'and'">{{ 'and this filter' | translate }}</span><span data-ng-if="getNegOperator() === 'or'">{{ 'or this filter' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/reports/directives/report-sort.html': `<div class="row">
  <div ng-class="{'col-sm-10': editMode, 'col-sm-12': !editMode}">
    <formly-form class="inline" model="field" fields="sortForm.fields" options="options" form="form" aria-label="{{ 'Sort' | translate }}"></formly-form>
  </div>
  <div class="col-sm-2 text-right" style="padding-top: 15px" ng-if="::editMode">
    <ul class="list-inline list-unstyled list-icon-actions">
      <li><a href="" class="drag-handle" aria-label="{{ 'Move' | translate }}"><i class="icon-move"></i></a></li>
      <li><a href="" data-ng-click="removeSort()"><i title="{{ 'Remove field' | translate }}" class="icon-trash"></i></a></li>
    </ul>
  </div>
</div>
`,
  'app/components/reports/directives/report-task-button.html': `<div class="pull-right">
  <div data-ng-cloak="!loaded" data-ng-if="loaded">
    <div data-ng-cloak="!generated" data-ng-if="!generated">
      <button type="button" data-ng-click="generateTaskInBackground(false)" class="btn btn-primary">{{ 'Export as csv file' | translate }}</button>
      <p data-ng-if="failure" class="text-danger data-ng-cloak">{{ 'Error:' | translate }} {{ failureMessage }}</p>
    </div>
    <div data-ng-if="generated && !finished" data-ng-cloak>
      <button type="button" class="btn btn-info" disabled=true>
        <div class="row">
          <div class="col-xs-2">
            <span kz-loading loaded="finished"></span>
          </div>
          <div class="col-xs-10">
            {{ 'Exporting data' | translate }} ({{ progress }}%) ...
          </div>
        </div>
      </button>
      <button type="button" class="btn btn-danger" data-ng-click="cancelTask()">{{ 'Cancel' | translate }}</button>
    </div>
    <div data-ng-if="generated && finished" class="data-ng-cloak">
      <button type="button" data-ng-click="generateTaskInBackground(true)" class="btn btn-info" aria-label="{{ 'Reload' | translate }}"><i class="icon-reload"></i></button>
      <button type="button" data-ng-click="downloadGeneratedCSV()" class="btn btn-info">{{ 'Download csv file' | translate }}</button>
      <p data-ng-if="finished" class="text-gray data-ng-cloak">{{ 'Last generated:' | translate }} {{ dateGenerated | date: dateFormat }}</p>
      <p data-ng-if="failure" class="text-danger data-ng-cloak">{{ failureMessage }}</p>
    </div>
  <div>
</div>
`,
  'app/components/reports/directives/report-value.html': `<span data-ng-if="value.composed">
  <span data-ng-repeat="item in value.items track by $index">
    <span class="text-{{item[2]}}">
      <span data-ng-if="value.items.length > 1 && ['count', 'bool', 'max', 'min', 'sum', 'avg'].indexOf(item[0]) > -1">{{ item[0] }}: </span>
      <span ng-switch on="item[0]">
        <span ng-switch-when="bool" class="text-{{ labelStyle(item[1] * 100) }}">{{ item[1] | smartboolean: 'yesno' }}</span>
        <span ng-switch-when="count">{{ item[1] }}</span>
        <span ng-switch-default>{{ item[1] | smartDate }}</span>
      </span>
    </span>
    <br data-ng-if="!$last"/>
  </span>
</span>
<span class="text-{{ labelStyle(value) }}" data-ng-if="!value.composed && fields[$index].def.type === 'percent'">
  {{ value }}<span ng-if="value && value != '-'"></span>
</span>
<span data-ng-if="!value.composed && fields[$index].def.type === 'date'">{{ value|date:dateOnlyFormat }}</span>
<span data-ng-if="!value.composed && fields[$index].def.type === 'datetime'">{{ value|date:dateFormat }}</span>
<span data-ng-if="!value.composed && fields[$index].def.type === 'timedelta'">{{ value|kzTimeDelta }}</span>
<a href="" data-ng-if="!value.composed && fields[$index].def.type === 'preview' && value" data-ng-click="preview(value)">{{ fields[$index]['linkText'] || ('Preview' | translate) }}</a>
<a href="" data-ng-if="!value.composed && fields[$index].def.type === 'mark' && value" data-ng-click="markGoal(value)">{{ fields[$index]['linkText'] || ('Mark' | translate) }}</a>
<span data-ng-if="!value.composed && ['date', 'datetime', 'timedelta', 'preview', 'mark', 'percent'].indexOf(fields[$index].def.type) === -1">
  <span ng-if="value.indexOf('*** You do not have permission to view this data ***') === -1">{{ value | smartDate }}</span>
  <span ng-if="value.indexOf('*** You do not have permission to view this data ***') > -1">
    <span ng-repeat="v in value.split(', ') track by $index">
      <span ng-if="v !== '*** You do not have permission to view this data ***'">{{ v | smartDate }}</span>
      <span ng-if="v === '*** You do not have permission to view this data ***'"><i class="icon-lock"></i></span>
    </span>
  </span>
</span>
`,
  'app/components/reports/directives/report-view-conf.html': `<div>
  <form role="form">
    <formly-form model="viewConfCtrl.model" fields="viewConfCtrl.form.fields" options="viewConfCtrl.options" form="form" aria-label="{{ 'View configuration' | translate }}"></formly-form>
  </form>

  <div class="text-danger" data-ng-if="error">{{viewConfCtrl.error}}</div>
</div>
`,
  'app/components/reports/directives/report-view.html': `<div id="{{ domID }}">
  <div data-ng-if="loaded">
    <kz-print-pdf-button
      class="btn btn-xs btn-border btn-info no-print"
      button-title="{{ 'Download PDF' | translate }}"
      dom-element="{{ domID }}"
      data-ng-if="showPDFDownload"
      filename="{{ baseReport.doc.title }}.pdf"></kz-print-pdf-button>
    <kz-single-report-view
      report="report"
      model="model"
      generated="generated"
      items-to-display="itemsToDisplay"
      stored-result="storedResult"
      extra="extra"
      size="size"
      result-loaded="resultLoaded2(result)"
      need-preview="needPreview"
      ng-if="report.type === 'singleReport'"
    >
    </kz-single-report-view>

    <div ng-repeat="element in report.elements track by element._id" ng-if="report.type === 'multiReport'">
      <div ng-if="element.type === 'text'">
        <div ng-bind-html="element.text | nl2br | a2nt | placeholder | videoUrlToIframe" class="readonly"></div>
      </div>
      <div ng-if="element.type === 'report'">
          <kz-single-report-view
            result-loaded="resultLoaded2(result)"
            report="report.singleReports[element._id]"
            model="model"
            generated="generated"
            items-to-display="{ display: 'all' }"
            stored-result="storedResult[element._id]"
            extra="extra"
            size="size"
            need-preview="needPreview"
          >
          </kz-single-report-view>
      </div>
      <div ng-if="element.type === 'sqlreport'">
        <kz-sql-report-view
          model="model"
          report="report.sqlReports[element._id]"
          stored-result="storedResult[element._id]"
          result-loaded="resultLoaded2(result)"
          extra="extra"
        ></kz-sql-report-view>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/reports/directives/single-report-view.html': `<div>
  <div data-ng-if="showReport">
    <div class="alert alert-warning" data-ng-if="chartLoadMore && charts.length">
        {{getChartLimitMessage()}}
    </div>

    <div class="box box-warning" data-ng-if="mode !== 'edit' && field.generatedAt && regenerated">
      {{ 'Report generated just now' | translate }}
    </div>

    <div class="box box-info" data-ng-if="mode !== 'edit' && field.generatedAt && !regenerated">
      {{ 'Report generated on:' | translate }} {{ field.generatedAt|date:dateFormat }}
    </div>

    <!-- Graph -->
    <div style="max-width: 700px" data-ng-repeat="chart in charts track by $index" data-ng-if="!loading">
      <canvas
        epf-chartjs-line
        chart-data="chart.data"
        chart-options="chart.options"
        data-ng-if="chart.type === 'line'"
      ></canvas>
      <canvas
        epf-chartjs-bar
        chart-data="chart.data"
        chart-options="chart.options"
        data-ng-if="chart.type === 'bar'"
      ></canvas>
      <canvas
        epf-chartjs-radar
        chart-data="chart.data"
        chart-options="chart.options"
        data-ng-if="chart.type === 'radar'"
      ></canvas>
      <canvas
        epf-chartjs-polararea
        chart-data="chart.data"
        chart-options="chart.options"
        data-ng-if="chart.type === 'polar'"
      ></canvas>
      <canvas
        epf-chartjs-pie
        chart-data="chart.data"
        chart-options="chart.options"
        data-ng-if="chart.type === 'pie'"
      ></canvas>
      <canvas
        epf-chartjs-doughnut
        chart-data="chart.data"
        chart-options="chart.options"
        data-ng-if="chart.type === 'doughnut'"
      ></canvas>
      <canvas
        epf-chartjs-bubble
        chart-data="chart.data"
        chart-options="chart.options"
        data-ng-if="chart.type === 'bubble'"
      ></canvas>
      <p class="text-gray">{{chart.description}}</p>
      <span class="text-danger" data-ng-if="chart.error">{{ 'Oups somethings went wrong with the chart:' | translate }} {{chart.title}}</span>
    </div>

    <!-- Table -->
    <div data-ng-if="showTable">
    <div data-ng-if="loading">
        <p class="text-center"><i class="icon-spin animate-spin"></i></p>
      </div>

      <div class="row no-print" data-ng-if="showPaginator">
        <div class="col-sm-8 text-gray" >
          <span>
            {{ 'Showing' | translate }} {{ lowest() }} {{ 'to' | translate }} {{ highest() }} {{ 'of' | translate }} {{ result.total }}.
          </span>
        </div>
        <div class="col-sm-4 text-right">
          <span>{{ 'Results per page' | translate }}
            <select ng-model="sizeDataInput.size" name="size" ng-change="apply()">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
              <option value="1000">1000</option>
              <option value="5000">5000</option>
            </select>
          </span>
        </div>
      </div>
      <div data-ng-if="!loading && !error">
        <div data-ng-if="report.conf.outputType == 'detailed'" class="report-detailed">
          <div data-ng-repeat="row in result.hits track by $index" style="break-inside: avoid" class="row report-detailed-item">
            <div class="col-xs-12">
              <ng-container data-ng-repeat="value in row.row track by $index">
                <ng-container data-ng-if="fields[$index].def.type === 'extended'">
                  <div class="row report-detailed-row" data-ng-repeat="item in value.items">
                    <div class="col-xs-3">
                      {{ item[0] }}
                    </div>
                    <div class="col-xs-9">
                      {{ item[1] | smartDate }}
                    </div>
                  </div>
                </ng-container>
                <div class="row report-detailed-row" data-ng-if="fields[$index].def.type !== 'extended'">
                  <div class="col-xs-3">
                    {{ result.headers[$index] }}
                  </div>
                  <div class="col-xs-9">
                    <span data-ng-include="'app/components/reports/directives/report-value.html'"></span>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="table-scrollable" data-ng-if="report.conf.outputType === undefined || report.conf.outputType === 'simple'">
          <table  class="report-table table table-condensed">
            <thead>
              <tr>
                <th scope="col" data-ng-repeat="title in result.headers track by $index">{{ title}}</th>
              </tr>
            </thead>
            <tr data-ng-repeat="row in result.hits track by $index" class="{{ row.type === 'grand-total' ? 'grand-total' : '' }}">
              <td class="{{ row.level < $index + 2 ? 'level-' + row.level : '' }}" data-ng-repeat="value in row.row track by $index">
                <span data-ng-include="'app/components/reports/directives/report-value.html'"></span>
              </td>
            </tr>
            <tr data-ng-if="result.hits.length === 0">
              <td colspan="{{ result.headers.length }}" class="text-center">{{ 'There are no data for the given criteria' | translate }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div>
        <button type="button" class="btn btn-info" data-ng-if="start >= sizeData.size" data-ng-click="prevPage()">{{ 'Previous page' | translate }}</button>
        <button type="button" class="btn btn-info" data-ng-if="result.loadMore" data-ng-click="nextPage()">{{ 'Next page' | translate }}</button>
      </div>
      <div data-ng-if="error" class="text-warning">{{error.message}}</div>
    </div>
  </div>
</div>
`,
  'app/components/reports/directives/sql-report-builder.html': `<div>
    <div class="wrapper">
      <div class="row">
        <div class="col-sm-12">
          <formly-form model="$ctrl.model" fields="$ctrl.basicForm.fields" form="form" aria-label="{{ 'Sql report' | translate }}"></formly-form>
        </div>
      </div>
    </div>

    <sql-report-human conf="$ctrl.rawModel.raw"></sql-report-human>

    <div class="wrapper">
      <div class="row">
        <div class="col-sm-8">
          <h4>{{ 'View report' | translate }}</h4>
        </div>
        <div class="col-sm-4">
          <button class="btn btn-primary" ng-click="$ctrl.toggleView()">
              <span ng-if="$ctrl.viewVisible">{{ 'Hide' | translate }}</span>
              <span ng-if="!$ctrl.viewVisible">{{ 'Show' | translate }}</span>
          </button>
        </div>
      </div>
      <div ng-if="$ctrl.viewVisible" class="row" ng-repeat="disp in $ctrl.display track by $index">
        <div class="col-sm-12">
            <div ng-switch="disp.type">
                <div ng-switch-when="table">
                    {{ 'Table:' | translate }}
                    <span ng-if="disp.source.description">
                        {{ disp.source.description }} ({{ disp.source.id }})
                    </span>
                    <span ng-if="!disp.source.description">
                         {{ disp.source.id }}
                    </span>
                    <div class="table-scrollable">
                        <table class="report-table table table-condensed">
                            <thead>
                                <tr>
                                    <th ng-repeat="item in disp.source.columns track by $index">
                                        {{ item.label || item.field }}
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
                <div ng-switch-when="text">
                    {{ 'Text:' | translate }}
                    <div ng-bind-html="disp.content | nl2br | a2nt | videoUrlToIframe" class="readonly"></div>
                </div>
                <div ng-switch-when="chart">
                    {{ 'Chart:' | translate }} {{ disp.title }}
                    <ul>
                        <li ng-if="disp.description">{{ 'Description:' | translate }} {{ disp.description }}</li>
                        <li>{{ 'Type:' | translate }} {{ disp.chartType }}</li>
                        <li>{{ 'Horizontal:' | translate }} {{ disp.horizontal.label}} ({{ disp.horizontal.output}}.{{disp.horizontal.column }})</li>
                        <li>{{ 'Datasets' | translate }}
                            <ul>
                                <li ng-repeat="vert in disp.vertical track by $index">
                                    {{ vert.label}} ({{ vert.output}}.{{vert.column }})
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="wrapper" data-ng-if="$ctrl.canEditRaw">
      <div class="row">
        <div class="col-sm-12">
          <h4>{{ 'Raw edit report' | translate }}</h4>
        </div>
      </div>
      <div class="row">
          <div class="col-sm-12">
              <form>
                <formly-form model="$ctrl.rawModel" fields="$ctrl.rawForm.fields" form="form" aria-label="{{ 'Sql report' | translate }}"></formly-form>
              </form>
          </div>
        </div>
    </div>


  </div>
`,
  'app/components/reports/directives/sql-report-human.html': `<div class="wrapper">
    <div class="row">
        <div class="col-sm-8">
            <h4>{{ 'Human version' | translate }}</h4>
        </div>
        <div class="col-sm-4">
            <button class="btn btn-primary" ng-click="$ctrl.toggle()">
                <span ng-if="$ctrl.visible">{{ 'Hide' | translate }}</span>
                <span ng-if="!$ctrl.visible">{{ 'Show' | translate }}</span>
            </button>
        </div>
    </div>
    <div ng-if="$ctrl.visible" class="row">
        <div class="col-sm-12">
            <div ng-if="$ctrl.error">{{ $ctrl.error }}</div>
            <div ng-repeat="part in $ctrl.parts track by part.name">
                {{ part.name }}
                <div ng-repeat="source in part.data track by source.id">
                    <div>
                        <h5>{{ source.id }} {{ 'based on' | translate }} {{ source.source }}</h5>
                    </div>
                    <div ng-if="source.filters.length > 0">
                        <strong>{{ 'Filters' | translate }}</strong>
                        <div ng-repeat="filter in source.filters track by $index">
                            {{ filter.field }} {{ filter.operator }}
                            <ul>
                                <li ng-repeat="value in filter.resolved || filter.value track by $index">
                                    {{ value }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div ng-if="source.columns.length > 0">
                        <strong>{{ 'columns' | translate }}</strong>
                        <ul>
                            <li ng-repeat="column in source.columns track by $index">
                                {{ column.label || column.field }}
                                <ul>
                                    <li>{{ 'Source:' | translate }} {{ column.source }}</li>
                                    <li ng-if="!column.resolved">{{ 'Field:' | translate }} {{ column.field }}</li>
                                    <li ng-if="column.resolved">{{ 'Field:' | translate }}
                                        <ul>
                                            <li ng-repeat="value in column.resolved || column.value track by $index">
                                                {{ value }}
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`,
  'app/components/reports/directives/sql-report-view.html': `<div>
    <div ng-if="$ctrl.display">
        <div ng-repeat="res in $ctrl.display">
            <div data-ng-switch on="res.type">
                <div data-ng-switch-when="table">
                    <div class="row">
                        <div class="col-sm-12">
                            <kz-report-task-button style="pull-right" report="$ctrl.report" model="$ctrl.model" extra="$ctrl.extra" data-ng-if="$ctrl.showCsvDownload(res)"
                                options="{limit_to: [res.output]}"
                            ></kz-report-task-button>
                        </div>
                    </div>
                    <kz-sql-table
                        table="$ctrl.outputs[res.output]"
                        options="res.options"
                        on-page="$ctrl.loadPage($name, $start, $size)"
                        on-preview="$ctrl.showPreview($col)"></kz-sql-table>
                </div>
                <div data-ng-switch-when="text">
                    <div ng-bind-html="res.content | nl2br | a2nt | videoUrlToIframe" class="readonly"></div>
                </div>
                <div data-ng-switch-when="chart">
                    <!-- Graph -->
                    <div style="max-width: 700px">
                        <canvas
                        epf-chartjs-line
                        chart-data="res.chart.data"
                        chart-options="res.chart.options"
                        data-ng-if="res.chart.type === 'line'"
                        ></canvas>
                        <canvas
                        epf-chartjs-bar
                        chart-data="res.chart.data"
                        chart-options="res.chart.options"
                        data-ng-if="res.chart.type === 'bar'"
                        ></canvas>
                        <canvas
                        epf-chartjs-radar
                        chart-data="res.chart.data"
                        chart-options="res.chart.options"
                        data-ng-if="res.chart.type === 'radar'"
                        ></canvas>
                        <canvas
                        epf-chartjs-polararea
                        chart-data="res.chart.data"
                        chart-options="res.chart.options"
                        data-ng-if="res.chart.type === 'polar'"
                        ></canvas>
                        <canvas
                        epf-chartjs-pie
                        chart-data="res.chart.data"
                        chart-options="res.chart.options"
                        data-ng-if="res.chart.type === 'pie'"
                        ></canvas>
                        <canvas
                        epf-chartjs-doughnut
                        chart-data="res.chart.data"
                        chart-options="res.chart.options"
                        data-ng-if="res.chart.type === 'doughnut'"
                        ></canvas>
                        <canvas
                        epf-chartjs-bubble
                        chart-data="res.chart.data"
                        chart-options="res.chart.options"
                        data-ng-if="res.chart.type === 'bubble'"
                        ></canvas>
                        <p class="text-gray">{{res.chart.description}}</p>
                        <span class="text-danger" data-ng-if="chart.error">{{ 'Oups somethings went wrong with the chart:' | translate }} {{chart.title}}</span>
                    </div>
                </div>
                <div data-ng-switch-default>
                    {{ 'Other' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
`,
  'app/components/reports/directives/sql-table.html': `<div class="table-scrollable">
    <div ng-if="$ctrl.showPagination">{{ 'Showing' | translate }} {{ $ctrl.table.start + 1 }} - {{ $ctrl.table.start + $ctrl.table.data.length }} {{ 'of' | translate }} {{ $ctrl.table.total }}</div>
    <table class="report-table table table-condensed">
        <thead>
            <tr>
                <th scope="col" ng-repeat="item in $ctrl.processedTable.headers track by $index">{{ item.id }}</th>
            </tr>
        </thead>
        <tbody>
            <tr ng-repeat="row in $ctrl.processedTable.data track by $index">
                <td ng-repeat="col in row track by $index">
                    <span ng-switch="col.type">
                        <span ng-switch-when="preview">
                            <button type="button" class="btn btn-sm btn-link text-link" data-ng-click="$ctrl.preview(col)" data-ng-if="col.value !== null && col.value !== undefined && col.value !== ''">{{ col.display }}</button>
                        </span>
                        <span ng-switch-default>{{ col.display }}</span>
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="text-center" ng-if="$ctrl.showPagination">
        <button type="button" ng-disabled="!$ctrl.showFirst" ng-click="$ctrl.first()"><<</button>
        <button type="button" ng-disabled="!$ctrl.showFirst" ng-click="$ctrl.prev()"><</button>
        <button type="button" ng-disabled="!$ctrl.showLast" ng-click="$ctrl.next()">></button>
        <button type="button" ng-disabled="!$ctrl.showLast" ng-click="$ctrl.last()">>></button>
        {{ 'Page size:' | translate }} <select ng-model="$ctrl.sizeModel.size" ng-change="$ctrl.sizeChanged()">
            <option ng-repeat="page in $ctrl.pageSizes" ng-value="page">{{ page }}</option>
        </select>
    </div>
</div>
`,
  'app/components/reports/layout.left.html': `<div class="wrapper">
  <header class="row">
    <div class="col-sm-12">
      <h2>{{ reportViewFiltersCtrl.reportViewer.title }}</h2>
      <p>
        <span class="text-gray" data-ng-bind-html="reportViewFiltersCtrl.reportViewer.subtitle"></span>
        <button type="button" class="btn btn-xs btn-primary" ng-click="reportViewFiltersCtrl.showDatesForm()" data-ng-if="!reportViewFiltersCtrl.showDates">{{ 'Change date range' | translate }}</button>
        <button type="button" class="btn btn-xs btn-primary" ng-click="reportViewFiltersCtrl.updateDates()" data-ng-if="reportViewFiltersCtrl.showDates">{{ 'update' | translate }}</button>
      </p>
      <p class="text-gray">
        <span data-ng-repeat="item in reportViewFiltersCtrl.report.overview" data-ng-class="item.style" data-ng-bind="item.label + ': ' + item.data + '. '"></span>
      </p>
    </div>

    <div data-ng-if="reportViewFiltersCtrl.showDates">
      <formly-form class="col-sm-6" model="reportViewFiltersCtrl.dates" fields="reportViewFiltersCtrl.leftForm.fields" aria-label="{{ 'Dates' | translate }}"></formly-form>
      <formly-form class="col-sm-6" model="reportViewFiltersCtrl.dates" fields="reportViewFiltersCtrl.rightForm.fields" aria-label="{{ 'Dates' | translate }}"></formly-form>
    </div>

  </header>

  <div class="row" style="overflow: auto; width: 100%; height: 850px;">
    <div id="report-details" class="col-sm-12"
         data-ng-if="reportViewFiltersCtrl.reportViewer.list.search && !reportViewFiltersCtrl.reportViewer.noBlueprints"
         data-kz-search
         data-search="reportViewFiltersCtrl.reportViewer.list.search"
         data-search-model="reportViewFiltersCtrl.reportViewer.list.searchModel"
         data-do-search="reportViewFiltersCtrl.reportViewer.list.doSearch()"></div>

    <div class="col-sm-12" data-ng-if="reportViewFiltersCtrl.reportViewer.noBlueprints">
        {{ 'There are no further tags to select. Showing information only on events tagged with' | translate }} {{ reportViewFiltersCtrl.reportViewer.title }}
    </div>
  </div>

  <div class="row" data-ng-if="reportViewFiltersCtrl.loading">
    <p class="text-center"><i class="icon-spin animate-spin"></i></p>
  </div>
</div>
`,
  'app/components/reports/multiReport.edit.element.html': `<form novalidate unsaved-warning-form name="form" aria-label="{{ 'Edit multi report element' | translate }}">
  <div class="wrapper">
    <header class="row">
      <div class="col-sm-8">
        <h2>{{ 'Edit' | translate }} <b>{{ multiReportEditElementCtrl.baseReport.doc.title }}</b> {{ 'multi report element' | translate }}</h2>
      </div>
      <div class="col-sm-4">
        <p class="button-list">
          <button type="submit" class="btn btn-success btn-raised" data-ng-click="multiReportEditElementCtrl.save()" data-ng-if="multiReportEditElementCtrl.editMode" unsaved-warning-clear>{{ 'Save' | translate }}</button>
          <button type="button" class="btn btn-info btn-raised" router-link="['/report_templates', multiReportEditElementCtrl.reportId, 'edit']">{{ 'Cancel' | translate }}</button>
        </p>
      </div>
    </header>
  </div>

  <div class="wrapper focus">
    <div class="row">
      <div class="col-sm-12">
        <formly-form model="multiReportEditElementCtrl.elementToEdit" fields="multiReportEditElementCtrl.form.fields" form="form" ng-if="multiReportEditElementCtrl.form" aria-label="{{ 'Edit multi report' | translate }}"></formly-form>
        <div ng-bind-html="multiReportEditElementCtrl.elementToEdit.text | nl2br" ng-if="!multiReportEditElementCtrl.form" class="readonly"></div>

        <div kz-loading loaded="multiReportEditElementCtrl.elementToEdit"></div>
        <report-builder single-report="multiReportEditElementCtrl.multiReport.singleReports[multiReportEditElementCtrl.elementToEdit._id]" data-ng-if="multiReportEditElementCtrl.elementToEdit.type === 'report'" edit-mode="::multiReportEditElementCtrl.editMode"></report-builder>
        <sql-report-builder report="multiReportEditElementCtrl.multiReport.sqlReports[multiReportEditElementCtrl.elementToEdit._id]" data-ng-if="multiReportEditElementCtrl.elementToEdit.type === 'sqlreport'" edit-mode="::multiReportEditElementCtrl.editMode"></sql-report-builder>
      </div>
    </div>
  </div>
</form>
`,
  'app/components/reports/partials/filters-definition.html': `<form novalidate name="eventFilter" aria-label="{{ 'Define your report filters' | translate }}">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="{{ 'Close' | translate }}"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title">
      <h2 class="heading-4">{{ 'Define your report filters' | translate }}</h2>
    </div>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <p class="text-gray">{{ 'This section is for you to select which data you would like the system to search for when running this report. Use the AND and OR buttons to create layers of nested filters. SPLIT is useful when you want to turn one filter into many within a single layer of the expression, just like grouping within parentheses. The USER CAN OVERRIDE field allows you to specify whether any of these fields can be changed by the user running the report, or whether they should all be preset.' | translate }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <kz-report-single-filter filter="singleReport.conf.filter" report="singleReport" edit-mode="editMode"></kz-report-single-filter>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-raised" data-ng-disabled="eventFilter.$invalid" data-ng-click="dismiss()">{{ "I'm Done" | translate }}</button>
  </div>
</form>
`,
  'app/components/reports/report.wrapper.html': `<div class="row">

    <div id="sidebar-left" class="col-sm-6" ng-if="$ctrl.loaded">
      <div class="row">
        <div class="col-sm-12">
          <report-view-filters report-viewer="$ctrl.reportViewer"></report-view-filters>
        </div>
      </div>
    </div>

    <div id="content" class="col-sm-6" ng-if="$ctrl.loaded">
      <div class="row">
        <div class="col-sm-12">
          <report-view-events show-action-buttons="$ctrl.showActionButtons" report-viewer="$ctrl.reportViewer"></report-view-events>
        </div>
      </div>
    </div>

</div>
`,
  'app/components/reports/reportTemplate.slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-sm-12">
      <h2><a router-link="['report_templates', 'run', item.doc._id]">{{ ::item.doc.title }}</a></h2>

      <div class="text-gray" data-ng-if="ctrl.showDescription" data-ng-bind-html="item.doc.description | nl2br"></div>
      <p class="text-gray"  data-ng-if="ctrl.showDescription">
        <span>{{ 'CURRENT VERSION:' | translate }} {{::ctrl.headVersion.version}} </span>
        <version-state version="ctrl.headVersion"></version-state>
      </p>
      <p class="text-success" data-ng-if="ctrl.showDescription && ctrl.published">
        <span>{{ 'PUBLISHED VERSION:' | translate }} {{::ctrl.published.version}}
          <span ng-if="item.doc.name !== ctrl.published.name">({{::ctrl.published.name}})</span>
        </span>
      </p>
    </div>
  </div>

  <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons" version="item" options="options"></kz-list-buttons>
</div>
`,
  'app/components/reports/run.html': `<section class="wrapper">

  <header class="row">
    <div class="col-sm-12">
      <h1>{{ reportsCtrl.baseReport.doc.title }}</h1>
    </div>

  </header>

</section>

<div kz-loading loaded="reportsCtrl.showForm">
  <div class="wrapper">
    <div class="row">
      <div class="col-sm-12">
        <form name="form" aria-label="reportsCtrl.baseReport.doc.title">
        <kz-report-form report="reportsCtrl.baseReport" model="reportsCtrl.reportData" required="true"></kz-report-form>

        <button type="submit" class="btn btn-success" data-ng-disabled="form.$invalid" data-ng-click="reportsCtrl.generate()">
          {{ (reportsCtrl.generated ? 'Update' : 'Generate') | translate }}
        </button>
        <kz-report-task-button style="pull-right" report="reportsCtrl.report" model="reportsCtrl.reportData" extra="reportsCtrl.extra" data-ng-if="reportsCtrl.showCsvDownload"></kz-report-task-button>
        </form>
      </div>
    </div>
  </div>

  <div class="print-ready wrapper" data-ng-if="reportsCtrl.showResult">
    <div class="row">
      <div class="col-sm-12">
        <kz-report-view report="reportsCtrl.baseReport" model="reportsCtrl.model" generated="reportsCtrl.generated" extra="reportsCtrl.extra" items-to-display="{ display: 'all' }"></kz-report-view>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/reports/templates_form.html': `<form novalidate unsaved-warning-form name="form" aria-label="{{ reportCtrl.baseReport.doc.title || ('New report template' | translate) }}">
  <div class="wrapper">
    <header class="row">
      <div class="col-sm-8">
        <h2 data-ng-bind="reportCtrl.baseReport.doc.title || 'New report template'"></h2>
      </div>
      <div class="col-sm-4">
        <p class="button-list">
          <button type="submit" class="btn btn-success btn-raised" data-ng-if="reportCtrl.editMode" data-ng-click="reportCtrl.save()" unsaved-warning-clear>{{ 'Save' | translate }}</button>
          <button type="button" class="btn btn-info btn-raised" router-link="['/report_templates']">{{ 'Cancel' | translate }}</button>
          <ng-container kz-feature-enabled feature="reporting">
            <a href="" class="btn btn-info btn-raised" router-link="['/report-management/new']" query-params="{ from: reportCtrl.baseReport.doc._id }">{{ 'Migrate' | translate }}</a>
            </ng-container>
        </p>
      </div>
      <audit-log-component ng-if="reportCtrl.baseReport.doc._rev" entries="reportCtrl.auditlog" on-expand="reportCtrl.loadAuditlog()"></audit-log-component>
    </header>
    <version-widget version="reportCtrl.version" form="form" data-ng-if="reportCtrl.version"></version-widget>

    <div class="row" ng-if="reportCtrl.loaded">
      <div class="col-sm-12">
        <p class="text-gray">
          <kz-report-event-types report="reportCtrl.baseReport"></kz-report-event-types>
        </p>
      </div>
    </div>
  </div>

  <div class="wrapper">
    <div class="row" data-ng-if="::reportCtrl.editMode">
      <div class="col-sm-12 text-right">
        <div ng-switch on="reportCtrl.report.type">
          <div ng-switch-when="singleReport">
            <a href="" class="text-info" ng-click="reportCtrl.switchToMultiReport()" ><i class="icon-toggle-off"></i> {{ 'Convert to multi report' | translate }}</a>
          </div>
          <div ng-switch-when="multiReport">
            <span href="" class="text-success"><i class="icon-toggle-on"></i> {{ 'Multi report' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <formly-form model="reportCtrl.baseReport.doc" fields="reportCtrl.baseForm.fields" form="form" aria-label="{{ 'Report' | translate }}"></formly-form>
      </div>
    </div>
  </div>

  <div ng-if="reportCtrl.showReportBuilder">
    <div kz-loading loaded="reportCtrl.report.type"></div>
    <report-builder single-report="reportCtrl.report" edit-mode="::reportCtrl.editMode" ng-if="reportCtrl.report.type === 'singleReport'"></report-builder>
    <multi-report-builder multi-report="reportCtrl.report" report-id="reportCtrl.baseReport.doc._id" edit-mode="::reportCtrl.editMode" ng-if="reportCtrl.report.type === 'multiReport'"></multi-report-builder>
  </div>

  <div class="wrapper">
    <div class="row">
      <div class="col-sm-12">
        <p class="text-danger" data-ng-if="reportCtrl.hasBeenModified">{{ 'The report template has been changed. Please use the Preview button to generate a new preview' | translate }}</p>
        <form name="form" aria-label="{{ 'Report generate and preview' | translate }}">
          <button type="button" class="btn btn-success" data-ng-disabled="form.$invalid" data-ng-click="reportCtrl.generate()">
            {{ (reportCtrl.showResult ? 'Update preview' : 'Preview') | translate }}
          </button>
          <kz-report-form report="reportCtrl.baseReport" model="reportCtrl.reportData" required="true" data-ng-if="reportCtrl.showResult"></kz-report-form>

        </form>
      </div>
    </div>
  </div>

  <div class="wrapper" data-ng-if="reportCtrl.showResult">
    <div class="row">
      <div class="col-sm-12">
        <kz-report-view report="reportCtrl.baseReport" model="reportCtrl.model" generated="reportCtrl.generated" extra="reportCtrl.extra" items-to-display="{ display: 'all' }" need-preview="true"></kz-report-view>
      </div>
    </div>
  </div>
</form>
`,
  'app/components/reports/templates_list.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="reportsCtrl.actions"><h1>
        <span ng-if="reportsCtrl.featureEnabled">
        {{ 'Legacy report templates' | translate }}
      </span>
      <span ng-if="!reportsCtrl.featureEnabled">
        {{ 'Reports' | translate }}
      </span></h1></kz-header>
      <kz-simple-search list="reportsCtrl.list"></kz-simple-search>
      <kz-search-string list="reportsCtrl.list"></kz-search-string>
  </header>
</section>

<kz-refine-filter
  list="reportsCtrl.list"
  refine-by="state"
></kz-refine-filter>

<kz-list-view list="reportsCtrl.list" options="reportsCtrl.options">
<report-type-slot item="item" options="options"></report-type-slot>
</kz-list-view>
`,
  'app/components/reports/view.html': `<section class="wrapper" style="overflow: auto; width: 100%; height: 1100px;">

  <header class="row">
    <div class="col-sm-9">
      <h1>{{ 'Events' | translate }}</h1>
      <kz-search-string list="reportViewEventsCtrl.list"></kz-search-string>

    </div>
  </header>
  <kz-list-view list="reportViewEventsCtrl.list" options="reportViewEventsCtrl.options" data-ng-if="reportViewEventsCtrl.list">
    <event-section-slot data-ng-if="item.doc.type === 'eventSection'" event-section="item" options="options"></event-section-slot>
    <event-slot data-ng-if="item.doc.type === 'event'" event="item" options="options"></event-slot>
  </kz-list-view>

</section>
`,
  'app/components/reports/widgets/blueprint-coverage/edit.html': `<form role="form" aria-label="{{ 'Blueprint coverage' | translate }}">
  <div class="form-group">
    <label for="blueprint">{{ 'Select a blueprint to use' | translate }}</label>
    <select name="blueprint" id="blueprint" class="form-control" placeholder="{{ 'Select a blueprint' | translate }}" data-ng-options="blueprint.name for blueprint in BlueprintCoverageWidgetCtrl.blueprints track by blueprint.id" data-ng-model="BlueprintCoverageWidgetCtrl.config.blueprint"></select>
  </div>
  <div class="form-group">
    <input type="checkbox" name="displayGraph" id="displayGraph" data-ng-model="BlueprintCoverageWidgetCtrl.config.displayGraph" />
    <label for="displayGraph">{{ 'Show coverage circles' | translate }}</label>
  </div>
</form>
`,
  'app/components/reports/widgets/blueprint-coverage/view.html': `<div>
  <!-- loading graph spinner -->
  <div data-ng-if="BlueprintCoverageWidgetCtrl.loadingGraph">
    <p class="text-center"><i class="icon-spin animate-spin"></i></p>
  </div>

  <div id="report-overview" class="row" data-ng-if="BlueprintCoverageWidgetCtrl.report && !BlueprintCoverageWidgetCtrl.loadingGraph">
    <div data-ng-repeat="item in ::BlueprintCoverageWidgetCtrl.report.data.overview" data-ng-class="::([BlueprintCoverageWidgetCtrl.widgetCircleClass, item.style])">
      <div class="circle circle-lg" data-ng-class="::item.style" data-ng-bind="::item.data"></div>
      <p data-ng-bind="::item.label"></p>
    </div>

      <div class="row text-center"><h4 class="text-center" kz-blueprint-category-title category="BlueprintCoverageWidgetCtrl.currentBlueprint"></h4></div>
  </div>

  <div data-ng-if="BlueprintCoverageWidgetCtrl.coverages && !BlueprintCoverageWidgetCtrl.loadingCoverages">
    <div ng-repeat="(periodName, blueprints) in BlueprintCoverageWidgetCtrl.coverages track by $index">
      <div
        class="row"
        style="background-color: lightgrey; margin-top: 10px; padding-left: 10px">
        {{ periodName | capitalize:'first' }}
      </div>


      <!--<div class="text-gray" style="color: deepskyblue; font-size:10px" epf-relation-title relation="{{::relationId}}"></div>-->
      <div ng-repeat="item in ::blueprints track by $index">
        <div ng-repeat="(blueprintId, values) in ::item.blueprint track by blueprintId">
          <div class="row" data-ng-if="!values.length">
            <div class="col-xs-9" >
              <a href="" class="tag-name" kz-blueprint-category-title category="blueprintId"
                 data-ng-click="BlueprintCoverageWidgetCtrl.updateGraph({ blueprintId: blueprintId })"></a>
            </div>
            <div class="col-xs-3 text-right" data-ng-if="!values.length">
              <button type="button" class="btn btn-info btn-xs" data-ng-click="BlueprintCoverageWidgetCtrl.goToCoverage(blueprintId)">{{ 'View' | translate }}</button>
            </div>
          </div>
          <div class="row" ng-repeat="blueprintCatId in ::values track by blueprintCatId.id">
            <div class="col-xs-9" >
              <a href="" class="tag-name"
               data-ng-click="BlueprintCoverageWidgetCtrl.updateGraph({ blueprintId: blueprintId, blueprintCatId: blueprintCatId.id })">{{ blueprintCatId.title }}</a>

            <!-- showing dates -->
              <div ng-repeat="date in ::item.dates track by $index">
                <span class="text-gray" style="font-size:10px">
                  {{::date.start|date:BlueprintCoverageWidgetCtrl.dateFormat}} - {{::date.end|date:BlueprintCoverageWidgetCtrl.dateFormat}}
                </span>
              </div>
            </div>
            <div class="col-xs-3 text-right">
              <button type="button" class="btn btn-info btn-xs" data-ng-click="BlueprintCoverageWidgetCtrl.goToCoverage(blueprintId, blueprintCatId.id)">{{ 'View' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- loading coverages spinner -->
  <div class="col-xs-12" data-ng-if="BlueprintCoverageWidgetCtrl.loadingCoverages">
    <p class="text-center"><i class="icon-spin animate-spin"></i></p>
  </div>

  <!-- no coverages available -->
  <div class="text-center" data-ng-if="!BlueprintCoverageWidgetCtrl.coverages && !BlueprintCoverageWidgetCtrl.loadingCoverages && !BlueprintCoverageWidgetCtrl.error">
    <span data-ng-if="!BlueprintCoverageWidgetCtrl.isRemoteUser">{{ 'You have not been assigned this yet' | translate }}</span>
    <span data-ng-if="BlueprintCoverageWidgetCtrl.isRemoteUser"><span epf-fullname user="BlueprintCoverageWidgetCtrl.user"></span> {{ 'has not been assigned this yet' | translate }}</span>
  </div>

  <!-- error message -->
  <div data-ng-if="BlueprintCoverageWidgetCtrl.error" class="text-danger text-center">
    {{BlueprintCoverageWidgetCtrl.error}}
  </div>
</div>
`,
  'app/components/reports/widgets/report/edit.html': `<kz-report-conf-view model="editCtrl.config" options="{ useVersionId: true }"></kz-report-conf-view>
<kz-report-form class="col-xs-12" report="editCtrl.report" model="editCtrl.config.reportData" default-model="editCtrl.config.reportData" data-ng-if="editCtrl.report"></kz-report-form>
`,
  'app/components/reports/widgets/report/view.html': `<div>
  <!-- loading graph spinner -->
  <div data-ng-if="viewCtrl.loading">
    <p class="text-center"><i class="icon-spin animate-spin"></i></p>
  </div>

  <div data-ng-if="viewCtrl.showResult">
    <kz-report-view report="viewCtrl.report" model="viewCtrl.defaultModel" generated="viewCtrl.generated" items-to-display="viewCtrl.config" extra="{ user: viewCtrl.username, hidePDF: true }"></kz-report-view>
  </div>

  <!-- link -->
  <div ng-if="!viewCtrl.remoteUser">
    <p class="text-center"><a class="btn btn-xs btn-primary" router-link="['/report_templates/run', viewCtrl.report.doc._id]" data-ng-if="viewCtrl.report.doc._id">{{ 'View full report' | translate }}</a></p>
  </div>

  <!-- error message -->
  <div data-ng-if="viewCtrl.error" class="text-danger">
    {{viewCtrl.error}}
  </div>
</div>
`,
  'app/components/roles/form.html': `<form novalidate unsaved-warning-form name="form" aria-label="{{ 'Edit role' | translate }}">

  <div kz-loading loaded="roleCtrl.loaded">
    <div class="wrapper">

      <header class="row">
        <div class="col-sm-6">
          <h1>{{ 'Edit role' | translate }}</h1>
        </div>
        <div class="col-sm-6">
          <p class="button-list">
            <button type="submit" class="btn btn-success btn-raised" data-ng-if="roleCtrl.showSave" data-ng-click="roleCtrl.save(form)">{{ 'Save' | translate }}</button>
            <button type="button" class="btn btn-info btn-raised" router-link="['/roles']">{{ 'Cancel' | translate }}</button>
            <button type="button" class="btn btn-danger btn-raised" data-ng-if="roleCtrl.showDelete" data-ng-click="roleCtrl.remove()">{{ 'Delete' | translate }}</button>
            <button type="button" class="btn btn-success btn-raised" data-ng-if="roleCtrl.showDuplicate" data-ng-click="roleCtrl.duplicate()">{{ 'Duplicate' | translate }}</button>
          </p>
        </div>
        <audit-log-component ng-if="roleCtrl.role._rev" entries="roleCtrl.auditlog" on-expand="roleCtrl.loadAuditlog()"></audit-log-component>
      </header>

      <div class="row">
        <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
      </div>

      <div class="row">
        <div class="form-group col-xs-12" data-ng-class="{ 'has-error has-feedback': form.title.$invalid && formIsSubmitted}">
          <label for="role-title">{{ 'Title' | translate }} <i class="icon-star required" aria-label="{{ 'star' | translate }}"></i></label>
          <input data-ng-model="roleCtrl.role.title" type="text" id="role-title" name="title" class="form-control" data-ng-required="true" aria-describedby="titleStatus">

          <div data-ng-if="form.title.$invalid && formIsSubmitted">
            <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
            <p id="titleStatus" class="help-block text-gray">{{ 'The title is required.' | translate }}</p>
          </div>
        </div>

        <div class="col-xs-12">
          <div class="form-group">
            <label for="role-description">{{ 'Description' | translate }}</label>
            <textarea id="role-description" name="description" data-ng-model="roleCtrl.role.description" class="form-control"></textarea>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-9">
          <div class="form-group">
            <label for="role-permissions">{{ 'Select individual permissions for users with this role' | translate }}</label>
            <ui-select id="role-permissions" multiple ng-model="roleCtrl.role.permissions" close-on-select="false" title="{{ 'Choose permissions' | translate }}">
              <ui-select-match placeholder="{{ 'Select permissions...' | translate }}">{{$item.description}}</ui-select-match>
              <ui-select-choices repeat="permission.name as permission in roleCtrl.permissions | filter:$select.search">
                {{permission.description}}
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <div class="col-sm-3 text-right">
          <ul class="list-inline list-unstyled">
            <li><a data-ng-if="roleCtrl.role.permissions.length !== roleCtrl.permissions.length" class="btn btn-xs border border-primary" href="" data-ng-click="roleCtrl.selectAllPermissions()">{{ 'Select all' | translate }}</a></li>
            <li><a class="btn btn-xs btn-border btn-danger" href="" data-ng-click="roleCtrl.clearAllPermissions()">{{ 'Clear all' | translate }}</a></li>
          </ul>
        </div>
      </div>

      <div class="row" data-ng-if="roleCtrl.roles">
        <div class="col-sm-12">
          <div class="form-group">
            <label for="role-appliesTo">{{ 'Restrict the above permissions to be actionable only against other users of the system with the following roles. If left blank then the above permissions will be actionable against all users in the system.' | translate }}</label>
            <ui-select id="role-appliesTo" multiple ng-model="roleCtrl.role.appliesToRoles" close-on-select="false" title="{{ 'Choose roles' | translate }}">
              <ui-select-match placeholder="{{ 'Select roles...' | translate }}">{{$item.title}}</ui-select-match>
              <ui-select-choices repeat="role._id as role in roleCtrl.roles| filter:$select.search">
                {{role.title}}
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
      </div>

      <div class="row" data-ng-show="roleCtrl.role.permissions.indexOf('events.view') !== -1">
        <div class="col-sm-12">
          <div class="form-group">
            <label>{{ 'Select which events of other users should be visible' | translate }}</label>
            <formly-form model="roleCtrl.restData" fields="roleCtrl.restForm.fields" aria-label="{{ 'Visability' | translate }}"></formly-form>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <div class="checkbox">
            <label>
              <input type="checkbox" data-ng-model="roleCtrl.role.invitable" type="checkbox">
              {{ 'Allow new users to be invited to fill in next section. If selected then this role cannot be assigned any relations.' | translate }}</label>
            </div>
          </div>
          <div class="form-group" data-ng-show="roleCtrl.role.invitable">
            <label for="invitableDomains">{{ 'Allowed domains' | translate }}</label>
            <textarea name="invitableDomains" id="invitableDomains" msd-elastic="\n" data-ng-model="roleCtrl.invitableDomains" class="form-control"></textarea>
          </div>
        </div>
      </div>

      <div class="row" data-ng-show="!roleCtrl.role.invitable">
        <div class="col-sm-9">
          <div class="form-group">
            <label for="role-relations">{{ 'Restrict the above permissions to be actionable only against other users of the system that match the following relations.' | translate }}</label>
            <ui-select id="role-relations" multiple ng-model="roleCtrl.role.relations" close-on-select="false" title="{{ 'Choose relations' | translate }}">
              <ui-select-match placeholder="{{ 'Select relations...' | translate }}">{{$item.doc.name}}</ui-select-match>
              <ui-select-choices repeat="relation.doc._id as relation in roleCtrl.relations | filter:$select.search">
                {{relation.doc.name}}
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group">
            <div class="checkbox">
              <label>
                <input name="roleCtrl.role.isUserDependent" data-ng-model="roleCtrl.role.isUserDependent" type="checkbox"> {{ 'Mark this role as user dependent?' | translate }}
              </label>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</form>
`,
  'app/components/roles/list.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="rolesCtrl.actions"><h1>{{ 'Roles' | translate }}</h1></kz-header>
      <kz-simple-search list="rolesCtrl.list"></kz-simple-search>
      <kz-search-string list="rolesCtrl.list"></kz-search-string>
  </header>
  <kz-refine-filter list="rolesCtrl.list"
    ></kz-refine-filter>
</section>


<kz-list-view list="rolesCtrl.list" options="rolesCtrl.options">
  <list-slot item="item" options="options"></list-slot>
</kz-list-view>
`,
  'app/components/roles/roles.group.html': `<div class="box box-info" data-ng-if="depRoles.length > 0">
  {{ 'Please note some roles you have selected require users to be explicitly linked together in order for the permissions to take effect:' | translate }}
<span epf-roles-title roles="depRoles"></span>
</div>
<formly-form model="model" fields="form.fields" form="form" aria-label="{{ 'Roles' | translate }}"></formly-form>
`,
  'app/components/settings/cleanup.banner.html': `<div>
    <div data-ng-if="shown">
      <div class="box box-info">
        <p>
          <strong>{{ 'Your browser cache is getting too big. For better user experience we recommend to clean up your browser. If you would like to optimise risr/advance please use the button below.' | translate }}</strong>
        </p>
        <p>
          <a href="" class="btn btn-info btn-sm" data-ng-click="cleanUp()">{{ 'Optimise' | translate }}</a>
          <a href="" class="btn btn-info btn-sm" data-ng-click="dismiss()">{{ 'Dismiss' | translate }}</a>
        </p>
      </div>
    </div>
  </div>
`,
  'app/components/settings/form.html': `  <div class="wrapper">

    <header class="row">
      <div class="col-sm-6">
        <h1>{{ 'Settings' | translate }}</h1>
      </div>
      <div class="col-sm-6">
        <p class="button-list">
          <button type="button" class="btn btn-info btn-raised" router-link="['/dashboard']">{{ 'Back' | translate }}</button>
        </p>
      </div>
    </header>

  </div>

  <div class="wrapper">

    <uib-tabset class="row">
      <uib-tab index="0" heading="{{ 'Security' | translate }}">
        <div class="row" data-ng-if="settingsCtrl.pinForm">
          <div class="col-xs-12">
            <h4>{{ settingsCtrl.pinHeader }}</h4>
            <p>{{ 'In areas without internet connection a PIN is required to access your ePortfolio. When the device connects to the internet you may be asked to login before it will synchronize' | translate }}</p>
            <p class="text text-danger" data-ng-if="settingsCtrl.error">{{ settingsCtrl.error }}</p>
            <form name="pinForm" ng-submit="settingsCtrl.updatePin(pinForm)" aria-label="{{ 'PIN form' | translate }}">
              <formly-form model="settingsCtrl.pin" fields="settingsCtrl.pinForm.fields" form="pinForm" aria-label="{{ 'PIN' | translate }}"></formly-form>
              <button type="button" class="btn btn-info" data-ng-disabled="pinForm.$invalid">{{ settingsCtrl.pinHeader }}</button>
            </form>
          </div>
        </div>
        <div class="row" data-ng-if="settingsCtrl.storageModeForm">
          <div class="col-xs-12">
            <h4>{{ 'Local storage mode' | translate }}</h4>
            <p>{{ 'Set the use of storage in this browser' | translate }}</p>
            <form name="storageModeForm" ng-submit="settingsCtrl.updateStorageMode(storageModeForm)" aria-label="{{ 'Local storage mode' | translate }}">
              <formly-form model="settingsCtrl.storage" fields="settingsCtrl.storageModeForm.fields" form="storageModeForm"></formly-form>
              <button type="button" class="btn btn-info" data-ng-disabled="storageModeForm.$invalid">{{ 'Update' | translate }}</button>
            </form>
          </div>
        </div>
      </uib-tab>

      <uib-tab index="1" heading="{{ 'Experimental' | translate }}">
        <div class="row" data-ng-if="false">
          <div class="col-xs-12" data-ng-if="settingsCtrl.settings.preferredMode === 'online'">
            <h4>{{ 'risr/advance in online mode' | translate }}</h4>

            <div data-ng-show="settingsCtrl.allowLocalDataStorage">
              <p>{{ 'risr/advance is set to operate in online mode. This mode does not store anything on the device. It is recommend to allow the device to store data so it is possible to work in areas without internet connection.' | translate }}</p>

              <p>{{ 'Allow risr/advance to store data locally' | translate }}</p>
              <button type="button" class="btn btn-success" data-ng-disabled="['online', 'offline'].indexOf(settingsCtrl.actualMode) === -1" data-ng-click="settingsCtrl.setOffline(true)">{{ 'Allow' | translate }}</button>
            </div>

            <p data-ng-show="!settingsCtrl.allowLocalDataStorage" data-ng-bind="settingsCtrl.noLocalStorageMessage"></p>

          </div>
          <div class="col-xs-12" data-ng-if="settingsCtrl.settings.preferredMode === 'offline'">
            <h4>{{ 'risr/advance in offline mode' | translate }}</h4>

            <p>{{ 'risr/advance is allowed to store data on the device. It is the recommended mode as it allows usage in areas without internet connection.' | translate }}</p>

            <p>{{ 'Remove all data from this device and switch to online only mode' | translate }}</p>
            <button type="button" class="btn btn-info"  data-ng-disabled="['online', 'offline'].indexOf(settingsCtrl.actualMode) === -1" data-ng-click="settingsCtrl.setOffline(false)">{{ 'Turn off' | translate }}</button>
          </div>
        </div>

        <div class="row" data-ng-if="false">
          <div class="col-xs-12">
            <h4>{{ 'Optimise data usage' | translate }}</h4>
            <p>{{ 'This is an experimental beta version to reduce the data required upon dashboard and timeline loading.' | translate }}</p>
            <formly-form model="settingsCtrl.settings" fields="settingsCtrl.optimizeForm.fields" form="form" aria-label="{{ 'Optimization' | translate }}"></formly-form>
            <button type="button" class="btn btn-info" data-ng-click="settingsCtrl.updateOptimize()">{{ 'Save' | translate }}</button>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h4>{{ 'Empty cache' | translate }}</h4>
            <p>{{ 'Use this if you encounter some issues with saved changes not appearing to update immediately, for example updates to form fields or amendments to role permissions.' | translate }}</p>
            <button type="button" class="btn btn-info" data-ng-click="settingsCtrl.clearCache()">{{ 'Clear' | translate }}</button>
            <p>{{ 'View cache usage' | translate }} <a href="" router-link="['/settings/status']">{{ 'here' | translate }}</a></p>
            <p>{{ 'Review local data' | translate }} <a href="" router-link="['/settings/review']">{{ 'here' | translate }}</a></p>
            <p>{{ 'Test offline capability' | translate }} <a href="" router-link="['/settings/offlinetest']">{{ 'here' | translate }}</a></p>
          </div>
        </div>
      </uib-tab>

      <uib-tab index="2" heading="{{ 'Application information' | translate }}">
        <div class="row">
          <div class="col-xs-12">
            <h4>{{ 'Current versions' | translate }}</h4>
            <ul class="list-unstyled">
              <li data-ng-if="settingsCtrl.versions.kaizen">{{ 'risr/advance:' | translate }} <span class="text-success" data-ng-bind="settingsCtrl.versions.kaizen"></span></li>
              <li data-ng-if="settingsCtrl.versions.frontend">{{ 'Frontend:' | translate }} <span class="text-success" data-ng-bind="settingsCtrl.versions.frontend"></span></li>
            </ul>
          </div>
        </div>
      </uib-tab>
    </uib-tabset>

  </div>
`,
  'app/components/settings/offline.banner.html': `<div>
  <div data-ng-if="shown">
    <div class="box box-info">
      <p>
        <strong>{{ 'Would you like to store data on this device?' | translate }}</strong>
      </p>
      <p>
        {{ 'risr/advance uses device storage for quicker access and offline use. You can always' | translate }} <a router-link="['/settings/offline']">{{ 'review your offline settings' | translate }}</a>.
      </p>

      <p>
        <a href="" class="btn btn-info btn-sm" data-ng-click="setTrusted()">{{ 'I trust this device' | translate }}</a>
        <a href="" class="btn btn-info btn-sm" data-ng-click="setShared()">{{ 'This is a shared device' | translate }}</a>
      </p>
    </div>
  </div>
</div>
`,
  'app/components/settings/offlineresult.html': `  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-8">
        <span data-ng-if="level === undefined" class="lead {{ test.result.state | kzStateClass:'lead' }}">{{ test.description }}</span>
        <span data-ng-if="level > 0" class="{{ test.result.state | kzStateClass }}">{{ test.description }}</span>
        <br  data-ng-if="level === undefined"/>
        <span class="sublevel"></span>
        <span class="text-gray">
          <span data-ng-if="test.result">{{ test.result.message }}</span>
        </span>
      </div>
      <div class="col-sm-4 text-right">
        <button type="button" data-ng-if="test.result.button"
          class="btn btn-border btn-sm {{ test.result.button.class }}"
          router-link="test.result.button.route">{{ test.result.button.label }}</button>

        <span class="lead" data-ng-if="!test.result.button && level === undefined">
          <i data-ng-if="test.result.state === 'success'" class="icon-ok text-success"></i>
          <i data-ng-if="test.result.state === 'warning'" class="icon-info text-warning"></i>
          <i data-ng-if="test.result.state === 'error'" class="icon-warning text-danger"></i>
        </span>
        <span class="text-gray" data-ng-if="!test.result.button && level !== undefined">
          <i data-ng-if="test.result.state === 'success'" class="icon-ok text-success"></i>
          <i data-ng-if="test.result.state === 'warning'" class="icon-info text-warning"></i>
          <i data-ng-if="test.result.state === 'error'" class="icon-warning text-danger"></i>
        </span>
      </div>
    </div>
  </div>
`,
  'app/components/settings/offlineresultlist.html': `<div>
  <div data-ng-if="level === undefined" class="row row-bordered" level="level"
       kz-offline-result-item test="test" ng-repeat="test in tests">
  </div>
  <div data-ng-if="level > 0" class="row" level="level"
       kz-offline-result-item test="test" ng-repeat="test in tests">
  </div>
</div>
`,
  'app/components/settings/offlinesettings.html': `<div class="wrapper">

  <header class="row">
    <div class="col-sm-12">
      <h1>{{ 'Offline settings' | translate }}</h1>
    </div>
  </header>

</div>

<div class="wrapper">
  <div class="row">
    <div class="col-sm-12">
      <p>{{ 'risr/advance can be used without a network connection. To take advantage of this functionality please enable a PIN and allow data to be stored on this device. If this is a shared device then you may wish to disallow data from being stored for security reasons. This will not allow you to work in offline mode.' | translate }}</p>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-8">
      <h4>{{ 'Can my device work offline?' | translate }}</h4>
      <ul class="list-unstyled" data-ng-if="offlineCtrl.info.offlineCapability.state !== undefined">
        <li>
          <p>
             <span class="{{ offlineCtrl.info.offlineCapability.state | kzStateClass }}">
              <i class="icon-warning {{ offlineCtrl.info.offlineCapability.state | kzStateClass }}"></i>
              {{ offlineCtrl.info.offlineCapability.message }}
            </span>
          </p>
        </li>
      </ul>

    </div>
    <div class="col-sm-4 text-right">
      <a class="btn btn-primary btn-sm" router-link=['/settings/test'] >{{ 'Diagnose' | translate }}</a>
    </div>
  </div>

  <div class="row" kz-loading loaded="offlineCtrl.loaded">
    <div class="col-sm-8">
      <h4>{{ 'Set a PIN' | translate }}</h4>
      <p class="text-gray">{{ 'By setting a PIN you are able to login to risr/advance in areas without a network connection. Once back online please ensure you authenticate with your account using your usual username and password in order to synchronise your changes.' | translate }}</p>
      <p>
        <span data-ng-if="offlineCtrl.pin" class="text-success">{{ 'PIN is set' | translate }}</span>
        <span data-ng-if="!offlineCtrl.pin" class="text-danger">{{ 'Please set your PIN' | translate }}</span>
      </p>
    </div>
    <div class="col-sm-4 text-right">
      <a href="" class="btn btn-primary btn-sm" data-ng-if="!offlineCtrl.showPinForm"
        data-ng-click="offlineCtrl.setupPinForm()">
        <span data-ng-if="offlineCtrl.pin">{{ 'Change PIN' | translate }}</span>
        <span data-ng-if="!offlineCtrl.pin">{{ 'Set PIN' | translate }}</span>
      </a>
      <a href="" class="btn btn-primary btn-sm" data-ng-if="offlineCtrl.showPinForm"
        data-ng-click="offlineCtrl.hidePinForm()">
        {{ 'Hide' | translate }}
      </a>
    </div>
    <div class="col-sm-12" data-ng-if="offlineCtrl.showPinForm">
      <p class="text text-danger" data-ng-if="offlineCtrl.pinFormError">{{ offlineCtrl.pinFormError }}</p>
      <form name="pinForm" ng-submit="offlineCtrl.updatePin(pinForm)" aria-label="{{ 'PIN form' | translate }}">
        <formly-form model="offlineCtrl.pinData" fields="offlineCtrl.pinForm.fields" form="pinForm" aria-label="{{ 'PIN' | translate }}"></formly-form>
        <button type="submit" class="btn btn-info" data-ng-disabled="pinForm.$invalid">{{ 'Set' | translate }}</button>
        <button type="button" data-ng-click="offlineCtrl.unsetPin(pinForm)" class="btn btn-danger">{{ 'Unset' | translate }}</button>
      </form>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-8">
      <h4>{{ 'Data storage mode' | translate }}</h4>
      <p data-ng-if="offlineCtrl.noIDBSupport" class="box box-danger">
        {{ 'There is no support for local storage on this device' | translate }}
      </p>
      <p class="text-gray">{{ 'This is where you can choose whether or not to allow this device to store some of your risr/advance data. In order to work offline you will need to allow data to be stored. If this is a shared device then we recommend you store the data temporarily. This will clear all risr/advance data when you logout.' | translate }}</p>
      <ul class="list-unstyled">
        <li>
          <p>
            <span class="{{ offlineCtrl.storage.class }}">{{ offlineCtrl.storage.description}}</span>
          </p>
        </li>
      </ul>
    </div>
    <div class="col-sm-4 text-right">
      <a href="" class="btn btn-primary btn-sm" data-ng-if="!offlineCtrl.showStorageForm && !offlineCtrl.noIDBSupport"
        data-ng-click="offlineCtrl.setupStorageForm()">{{ 'Change storage mode' | translate }}</a>
      <a href="" class="btn btn-primary btn-sm" data-ng-if="offlineCtrl.showStorageForm"
        data-ng-click="offlineCtrl.hideStorageForm()">
        {{ 'Hide' | translate }}
      </a>
    </div>
    <div class="col-sm-12" data-ng-if="offlineCtrl.showStorageForm">
      <p class="text text-danger" data-ng-if="offlineCtrl.storageFormError">{{ offlineCtrl.storageFormError }}</p>
      <form name="storageForm" ng-submit="offlineCtrl.updateStorageMode(storageForm)">
        <formly-form model="offlineCtrl.storageData" fields="offlineCtrl.storageForm.fields" form="storageForm" aria-label="{{ 'Storage mode' | translate }}"></formly-form>
        <button type="submit" class="btn btn-info" data-ng-disabled="storageForm.$invalid">{{ 'Set storage mode' | translate }}</button>
      </form>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-8">
      <h4>{{ 'Local data awaiting synchronisation' | translate }}</h4>
      <p class="text-gray">{{ 'Any data submitted whilst you are working in offline mode is synchronised to your account when you come back online. If there are any problems with this sync you can act upon them here.' | translate }}</p>
      <ul class="list-unstyled">
        <li>
          <p data-ng-class="{'text-success': offlineCtrl.info.toSync === 0, 'text-warning': offlineCtrl.info.toSync > 0}">
            <span data-ng-if="offlineCtrl.info.toSync === 0">{{ 'There are no locally modified items waiting to be synchronised.' | translate }}</span>
            <span data-ng-if="offlineCtrl.info.toSync === 1">{{ 'There is 1 locally modified item waiting to be synchronised.' | translate }}</span>
            <span data-ng-if="offlineCtrl.info.toSync > 1">{{ offlineCtrl.info.toSync }} {{ 'locally modified items waiting to be synchronised.' | translate }}</span>
          </p>
        </li>
      </ul>

    </div>
    <div class="col-sm-4 text-right">
      <a class="btn btn-primary btn-sm" router-link="['/settings/review']">
        {{ 'Review' | translate }}
      </a>
    </div>
  </div>
  <div id="trouble-container" class="row" ng-show="offlineCtrl.troubleExpanded">
    <div class="col-xs-12">
      <div class="row">
        <div class="col-sm-8">
          <h4>{{ 'Application version' | translate }}</h4>
          <ul class="list-unstyled">
            <li>
              {{ 'Version:' | translate }} <span class="text-success" data-ng-if="offlineCtrl.versions.platform" data-ng-bind="offlineCtrl.versions.platform"></span>
              <span class="text-danger" data-ng-if="!offlineCtrl.versions.platform">{{ 'Information not available, you may be working offline' | translate }}</span>
            </li>
            <li data-ng-if="offlineCtrl.versions.frontend">
              {{ 'Frontend:' | translate }}
              <span class="{{ offlineCtrl.versions.upgradeNeeded ? 'text-danger' : 'text-success' }}" data-ng-bind="offlineCtrl.versions.frontend"></span>
              <span data-ng-if="offlineCtrl.versions.upgradeNeeded" class="text-danger">{{ ' - There is a new frontend available:' | translate }} {{ offlineCtrl.versions.serverFrontend }}. {{ 'Please refresh this page.' | translate }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <h4>{{ 'Troubleshooting' | translate }}</h4>
          <div>
            <ul class="list-unstyled">
              <li>
                <p>{{ 'If you allow it to, risr/advance stores data on this device to offer a better experience. In some unusual cases you may need to update this data manually or clear it in the event of a problem.' | translate }}</p>
                <p>
                  <span data-ng-if="offlineCtrl.itemCount === 0">{{ 'There are no items stored on this device' | translate }}</span>
                  <span data-ng-if="offlineCtrl.itemCount === 1">{{ 'There is 1 item stored on this device' | translate }}</span>
                  <span data-ng-if="offlineCtrl.itemCount > 1">{{ offlineCtrl.itemCount }} {{ 'items stored on this device' | translate }}</span>
                  <a href="" class="btn btn-info btn-xs" ng-click="offlineCtrl.updateAll()">{{ 'Update' | translate }}</a>
                  <a href="" class="btn btn-danger btn-xs" ng-click="offlineCtrl.clearAll()">{{ 'Clear' | translate }}</a>
                </p>
              </li>
              <li>
                <p>{{ 'To completely remove all risr/advance data from your browser use the reset button below. Please note that any data created offline that is waiting to sync to your account will be removed.' | translate }}</p>
                <p>
                  {{ 'Reset data and reinstall the application' | translate }}
                  <a href="" class="btn btn-danger btn-xs" ng-click="offlineCtrl.clearCache()">{{ 'Reset' | translate }}</a>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 text-center">
      <button type="button" class="btn btn-sm btn-link text-info" aria-controls="trouble-container" aria-expanded="{{offlineCtrl.troubleExpanded}}" ng-click="offlineCtrl.troubleExpanded = !offlineCtrl.troubleExpanded">
        <span ng-if="!offlineCtrl.troubleExpanded">
          {{ 'Show advanced' | translate }} <i class="icon-down-open-big"></i>
        </span>
        <span ng-if="offlineCtrl.troubleExpanded">
          {{ 'Hide advanced' | translate }} <i class="icon-up-open-big"></i>
        </span>
      </button>
    </div>
  </div>
</div>
`,
  'app/components/settings/offlinetest.html': `<div class="wrapper">

  <header class="row">
    <div class="col-sm-6">
      <h1>{{ 'Offline diagnostics report' | translate }}</h1>
    </div>
    <div class="col-sm-6">
      <p class="button-list">
        <button type="button" class="btn btn-info btn-raised" router-link="['/settings/offline']">{{ 'Back' | translate }}</button>
      </p>
    </div>
  </header>

</div>

<div class="wrapper">
  <div class="row">
    <p>{{ 'The offline diagnostics test will determine if the device is capable of running risr/advance offline and whether it has any limitations.' | translate }}</p>
    <p>{{ 'To start the test, please press the below button.' | translate }}</p>
    <p>
      <a class="btn btn-info" data-ng-disabled="testCtrl.running" href="" data-ng-click="testCtrl.testAll()">{{ 'Start test' | translate }}</a>
    </p>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="box box-info">
        <p data-ng-if="testCtrl.running">{{ 'The test is running...' | translate }}</p>
        <p>{{ 'Estimated test database size:' | translate }} {{ testCtrl.info.doc_count }}MB</p>
      </div>
    </div>
  </div>
  <kz-offline-result tests="testCtrl.tests"></kz-offline-result>
</div>

<div class="wrapper">
  <div>
    <div class="row row-bordered">
      <div class="col-sm-8">
        <span class="lead {{ testCtrl.overAll.state | kzStateClass:'lead' }}">{{ 'Overall result' | translate }}</span>
        <br />
        <span>{{ testCtrl.overAll.message }}</span>
      </div>
      <div class="col-sm-4 text-right">
        <span class="lead">
          <i data-ng-if="testCtrl.overAll.state === 'success'" class="icon-ok text-success"></i>
          <i data-ng-if="testCtrl.overAll.state === 'warning'" class="icon-info text-warning"></i>
          <i data-ng-if="testCtrl.overAll.state === 'error'" class="icon-warning text-danger"></i>
        </span>
      </div>

    </div>
  </div>
</div>
`,
  'app/components/settings/review.html': `<div class="wrapper">

  <header class="row">
    <kz-header actions="reviewCtrl.actions">
      <h1>{{ 'Locally modified data' | translate }}</h1>
    </kz-header>
  </header>

  <div class="row">
    <div class="col-xs-12" kz-loading loaded="reviewCtrl.loaded">
      <div class="box box-danger" data-ng-if="reviewCtrl.error">
        <div data-ng-if="reviewCtrl.error.status === 401">
          {{ 'In order to synchronise data with your account please login to your account using your usual username and password. Please click login to being the process.' | translate }}
          <a href="" class="btn btn-xs btn-primary" data-ng-click="reviewCtrl.relogin()">{{ 'Login' | translate }}</a>
        </div>
        <div data-ng-if="reviewCtrl.error.status !== 401">
          {{ reviewCtrl.error.message }}
        </div>
      </div>

      <div data-ng-if="reviewCtrl.items.length === 0">
        <p>
          {{ 'Everything is up to date. No data waiting for synchronisation.' | translate }}
        </p>
      </div>
      <div data-ng-if="reviewCtrl.list && reviewCtrl.items.length > 0">
        <p>
          {{ 'The items below have been modified while in offline mode. They are either waiting to be synchronised or they are waiting for a problem resolution.' | translate }}
        </p>
        <kz-search-string list="reviewCtrl.list"></kz-search-string>
      </div>
    </div>
  </div>
  <kz-refine-filter
    list="reviewCtrl.list"
    data-ng-if="reviewCtrl.items.length > 0"
    refine-by="type"
  ></kz-refine-filter>

</div>


<kz-list-view data-ng-if="reviewCtrl.items.length > 0" list="reviewCtrl.list" options="reviewCtrl.options">
  <review-slot item="item"></review-slot>
</kz-list-view>
`,
  'app/components/settings/review.slot.html': `<div class="col-xs-12">
  <div class="row event-inner">
    <div class="col-sm-7">
      <h2>
        <span>
          <span data-ng-if="item.item.doc.type === 'queue'">{{ item.item.doc.type|kzDocTypeTitle }}:</span>
          <span data-ng-if="item.item.doc.type !== 'queue'">
            <span data-ng-if="item.item.doc._rev === undefined">{{ 'Creating' | translate }}</span>
            <span data-ng-if="item.item.doc._rev !== undefined">{{ 'Updating' | translate }}</span>
            {{ item.item.doc.type|kzDocTypeTitle|lowercase }}:
          </span>
        </span>
        <span kz-title doc="item.item.doc"></span>
      </h2>
      <span data-ng-show="false">{{ item.item._id }}</span>
    </div>
    <div class="col-sm-5 text-right">
      <span class="label label-default">{{ 'Modified on:' | translate }}</span>
      <span data-ng-bind="::item.item.modifiedDate | date:dateFormat"></span>
    </div>
  </div>
  <div class="row" data-ng-if="item.error && [404, 509].indexOf(item.error.status) === -1">
    <div class="col-sm-12 text-danger">
      <!-- Cannot synchronise back to server due to: {{ item.error.status }} {{ item.error.message }} -->
      {{ 'Cannot synchronise back to server. This data may already have been synchronised.' | translate }}
      {{ '(Reason:' | translate }} {{ item.error.message }})
    </div>
  </div>

  <kz-list-buttons
    actions="ctrl.actionButtons"
    secondary-actions="ctrl.secondaryActions"
    left-slot-size="8"></kz-list-buttons>
</div>
`,
  'app/components/settings/status.card.html': `<div class="row">
  <div class="col-xs-12">
    <div class="row row-bordered" data-ng-if="ctrl.info.mode">
      <div class="col-xs-12">
        <i class="icon-view text-success"></i>
        {{ 'You are currently' | translate }} <span class="{{ ctrl.info.mode.class }}">{{ ctrl.info.mode.status }}</span>
      </div>
    </div>
    <div class="row row-bordered" data-ng-if="ctrl.info.offlineCapability">
      <div class="col-xs-12">
        <i class="icon-view {{ ctrl.info.offlineCapability.state | kzStateClass }}"></i>
        <span class="{{ ctrl.info.offlineCapability.state | kzStateClass }}">{{ ctrl.info.offlineCapability.message }}</span>
      </div>
    </div>
    <div class="row row-bordered" data-ng-if="ctrl.info.toSync > 0">
      <div class="col-xs-12">
        <span>
          <i class="icon-view text-warning"></i>
          <span data-ng-if="ctrl.info.toSync === 1">{{ '1 item to sync' | translate }}</span>
          <span data-ng-if="ctrl.info.toSync > 1">{{ ctrl.info.toSync }} {{ 'items to sync' | translate }}</span>
        </span>
      </div>
    </div>
    <div class="row row-bordered" data-ng-if="ctrl.info.toSyncOthers > 0">
      <div class="col-xs-12">
        <span>
          <i class="icon-view text-warning"></i>
          <span data-ng-if="ctrl.info.toSyncOthers === 1">{{ '1 item to sync in other organisations' | translate }}</span>
          <span data-ng-if="ctrl.info.toSyncOthers > 1">{{ ctrl.info.toSyncOthers }} {{ 'items to sync in other organisations' | translate }}</span>
        </span>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/settings/status.html': `<div class="wrapper">

  <header class="row">
    <div class="col-sm-6">
      <h1>{{ 'Status' | translate }}</h1>
    </div>
    <div class="col-sm-6">
      <p class="button-list">
        <button type="button" class="btn btn-info btn-raised" router-link="['/settings/offline']">{{ 'Back' | translate }}</button>
      </p>
    </div>
  </header>

</div>

<div class="wrapper">
  <a href="" class="btn btn-info" ng-click="statusCtrl.loadAll()">{{ 'Load all stores' | translate }}</a>
  <a href="" class="btn btn-info" ng-click="statusCtrl.reloadAll()">{{ 'Reload all stores' | translate }}</a>
  <a href="" class="btn btn-info" ng-click="statusCtrl.updateAll()">{{ 'Update all stores' | translate }}</a>
  <a href="" class="btn btn-info" ng-click="statusCtrl.load()">{{ 'Reload' | translate }}</a>
  <a href="" class="btn btn-info" ng-click="statusCtrl.clearAll()">{{ 'Clear all' | translate }}</a>
  <div class="row" data-ng-repeat="store in statusCtrl.data track by $index">
    <div class="col-xs-12">
      {{ store.storeId }}
      <div class="box box-danger" data-ng-if="store.idbError">
        {{ 'There has beeen an error saving to browser data store' | translate }}
        <pre>{{ store.idbError| json }}</pre>
      </div>
      <div class="table-scrollable">
        <table class="table table-striped table-bordered table-hover">
          <tr>
            <th scope="col">{{ 'Type' | translate }}</th>
            <th scope="col">{{ 'Item count' | translate }}</th>
            <th scope="col">{{ 'Size' | translate }}</th>
            <th scope="col">{{ 'Compressed' | translate }}</th>
            <th scope="col">{{ 'Last updated' | translate }}</th>
            <th scope="col">{{ 'Saved' | translate }}</th>
            <th></th>
          </tr>
          <tr data-ng-repeat="item in store.stores">
            <td>{{ item.id|kzDocTypeTitle }}</td>
            <td>{{ item.size }}</td>
            <td>{{ item.byteSize }}MB</td>
            <td>{{ item.compressedSize }}MB</td>
            <td>{{ item.lastUpdated| date:statusCtrl.dateFormat }}</td>
            <td>{{ item.dirty ? ('Yes' | translate) : ('No' | translate) }}</td>
            <td><a href="" data-ng-click="statusCtrl.clearType(store.storeId, item.id)">{{ 'Clear' | translate }}</a></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/sqlreports/sqlreport-field.component.html': `<sql-report-field
    [model]="$ctrl.model"
    [extra]="$ctrl.extra"
    [report]="$ctrl.report"
    [report-id]="$ctrl.reportId"
    [read-only]="$ctrl.readOnly"
    (update)="$ctrl.update($event)">
</sql-report-field>
`,
  'app/components/sqlreports/widgets/sqlreport/edit.html': `<sql-report-widget-edit [config]="config" (config-change)="editCtrl.configChange($event)"></sql-report-widget-edit>`,
  'app/components/sqlreports/widgets/sqlreport/view.html': `<sql-report-widget [config]="viewCtrl.config" [username]="viewCtrl.username"></sql-report-widget>`,
  'app/components/todos/activity.html': `<kz-inbox-notifications always-show="true"></kz-inbox-notifications>

<adf-dashboard
  ng-if="activityCtrl.template"
  name="asdf"
  collapsible="true"
  editable="false"
  adf-model="activityCtrl.template">
</adf-dashboard>
`,
  'app/components/todos/list.html': `<div class="row" kz-loading loaded="todosCtrl.loaded">
  <div class="col-sm-6">
    <div class="wrapper events-group">
      <div class="row">
        <div class="col-sm-12">
      <h2>{{ 'To Do list' | translate }}</h2>
      <kz-search-string list="todosCtrl.list"></kz-search-string>
      <kz-refine-filter
        list="todosCtrl.list"
        refine-by="state"
      ></kz-refine-filter>
      <div class="row">
        <div class="col-sm-12">
          <kz-list-view list="todosCtrl.list" options="todosCtrl.options">
            <event-section-slot event-section="item.main" use-compact-view="true" options="options"></event-section-slot>
          </kz-list-view>
        </div>
      </div>
    </div>
  </div>
    </div>
  </div>
  <div class="col-sm-6">
    <div class="wrapper events-group">
      <div class="row">
        <div class="col-sm-12">
      <h2>{{ 'Drafts list' | translate }}</h2>
      <kz-search-string list="todosCtrl.draftlist"></kz-search-string>
      <kz-refine-filter
        list="todosCtrl.draftlist"
        refine-by="state"
      ></kz-refine-filter>
      <div class="row">
        <div class="col-sm-12">
          <kz-list-view list="todosCtrl.draftlist" options="todosCtrl.draftOptions">
            <event-section-slot event-section="item.main" use-compact-view="true" options="options"></event-section-slot>
          </kz-list-view>
        </div>
      </div>
    </div>
  </div>
</div>
  </div>
</div>
`,
  'app/components/user-fields/filters/kz-userfields-fields-filter.html': `<formly-form unsaved-warning-form model="ctrl.formData" fields="ctrl.form.fields" form="kzSearchForm" aria-label="{{ 'Userfield' | translate }}">
  <button type="button" class="btn btn-xs btn-primary btn-border" data-ng-click="ctrl.addPair()">{{ 'Add new field' | translate }}</button>
</formly-form>
`,
  'app/components/user-fields/form.discrete.html': `<div class="row">
  <legend>{{ 'User field categories' | translate }}</legend>
</div>

<!-- Nested node template -->
<script type="text/ng-template" id="user-field-hierarchy.html">
  <div data-ui-tree-handle class="row tree-node tree-node-content">
    <div class="col-xs-10">
      <div class="form-group" data-ng-class="{ 'has-error has-feedback': form[category._id].$invalid && formIsSubmitted}">
        <label for="{{category._id}}-name">{{ 'Category name' | translate }} <i class="icon-star required" aria-label="{{ 'star' | translate }}"></i></label>
        <input data-ng-model="category.name" type="text" id="{{category._id}}-name" name="{{category._id}}-name" class="form-control" data-ng-required="true" aria-describedby="{{category._id + '-status'}}">
        <div data-ng-if="form[category._id].$invalid && formIsSubmitted">
          <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
          <p id="{{category._id + '-status'}}" class="help-block text-gray">{{ 'The category name is required.' | translate }}</p>
        </div>
      </div>
    </div>
    <div class="col-xs-2 text-right">
      <br/>
      <ul class="list-inline list-unstyled list-icon-actions">
        <li><button class="btn-link text-gray" data-nodrag data-ng-click="userFieldCtrl.toggle(this)" aria-label="{{ 'Toggle sub nodes' | translate }}"><i data-ng-class="{'icon-right-open-big': collapsed, 'icon-down-open-big': !collapsed}"></i></button></li>
        <li><button class="btn-link text-info" data-nodrag data-ng-click="userFieldCtrl.newSubNode(this)" aria-label="{{ 'Add sub node' | translate }}"><i class="icon-plus"></i></button></li>
        <li><button class="btn-link text-danger" data-nodrag data-ng-click="userFieldCtrl.removeNode(this)" aria-label="{{ 'Remove node' | translate }}"><i class="icon-trash"></i></button></li>
      </ul>
    </div>
  </div>
  <ol data-ui-tree-nodes data-ng-model="category.categories" data-ng-class="{hidden: collapsed}">
    <li data-ng-repeat="category in category.categories track by category._id" data-ui-tree-node data-ng-include="'user-field-hierarchy.html'">
    </li>
  </ol>
</script>

<div data-ui-tree id="tree-root">
  <ol data-ui-tree-nodes data-ng-model="userFieldCtrl.userField.categories">
    <li data-ng-repeat="category in userFieldCtrl.userField.categories track by category._id" data-ui-tree-node data-ng-include="'user-field-hierarchy.html'"></li>
  </ol>
</div>

<p><button type="button" data-ng-click="userFieldCtrl.addCategory()" class="btn btn-sm btn-primary">{{ 'Add new category' | translate }}</button></p>
`,
  'app/components/user-fields/form.file.html': `<div class="row">
    <div class="form-group col-xs-12">
      <div>
        <label for="fileTypes">{{ 'Allowed file types' | translate }}<i class="icon-star required"></i></label>
        <ui-select multiple data-ng-required="true" ng-model="userFieldCtrl.userField.fileTypes" close-on-select="false" title="{{ 'Pick allowed types' | translate }}">
          <ui-select-match placeholder="{{ 'Select allowed types...' | translate }}">{{$item.title}}</ui-select-match>
          <ui-select-choices repeat="item.id as item in userFieldCtrl.availableTypes | filter:$select.search" >
            {{item.title}}
          </ui-select-choices>
        </ui-select>
      </div>

      <div>
        <label for="sizeLimit">{{ 'Maximum size in MB per file (up to 1000MB)' | translate }} <i ng-class="icon-star required"></i></label>
        <input id="sizeLimit" type="number" data-ng-model="userFieldCtrl.userField.sizeLimit" name="sizeLimit" class="form-control" data-ng-required="true">
        <p class="text-gray">{{ 'The maximum file size risr/advance allows is 1000MB (1GB).' | translate }}
        </p>
      </div>

      <div class="checkbox">
        <label>
          <input name="multiple" data-ng-model="userFieldCtrl.userField.multiple" type="checkbox">
          {{ 'Allow multiple files to be uploaded' | translate }}
        </label>
      </div>
      <div data-ng-if="userFieldCtrl.userField.multiple">
        <label for="fileLimit">{{ 'Maximum number of files' | translate }} <i ng-class="icon-star required"></i></label>
        <input id="fileLimit" type="number" data-ng-model="userFieldCtrl.userField.fileLimit" name="fileLimit" class="form-control" data-ng-required="true">
        <p class="text-gray">{{ 'Set to 0 for unlimited number of files.' | translate }}
        </p>
      </div>
    </div>
  </div>
`,
  'app/components/user-fields/form.html': `<form novalidate unsaved-warning-form name="form" aria-label="{{ 'Edit user field' | translate }}">

  <div kz-loading loaded="userFieldCtrl.loaded">
    <div class="wrapper">
      <header class="row">
        <div class="col-sm-6">
          <h1>{{ 'Edit user field' | translate }}</h1>
        </div>
        <div class="col-sm-6">
          <p class="button-list">
            <button type="submit" class="btn btn-success btn-raised" data-ng-if="userFieldCtrl.showSave" data-ng-click="userFieldCtrl.save(form.$valid, 'draft')">{{ 'Save' | translate }}</button>
            <button type="button" class="btn btn-info btn-raised" router-link="['/user-fields']">{{ 'Cancel' | translate }}</button>
            <button type="button" class="btn btn-danger btn-raised" data-ng-if="userFieldCtrl.showDelete" data-ng-click="userFieldCtrl.remove()">{{ 'Delete' | translate }}</button>
          </p>
        </div>
        <audit-log-component ng-if="userFieldCtrl.userField._rev" entries="userFieldCtrl.auditlog" on-expand="userFieldCtrl.loadAuditlog()"></audit-log-component>
      </header>

      <div class="row">
        <p class="text-gray">{{ 'Fields marked with' | translate }} <i class="icon-star required" aria-hidden="true"></i><span class="sr-only">{{ 'star' | translate }}</span> {{ 'are required.' | translate }}</p>
      </div>

      <div class="row">
        <div class="form-group col-sm-7" data-ng-class="{ 'has-error has-feedback': form.userFieldName.$invalid && formIsSubmitted}">
          <label for="userFieldName">{{ 'User field name' | translate }} <i class="icon-star required" aria-label="{{ 'star' | translate }}"></i></label>
          <input data-ng-model="userFieldCtrl.userField.name" type="text" id="userFieldName" name="userFieldName" class="form-control" data-ng-required="true" aria-describedby="userFieldNameStatus">
          <div data-ng-if="form.userFieldName.$invalid && formIsSubmitted">
            <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
            <p id="eventTitleStatus" class="help-block text-gray">{{ 'The user field name is required.' | translate }}</p>
          </div>
        </div>

        <div class="form-group col-sm-5" data-ng-class="{ 'has-error has-feedback': form.userFieldType.$invalid && formIsSubmitted}">
          <label for="userFieldType">{{ 'User field type' | translate }} <i class="icon-star required" aria-label="{{ 'star' | translate }}"></i></label>

          <select id="userFieldType" name="userFieldType" class="form-control" data-ng-model="userFieldCtrl.userField.fieldType" data-ng-options="type.name as type.label for type in userFieldCtrl.blueprintTypes" data-ng-required="true" aria-describedby="userFieldTypeStatus" ng-change="userFieldCtrl.fieldTypeChanged()"></select>
          <div data-ng-if="form.userFieldType.$invalid && formIsSubmitted">
            <span class="icon-attention form-control-feedback" aria-hidden="true"></span>
            <p id="userFieldTypeStatus" class="help-block text-gray">{{ 'The user field type is required.' | translate }}</p>
          </div>
        </div>
      </div>

      <!-- if the user selected a discrete, show the appropriate form -->
      <div class="row" data-ng-include="'app/components/user-fields/form.discrete.html'" data-ng-if="userFieldCtrl.userField.fieldType === 'discrete' || userFieldCtrl.userField.fieldType === 'discrete_multiple'"></div>

      <div class="row">
        <div class="col-xs-12">
          <h2 class="heading-4">{{ 'Field properties' | translate }}</h2>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-xs-6" data-ng-if="userFieldCtrl.userField.fieldType !== 'boolean'">
          <div class="checkbox">
            <label>
              <input name="user-field-required" data-ng-model="userFieldCtrl.userField.isRequired" type="checkbox" data-ng-checked="userFieldCtrl.userField.isRequired"> {{ 'Make this a required field?' | translate }}
            </label>
          </div>
          <div class="checkbox">
            <label>
              <input name="user-field-isunique" data-ng-model="userFieldCtrl.userField.isUnique" type="checkbox" data-ng-checked="userFieldCtrl.userField.isUnique"> {{ 'Make this a unique field?' | translate }}
            </label>
          </div>
        </div>
        <div class="form-group col-xs-6">
          <div class="checkbox">
            <label>
              <input name="user-field-locked" data-ng-model="userFieldCtrl.userField.isLocked" type="checkbox" data-ng-checked="userFieldCtrl.userField.isLocked"> {{ 'Lock this field (non editable by users)?' | translate }}
            </label>
          </div>
          <div class="checkbox">
            <label>
              <input name="user-field-featured" data-ng-model="userFieldCtrl.userField.isFeatured" type="checkbox" data-ng-checked="userFieldCtrl.userField.isFeatured"> {{ 'Show this field on the users list?' | translate }}
            </label>
          </div>
        </div>
        <div class="form-group col-xs-12" data-ng-if="userFieldCtrl.visibleByForm">
          <formly-form
      model="userFieldCtrl.userField" fields="userFieldCtrl.visibleByForm.fields" form="form" aria-label="{{ 'Allowed by roles' | translate }}"></formly-form>
        </div>
      </div>

      <div class="row" data-ng-include="'app/components/user-fields/form.file.html'" data-ng-if="userFieldCtrl.userField.fieldType === 'file'"></div>

    </div>
  </div>

</form>
`,
  'app/components/user-fields/list-reorder.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="userFieldsReorderCtrl.actions"><h1>{{ 'User fields' | translate }}</h1></kz-header>
      <p>{{userFieldsReorderCtrl.userFields.length}} {{ 'user fields.' | translate }}</p>
  </header>
</section>
<div kz-loading loaded="userFieldsReorderCtrl.loaded">
  <p class="box box-info" ng-bind-html="userFieldsReorderCtrl.reorderInfo"></p>
  <div hidden id="user-fields-move-instructions">{{ 'Use the arrow up and down keys to move this user field' | translate }}</div>
  <div ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost', onUpdate: userFieldsReorderCtrl.reorder }">
    <div class="wrapper" data-ng-repeat="item in userFieldsReorderCtrl.userFields track by item.doc._id">
      <div class="row event progress-border progress-border-complete">
        <div class="col-xs-12">
          <div class="row event-inner">
            <div class="col-xs-8">
              <h2>{{ item.doc.name || item.doc.title}}</h2>
            </div>
            <div class="col-xs-4 button-list">
              <ul class="list-inline list-unstyled list-icon-actions">
                <li>
                  <button type="button" class="btn-link text-success drag-handle" aria-label="{{ 'Move' | translate }} {{ item.doc.name || item.doc.title }}" aria-describedby="user-fields-move-instructions">
                    <i class="icon-move"></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div class="row event-inner">
            <div class="col-xs-8">
              <div class="text-gray">{{ item.doc.description }}</div>
            </div>
            <div class="col-xs-4 col-right">
              <kz-state map="userFieldsReorderCtrl.options.stateMapping" state="item | kzGetDotted: userFieldsReorderCtrl.options.stateField"></kz-state>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/user-fields/list.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="userFieldsCtrl.actions"><h1>{{ 'User fields' | translate }}</h1></kz-header>
      <kz-simple-search list="userFieldsCtrl.list"></kz-simple-search>
      <kz-search-string list="userFieldsCtrl.list"></kz-search-string>
  </header>
  <kz-refine-filter list="userFieldsCtrl.list"
    ></kz-refine-filter>
</section>


<kz-list-view list="userFieldsCtrl.list" options="userFieldsCtrl.options">
  <list-slot item="item" options="options"></list-slot>
</kz-list-view>
`,
  'app/components/users/create.html': `<div class="sweet-overlay" tabIndex="-1" style="display: block" data-ng-if="userCreateCtrl.formIsSubmitted"></div>
<form name="form">
  <div class="wrapper">
    <header class="row">
      <div class="col-sm-6"><h1>{{ 'New user' | translate }}</h1></div>
      <div class="col-sm-6">
        <p class="button-list">
          <button type="submit" class="btn btn-success btn-raised" data-ng-disabled="userCreateCtrl.formIsSubmitted || !form.$valid" data-ng-click="userCreateCtrl.create(form.$valid)">{{ 'Create' | translate }}</button>
          <button type="button" class="btn btn-info btn-raised" router-link="['/users']">{{ 'Cancel' | translate }}</button>
        </p>
      </div>
    </header>

    <div class="row">
      <div class="col-sm-12">
        <p class="text-gray" ng-bind-html="'Fields marked with <i class=&quot;icon-star required&quot; aria-hidden=&quot;true&quot;></i> are required.' | translate"></p>
      </div>
    </div>

    <div class="row bg-gray-300 text-gray-700 ">
      <div class="col-xs-12">{{ 'Basic Information' | translate }}</div>
    </div>
    <div class="row" data-ng-if="userCreateCtrl.profile">
      <div class="col-sm-12">
        <user-basic action="create" profile="userCreateCtrl.profile" ></user-basic>
      </div>
    </div>

    <div class="row bg-gray-300 text-gray-700 ">
      <div class="col-xs-12">{{ 'Email addresses' | translate }}</div>
    </div>
    <div class="row" data-ng-if="userCreateCtrl.profile">
      <div class="col-sm-12">
        <user-emails action="create" profile="userCreateCtrl.profile"></user-emails>
      </div>
    </div>

    <div class="row bg-gray-300 text-gray-700 ">
      <div class="col-xs-12">{{ 'Additional information' | translate }}</div>
    </div>
    <div class="row" data-ng-if="userCreateCtrl.profile">
      <div class="col-sm-12">
        <user-details action="create" profile="userCreateCtrl.profile"></user-details>
      </div>
    </div>

    <div class="row bg-gray-300 text-gray-700 " data-ng-if="userCreateCtrl.canManageAccounts">
      <div class="col-xs-12" >{{ 'Login credentials' | translate }}</div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <user-credentials action="create" credentials="userCreateCtrl.accounts" data-ng-if="userCreateCtrl.canManageAccounts && userCreateCtrl.accounts"></user-credentials>
      </div>
    </div>

    <div class="row bg-gray-300 text-gray-700 " data-ng-if="userCreateCtrl.profile && userCreateCtrl.canAssignRoles">
      <div class="col-xs-12">{{ 'Access control' | translate }}</div>
    </div>
    <div class="row" data-ng-if="userCreateCtrl.profile && userCreateCtrl.canAssignRoles">
      <div class="col-sm-12">
        <user-roles action="create" profile="userCreateCtrl.profile"></user-roles>
      </div>
    </div>
  </div>
</form>
`,
  'app/components/users/directives/auditLogs.html': `<div class="row">
  <div class="col-xs-12 condensed text-small">
    <div class="row" ng-if="ctrl.showHeader">
      <div class="col-xs-7">{{ 'Auditlog' | translate }}</div>
      <div class="col-xs-5 text-right">
        <a href="" ng-click="options.shownAuditlog = !options.shownAuditlog" class="text-info">
          {{ options.shownAuditlog ? ('Collapse' | translate) : ('Expand' | translate) }}
        </a>
      </div>
    </div>

    <div class="row" data-ng-if="options.shownAuditlog || ctrl.expanded">
      <div class="col-xs-12">
        <p ng-if="ctrl.loading">Loading...</p>
        <kz-audit-log ng-if="!ctrl.loading && ctrl.dates.length" show-header="false" per-page="perPage" dates="ctrl.dates"></kz-audit-log>
      </div>
    </div>
  </div>
</div>
`,
  'app/components/users/directives/credentialForm.html': `<div>
  <formly-form model="model" fields="ctrl.form.fields" form="ctrl.formName" data-ng-if="ctrl.form" aria-label="{{ 'Credentials' | translate }}"></formly-form>
</div>
`,
  'app/components/users/directives/relations.html': `<div class="row">
  <div class="col-xs-12" ng-repeat="period in ctrl.periodsToDisplay track by $index">
    <div class="row {{ ctrl.headerBgClassNames }}" ng-if="::ctrl.history[period] && ctrl.history[period].length > 0">
      <div class="col-xs-7">{{ period | capitalize:'first' }} {{ 'information' | translate }}</div>
      <div class="col-xs-5 text-right">
        <a aria-label="{{ ctrl.shownPeriod[period] ? ('Collapse section' | translate) : ('Expand section' | translate) }}" href=""
           ng-click="ctrl.showPeriod(period)" class="text-info"
           ng-bind-html="ctrl.shownPeriod[period] ? ctrl.collapseAction : ctrl.expandAction"></a>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="row has-border-bottom condensed"
             ng-repeat="obj in ::ctrl.history[period] track by $index" ng-show="ctrl.shownPeriod[period]">
          <div class="col-xs-12">
            <!-- showing obj name -->
            <span class="text-info text-sm" epf-relation-title relation="{{::obj.id}}" data-ng-if="::obj.type === 'relation'"></span>
            <span class="text-info text-sm" epf-role-title user-role="{{ ::obj.id }}" data-ng-if="::obj.type === 'user_dependent'"></span>
            <div class="text-gray">
              <div ng-repeat="category in ::obj.categories track by $index">
                <!-- showing obj value -->
                <strong epf-relation-title relation="{{::category.id}}" data-ng-if="::obj.type === 'relation'"></strong>
                <strong epf-fullnames user="::category.id" data-ng-if="::obj.type === 'user_dependent'"></strong>

                <!-- showing dates -->
                <ul class="list-unstyled list-condensed">
                  <li ng-repeat="date in ::category.values track by $index">
                    <span class="text-xs text-gray">
                      {{ date.start|date:ctrl.dateFormat}} - {{ date.end|date:ctrl.dateFormat}}
                      (<a data-ng-if="!ctrl.remoteUser" router-link="['/events/view', date.event]">{{ 'View' | translate }}</a><a
                        data-ng-if="ctrl.remoteUser" router-link="['/users/edit', ctrl.user, 'events', date.event]">{{ 'View' | translate }}</a>)
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row audit-log" data-ng-if="ctrl.shownLinkedEvents">
      <target-linked-events target="::target"></target-linked-events>
    </div>
  </div>
</div>
`,
  'app/components/users/directives/userAccounts.html': `<div>
  <div ng-if="ctrl.newlyCreatedAPICredential" class="box box-warning">
    <p>
      <i class="icon-warning"></i><strong>{{ 'Warning!' | translate }}</strong> {{ 'Make sure you copy the API credentials below. You won't be able to see them again!' | translate }}
    </p>
  </div>

  <div ng-if="ctrl.newlyCreatedAPICredential" class="box box-info row">
    <div class="col-xs-8">
      <ul>
        <li>public_key: {{ctrl.newlyCreatedAPICredential.public_key}}</li>
        <li>secret_key: {{ctrl.newlyCreatedAPICredential.secret_key}}</li>
      </ul>
    </div>
    <div class="col-xs-4 text-right">
      <button class="btn btn-info copy-btn" ng-click="ctrl.copyToClipboard()">{{ 'Copy' | translate }}</button>
    </div>
  </div>

  <div class="row" data-ng-if="ctrl.action === 'view' && ctrl.credentials">
    <div class="col-xs-12">
      <div class="row has-border-bottom condensed" ng-repeat="cred in ctrl.credentials track by $index">
        <div class="col-xs-12">
          <span class="text-info text-sm">{{ctrl.readableName[cred.type]}}</span>
          <div class="text-gray">
            <strong>{{cred.username || cred.public_key}}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" data-ng-repeat="credential in ctrl.credentials track by $index" data-ng-if="['create'].indexOf(ctrl.action) > -1 && ctrl.credentials && ctrl.loaded"
    style="padding:10px">
    <div class="col-xs-6">
      <div class="label label-info">{{ctrl.readableName[credential.type]}}</div>
      <div><strong>{{ credential.username || credential.public_key }}</strong></div>
      <div class="label label-warning" data-ng-if="(credential.passwordNotSet || credential.passwordOptions === 'letTheUserChooseOne') && credential.type === 'local'">
        {{ 'A welcome email will be sent to guide the user through the setup process' | translate }}
      </div>
    </div>
    <div class="col-xs-6 text-right">
      <button type="button" class="btn btn-xs btn-primary" data-ng-click="ctrl.openAccountForm(credential)" data-ng-if="ctrl.perm.edit(credential)">
        {{ 'Edit' | translate }}
      </button>
      <button type="button" class="btn btn-xs btn-primary"
              data-ng-click="ctrl.openEditForm(credential, 'editUsername')"
              data-ng-if="ctrl.perm.editUsername(credential)"
      >
        {{ 'Edit' | translate }} {{ credential.type === 'local' ? ('Username' | translate) : ('SSO ID' | translate) }}
      </button>
      <button type="button" class="btn btn-xs btn-primary" data-ng-click="ctrl.resetPassword(credential)" data-ng-if="ctrl.perm.resetPwd(credential)">
        {{ 'Send password reset email' | translate }}
      </button>
      <button type="button" class="btn btn-xs btn-primary" data-ng-click="ctrl.openEditForm(credential, 'editPassword')" data-ng-if="ctrl.perm.changePwd(credential)">
        {{ 'Change Password' | translate }}
      </button>
      <button type="button" class="btn btn-xs btn-danger" data-ng-click="ctrl.remove($index)" data-ng-if="ctrl.perm.remove(credential)">
        {{ 'Remove' | translate }}
      </button>
    </div>
  </div>

  <div class="row" ng-if="ctrl.showActions">
    <div class="col-md-12 text-right">
      <button type="button" class="btn btn-sm btn-info" data-ng-click="ctrl.openAccountForm()" data-ng-if="ctrl.canManage">
        {{ 'Add login credential' | translate }}
      </button>
    </div>
  </div>
</div>
`,
  'app/components/users/directives/userBasic.html': `<div class="col-md-12">
  <div data-ng-if="ctrl.action === 'create'">
    <formly-form model="ctrl.profile" fields="ctrl.basicForm.fields" form="form" aria-label="{{ 'New user' | translate }}"></formly-form>
  </div>
  <div data-ng-if="ctrl.action === 'edit'">
    <form name="ctrl.userBasicForm" unsaved-warning-form>
      <div class="row">
        <div class="col-sm-2">
          <div class="profile-widget-avatar">
            <div class="avatar">
              <kz-avatar user="ctrl.profile" size="big" src="ctrl.profilePictureSource"></kz-avatar>
            </div>
          </div>
          <formly-form model="ctrl.profile" fields="ctrl.profilePhotoForm.fields" form="ctrl.userBasicForm" aria-label="{{ 'Edit profile photo' | translate }}"></formly-form>
        </div>
        <div class="col-sm-10">
          <formly-form model="ctrl.profile" fields="ctrl.basicForm.fields" form="ctrl.userBasicForm" aria-label="{{ 'Edit user' | translate }}"></formly-form>
        </div>
      </div>

      <hr />

      <button type="submit" class="btn btn-success"
                data-ng-disabled="!ctrl.userBasicForm.$valid"
                data-ng-click="ctrl.saveProfile(ctrl.userBasicForm.$valid)">
          {{ 'Save' | translate }}
        </button>
      </form>
  </div>
</div>
`,
  'app/components/users/directives/userDetails.html': `<div class="col-sm-12">
  <ul class="list-unstyled" ng-if="ctrl.action === 'view'">
    <li class="has-border-bottom" ng-repeat="userField in ctrl.userFields track by userField.id" ng-if="!(ctrl.profile[userField.id] | kzIsEmpty)">
      <span class="text-info text-sm">{{userField.value}}</span>
      <div class="text-gray">
        <span kz-form-title item="ctrl.profile[userField.id]" kz-type="userField" type="{{userField.type}}" parent="ctrl.profile._id"></span>
      </div>
    </li>
  </ul>
  <div data-ng-if="ctrl.action === 'create'">
    <formly-form model="ctrl.profile" fields="ctrl.userDetailsForm.fields" form="form" aria-label="{{ 'New user details' | translate }}"></formly-form>
  </div>
  <div data-ng-if="ctrl.action === 'edit'">
    <form name="ctrl.userDetailsFormCon" unsaved-warning-form>
      <formly-form model="ctrl.profile" fields="ctrl.userDetailsForm.fields" form="ctrl.userDetailsFormCon" aria-label="{{ 'Edit user details' | translate }}"></formly-form>
      <button type="submit" class="btn btn-success" data-ng-click="ctrl.saveProfile(ctrl.userDetailsFormCon.$valid)">
        {{ 'Save' | translate }}
      </button>
    </form>
  </div>
</div>
`,
  'app/components/users/directives/userEmails.html': `<div>
  <div data-ng-if="['create', 'edit'].indexOf(ctrl.action) > -1">
    <div class="row" data-ng-if="ctrl.action === 'create'">
      <div class="col-xs-12">
        <formly-form model="ctrl.profile" fields="ctrl.primaryEmailForm.fields" form="form" aria-label="{{ 'Primary email' | translate }}"></formly-form>
      </div>
    </div>

    <div class="row" style="padding:10px" data-ng-if="ctrl.action === 'edit'">
      <div class="col-lg-9">
        <div class="label label-info">{{ 'Primary Email Address' | translate }}</div>
        <div>{{ ctrl.profile.email }}</div>
      </div>
      <div class="col-md-3 text-right">
        <button type="button" class="btn btn-xs btn-primary" data-ng-click="ctrl.editEmail(ctrl.profile, 'email', ctrl.profile.email)">{{ 'Edit' | translate }}</button>
      </div>
    </div>

    <div class="row" data-ng-repeat="email in ctrl.profile.secondaryEmails track by $index" style="padding:10px">
      <div class="col-xs-6">
        <div class="label label-info">{{ 'Secondary Email Address' | translate }}</div>
        <strong>{{ email }}</strong>
      </div>
      <div class="col-xs-6 text-right">
        <button class="btn btn-xs btn-primary"
                type="button"
                data-ng-click="ctrl.makePrimary(email)">
          {{ 'Make Primary' | translate }}
        </button>
        <button class="btn btn-xs btn-primary"
                type="button"
                data-ng-click="ctrl.editEmail(ctrl.profile, 'secondaryEmails', email)">
          {{ 'Edit' | translate }}
        </button>
        <button class="btn btn-xs btn-danger"
                type="button"
                data-ng-click="ctrl.removeSecondaryEmail($index)">
          {{ 'Remove' | translate }}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-sm btn-info"
                type="button"
                data-ng-click="ctrl.editEmail(ctrl.profile, 'secondaryEmails')"
                >{{ 'Add secondary email' | translate }}</button>
      </div>
    </div>
  </div>
  <div class="col-lg-12" ng-if="ctrl.action === 'view'">
    <ul class="list-unstyled">
      <li class="has-border-bottom">
          <div class="text-info text-sm">{{ 'Primary Email Address' | translate }}</div>
          <div>{{ ctrl.profile.email }}</div>
      </li>
      <li class="has-border-bottom" ng-repeat="email in ctrl.profile.secondaryEmails track by $index">
        <span class="text-info text-sm">{{ 'Secondary Email Address' | translate }}</span>
        <div class="text-gray">{{ email }}</div>
      </li>
    </ul>
  </div>
</div>
`,
  'app/components/users/directives/userRoles.html': `<div>
  <div data-ng-if="ctrl.action === 'view'">
    <p class="text-gray" data-ng-if="ctrl.userRoles">
      <epf-roles-title roles="::ctrl.userRoles" />
      <span data-ng-if="!ctrl.userRoles.length">
        {{ 'No roles assigned' | translate }}
      </span>
    </p>
  </div>

  <div data-ng-if="ctrl.action === 'create'">
    <formly-form model="ctrl.profile" fields="ctrl.form.fields" form="form" aria-label="{{ 'New user roles' | translate }}"></formly-form>
  </div>
  <div data-ng-if="ctrl.action === 'edit'">
    <form name="ctrl.userRolesForm" unsaved-warning-form>
      <formly-form model="ctrl.profile" fields="ctrl.form.fields" form="ctrl.userRolesForm" aria-label="{{ 'Edit user roles' | translate }}"></formly-form>
      <button type="submit" class="btn btn-success"
                data-ng-disabled="!ctrl.userRolesForm.$valid"
                data-ng-click="ctrl.saveProfile(ctrl.userRolesForm.$valid)">
        {{ 'Save' | translate }}
      </button>
      </form>
  </div>
</div>
`,
  'app/components/users/edit.html': `<div class="wrapper">
  <div class="row">
    <div class="col-md-10">
      <h1>
        {{ 'Edit user' | translate }} {{ userEditCtrl.profile.firstName }} {{ userEditCtrl.profile.lastName }}
      </h1>
      <p data-ng-if="userEditCtrl.canReview && userEditCtrl.profile.state === 'waiting_for_approval'">
          {{ 'This user is waiting for their external response to be approved' | translate }}<br />
          <button data-ng-if="!userEditCtrl.formIsSubmitted"
             type="button"
             class="btn btn-sm btn-link text-link"
             data-ng-click="userEditCtrl.approve()">{{ 'Manually approve this user' | translate }}</button>
          <button data-ng-if="userEditCtrl.formIsSubmitted" type="button" class="btn btn-sm btn-link text-link disabled">{{ 'Manually approve this user' | translate }}</button>
      </p>
    </div>
    <div class="col-md-2 text-right">
      <button type="button" class="btn btn-info" router-link="['/profile/view', userEditCtrl.remoteUser || '']">{{ 'Done' | translate }}</button>
    </div>
  </div>

  <div class="row" data-ng-if="userEditCtrl.profile.roles === undefined || userEditCtrl.profile.roles.length === 0">
        <p class="box box-warning">
    {{ 'This user has not been assigned any roles' | translate }}
  </p>
    </div>

  <div class="row">
    <ul class="nav nav-tabs">
      <li ng-repeat="item in userEditCtrl.items"
          ng-class="{ active: userEditCtrl.current === item.id }">
        <a href="" ng-click="userEditCtrl.goToTab(item.id)">{{ item.name }}</a>
      </li>
    </ul>
  </div>

  <div class="row" kz-loading loaded="userEditCtrl.loaded">
    <div class="col-md-12" data-ng-if="userEditCtrl.current === 'basic'">
      <user-basic profile="userEditCtrl.profile"
                  action="edit"
                  data-ng-if="userEditCtrl.profile">
      </user-basic>
    </div>

    <user-emails profile="userEditCtrl.profile" action="{{ userEditCtrl.remoteUser ? 'edit' : 'view' }}" data-ng-if="userEditCtrl.current === 'emails'"></user-emails>
    <user-details
      profile="userEditCtrl.profile"
      action="edit"
      data-ng-if="userEditCtrl.profile && userEditCtrl.current === 'details'"
    ></user-details>

    <user-roles
      action="edit"
      profile="userEditCtrl.profile"
      data-ng-if="userEditCtrl.profile && userEditCtrl.current === 'roles'">
    </user-roles>
  </div>
</div>
`,
  'app/components/users/eventlist.html': `<div>
<section class="wrapper">
  <header class="row">
      <kz-header actions="eventsCtrl.actions">
        <h1><span epf-fullname user="eventsCtrl.username"></span>'s {{ eventsCtrl.resolvedFilter.name || ('Timeline' | translate) }}</h1>
      </kz-header>
      <kz-simple-search list="eventsCtrl.list"></kz-simple-search>
      <kz-search-string list="eventsCtrl.list"></kz-search-string>
  </header>
  <kz-refine-filter
    list="eventsCtrl.list"
    refine-by="state"
  ></kz-refine-filter>
</section>

<div class="wrapper events-group smaller" data-ng-if="eventsCtrl.sectionList.total_count">
  <div class="row group-title progress-border progress-border-pending">
    <div class="col-xs-8">
      <h5 class="text-gray">{{ 'Your to do list for this user' | translate }}</h5>
    </div>
    <div class="col-xs-4 text-right">
      <span class="text-gray">{{eventsCtrl.sectionList.total_count}} {{ 'events' | translate }}</span>
    </div>
  </div>
  <kz-list-view list="eventsCtrl.sectionList" options="eventsCtrl.todoOptions">
    <event-section-slot event-section="item.main" use-compact-view="true"></event-section-slot>
  </kz-list-view>
</div>

<kz-list-view list="eventsCtrl.list" options="eventsCtrl.options">
  <event-group-slot item="item" options="options"></event-group-slot>
</kz-list-view>
</div>
`,
  'app/components/users/goalslist.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="goalsCtrl.actions">
        <h1><span epf-fullname user="goalsCtrl.username"></span>'s {{goalsCtrl.resolvedFilter.name || ('Goals' | translate)}}</h1>
      </kz-header>
      <kz-simple-search list="goalsCtrl.list"></kz-simple-search>
      <kz-search-string list="goalsCtrl.list"></kz-search-string>
  </header>
  <kz-refine-filter
    list="goalsCtrl.list"
    refine-by="event_state"
  ></kz-refine-filter>
</section>

<kz-list-view template="app/components/goals/listview.html" list="goalsCtrl.list" options="goalsCtrl.options">
  <goal-slot goal="item" options="options"></goal-slot>
</kz-list-view>
`,
  'app/components/users/list.html': `<section class="wrapper">
  <header class="row">
      <kz-header actions="usersCtrl.actions"><h1>{{ 'Users' | translate }}</h1></kz-header>

      <kz-simple-search list="usersCtrl.list"></kz-simple-search>
      <kz-search-string list="usersCtrl.list"></kz-search-string>

  </header>
  <kz-refine-filter
    list="usersCtrl.list"
    refine-by="state"
  ></kz-refine-filter>
</section>


<kz-list-view list="usersCtrl.list" options="usersCtrl.options">
  <user-slot item="item" options="options"></user-slot>
</kz-list-view>
`,
  'app/components/users/partials/credential-form.html': `<form novalidate name="credentialForm">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="{{ 'Close' | translate }}"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
      <h4 id="myModalLabel">{{ mode === 'editNotSavedOnServer' ? ('Edit login credential' | translate) : ('Add login credential' | translate) }}</h4>
      <div class="text-gray"></div>
    </div>
  </div>
  <div class="modal-body" style="height: 300px">
    <credential-form model="credential" form-name="credentialForm"></credential-form>
  </div>
  <div class="modal-footer text-right">
    <button type="button" class="btn btn-info" data-ng-click="dismiss()">{{ 'Cancel' | translate }}</button>
    <button type="submit" class="btn btn-success btn-raised" data-ng-disabled="credentialForm.$invalid" data-ng-click="save(credentialForm.$valid)">{{ 'Save' | translate }}</button>
  </div>
</form>
`,
  'app/components/users/partials/edit-cred-form.html': `<form novalidate name="editCredForm">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="{{ 'Close' | translate }}"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
      <h4 id="myModalLabel">{{ mode === 'create' ? ('Add login credential' | translate) : ('Edit login credential' | translate) }}</h4>
      <div class="text-gray"></div>
    </div>
  </div>
  <div class="modal-body" style="height: 300px">
    <formly-form form="editCredForm" fields="form.fields" model="credential" aria-label="{{ 'Credentials' | translate }}"></formly-form>
  </div>
  <div class="modal-footer text-right">
    <button type="button" class="btn btn-info" data-ng-click="dismiss()">{{ 'Cancel' | translate }}</button>
    <button type="submit" class="btn btn-success btn-raised" data-ng-disabled="editCredForm.$invalid" data-ng-click="save(editCredForm.$valid)">{{ 'Save' | translate }}</button>
  </div>
</form>
`,
  'app/components/users/partials/edit-email.html': `<form novalidate name="editEmailForm" aria-label="{{ 'Edit email' | translate }}">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="{{ 'Close' | translate }}"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
      <h4 id="myModalLabel">{{ 'Edit email' | translate }}</h4>
      <div class="text-gray"></div>
    </div>
  </div>
  <div class="modal-body" style="height: 300px">
    <formly-form model="formModel" fields="form.fields" aria-label="{{ 'Email' | translate }}"></formly-form>
  </div>
  <div class="modal-footer text-right">
    <button type="button" class="btn btn-info" data-ng-click="dismiss()">{{ 'Cancel' | translate }}</button>
    <button type="submit" class="btn btn-success btn-raised" data-ng-disabled="!editEmailForm.$valid" data-ng-click="save(editEmailForm.$valid)">{{ 'Save' | translate }}</button>
  </div>
</form>
`,
  'app/components/users/partials/preview.html': `<div class="modal-body event-modal-body">
  <div class="avatar text-center">
    <kz-avatar user="profileDoc" size="big" meta="meta"></kz-avatar>
    <h3 epf-fullname doc="profileDoc"></h3>
  </div>

  <h3>{{ 'Emails' | translate }}</h3>
  <user-emails profile="profileDoc" action="view"></user-emails>

  <h4>{{ 'Roles' | translate }}</h4>
  <user-roles action="view" profile="profileDoc"></user-roles>

  <h4>{{ 'Details' | translate }}</h4>
  <user-details profile="profileDoc" action="view"></user-details>
</div>
`,
  'app/components/users/profile.view.html': `<div class="row">
  <div class="col-xs-6">
    <h3>{{ 'Details' | translate }} </h3>
    <p><span class="text-gray">{{ 'First name:' | translate }}</span> {{user.firstName}}</p>
    <p><span class="text-gray">{{ 'Last name:' | translate }}</span> {{user.lastName}}</p>
    <p><span class="text-gray">{{ 'Email:' | translate }}</span> {{user.email}}</p>

    <!-- user fields -->
    <p data-ng-repeat="userField in userFields track by userField.id" data-ng-if="user[userField.id]">
      <span class="text-gray" epf-user-field-title field="{{userField.id}}"></span>:
      <span kz-category-title category="user[userField.id]"></span>
    </p>

    <p ng-if="user.relations" ng-repeat="(relation, categories) in ::user.relations track by $index">
      <span class="text-gray" epf-relation-title relation="{{::relation}}"></span>
      <span>: </span>
      <span ng-repeat="category in ::categories track by $index">
        <span epf-relation-title relation="{{::category}}"></span>
        <span ng-if="!$last">, </span>
      </span>
    </p>

    <p ng-if="user.dependent" ng-repeat="(role, dependent) in ::user.dependent track by $index">
      <span class="text-gray" epf-role-title user-role="{{ ::role }}"></span>
      <span epf-fullnames user="::dependent"></span>
    </p>

    <p>
      <span class="text-gray">{{ 'Roles:' | translate }}</span>
      <span epf-roles-title roles="user.roles"></span>
    </p>
  </div>
  <div class="col-xs-6">
    <h3>{{ 'Logins' | translate }} </h3>
    <p data-ng-repeat="account in userAccounts track by account.username">
      <!-- @todo update this for phase 2-->
      <span class="text-gray">{{ 'Username' | translate }}</span>: {{account.username}}
    </p>
  </div>
</div>
`,
  'app/components/users/user.slot.html': `  <div class="col-xs-12">
    <div class="row event-inner">
      <div class="col-sm-7">
        <h2><a router-link="['/summary', item.doc.username]">
          <span epf-fullname doc="::item.doc"></span>
        </a></h2>
        <ul class="list-inline list-unstyled">
          <li class="text-gray" data-ng-bind="::item.doc.email"></li>
          <li data-ng-repeat="userField in ctrl.featuredUserFields" class="text-gray">
            <kz-form-title item="item.doc[userField.doc._id]" kz-type="userField" type="{{userField.doc.fieldType}}"></kz-form-title>
          </li>
          <!--<li data-ng-repeat="(key, value) in ::item.doc.extra" class="text-gray">-->
            <!--{{ ::key }}: {{::value}}-->
          <!--</li>-->
        </ul>
      </div>

      <div class="col-sm-5 col-right" style="padding: 15px;">
        <kz-state map="ctrl.STATES" state="item.doc.state"></kz-state>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12" data-ng-if="ctrl.shownDescription && item.doc.dates">
        <div class="row audit-log">
          <div class="col-xs-12">
            <kz-audit-log dates="::item.doc.dates"></kz-audit-log>
          </div>
        </div>
      </div>
    </div>

    <kz-list-buttons actions="ctrl.actionButtons" secondary-actions="ctrl.secondaryActionButtons" left-slot-size="8"></kz-list-buttons>
  </div>
`,
  'app/components/users/view.html': `<div class="wrapper">

  <div class="row">
    <div class="col-sm-3">
      <div class="avatar text-center">
        <kz-avatar user="userViewCtrl.profile" size="big"></kz-avatar>
      </div>
    </div>
    <div class="col-sm-9">
      <div class="row">
        <div class="text-center text-left-sm col-sm-8">
          <h1 epf-fullname user="userViewCtrl.user"></h1>
          <user-roles action="view"></user-roles>
        </div>
        <div class="col-sm-4 text-center text-left-sm">
          <p class="text-center text-right-sm">
            <a class="btn btn-sm btn-success" router-link="['/profile/security/credentials']" ng-if="!userViewCtrl.remoteUser">
              {{ 'Account security' | translate }}
            </a>
            <a class="btn btn-sm btn-success" router-link="['/users/security', userViewCtrl.user, 'credentials']" ng-if="userViewCtrl.remoteUser && userViewCtrl.hasManageCredentialPermission">
              {{ 'Account security' | translate }}
            </a>
            <a class="btn btn-sm btn-primary" router-link="['/profile/edit', userViewCtrl.remoteUser || '']" ng-if="userViewCtrl.hasEditPermission && userViewCtrl.remoteUser">
              {{ 'Edit profile' | translate }}
            </a>
            <a class="btn btn-sm btn-primary" router-link="['/profile/edit']" ng-if="userViewCtrl.hasEditPermission && !userViewCtrl.remoteUser">
              {{ 'Edit profile' | translate }}
            </a>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <p class="box box-info" ng-if="userViewCtrl.canReview && userViewCtrl.profile.state === 'waiting_for_approval'">
            {{ 'This user is waiting for their external response to be approved.' | translate }} <a href="" ng-click="userViewCtrl.approve()">{{ 'Manually approve this user' | translate }}</a>
          </p>
          <p class="box box-warning" ng-if="userViewCtrl.userIsDisabled">
            {{ 'This user is disabled.' | translate }}
          </p>
        </div>
        <div class="col-xs-12 text-center text-left-sm">
          <kz-list-buttons actions="userViewCtrl.actionButtons"></kz-list-buttons>
        </div>
      </div>
    </div>
  </div>

  <div class="row" kz-loading loaded="userViewCtrl.loaded">
    <div class="col-sm-9 col-sm-push-3">
      <div class="row">
        <div class="col-sm-6">
          <div class="row user-profile-view-group">
            <div class="col-xs-12">
              <h2 class="heading-3">{{ 'Details' | translate }}</h2>
              <div class="row">
                <user-details profile="userViewCtrl.profile" action="view" data-ng-if="userViewCtrl.profile"></user-details>
              </div>
            </div>
          </div>
          <div class="row user-profile-view-group">
            <div class="col-xs-12">
              <h2 class="heading-3">{{ 'Emails' | translate }}</h2>
              <div class="row">
                <user-emails profile="userViewCtrl.profile" action="view"></user-emails>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 user-profile-view-group">
          <h2 class="heading-3">{{ 'Information' | translate }}</h2>
          <relations header-class-names="bg-transparent" accordion-type="icons"></relations>
        </div>
      </div>
    </div>
    <div class="col-sm-3 col-sm-pull-9">
      <div class="row user-profile-view-group">
        <div class="col-xs-12">
          <h2 class="heading-3">{{ 'Login information' | translate }}</h2>
          <user-credentials action="view" show-actions="false"></user-credentials>
        </div>
      </div>
      <div class="row user-profile-view-group">
        <div class="col-xs-12">
          <h2 class="heading-3">{{ 'Audit log' | translate }}</h2>
          <audit-logs ng-if="userViewCtrl.profile" show-header="false" expanded="true" profile-dates="userViewCtrl.profile.dates"
            per-page="5">
          </audit-logs>
        </div>
      </div>
    </div>
  </div>

</div>
`,
  'app/components/users/widgets/connections/edit.html': `<formly-form
  model="connectionsWidgetEditCtrl.config"
  fields="connectionsWidgetEditCtrl.form.fields"
  aria-label="{{ 'Connections' | translate }}">
</formly-form>
`,
  'app/components/users/widgets/connections/view.html': `<div>
  <div class="row" ng-if="connectionsWidgetCtrl.message.content">
    <div class="col-xs-12">
      <p class="box" ng-class="{'box-info': connectionsWidgetCtrl.message.type === 'info', 'box-danger': connectionsWidgetCtrl.message.type === 'error'}">
        <i class="icon-info"></i>
        <span class="text-gray">{{ connectionsWidgetCtrl.message.content }}</span>
    </p>
    </div>
  </div>

  <ul class="item-list item-list-bordered" ng-if="connectionsWidgetCtrl.list.ready && !connectionsWidgetCtrl.list.isLoading">
    <li class="item row" ng-repeat="user in connectionsWidgetCtrl.list.items">
      <div class="col-xs-2">
        <div class="avatar">
          <a ng-if="user.doc.state !== 'waiting_for_approval'" router-link="['/summary', user.doc.username]">
            <kz-avatar user="::user.doc"></kz-avatar>
          </a>
          <a ng-if="user.doc.state === 'waiting_for_approval'" router-link="['/admin/pending-sections']">
            <kz-avatar user="::user.doc"></kz-avatar>
          </a>
        </div>
      </div>
      <div class="col-xs-10">
        <a ng-if="user.doc.state === 'active'" router-link="['/summary', user.doc.username]"><span epf-fullname doc="::user.doc"></span></a>
        <a ng-if="user.doc.state === 'waiting_for_approval'" router-link="['/admin/pending-sections']"><span epf-fullname doc="::user.doc"></span></a>
      </div>
    </li>
  </ul>

  <kz-pagination
    ng-if="connectionsWidgetCtrl.list.ready && !connectionsWidgetCtrl.list.isLoading && connectionsWidgetCtrl.list.items.length"
    total="connectionsWidgetCtrl.list.found_count"
    startkey="connectionsWidgetCtrl.list.startkey"
    per-page="connectionsWidgetCtrl.list.findOptions.limit"
    to="connectionsWidgetCtrl.goToPage(page)">
  </kz-pagination>

  <div class="row" ng-if="connectionsWidgetCtrl.list.items.length">
    <div class="col-xs-12 text-center">
      <a router-link="['/users']" class="btn btn-primary btn-sm btn-raised">{{ 'View all users' | translate }}</a>
    </div>
  </div>
</div>
`,
  'app/components/users/widgets/profile/edit.html': `<form role="form">

  <div class="form-group" data-ng-if="false">
    <input type="checkbox" name="hideTitle" ng-model="profileWidgetEditCtrl.config.options.hideTitle" />
    <label for="hideTitle">{{ 'Hide panel title' | translate }}</label>
  </div>

  <div>
    <div hidden id="profile-information-move-instructions">{{ 'Use the arrow up and down keys to move this profile information' | translate }}</div>
    <div ng-sortable="{ handle: '.drag-handle', scroll: true, ghostClass: 'sortable-ghost' }">
      <div class="wrapper" ng-repeat="part in profileWidgetEditCtrl.options.parts track by $index">
        <div class="row event progress-border">
          <div class="col-xs-12">
            <div class="row event-inner">
              <div class="col-sm-7">
                <div class="form-group">
                  <input type="checkbox" name="hideTitle" ng-model="profileWidgetEditCtrl.visibleData[part._id]" />
                  <label for="hideTitle">{{ profileWidgetEditCtrl.attrs[part._id] }}</label>
                </div>
              </div>
              <div class="col-sm-5 col-right">
                <ul class="list-inline list-unstyled">
                  <li>
                    <button type="button" class="btn-link text-info drag-handle" aria-label="{{ 'Move' | translate }} {{ profileWidgetEditCtrl.attrs[part._id] }}" aria-describedby="profile-information-move-instructions">
                      <i class="icon-move"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row event-inner" ng-if="profileWidgetEditCtrl.visibleData[part._id] && profileWidgetEditCtrl.subForms[part._id]">
              <div class="col-sm-12">
                <formly-form model="part.subOptions"
                             fields="profileWidgetEditCtrl.subForms[part._id].fields"
                             aria-label="{{ 'Sub Options' | translate }} {{ profileWidgetEditCtrl.attrs[part._id] }}">
                </formly-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
`,
  'app/components/users/widgets/profile/view.html': `<div>
  <div ng-repeat="part in profileWidgetCtrl.parts track by $index">
    <div ng-switch on="part._id">
      <div ng-switch-when="showAvatar">
        <div class="profile-widget-avatar">
          <div class="pwa_bg"></div>
          <div class="avatar">
            <kz-avatar user="profileWidgetCtrl.profile" size="big"></kz-avatar>
          </div>
        </div>
      </div>
      <div ng-switch-when="showFullName">
        <div class="row">
          <div class="col-xs-12 text-center">
            <p class="text-4xl" epf-fullname user="profileWidgetCtrl.user"></p>
          </div>
        </div>
      </div>
      <div ng-switch-when="showViewLink">
        <div class="row">
          <div class="col-xs-12 text-center">
            <p>
              <a class="btn btn-xs btn-primary" data-ng-if="profileWidgetCtrl.remoteUser"
                router-link="['/profile/view', profileWidgetCtrl.remoteUser]">
                {{ 'View profile' | translate }}
              </a>
              <a class="btn btn-xs btn-primary" data-ng-if="!profileWidgetCtrl.remoteUser"
                router-link="['/profile/view']">
                {{ 'View profile' | translate }}
              </a>
            </p>
          </div>
        </div>
      </div>
      <div ng-switch-when="showRelations">
        <relations options="part.subOptions"></relations>
      </div>
      <div ng-switch-when="showRoles">
        <user-roles action="view"></user-roles>
      </div>
      <div ng-switch-when="showUserDetails">
        <div class="row" data-ng-if="profileWidgetCtrl.profile">
          <div class="col-xs-12">{{ 'Basic Information' | translate }}</div>
        </div>
        <user-details profile="profileWidgetCtrl.profile"
                      action="view"
                      data-ng-if="profileWidgetCtrl.profile">
        </user-details>
      </div>
      <div ng-switch-when="showAuditLog">
        <audit-logs user-id="profileWidgetCtrl.user"
                    data-ng-if="profileWidgetCtrl.profile">
        </audit-logs>
      </div>
    </div>
  </div>
</div>
`,
  'app/core/error.different-user.html': `<div class="row" style="margin-top: 50px" data-ng-show="ctrl.show">
  <div class="col-xs-12 col-sm-6 col-sm-offset-3">
    <div class="wrapper">
      <div class="row">
        <h3>{{ 'Confirm user' | translate }}</h3>
      </div>

      <div class="row">
        <ul>
          <li>You are currently logged in as <strong epf-fullnames user="ctrl.user"></strong> but the link you have followed relates to a different user. Please login using the correct account and then try again.</li>
        </ul>
      </div>

      <div class="row">
        <p><button type="button" class="btn btn-info" data-ng-click="ctrl.logout()">Log in as different user</button>
      </p>

    </div>
  </div>
</div>
`,
  'app/core/error.html': `<div class="row" style="margin-top: 50px" data-ng-show="ctrl.show">
  <div class="col-xs-12 col-sm-6 col-sm-offset-3">
    <div class="wrapper">
      <div class="row">
        <h3>{{ 'An error occurred' | translate }}</h3>
      </div>

      <div class="row">
        <ul>
          <li>{{ ctrl.error.status }}: {{ ctrl.error.message }}</li>
        </ul>
      </div>

      <div class="row" data-ng-if="ctrl.error.details">
        <p class="text-gray">{{ ctrl.error.details }}</p>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <p><button type="button" class="btn btn-danger" data-ng-click="ctrl.retry()">{{ 'Try again' | translate }}</button></p>
        </div>
        <div class="col-sm-6 text-right" data-ng-ig="ctrl.error.allowLogout">
          <p><button type="button" class="btn btn-danger" data-ng-click="ctrl.logout()">{{ 'Log out' | translate }}</button>
          </p>
        </div>
      </div>

      <div class="row" data-ng-if="false">
        <p>Turn on online mode. This may remove all date not yet synchronized to server.</p>
        <p><button type="button" class="btn btn-danger" data-ng-click="ctrl.setOnline()">Turn on online</button>
        </p>
      </div>

    </div>
  </div>
</div>
`,
  'app/core/helpeditor.html': `<div class="row">
  <div class="col-xs-12">
    <div class="wrapper">
      <div class="row">
        <h3>{{ 'Enter help' | translate }}</h3>
        <p>This is a very very simple help editor. Please note that it does not save it anywhere so all changes are lost unless you copy and paste the json at the bottom</p>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <formly-form model="ctrl.model" fields="ctrl.hform.fields" form="form" aria-label="Help editor"></formly-form>
          <button type="button" data-ng-click="ctrl.add(form)">{{ 'Add' | translate }}</button>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <ul>
            <li data-ng-repeat="(key, value) in ctrl.help">
              <a href="" data-ng-click="ctrl.load(key, value)">{{ key }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <pre>
          {{ ctrl.help | json }}
          </pre>
        </div>
      </div>
    </div>
  </div>
</div>
`,
  'app/core/upgrade.html': `<div class="row" style="margin-top: 50px" data-ng-show="ctrl.show">
  <div class="col-xs-12 col-sm-6 col-sm-offset-3">
    <div class="wrapper">
      <div class="row">
        <h3>{{ 'Upgrade required' | translate }}</h3>
      </div>

      <div class="row">
        <p>
          risr/advance has been updated and needs to be reloaded. This will happen automatically within 15 seconds.
        </p>
        <p>Alternatively you can reload manually by clicking the button below.</p>

      </div>
      <div class="row">
        <div class="col-sm-6">
          <p><button type="button" class="btn btn-info" data-ng-click="ctrl.reload()">{{ 'Reload' | translate }}</button>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
`,
  'app/core/widgets/wysiwyg/edit.html': `<form role="form">
  <div class="form-group">
    <label for="content">Content <i class="icon-star required" aria-label="star"></i></label>
    <ng-quill-editor ng-model="wysiwygEditCtrl.config.content" toolbar="true" toolbar-entries="size bold list bullet italic underline strike align color background link image" link-tooltip="true" image-tooltip="true" class="form-control wysiwyg-editor" error-class="input-error" editor-required="true" required="required">
    </ng-quill-editor>
    <p class="text-gray">You can also embed videos from Youtube or Vimeo by inserting a hyperlink to the video URL.</p>
  </div>
</form>
`,
  'app/core/widgets/wysiwyg/view.html': `<div ng-bind-html="wysiwygCtrl.config.content | nl2br | a2nt | videoUrlToIframe" class="readonly"></div>
`,
  'app/layout/header/header.html': `<div class="container-fluid">
  <div>
    <div id="phone-layout">
      <ul class="list-unstyled">
        <li>
          <kz-hamburger-menu links="headerCardCtrl.menu.main" data-ng-if="headerCardCtrl.menu.main"></kz-hamburger-menu>
        </li>

        <li class="v-align phone-logo-item">
          <div id="phone-kz-logo" class="text-center">
            <a router-link="'/'" title="{{ 'Go to My Dashboard' | translate }}">
              <kz-logo type="mobile" class="navbar-logo"></kz-logo>
            </a>
          </div>
        </li>

        <li class="v-align" style="padding-top: 3px">
          <a router-link="['/events/new']" ng-show="headerCardCtrl.canCreateEvents" aria-label="{{ 'Create a new event' | translate }}">
            <i class="icon-plus" style="font-size: 23px"></i>
          </a>
        </li>

        <li class="v-align" style="padding-top: 5px" kz-menu-settings-links></li>

        <li class="v-align" style="padding-top: 5px" data-kz-menu-todo-link></li>

        <li class="v-align">
          <risr-language-switcher></risr-language-switcher>
        </li>

        <li class="avatar v-align">
          <kz-avatar-card user="headerCardCtrl.userProfile" />
        </li>
      </ul>
    </div>

    <div id="desktop-layout">
      <div class="navbar-header">
        <a router-link="'/'" title="{{ 'Go to My Dashboard' | translate }}">
          <kz-logo type="mobile" class="logo--mobile"></kz-logo>
          <kz-logo class="logo--desktop"></kz-logo>
        </a>
      </div>
      <div id="navbar" data-ng-if="headerCardCtrl.loading">
        <nav aria-label="{{ 'Main' | translate }}">
          <ul class="nav navbar-nav" data-kz-menu menu-items="::headerCardCtrl.menu.main"></ul>
        </nav>
      </div>

      <nav aria-label="{{ 'Actions and profile' | translate }}">
        <ul class="nav navbar-nav navbar-right text-right" data-kz-menu menu-items="::headerCardCtrl.menu.right">
          <li>
            <a router-link="['/events/new']" ng-show="headerCardCtrl.canCreateEvents" aria-label="{{ 'Create a new event' | translate }}">
              <i class="icon-plus" style="font-size: 20px"></i>
            </a>
          </li>
          <li data-kz-menu-todo-link></li>
          <li kz-menu-settings-links></li>
          <li>
            <risr-language-switcher></risr-language-switcher>
          </li>
          <li class="avatar">
            <kz-avatar-card user="headerCardCtrl.userProfile" />
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
`,
  'app/layout/header/kz-avatar-card.html': `<div>
  <kz-avatar user="avatarCardCtrl.user" data-ng-if="avatarCardCtrl.isRemoteProfile"></kz-avatar>

  <div uib-dropdown on-toggle="avatarCardCtrl.toggle(open)" auto-close="always" data-ng-if="!avatarCardCtrl.isRemoteProfile">
    <a href="" class="profile-dropdown" uib-dropdown-toggle aria-label="{{ 'Toggle profile settings' | translate }}">
      <span
        class="label-color-dot label-color-dot-sm"
        ng-class="{'label-success-dot': avatarCardCtrl.mode === 'online', 'label-warning-dot': avatarCardCtrl.mode === 'offline'}">
      </span>
      <kz-avatar
        ng-class="[avatarCardCtrl.mode]"
        user="avatarCardCtrl.user">
      </kz-avatar>
      <span data-ng-class="{
        'badge': true,
        'badge-danger': avatarCardCtrl.info.error.warn,
        'badge-info': !avatarCardCtrl.info.error.warn
        }" ng-if="avatarCardCtrl.pendingItems.total > 0">
        {{ avatarCardCtrl.pendingItems.total }}
      </span>
      <span class="caret"></span>
    </a>
    <ul class="dropdown-menu" uib-dropdown-menu role="menu">
      <li class="avatar-highlight">
        <div class="col-xs-1">
          <kz-avatar user="avatarCardCtrl.avatar"></kz-avatar>
        </div>
        <div class="col-xs-6">
          <span ng-bind="avatarCardCtrl.avatar.fullName"></span>
        </div>
        <div class="col-xs-5 text-right">
          <a class="btn bg-white btn-xs text-primary" router-link="['/profile/view']">{{ 'View profile' | translate }}</a>
        </div>
      </li>

      <li>
        <kz-net-status></kz-net-status>
      </li>

      <li ng-repeat="action in avatarCardCtrl.pendingItems.perAction" ng-if="action.states.pending">
        <p class="col-xs-12 text-gray">
          <span>
            <i class="icon-reload text-warning"></i>
            {{ action.action }}
          </span>
        </p>
      </li>

      <li>
        <p class="col-xs-7">
          <span class="text-gray">{{ 'Organisation:' | translate }}</span>
          <span ng-bind="avatarCardCtrl.avatar.organisation"></span>
        </p>
        <p class="col-xs-5 text-right" data-ng-if="avatarCardCtrl.showOrg">
          <a class="btn btn-xs border border-primary" router-link="['/org-chooser']">{{ 'Change' | translate }}</a>
        </p>
      </li>

      <li class="avatar-highlight">
        <button type="button" class="btn btn-sm bg-white text-primary" ng-click="avatarCardCtrl.logout()">{{ 'Logout' | translate }}</button>
      </li>
    </ul>

    <ul class="dropdown-menu" uib-dropdown-menu role="menu" ng-if="avatarCardCtrl.error">
      <li class="avatar-highlight" ng-class="{ 'remote-profile': avatarCardCtrl.isRemoteProfile }">
        <span ng-bind="avatarCardCtrl.message"></span>
      </li>

      <li class="avatar-highlight">
        <a class="btn btn-sm bg-white text-primary" href="" ng-click="avatarCardCtrl.logout()">{{ 'Logout' | translate }}</a>
      </li>
    </ul>

    </ul>
  </div>
  <kz-live-chat></kz-live-chat>
</div>
`,
  'app/layout/header/kz-avatar-remote-card.html': `<div>
    <div uib-dropdown on-toggle="avatarCardCtrl.toggle(open)" auto-close="always">
      <a href="" class="profile-dropdown remote-profile-dropdown" uib-dropdown-toggle>
        <kz-avatar
          user="avatarCardCtrl.user">
        </kz-avatar>
        <span data-ng-class="{
          'badge': true,
          'badge-danger': true,
          'badge-info': false
          }" ng-if="avatarCardCtrl.pendingItems.total > 0">
          {{ avatarCardCtrl.pendingItems.total }}
        </span>
        <span class="caret"></span>
      </a>
      <ul class="dropdown-menu remote-dropdown-menu" uib-dropdown-menu role="menu">
        <li class="avatar-highlight">
          <div class="col-xs-1">
            <kz-avatar user="avatarCardCtrl.avatar"></kz-avatar>
          </div>
          <div class="col-xs-6">
            <span ng-bind="avatarCardCtrl.avatar.fullName"></span>
          </div>
          <div class="col-xs-5 text-right">
            <a class="btn bg-white btn-xs text-primary" router-link="['/profile/view', avatarCardCtrl.user.user]">{{ 'View profile' | translate }}</a>
          </div>
        </li>

        <li ng-if="avatarCardCtrl.pendingItems.total === 0">
            <p class="col-xs-8 text-gray">
                <span><i class="icon-ok text-success"></i>{{ 'Up to date' | translate }}</span>
            </p>
        </li>

        <li ng-repeat="action in avatarCardCtrl.pendingItems.perAction" ng-if="action.states.pending">
          <p class="col-xs-12 text-gray">
            <span>
              <i class="icon-reload text-warning"></i>
              {{ action.action }}
            </span>
          </p>
        </li>
      </ul>

      <ul class="dropdown-menu" uib-dropdown-menu role="menu" ng-if="avatarCardCtrl.error">
        <li class="avatar-highlight" ng-class="{ 'remote-profile': avatarCardCtrl.isRemoteProfile }">
          <span ng-bind="avatarCardCtrl.message"></span>
        </li>

        <li class="avatar-highlight">
          <a class="btn btn-sm bg-white text-primary" href="" ng-click="avatarCardCtrl.logout()">{{ 'Logout' | translate }}</a>
        </li>
      </ul>

      </ul>
    </div>
  </div>
`,
  'app/layout/header/kz-avatar.html': `<span ng-class="[{'avatar--big': size === 'big'}]">
  <span class="avatar__image" ng-if="avatarCtrl.avatar.imageUrl">
    <kz-image loader="{{avatarCtrl.avatar.imageUrl}}" signed="true" alt="{{avatarCtrl.avatar.name}}" cache="immutable" layout="responsive"></kz-image>
  </span>
  <span class="avatar__image" ng-if="avatarCtrl.avatar.src">
    <kz-image
      alt="{{avatarCtrl.avatar.name}}"
      cache="immutable"
      layout="responsive"
      src="{{avatarCtrl.avatar.src}}">
    </kz-image>
  </span>
  <span class="avatar__name"
        ng-if="!avatarCtrl.avatar.imageUrl && !avatarCtrl.avatar.src" ng-bind="avatarCtrl.avatar.initials">
  </span>
</span>
`,
  'app/layout/header/kz-hamburger-menu.html': `<div id="hamburger-menu" style="height: auto">
  <div id="full-screen-menu" ng-hide="!hamburgerMenuCtrl.show">
    <div class="row" style="padding-top: 20px" data-ng-if="!hamburgerMenuCtrl.categoryTitle">
      <div class="col-xs-12">
        <div class="row menu-row">
          <div class="col-xs-12"><p class="text-sm text-white text-uppercase">{{ 'Main Menu' | translate }}</p></div>
        </div>
        <div class="row menu-separator"></div>
      </div>
    </div>

    <div class="row" style="padding-top: 20px" data-ng-if="hamburgerMenuCtrl.categoryTitle">
      <div class="col-xs-12">
        <div class="row menu-row">
          <div class="col-xs-12">
            <button type="button" class="btn btn-link text-link" data-ng-click="hamburgerMenuCtrl.goTo('back')"><i class="icon-arrow-left"></i> {{ 'Back' | translate }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" data-ng-if="hamburgerMenuCtrl.categoryTitle">
      <div class="col-xs-12">
        <div class="row menu-row">
          <div class="col-xs-12"><p class="text-xl text-white">{{ hamburgerMenuCtrl.categoryTitle }}</p></div>
        </div>
        <div class="row menu-separator"></div>
      </div>
    </div>

    <nav aria-label="{{ 'Main' | translate }}">
      <div class="row" data-ng-repeat="link in hamburgerMenuCtrl.links">

      <div class="col-xs-12" ng-if="link.links">
        <a href="" data-ng-click="hamburgerMenuCtrl.goTo(link.links, link.title)">
          <div class="row menu-row">
            <div class="col-xs-10">
              <p class="text-lg text-white">{{ link.title }}</p>
              <span class="hm-sub-items-text" data-ng-repeat="subLink in link.links"><span data-ng-if="$index !== 0">, </span><span data-ng-if="!subLink.blueprintId">{{ subLink.title }}</span><span data-ng-if="subLink.blueprintId" kz-blueprint-category-title category="subLink.blueprintId"></span>
              </span>
            </div>
            <div class="col-xs-1 right-arrow"><i class="icon-arrow-right"></i></div>
          </div>
          <div class="menu-separator row"></div>
        </a>
      </div>

      <div class="col-xs-12"  data-ng-if="!link.links">
        <a data-ng-mouseup="hamburgerMenuCtrl.onClickLink()" router-link="link.route" data-ng-if="::link.blueprintId">
          <div class="row menu-row">
            <div class="col-xs-12">
              <p class="text-lg text-white" kz-blueprint-category-title category="link.blueprintId"></p>
            </div>
          </div>
          <div class="menu-separator row"></div>
        </a>
        <a data-ng-mouseup="hamburgerMenuCtrl.onClickLink()" data-ng-if="::link.route && !link.blueprintId" router-link="link.route">
          <div class="row menu-row">
            <div class="col-xs-12"><p class="text-white text-lg"> {{ link.title }}</p></div>
          </div>
          <div class="menu-separator row"></div>
        </a>
      </div>

    </div>
    </nav>
  </div>
  <button type="button" id="icon-menu" class="hamburger hamburger--squeeze" data-ng-class="{'is-active': hamburgerMenuCtrl.show}" data-ng-click="hamburgerMenuCtrl.onClickLink()" aria-label="{{ 'Main Menu' | translate }}" aria-expanded="{{hamburgerMenuCtrl.show}}">
    <div class="hamburger-box">
      <div class="hamburger-inner"></div>
    </div>
  </button>
</div>
`,
  'app/layout/header/kz-header-menu.html': `<li data-ng-repeat="link in links" data-ng-class="{active: link.active, 'dropdown': link.links}">
  <a href="" data-ng-if="(!link.route && link.links && link.links.length > 1)" class="dropdown-toggle" data-toggle="dropdown"><span data-ng-bind-html="link.title | translate"></span> <span class='caret'></span></a>

  <a router-link="link.route" data-ng-if="link.route" data-ng-mouseup="headerMenuCtrl.hideMenu()" data-ng-bind-html="link.title | translate"></a>
  <a router-link="link.links[0].route" data-ng-if="(!link.route && link.links && link.links.length === 1)" data-ng-mouseup="headerMenuCtrl.hideMenu()" data-ng-bind-html="link.links[0].title | translate"></a>

  <ul class="dropdown-menu">
    <li data-ng-class="{active: sublink.active}" data-ng-repeat="sublink in link.links track by $index">

      <a data-ng-mouseup="headerMenuCtrl.hideMenu()" router-link="sublink.route" data-ng-if="::sublink.blueprintId && !headerCardCtrl.loadingSubItems">
        <span  kz-blueprint-category-title category="sublink.blueprintId"></span>
      </a>
      <div data-ng-if="headerCardCtrl.loadingSubItems"><p class="text-center"><i class="icon-spin animate-spin"></i></p></div>
      <a href="" data-ng-if="::(!sublink.route && sublink.links)" data-ng-bind-html="link.title | translate"></a>

      <a router-link="sublink.route" ng-if="sublink.route && !sublink.blueprintId" data-ng-mouseup="headerMenuCtrl.hideMenu()" data-ng-bind-html="sublink.title | translate"></a>
    </li>
  </ul>
</li>
`,
  'app/layout/header/kz-menu-settings-links.html': `<li class="dropdown" ng-if="menuSettingsCtrl.showMainLink" ng-class="{ active: menuSettingsCtrl.hasActiveLinks() }">
  <a href="" class="dropdown-toggle" data-toggle="dropdown" aria-label="{{ 'Settings' | translate }}">
    <i class="icon-cog icon-md"></i>
    <span class="caret"></span>
  </a>
  <ul class="dropdown-menu" role="menu">
    <li class="menu-item" ng-if="menuSettingsCtrl.canManageLabsSettings"><a router-link="['/settings/labs']">{{ 'Labs settings' | translate }}</a></li>
    <li class="menu-item" ng-if="menuSettingsCtrl.canManageOrganisationSettings"><a router-link="['/settings/organisation']">{{ 'Organisation settings' | translate }}</a></li>
    <li class="menu-item" ng-if="menuSettingsCtrl.canManageProtectedSettings"><a router-link="['/settings/protected']">{{ 'Protected settings' | translate }}</a></li>
    <li class="menu-item" ng-if="menuSettingsCtrl.canViewAiUsage"><a router-link="['/settings/ai-usage']">{{ 'AI usage' | translate }}</a></li>
    <li class="menu-item" ng-if="menuSettingsCtrl.canManageIndexingStatus"><a router-link="['/indexing-status']">{{ 'Indexing status' | translate }}</a></li>
    <li class="menu-item" ng-if="menuSettingsCtrl.canManageTrash"><a router-link="['/trash']">{{ 'Trash' | translate }}</a></li>
  </ul>
</li>
`,
  'app/layout/header/kz-menu-todo-link.html': `<li>
  <a href="" router-link="['/activities']" aria-label="{{ 'Go to my activity' | translate }}">
    <i class="icon-bell icon-md" data-ng-class="{'required': ctrl.count || ctrl.hasDrafts}"></i>
    <span data-ng-show="ctrl.count" class="badge badge-danger">{{ctrl.count}}</span>
  </a>
</li>
`,
  'app/layout/header/logged-in-as-bar.html': `<div ng-if="original">
  <p>{{ 'You are logged in as' | translate }} <strong>{{ original.fullName }}</strong></p>
  <div class="text-right">
    <button class="btn btn-sm bg-white text-danger-800" ng-click="logout()">{{ 'Switch back to my account' | translate }}</button>
  </div>
</div>
`,
  'app/layout/header/partials/action-menu.html': `<form novalidate name="goalResolve">
  <div class="modal-header">
    <button type="button" class="close" data-ng-click="dismiss()" aria-label="{{ 'Close' | translate }}"><span aria-hidden="true">&times;</span></button>
    <div class="modal-title text-left">
      <h4 id="myModalLabel">{{ 'What would you like to create?' | translate }}</h4>
    </div>
  </div>
  <div class="modal-body" style="height: 300px">
    <ul style="list-style-type: none;">
      <li data-ng-repeat="link in links">
        <a class="dropdown-item"
           href="{{link.href}}"
           data-ng-if="link.href"
           data-ng-mouseup="dismiss()">
          {{ link.label }}
        </a>
        <a class="dropdown-item"
           href=""
           data-ng-if="link.links"
           data-ng-mouseup="dismiss()"
           data-ng-click="openLinksDialog(link.links)">
          {{ link.label }}
        </a>
      </li>
    </ul>
  </div>
</form>
`,
  'app/layout/header/remote-profile-bar.html': `<div ng-if="remoteProfileBarCtrl.remoteProfile">
  <div class="container-fluid">
    <ul class="nav navbar-nav">
      <li>
        <p>
          <span class="hidden-xs hidden-sm">{{ 'You are viewing' | translate }} </span>
          <strong class="truncate-xs-200">
            <epf-fullname doc="remoteProfileBarCtrl.remoteProfile"></epf-fullname>
          </strong><span class="hidden-xs hidden-sm">{{ "'s e-portfolio" | translate }}</span>
        </p>
      </li>
      <li>
        <button type="button" id="collapse-navbar-remote" class="navbar-toggle visible-xs-inline-block visible-sm-inline-block" aria-expanded="{{!remoteProfileBarCtrl.remoteNavbarCollapsed}}" aria-controls="remote-navbar" ng-click="remoteProfileBarCtrl.toggleRemoteNavbar()">
          <span class="sr-only">{{ 'Toggle navigation' | translate }}</span>
          <span ng-if="!remoteProfileBarCtrl.remoteNavbarCollapsed" class="icon-up-open-big"></span>
          <span ng-if="remoteProfileBarCtrl.remoteNavbarCollapsed" class="icon-down-open-big"></span>
        </button>
      </li>
    </ul>

    <ul class="nav navbar-nav navbar-right">
      <li class="avatar">
        <kz-avatar-remote-card user="remoteProfileBarCtrl.remoteProfile" is-remote-profile="true"></kz-avatar-remote-card>
      </li>
    </ul>

    <div id="remote-navbar" class="navbar-collapse collapse" ng-class="{in: !remoteProfileBarCtrl.remoteNavbarCollapsed}">
      <ul class="nav navbar-nav navbar-nav-links" data-kz-menu menu-items="remoteProfileBarCtrl.menu"></ul>
    </div>
  </div>
</div>
`,
  'app/layout/header/unsynced-bar.html': `<div class="row" data-ng-if="info.toSync > 0 && !burgerMenuShown">
    <div class="col-xs-12">
        <div class="alert alert-danger">
            {{ 'You have un-synced changes on this device.' | translate }} <span class="hidden-xs">{{ 'We will sync them as soon as you have an internet connection again.' | translate }}</span>
        </div>
    </div>
</div>
`,
  'app/layout/placeholders/list.html': `<div class="wrapper placeholder-row">
  <div class="placeholder-item">
    <div class="placeholder-item-animated">
      <div class="background-masker header-right"></div>
      <div class="background-masker subheader-right"></div>
      <div class="background-masker subheader-bottom"></div>
    </div>
  </div>
</div>
`,
  'app/layout/sidebar/cards/advanced-search.card.html': `<div>
  <div class="row" data-ng-if="search">
    <div class="col-xs-12 col-margins">

      <br/>

      <div class="advanced-search-form">
        <kz-advanced-search model="searchModel" search="search"></kz-advanced-search>
      </div>

      <div class="advanced-search-form">
        <formly-form model="model" fields="orderFields" form="form" aria-label="{{ 'Order' | translate }}"></formly-form>
      </div>

      <a class="btn btn-xs btn-primary" href="" data-ng-click="apply()">{{ 'Apply' | translate }}</a>
    </div>
  </div>
</div>
`,
  'app/layout/sidebar/cards/bookmark.card.html': `<div>
  <div class="row row-bordered" data-ng-show="bookmarks.length > 0" ng-repeat="item in bookmarks track by $index">
    <div class="col-xs-11 col-sm-10">
      <a href="" data-ng-click="use(item)">{{ item.title }}</a>
    </div>
    <div class="col-xs-1 col-sm-2 text-right">
      <a href="" data-ng-click="remove(item)" class="text-danger"><i aria-label="{{ 'Remove bookmark' | translate }}" class="icon-trash"></i></a>
    </div>
  </div>
  <form class="flex items-start justify-between gap-4 p-4" name="form" data-ng-submit="add(form)">
    <div class="w-full">
      <formly-form model="data" fields="addform.fields" form="form"></formly-form>
    </div>
    <button type="submit" class="btn btn-info mt-4" data-ng-click="add(form)" data-ng-disabled="searchModel.filteredBy | kzIsEmpty:'deep'">{{ 'Add' | translate }}</button>
  </form>
</div>
`,
  'app/layout/sidebar/cards/formerrors.card.html': `<div>

  <div class="row row-bordered">
    <div class="col-xs-12">
    <ul class="list-unstyled">
      <li data-ng-if="errors > 0">
        <p>
          {{ 'This form contains' | translate }}
          <span data-ng-if="errors === 1">{{ 'one error' | translate }}</span>
          <span data-ng-if="errors !== 1">{{ errors }} {{ 'errors' | translate }}</span>.
        </p>
      </li>
      <li data-ng-if="required > 0">
        <p>
          {{ 'This form contains' | translate }} {{ required }} {{ 'empty mandatory' | translate }}
          <span data-ng-if="required === 1">{{ 'field' | translate }}</span>
          <span data-ng-if="required !== 1">{{ 'fields' | translate }}</span>.
        </p>
      </li>
    </ul>
    </div>
  </div>
  <p>
    <a href="" data-ng-click="showMe()">{{ 'Show me' | translate }}</a>
  </p>
</div>
`,
  'app/layout/sidebar/sidebar-slot.html': `<div>
  <div data-ng-if="!hidden" class="wrapper" data-ng-class="{stick: cardPrefs.sticky}">
    <div class="card-header card-{{type || card.type}}">
      <div class="row">
        <div class="col-xs-12">
          <button type="button" aria-controls="{{card.id}}-sidebar-card" aria-expanded="{{!cardPrefs.collapsed}}" class="btn btn-link text-white" ng-click="cardPrefs.collapsed=!cardPrefs.collapsed" aria-label="{{ 'Toggle card visibility' | translate }}">
            <i class="icon-down-open-big" ng-if="cardPrefs.collapsed"></i>
            <i class="icon-up-open-big" ng-if="!cardPrefs.collapsed"></i>
          </button>
          <p class="heading-4">{{ card.title }}</p>
        </div>
      </div>
    </div>

    <div id="{{card.id}}-sidebar-card" ng-show="!cardPrefs.collapsed">
      <div class="card-content">
        <div class="card-pre-content" ng-bind-html="preContent"></div>
        <div class="inner-card"></div>
        <div class="card-post-content" ng-bind-html="postContent"></div>
      </div>

      <div class="card-footer" ng-if="footer" ng-bind-html="footer"></div>
    </div>
  </div>
</div>
`,
  'app/layout/sidebar/sidebar.html': `<div class="sidebar">
  <div ng-repeat="card in cards track by card.id" class="sidebar-card">
    <sidebar-slot ng-show="!card.isHidden" card="card" directive="{{card.directive}}"></sidebar-slot>
  </div>
</div>
`,
  'app/layout/templates/1-column-full.html': `<div class="row">
  <div class="col-xs-12" data-ui-view="main"></div>
</div>
`,
  'app/layout/templates/1-column.html': `<main id="main" class="container" aria-label="{{ 'risr/advance main content' | translate }}">
  <div class="row">
    <div class="col-xs-12" data-ui-view="content"></div>
  </div>
</main>
`,
  'app/layout/templates/2-columns-half.html': `<div class="row">

  <div id="sidebar-left" class="col-sm-6">
    <div class="row">
      <div class="col-xs-12" data-ui-view="left"></div>
    </div>
  </div>

  <div id="content" class="col-sm-6">
    <div class="row">
      <div class="col-xs-12" data-ui-view="main"></div>
    </div>
  </div>

</div>
`,
  'app/layout/templates/2-columns-left.html': `<div class="row">
  <div id="sidebar-left" class="col-sm-3">
    <div class="wrapper" data-kz-profile-card></div>
  </div>
  <div id="content" class="col-sm-9">
    <div class="row">
      <div class="col-xs-12" data-ui-view="main"></div>
    </div>
  </div>
</div>
`,
  'app/layout/templates/2-columns-right.html': `<div class="row">
  <div id="content" class="col-md-9">
    <div class="row">
      <div class="col-xs-12">
        <ng-transclude></ng-transclude>
      </div>
    </div>
  </div>
  <div id="sidebar-left" class="col-md-3 hidden-xs hidden-sm">
    <div class="row">
      <div class="col-xs-12" data-kz-sidebar></div>
    </div>
  </div>
</div>
`,
  'app/layout/templates/main.html': `<kz-root-styles></kz-root-styles>
<header>
  <div id="header-menu" class="navbar navbar-default navbar-fixed-top" data-kz-header-card></div>
  <div id="remote-header-menu" class="navbar navbar-remote navbar-fixed-top" kz-remote-profile-bar></div>
  <div id="logged-in-as-menu" kz-logged-in-as-bar></div>
  <div id="unsynced-bar" kz-unsynced-bar></div>
</header>

<main id="main" class="container-fluid" aria-label="{{ 'risr/advance main content' | translate }}">
  <div class="row-fluid">
    <div id="main-content" class="col-sm-12" tabindex="-1">
      <kz-offline-banner></kz-offline-banner>
      <ng-transclude></ng-transclude>
      <div kz-jira-collector></div>
    </div>
  </div>
  <div id="toast-status-messages" role="status"></div>
</main>
`,
  'auth-callback.html': `<!DOCTYPE html>
<html>

  <head>
    <meta charset="utf-8" />
    <title>risr/advance - Callback</title>
    <script src="assets/scripts/oidc-client-ts.min.js"></script>
    <style>
        @import url(https://fonts.googleapis.com/css?family=Roboto:400,100);

        body {
          font-family: 'Roboto', sans-serif;
          margin: 0;
          padding: 0;
        }

        pre {
          white-space: pre-line;
        }

        .login {
          text-align: center;
          font-size: 14px;
          font-family: 'Arial', sans-serif;
          font-weight: 700;
          height: 36px;
          padding: 0 8px;
        }

        .login-submit {
          border: 0px;
          color: #fff;
          text-shadow: 0 1px rgba(0,0,0,0.1);
          background-color: #4d90fe;
        }

        .login-help {
          width: 100%;
          text-align: center;
          font-size: 12px;
        }

        .login-client-image img {
          margin-bottom: 20px;
        }

        .grant-debug {
          font-family: Fixed, monospace;
          width: 100%;
          text-align: center;
          font-size: 12px;
          color: #999;
          padding-top: 10px;
        }

        button {
          cursor: pointer;
        }

        .login-client-image img {
          display: inline-block;
          max-width: 100%;
          vertical-align: middle;
          width: 100%;
        }

        /* We shoould move these styles into their own file */
        #content {
          align-items: center;
          display: grid;
          height: 100vh;
        }

        body {
          background: #fafafa;
        }

        .ub-card {
          padding: 20px 40px;
          max-width: 80vw;
          width: 480px;
          background-color: #fff;
          margin: 0 auto 10px;
          border-radius: 4px;
          border: 1px solid #e6e6e6;
        }

        .ub-card h1 {
          color: #0d0d58;
          font-weight: 700;
          text-align: center;
          font-size: 2.25em;
          margin: 8px 0;
          padding: 8px 0
        }

        .ub-card [type=submit] {
          width: 100%;
          display: block;
          margin-bottom: 10px;
          position: relative;
        }

        .ub-card a {
          text-decoration: none;
          /* color: #666; */
          /* font-weight: 400; */
          text-align: center;
          display: inline-block;
          /* opacity: 0.6; */
        }

        .ub-button {
          background-color: #2a2a2a;
          border: 1px solid #2a2a2a;
          color: #fff;
          font-size: 1.2em;
          font-weight: 700;
          line-height: 140%;
          padding: 12px 35px;
          width: 100%;
        }

        .ub-button:hover {
          background-color: #000;
          border: 1px solid #000;
        }

        .ub-form-group {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          margin: 0 0 8px 0;
        }

        .ub-form-group .ub-form-label,
        .ub-form-group .ub-form-input,
        .ub-form-group .ub-form-select {
          flex: none;
        }

        .ub-form-label {
          color: #444;
          font-size: 16px;
        }

        .ub-form-control {
          background: #fff;
          border-top: 1px solid #c0c0c0;
          border: 1px solid #d9d9d9;
          box-sizing: border-box;
          display: block;
          font-size: 16px;
          height: 44px;
          margin-bottom: 10px;
          padding: 0 8px;
          width: 100%;
        }

        .ub-form-checkbox {
          border-radius: 0px;
          border: 1px solid #ddd;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05);
          display: inline-block;
          padding: 9px;
          position: relative;
          -webkit-appearance: none;
          appearance: none;
          background-color: #fff;
        }

        .ub-form-checkbox:active,
        .ub-form-checkbox:checked:active {
          box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px 1px 3px rgba(0,0,0,0.1);
        }

        .ub-form-checkbox:checked {
          background-color: #e9ecee;
          border: 1px solid #adb8c0;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05), inset 15px 10px -12px rgba(255,255,255,0.1);
          color: #99a1a7;
        }

        .ub-form-checkbox:checked:after {
          content: '\xb9';
          color: #444;
          font-size: 14px;
          position: absolute;
          top: 0px;
          left: 3px;
        }

        .ub-form-select {
          -webkit-appearance: none;
          appearance: none;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAIAAAAmzuBxAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpGQTdGMTE3NDA3MjA2ODExOTJCMEI4QUY2OEFGOTJFOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo0NDNBNDZGRUQwRUUxMUUyQkRGNEQ3NThBREE3RDhCQiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo0NDNBNDZGREQwRUUxMUUyQkRGNEQ3NThBREE3RDhCQiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M0IE1hY2ludG9zaCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjAyODAxMTc0MDcyMDY4MTE5MkIwODgxQTcwOTI5MEE3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkZBN0YxMTc0MDcyMDY4MTE5MkIwQjhBRjY4QUY5MkU5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+0G/y9QAAAKFJREFUeNp8kLEKwyAQhqsUCbqECIKDDk4ZEpwSQYiv4HPm3VxDN+21KWmbpP3g4D/+Dw4OlVIuf0FgpJRyzseuaZorsCzLPM+nRoxRa40ZY33fH2spJdQQMMw4jlVVfd1GKISw5ocBtXPu02jbVgjxNoCu6zjnayaEeO83+2VgjKdpWvMwDJTSvQEopYwxdV1ba/f/2JbbE3jDT+OUuwADANi+KdCnCjqhAAAAAElFTkSuQmCC);
          background-position: 95% 50%;
          background-repeat: no-repeat;
        }

        #err_description {
          border-top: 1px solid #e6e6e6;
          margin-top: 2em;
          padding-top: 2em;
        }

        #err_description ul {
          margin: 0;
          padding: 0;
        }

        #err_description ul li {
          list-style: none inside none;
          padding: 0.6em 0;
        }

      </style>
  </head>

  <body>
    <div id="loading">
      Verifying, please wait...
    </div>
    <div id="error" style="display: none">
        <main id="content">
            <div class="ub-card">
              <h1>Login failed</h1>
              Reason:
              <pre id="detail"></pre>
              <p>
                There was a problem during the login process. Please click below to try again.
              </p>
              <p>
                <button class="ub-button ub-button--primary" onClick="location.href='/'">Try again</button>
              </p>
            </div>
        </main>
    </div>

    <script src="assets/scripts/auth-callback.js"></script>
  </body>

</html>
`,
  'auth-loggedout.html': `<!DOCTYPE html>
<html>

  <head>
    <meta charset="utf-8" />
    <title>Callback</title>
    <style>
        @import url(https://fonts.googleapis.com/css?family=Roboto:400,100);

        body {
          font-family: 'Roboto', sans-serif;
          margin: 0;
          padding: 0;
        }

        .login {
          text-align: center;
          font-size: 14px;
          font-family: 'Arial', sans-serif;
          font-weight: 700;
          height: 36px;
          padding: 0 8px;
        }

        .login-submit {
          border: 0px;
          color: #fff;
          text-shadow: 0 1px rgba(0,0,0,0.1);
          background-color: #4d90fe;
        }

        .login-help {
          width: 100%;
          text-align: center;
          font-size: 12px;
        }

        .login-client-image img {
          margin-bottom: 20px;
        }

        .grant-debug {
          font-family: Fixed, monospace;
          width: 100%;
          text-align: center;
          font-size: 12px;
          color: #999;
          padding-top: 10px;
        }

        button {
          cursor: pointer;
        }

        .login-client-image img {
          display: inline-block;
          max-width: 100%;
          vertical-align: middle;
          width: 100%;
        }

        /* We shoould move these styles into their own file */
        #content {
          align-items: center;
          display: grid;
          height: 100vh;
        }

        body {
          background: #fafafa;
        }

        .ub-card {
          padding: 20px 40px;
          max-width: 80vw;
          width: 480px;
          background-color: #fff;
          margin: 0 auto 10px;
          border-radius: 4px;
          border: 1px solid #e6e6e6;
        }

        .ub-card h1 {
          color: #0d0d58;
          font-weight: 700;
          text-align: center;
          font-size: 2.25em;
          margin: 8px 0;
          padding: 8px 0
        }

        .ub-card [type=submit] {
          width: 100%;
          display: block;
          margin-bottom: 10px;
          position: relative;
        }

        .ub-card a {
          text-decoration: none;
          /* color: #666; */
          /* font-weight: 400; */
          text-align: center;
          display: inline-block;
          /* opacity: 0.6; */
        }

        .ub-button {
          background-color: #2a2a2a;
          border: 1px solid #2a2a2a;
          color: #fff;
          font-size: 1.2em;
          font-weight: 700;
          line-height: 140%;
          padding: 12px 35px;
          width: 100%;
        }

        .ub-button:hover {
          background-color: #000;
          border: 1px solid #000;
        }

        .ub-form-group {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          margin: 0 0 8px 0;
        }

        .ub-form-group .ub-form-label,
        .ub-form-group .ub-form-input,
        .ub-form-group .ub-form-select {
          flex: none;
        }

        .ub-form-label {
          color: #444;
          font-size: 16px;
        }

        .ub-form-control {
          background: #fff;
          border-top: 1px solid #c0c0c0;
          border: 1px solid #d9d9d9;
          box-sizing: border-box;
          display: block;
          font-size: 16px;
          height: 44px;
          margin-bottom: 10px;
          padding: 0 8px;
          width: 100%;
        }

        .ub-form-checkbox {
          border-radius: 0px;
          border: 1px solid #ddd;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05);
          display: inline-block;
          padding: 9px;
          position: relative;
          -webkit-appearance: none;
          appearance: none;
          background-color: #fff;
        }

        .ub-form-checkbox:active,
        .ub-form-checkbox:checked:active {
          box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px 1px 3px rgba(0,0,0,0.1);
        }

        .ub-form-checkbox:checked {
          background-color: #e9ecee;
          border: 1px solid #adb8c0;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05), inset 15px 10px -12px rgba(255,255,255,0.1);
          color: #99a1a7;
        }

        .ub-form-checkbox:checked:after {
          content: '\xb9';
          color: #444;
          font-size: 14px;
          position: absolute;
          top: 0px;
          left: 3px;
        }

        .ub-form-select {
          -webkit-appearance: none;
          appearance: none;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAIAAAAmzuBxAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpGQTdGMTE3NDA3MjA2ODExOTJCMEI4QUY2OEFGOTJFOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo0NDNBNDZGRUQwRUUxMUUyQkRGNEQ3NThBREE3RDhCQiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo0NDNBNDZGREQwRUUxMUUyQkRGNEQ3NThBREE3RDhCQiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M0IE1hY2ludG9zaCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjAyODAxMTc0MDcyMDY4MTE5MkIwODgxQTcwOTI5MEE3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkZBN0YxMTc0MDcyMDY4MTE5MkIwQjhBRjY4QUY5MkU5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+0G/y9QAAAKFJREFUeNp8kLEKwyAQhqsUCbqECIKDDk4ZEpwSQYiv4HPm3VxDN+21KWmbpP3g4D/+Dw4OlVIuf0FgpJRyzseuaZorsCzLPM+nRoxRa40ZY33fH2spJdQQMMw4jlVVfd1GKISw5ocBtXPu02jbVgjxNoCu6zjnayaEeO83+2VgjKdpWvMwDJTSvQEopYwxdV1ba/f/2JbbE3jDT+OUuwADANi+KdCnCjqhAAAAAElFTkSuQmCC);
          background-position: 95% 50%;
          background-repeat: no-repeat;
        }

        #err_description {
          border-top: 1px solid #e6e6e6;
          margin-top: 2em;
          padding-top: 2em;
        }

        #err_description ul {
          margin: 0;
          padding: 0;
        }

        #err_description ul li {
          list-style: none inside none;
          padding: 0.6em 0;
        }

      </style>
  </head>

  <body>
    <div>
        <main id="content">
            <div class="ub-card">
              <h1>You have logged out</h1>
              <p>
                <button class="ub-button ub-button--primary" onClick="location.href='/'">Log in again</button>
              </p>
            </div>
        </main>
    </div>

  </body>

</html>
`,
  'auth-popup-callback.html': `
<!DOCTYPE html>
<html>

<head>
    <meta charset="utf-8" />
    <title>Renew Callback</title>
    <link rel="icon"
          type="image/x-icon"
          href="favicon.png">
</head>

<body>
    <script src="assets/scripts/oidc-client-ts.min.js"></script>
    <script src="assets/scripts/auth-popup-callback.js"></script>
</body>

</html>`,
  'auth-silent-callback.html': `
<!DOCTYPE html>
<html>

<head>
    <meta charset="utf-8" />
    <title>Renew Callback</title>
    <link rel="icon"
          type="image/x-icon"
          href="favicon.png">
</head>

<body>
    <script src="assets/scripts/oidc-client-ts.min.js"></script>
    <script src="assets/scripts/auth-silent-callback.js"></script>
</body>

</html>`,
  'maintenance.html': `<!doctype html>
<html lang="en" class="no-js">
  <head>
    <meta charset="utf-8">
    <title>risr/advance - Down for maintenance</title>
    <meta name="description" content="">
    <meta name="viewport" content="width=device-width">

    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap">
    <link rel="stylesheet" href="styles/vendor.css">
    <link rel="stylesheet" href="styles/screen.css">

    <script src="scripts/respond.min.js"></script>

  </head>
  <body>

    <div class="container-fluid">
      <div class="row-fluid">

        <div class="col-sm-12">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-sm-offset-3">

              <p class="text-center">
                <img src="assets/images/risr-advance-logo.png" alt="risr/advance">
                <br/><br/>
              </p>

              <div class="wrapper">
                <div class="row">
                  <div class="col-xs-12 text-center">
                    <h2>We're currently improving the system</h2>
                    <br/>
                    <p>We'll be back shortly with an even better experience for you!</p>
                    <p>We apologise for the inconvenience!</p>
                    <p class="text-highlight">Your risr/advance team</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </body>
</html>
`,
  'old-browser.html': `<!doctype html>
<html>
  <head>
    <meta charset="utf-8">
    <title>risr/advance - Outdated browser</title>
    <meta name="description" content="">
    <meta name="viewport" content="width=device-width">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&display=swap" rel="stylesheet">

    <style>
      :root {
        --rsr-color-primary-100: #ebf5fa;
        --rsr-color-primary-200: #c3e2ef;
        --rsr-color-primary-300: #9bcfe4;
        --rsr-color-primary-400: #72bcd9;
        --rsr-color-primary-500: #4aa9ce;
        --rsr-color-primary-600: #318fb5;
        --rsr-color-primary-700: #266f8d;
        --rsr-color-primary-800: #1b4f64;
        --rsr-color-primary-900: #10303c;
        --rsr-color-primary-base: #1f5b73;
        --rsr-color-info-100: #e5f4ff;
        --rsr-color-info-200: #b3e0ff;
        --rsr-color-info-300: #80cbff;
        --rsr-color-info-400: #4db5ff;
        --rsr-color-info-500: #1aa1ff;
        --rsr-color-info-600: #0087e6;
        --rsr-color-info-700: #0069b3;
        --rsr-color-info-800: #004b80;
        --rsr-color-info-900: #002d4d;
        --rsr-color-info-base: #001e33;
        --rsr-color-danger-100: #ffe5e5;
        --rsr-color-danger-200: #ffb3b3;
        --rsr-color-danger-300: #ff8080;
        --rsr-color-danger-400: #ff4d4d;
        --rsr-color-danger-500: #ff1a1a;
        --rsr-color-danger-600: #e60000;
        --rsr-color-danger-700: #b30000;
        --rsr-color-danger-800: #800000;
        --rsr-color-danger-900: #4d0000;
        --rsr-color-danger-base: #d00000;
        --rsr-color-success-100: #eafbf7;
        --rsr-color-success-200: #bff3e8;
        --rsr-color-success-300: #94ebd9;
        --rsr-color-success-400: #69e3ca;
        --rsr-color-success-500: #3edbbb;
        --rsr-color-success-600: #24c1a1;
        --rsr-color-success-700: #2a7d6e;
        --rsr-color-success-800: #32695e;
        --rsr-color-success-900: #0c4036;
        --rsr-color-success-base: #105547;
        --rsr-color-warning-100: #fff0e5;
        --rsr-color-warning-200: #ffd3b3;
        --rsr-color-warning-300: #ffb680;
        --rsr-color-warning-400: #ff994d;
        --rsr-color-warning-500: #ff7c1a;
        --rsr-color-warning-600: #e66200;
        --rsr-color-warning-700: #b34c00;
        --rsr-color-warning-800: #803700;
        --rsr-color-warning-900: #4d2100;
        --rsr-color-warning-base: #ff6d00;
        --rsr-color-neutral-100: #f2f2f2;
        --rsr-color-neutral-200: #d9d9d9;
        --rsr-color-neutral-300: #bfbfc0;
        --rsr-color-neutral-400: #a5a5a6;
        --rsr-color-neutral-500: #8c8c8d;
        --rsr-color-neutral-600: #727273;
        --rsr-color-neutral-700: #59595a;
        --rsr-color-neutral-800: #3f3f40;
        --rsr-color-neutral-900: #262626;
        --rsr-color-neutral-base: #4f4f50;
      }

      *, ::after, ::before {
        box-sizing: border-box;
      }
      body {
        font-family: 'DM Sans', sans-serif;
        font-size: 16px;
        color: var(--rsr-color-neutral-800);
        line-height: 1.6;
        margin: 0;
        padding: 0;
      }
      h1 {
        font-size: 32px;
        font-weight: 400;
        margin: 16px 0;
      }
      h2 {
        color: var(--rsr-color-primary-800);
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 16px;
        text-align: center;
      }
      h3 {
        font-size: 16px;
        font-weight: 400;
      }
      header {
        background-color: var(--rsr-color-info-base);
        color: #fafafa;
        padding: 60px 16px;
        text-align: center;
      }
      .subtitle {
        font-size: 18px;
      }
      .details {
        background-color: var(--rsr-color-info-100);
        border: 1px solid var(--rsr-color-info-200);
        border-radius: 4px;
        color: var(--rsr-color-info-700);
        margin: 40px auto;
        max-width: 860px;
        padding: 16px;
        text-align: center;
      }
      main {
        margin: 20px 16px;
      }
      footer {
        border-top: 2px solid var(--rsr-color-neutral-100);
        margin: 40px auto;
        max-width: 100%;
        padding-top: 40px;
        width: 860px;
      }
      .row::before,
      .row::after {
        content: " ";
        display: table;
      }
      .row::after {
        clear: both;
      }
      .row {
        margin-left: -16px;
        margin-right: -16px;
      }
      .cards {
        margin: 40px auto;
        max-width: 860px;
        text-align: center;
      }
      .card {
        border-radius: 4px;
        border: 1px solid var(--rsr-color-neutral-200);
        margin-bottom: 16px;
        min-height: 1px;
        padding-left: 15px;
        padding-right: 15px;
        padding: 16px 8px;
        position: relative;
        transition: box-shadow 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      }
      .card:last-of-type {
        margin-right: 0;
      }
      .card:hover {
        box-shadow:
          0 1.7px 3.6px rgba(0, 0, 0, 0.024),
          0 4.6px 10px rgba(0, 0, 0, 0.035),
          0 11.2px 24.1px rgba(0, 0, 0, 0.046),
          0 37px 80px rgba(0, 0, 0, 0.07)
        ;
      }
      a {
        background-color: var(--rsr-color-primary-700);
        border: 1px solid var(--rsr-color-primary-800);
        border-radius: 4px;
        color: #fff;
        font-size: 14px;
        padding: 8px 32px;
        text-decoration: none;
      }
      a:hover {
        background-color: var(--rsr-color-primary-800);
        border: 1px solid var(--rsr-color-primary-900);
      }
      .text-center {
        text-align: center;
      }
      @media screen and (min-width: 480px) {
        header {
          padding: 120px 16px;
        }
        main {
          margin: 40px 16px;
        }
        .card {
          float: left;
          margin-right: 2%;
          width: 48%;
        }
      }
      @media screen and (min-width: 768px) {
        .card {
          float: left;
          margin-right: 1.33%;
          width: 24%;
        }
      }
    </style>

  </head>
  <body>
    <header>
      <img src="assets/images/risr-advance-logo-on-dark.png" alt="" />
      <h1>You're using an outdated browser</h1>
      <p class="subtitle">Keep your browser up-to-date to take advantage of the best possible experience when using risr/advance.</p>
    </header>

    <main>
      <h2>Download the latest version</h2>

      <div class="row cards">
        <div class="card">
          <img src="/assets/images/google-chrome-logo.png" width="100" height="100" />
          <h3>Google Chrome</h3>
          <p>
            <a href="https://www.google.com/chrome/index.html" title="Get Google Chrome">Download</a>
          </p>
        </div>
        <div class="card">
          <img src="/assets/images/mozilla-firefox-logo.png" width="100" height="100" />
          <h3>Mozilla Firefox</h3>
          <p>
            <a href="https://www.mozilla.org/en-US/firefox/new/" title="Get Mozilla Firefox">Download</a>
          </p>
        </div>
        <div class="card">
          <img src="/assets/images/apple-safari-logo.png" width="100" height="100" />
          <h3>Apple Safari</h3>
          <p>
            <a href="https://support.apple.com/downloads/safari" title="Get Apple Safari">Download</a>
          </p>
        </div>
        <div class="card">
          <img src="/assets/images/microsoft-edge-logo.png" width="100" height="100" />
          <h3>Microsoft Edge</h3>
          <p>
            <a href="https://www.microsoft.com/en-us/edge" title="Get Microsoft Edge">Download</a>
          </p>
        </div>
      </div>
    </main>

    <footer>
      <p class="text-center">
        <img src="assets/images/risr-advance-logo.png" alt="">
      </p>

      <p class="details">
        In an effort to deliver the best possible experience to you and other risr/advance users, we have taken the decision to only support the latest two major versions of each browser: Google Chrome, Mozilla Firefox, Apple Safari and Edge. Along with other companies worldwide, such as Google and Amazon, Fry-it is moving towards a better, modern web that is more compatible with the requirements of our users. Join us!
      </p>
    </footer>>
  </body>
</html>
`
};

/**
 * Get a template by its path
 * @param {string} templatePath - Path to the template (relative to src/)
 * @returns {string} The template content
 */
function getTemplate(templatePath) {
  const content = TEMPLATES[templatePath];
  if (content === undefined) {
    console.warn(`Template not found: ${templatePath}`);
    return '';
  }
  return content;
}

/**
 * Preload all templates into Angular's $templateCache
 */
function preloadTemplates($templateCache) {
  Object.entries(TEMPLATES).forEach(([path, content]) => {
    $templateCache.put(path, content);
  });
}

export { TEMPLATES, getTemplate, preloadTemplates };
